webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);


// jshint esversion: 6


if (!__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('uuid')) {
  __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', null);
}

if (!localStorage.webshoproles) {
  localStorage.webshoproles = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([]);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(vm, authData) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      vm.$webHelper.post('user/login', authData).then(function (res) {
        if (res.success) {
          __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', res.body.uuid, { expires: '8h' });
          localStorage.webshoproles = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.body.roles);
        }
        resolve(res);
      }).catch(function () {
        resolve(false);
      });
    });
  },
  manualLogin: function manualLogin(hash) {
    __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', hash, { expires: '8h' });
  },
  manualLogout: function manualLogout() {
    __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', null);
  },
  logout: function logout(vm, force) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      vm.$webHelper.post('user/logout').then(function (res) {
        if (res.success) {
          __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', null);
          localStorage.webshoproles = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([]);
        }
        resolve(res.success);
      }).catch(function () {
        resolve(false);
      });
      if (force) {
        __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.set('uuid', null);
      }
    });
  },


  // Check if uuid exists
  isLoggedIn: function isLoggedIn() {
    var uuid = __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a.get('uuid') || false;
    return uuid === 'null' ? false : uuid;
  },


  // Check if Admin
  isAdmin: function isAdmin() {
    var allRoles = localStorage.webshoproles ? JSON.parse(localStorage.webshoproles) : [];
    return !!allRoles.includes('ROLE_SUN_LOCAL_ADMIN');
  }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allergens_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72daf525_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allergens_vue__ = __webpack_require__(313);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allergens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72daf525_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allergens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_webshop_Header__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_webshop_Footer__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_3__components_webshop_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_4__components_webshop_Footer__["a" /* default */]
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    modal: 'modal',
    companyActive: 'companyActive',
    goDark: 'goDark'
  }),
  name: 'app',
  created: function created() {
    var _this = this;

    var isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.$store.dispatch('goDark', isDark);
    localStorage.theme = isDark ? 'dark' : 'light';
    this.checkStaticHash();
    // if (this.$route.query &&
    //     (this.$route.query.first ||
    //         this.$route.query.last ||
    //         this.$route.query.email ||
    //         this.$route.query.phone)) {
    //   const data = {
    //     first: this.$route.query.first || '',
    //     last: this.$route.query.last || '',
    //     email: this.$route.query.email || '',
    //     phone: this.$route.query.phone || '',
    //   };
    //   localStorage.customerData = JSON.stringify(data);
    //   this.$router.push({ path: this.$route.path });
    // }

    // this.$webHelper.post('token/create', {
    //   foreignKey: 'Yl7Z7ukF9JwSmWQRocRFnFLhGsUMgwoF',
    //   webShopResourceId: 'iP8uTMOY',
    //   expirationDateTime: '2021-05-04T14:43:27.389+0000',
    //   payloadPublic: {
    //     backlink: 'http://localhost:20011/t/BUSINESS-2',
    //     ordercompletedlink: 'http://localhost:20011/api/preorder/callback?foreignKey=%23foreignKey%23&orderId=%23orderId%23',
    //     email: 'alina@netkey.at',
    //     first: 'Alina',
    //     last: 'Kessler',
    //     phone: '+436602614891',
    //   },
    //   payloadPrivate: {
    //     orderCompletedCallback: 'http://localhost:20011/api/preorder/callback?foreignKey=#foreignKey#&orderId=#orderId#',
    //   },
    //   modifiedOn: '2021-04-13T14:43:28.426+0000',
    //   createdOn: '2021-04-13T14:43:28.426+0000',
    // })
    //   .then((res) => {
    //     console.log(res);
    //   });


    if (this.$route.query && this.$route.query.token) {
      var token = this.$route.query.token;
      this.$webHelper.get('token/' + token, null, this.$router).then(function (res) {
        if (!res.success) return;
        localStorage.tokenId = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ tokenId: token || '', deleteTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add('30', 'minutes') });
        var tokenData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.token.payloadPublic);
        if (tokenData && (tokenData.first || tokenData.last || tokenData.email || tokenData.phone || tokenData.backlink || tokenData.ordercompletedlink || tokenData.tokenId)) {
          var data = {
            first: tokenData.first || '',
            last: tokenData.last || '',
            email: tokenData.email || '',
            phone: tokenData.phone || ''
          };
          if (tokenData.backlink) {
            localStorage.backlink = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ backlink: tokenData.backlink || '', deleteTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add('30', 'minutes') });
          } else {
            localStorage.removeItem('backlink');
          }
          if (tokenData.ordercompletedlink) {
            localStorage.ordercompletedlink = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ backlink: tokenData.ordercompletedlink || '', deleteTime: __WEBPACK_IMPORTED_MODULE_5_moment___default()().add('30', 'minutes') });
          } else {
            localStorage.removeItem('ordercompletedlink');
          }
          localStorage.customerData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
          _this.$router.push({ path: _this.$route.path });
        } else {
          localStorage.removeItem('customerData');
          localStorage.removeItem('backlink');
          localStorage.removeItem('ordercompletedlink');
          _this.$router.push({ path: _this.$route.path });
        }
      });
    }
    if (this.$route.name === 'resourceSet' || this.$route.name === 'resourceSet2') return;
    var company = this.$storage.company;
    var resourceId = this.$route.params.resourceId ? this.$route.params.resourceId : localStorage.getItem('webShopResourceId');
    if (resourceId === 'undefined' || resourceId === 'null') resourceId = null;
    if (resourceId || this.$route.name === 'menu') {
      if (this.$route.name === 'menu') {
        resourceId = this.$route.query.webShopResourceId;
        localStorage.webShopResourceId = this.$route.query.webShopResourceId;
      }
      this.$webHelper.get('webshopresource/fetchbyexternalid/' + resourceId, null, this.$router).then(function (res) {
        if (!res.success) return;
        localStorage.setItem('webShopResourceId', resourceId);
        var companyData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.webShopResource);
        _this.$storage.company = companyData;
        _this.$store.dispatch('setCompany', companyData);
        _this.$store.dispatch('setTimeZone', companyData.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
        _this.$store.dispatch('setWorkingHours', companyData.openingDaysAndHours);
        document.title = companyData.name + ' ' + _this.$lang.global.webshop;
      });
    } else if (company) {
      this.$store.dispatch('setCompany', company);
      this.$store.dispatch('setTimeZone', company.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
      this.$store.dispatch('setWorkingHours', company.openingDaysAndHours);
      document.title = company.name + ' ' + this.$lang.global.webshop;
    }
    if (!resourceId && this.$route.name !== 'menu') {
      var url = window.location.origin;
      this.$webHelper.get('webshopresource/fetchbyurl?url=' + url, null, this.$router).then(function (res) {
        if (!res.success) return;
        localStorage.setItem('webShopResourceId', res.body.webShopResource.webShopResourceExternalId);
        _this.$storage.company = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.webShopResource);
        window.location.reload(true);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$router.beforeEach(function (to, from, next) {
      _this2.checkStaticHash();
      next();
    });
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.colorThemeListener);
  },

  methods: {
    colorThemeListener: function colorThemeListener(event) {
      if (event.matches) {
        localStorage.theme = 'dark';
        this.$store.dispatch('goDark', true);
      } else {
        localStorage.theme = 'light';
        this.$store.dispatch('goDark', false);
      }
    },
    checkStaticHash: function checkStaticHash() {
      this.$webHelper.get('/static/version.txt').then(function (staticHash) {
        if (staticHash) {
          if (!localStorage.staticHash || localStorage.staticHash !== staticHash.body) {
            localStorage.staticHash = staticHash.body;
            window.location.reload(true);
          }
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('change', this.colorThemeListener);
  }
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const__ = __webpack_require__(203);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].isLoggedIn(),
      isAdmin: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].isAdmin(),
      success: '',
      err: '',
      cookieAccepted: localStorage.getItem('cookiesAccepted'),
      language: localStorage.getItem('lang') || 'en',
      backlink: false,
      backlinkUrl: '',
      headerImageHeight: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    company: 'company',
    intercomVisible: 'intercomVisible',
    companyActive: 'companyActive',
    goDark: 'goDark',
    width: 'width'
  }), {
    logoImage: function logoImage() {
      if (this.company && this.company.htmlHints && this.company.htmlHints.find(function (x) {
        return x.name === 'webshop.logo';
      })) {
        return this.company.htmlHints.find(function (x) {
          return x.name === 'webshop.logo';
        }).value;
      }
      return false;
    },
    headerImage: function headerImage() {
      if (this.company && this.company.htmlHints && this.company.htmlHints.find(function (x) {
        return x.name === 'webshop.headerImage.mobile';
      })) {
        return this.company.htmlHints.find(function (x) {
          return x.name === 'webshop.headerImage.mobile';
        }).value;
      }
      return false;
    }
  }),
  created: function created() {
    this.$lang.setLang(this.language);
    if (this.$route.params.lang !== this.$lang.current_lang) {
      if (['en', 'de'].includes(this.$route.params.lang)) {
        this.$lang.setLang(this.$route.params.lang);
        localStorage.setItem('lang', this.$route.params.lang);
      } else {
        this.$router.push('/en');
      }
    }
    this.backlinkCheck();
  },

  methods: {
    backlinkCheck: function backlinkCheck() {
      var backlink = localStorage.backlink ? JSON.parse(localStorage.backlink) : false;
      var ordercompletedlink = localStorage.ordercompletedlink ? JSON.parse(localStorage.ordercompletedlink) : false;
      var tokenId = localStorage.tokenId ? JSON.parse(localStorage.tokenId) : false;
      if (backlink) {
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().toISOString() > __WEBPACK_IMPORTED_MODULE_1_moment___default()(backlink.deleteTime).toISOString()) {
          localStorage.removeItem('backlink');
          return;
        }
        this.backlinkUrl = backlink.backlink;
        var el = document.createElement('a');
        el.href = backlink.backlink;
        var hostnameArr = el.hostname.split('.');
        if (hostnameArr.length < 3) this.backlink = hostnameArr[0];
        if (hostnameArr.length >= 3) this.backlink = hostnameArr[1];
      }
      if (ordercompletedlink) {
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().toISOString() > __WEBPACK_IMPORTED_MODULE_1_moment___default()(ordercompletedlink.deleteTime).toISOString()) {
          localStorage.removeItem('ordercompletedlink');
        }
      }
      if (tokenId) {
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().toISOString() > __WEBPACK_IMPORTED_MODULE_1_moment___default()(tokenId.deleteTime).toISOString()) {
          localStorage.removeItem('tokenId');
        }
      }
    },
    inNewTab: function inNewTab(name) {
      var routeData = this.$router.resolve({ name: name, params: { lang: this.$lang.current_lang } });
      window.open(routeData.href, '_blank');
    },
    acceptCookies: function acceptCookies() {
      localStorage.setItem('cookiesAccepted', true);
      this.cookieAccepted = true;
    },
    toAddresses: function toAddresses() {
      this.$router.push('/' + this.$lang.current_lang + '/addresses');
    },
    toRegistration: function toRegistration() {
      this.$router.push('/' + this.$lang.current_lang + '/registration');
    },
    toVisits: function toVisits() {
      this.$router.push('/' + this.$lang.current_lang + '/visits');
    },
    toOrders: function toOrders() {
      this.$router.push('/' + this.$lang.current_lang + '/orders');
    },
    toLogin: function toLogin() {
      this.$router.push('/' + this.$lang.current_lang + '/login');
    },
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    activateIntercom: function activateIntercom() {
      window.Intercom('show');
    },
    logout: function logout() {
      var _this = this;

      var showAlert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].logout(this, force).then(function (res) {
        if (!res) {
          _this.err = _this.$lang.header.failLogOut;
          return;
        }
        _this.isLoggedIn = false;
        window.Intercom('shutdown');
        if (showAlert) {
          window.Intercom('boot', {
            app_id: __WEBPACK_IMPORTED_MODULE_4__const__["a" /* appId */]
          });
          _this.success = _this.$lang.header.logOut;
          _this.$router.push({ name: 'webShop' });
          window.location.reload(true);
          setTimeout(function () {
            _this.success = '';
          }, 3000);
        }
      });
    }
  },
  watch: {
    $route: {
      handler: function handler(val) {
        if (val.params.resource !== localStorage.getItem('webShopResourceId') && (val.name === 'resourceSet' || val.name === 'resourceSet2') && !val.query.nologout && __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].isLoggedIn()) {
          this.logout(false, true);
          return;
        }
        this.isLoggedIn = __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].isLoggedIn();
        this.isAdmin = __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */].isAdmin();
        if (val.query.nologout) {
          this.$router.push({ name: 'webShop' });
        }
        this.backlinkCheck();
      },

      immediate: true
    }
  }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appId; });
// eslint-disable-next-line import/prefer-default-export
var appId = 'niw9i7e2';

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoggedIn: null,
      paymentMethods: [],
      deliveryMethods: [],
      waitingTime: '',
      orange: true,
      blue: false,
      green: false,
      experiment: false,
      htmlHints: [],
      formatedHtmlHints: {},
      feVersion: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    workingHours: 'workingHours',
    deliveryCharges: 'deliveryCharges',
    companyActive: 'companyActive',
    goDark: 'goDark'
  }), {
    resource: function resource() {
      return localStorage.getItem('webShopResourceId');
    }
  }),
  watch: {
    orange: function orange(val) {
      if (val === true) {
        this.blue = false;
        this.green = false;
        this.experiment = false;
        this.$vuetify.theme.primary = '#efa546';
        this.$vuetify.theme.secondary = '#efa546';
        this.$vuetify.theme.accent = '#efa546';
      }
    },
    blue: function blue(val) {
      if (val === true) {
        this.orange = false;
        this.green = false;
        this.experiment = false;
        this.$vuetify.theme.primary = '#007BFF';
        this.$vuetify.theme.secondary = '#007BFF';
        this.$vuetify.theme.accent = '#007BFF';
      }
    },
    green: function green(val) {
      if (val === true) {
        this.blue = false;
        this.orange = false;
        this.experiment = false;
        this.$vuetify.theme.primary = '#43A047';
        this.$vuetify.theme.secondary = '#43A047';
        this.$vuetify.theme.accent = '#43A047';
      }
    },
    experiment: function experiment(val) {
      if (val === true) {
        this.blue = false;
        this.orange = false;
        this.green = false;
        var elems = document.getElementsByClassName('theme--light');
        elems[0].style.backgroundColor = 'white';
        var vcard = document.getElementById('vCardId');
        vcard.style.backgroundColor = '#F5F5F5';
        // this.$vuetify.theme.primary = '#43A047';
        // this.$vuetify.theme.secondary = '#43A047';
        // this.$vuetify.theme.accent = '#43A047';
      }
    },
    company: function company(val) {
      if (val) {
        // console.log(val);
        this.htmlHints = val.htmlHints;
        this.formatHtmlHints();
      }
    },

    '$route.path': {
      handler: function handler() {
        this.isLoggedIn = __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].isLoggedIn();
      }
    }
  },
  methods: {
    changeTheme: function changeTheme() {
      localStorage.theme = this.goDark ? 'light' : 'dark';
      this.$store.dispatch('goDark', !this.goDark);
    },
    formatHtmlHints: function formatHtmlHints() {
      if (this.htmlHints && this.htmlHints.length > 0) {
        for (var i = 0; i < this.htmlHints.length; i += 1) {
          this.formatedHtmlHints[this.htmlHints[i].name] = this.htmlHints[i].value;
        }
      }
    },
    inNewTab: function inNewTab(name) {
      var routeData = this.$router.resolve({ name: name });
      window.open(routeData.href, '_blank');
    },
    langChange: function langChange(lang) {
      this.$lang.setLang(lang);
      localStorage.setItem('lang', lang);
      if (this.$route.params.lang !== lang) {
        this.$route.params.lang = lang;
        // eslint-disable-next-line max-len
        this.$router.push({ name: this.$route.name, query: this.$route.query, params: this.$route.params });
      }
      window.location.reload(true);
    }
  },
  created: function created() {
    if (localStorage.staticHash) {
      this.feVersion = localStorage.staticHash;
    }
    if (this.company) {
      this.paymentMethods = this.company.paymentTypes;
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_webshop_ShoppingBasket__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__const__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ShoppingBasket: __WEBPACK_IMPORTED_MODULE_4__components_webshop_ShoppingBasket__["a" /* default */]
  },
  data: function data() {
    return {
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_6__auth__["a" /* default */].isLoggedIn(),
      success: '',
      itemSuccess: '',
      err: '',
      loaded: false,
      htmlHints: [],
      formatedHtmlHints: {},
      orderBackLinkUrl: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    itemsList: 'items',
    contact: 'contact',
    addresses: 'addresses',
    addressesSet: 'addressesSet',
    company: 'company',
    catalog: 'catalog',
    categories: 'categories',
    closed: 'closed',
    remainingWorkingRanges: 'remainingWorkingRanges',
    closingMessage: 'closingMessage',
    closedMessage: 'closedMessage',
    intercomUser: 'intercomUser',
    width: 'width'
  }), {
    showInfoPre: function showInfoPre() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page1.prefix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page1.prefix.de'];
      }
      return false;
    },
    showInfoPost: function showInfoPost() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page1.postfix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page1.postfix.de'];
      }
      return false;
    }
  }),
  methods: {
    goToOrderLink: function goToOrderLink() {
      window.open(this.orderBackLinkUrl, '_blank');
    },
    extractUrl: function extractUrl(fullUrl) {
      var shortenedUrl = '';
      var el = document.createElement('a');
      el.href = fullUrl;
      var hostnameArr = el.hostname.split('.');
      if (hostnameArr.length < 3) shortenedUrl = hostnameArr[0];
      if (hostnameArr.length >= 3) shortenedUrl = hostnameArr[1];
      return shortenedUrl;
    },
    flashSuccess: function flashSuccess(event) {
      var _this = this;

      this.itemSuccess = event;
      setTimeout(function () {
        _this.itemSuccess = '';
      }, 3000);
    },
    setupQuery: function setupQuery() {
      this.$store.dispatch('setUserData', {
        firstName: decodeURIComponent(this.$route.query.first),
        lastName: decodeURIComponent(this.$route.query.last)
      });
    },
    formatHtmlHints: function formatHtmlHints() {
      for (var i = 0; i < this.htmlHints.length; i += 1) {
        this.formatedHtmlHints[this.htmlHints[i].name] = '<v-flex xs1><i class="material-icons pr-3">info</i></v-flex><v-flex xs11>' + this.htmlHints[i].value + '</v-flex>';
      }
    },
    checkAcceptingOrders: function checkAcceptingOrders() {
      if (this.company) {
        return !!this.company.acceptingOrders;
      }
      return true;
    },
    initIntercom: function initIntercom() {
      var _this2 = this;

      var companyData = this.$storage.company;
      if (companyData.address.country === 'AT') {
        var intercomPayload = {};
        if (this.isLoggedIn) {
          if (this.addresses.length === 0 && !this.addressesSet) {
            this.$store.dispatch('setIsFetchingUser', true);
            this.$webHelper.get('contact/fetchforauser', null, this.$router).then(function (res) {
              if (!res.success) {
                _this2.err = _this2.$lang.errors.failedContactInfo;
                return;
              }
              _this2.$store.dispatch('setContact', {
                lastName: res.body.contact.lastName,
                phone: res.body.contact.phone
              });
              _this2.$store.dispatch('setIntercomUser', {
                lastName: res.body.contact.lastName,
                email: res.body.contact.email
              });
              intercomPayload = {
                name: _this2.intercomUser.lastName,
                app_id: __WEBPACK_IMPORTED_MODULE_5__const__["a" /* appId */],
                email: _this2.intercomUser.email
              };
              _this2.$store.dispatch('setIsFetchingUser', false);
              setTimeout(function () {
                window.Intercom('boot', intercomPayload);
                _this2.$store.dispatch('setIntercomVisible', true);
                window.Intercom('onUnreadCountChange', function (count) {
                  if (count > 0) {
                    window.Intercom('show');
                  }
                });
              }, 200);
            });
          } else {
            intercomPayload = {
              name: this.intercomUser.lastName,
              app_id: __WEBPACK_IMPORTED_MODULE_5__const__["a" /* appId */],
              email: this.intercomUser.email
            };
            setTimeout(function () {
              window.Intercom('boot', intercomPayload);
              _this2.$store.dispatch('setIntercomVisible', true);
              window.Intercom('onUnreadCountChange', function (count) {
                if (count > 0) {
                  window.Intercom('show');
                }
              });
            }, 200);
          }
        } else {
          intercomPayload = {
            app_id: __WEBPACK_IMPORTED_MODULE_5__const__["a" /* appId */]
          };
          setTimeout(function () {
            window.Intercom('boot', intercomPayload);
            _this2.$store.dispatch('setIntercomVisible', true);
            window.Intercom('onUnreadCountChange', function (count) {
              if (count > 0) {
                window.Intercom('show');
              }
            });
          }, 200);
        }
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.$route.params.resource) {
      var oldResourceId = localStorage.getItem('webShopResourceId') || null;
      localStorage.setItem('webShopResourceId', this.$route.params.resource);
      this.$storage.company = null;
      this.$store.dispatch('setCompany', null);
      this.$storage.catalog = null;
      this.$storage.order = null;
      this.$store.dispatch('clearCart');
      this.$webHelper.get('webshopresource/fetchbyexternalid/' + this.$route.params.resource, null, this.$router).then(function (res) {
        if (!res.success) return;
        var companyData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.webShopResource);
        _this3.$storage.company = companyData;
        if (companyData.htmlHints) {
          _this3.htmlHints = companyData.htmlHints;
          _this3.formatHtmlHints();
        }
        var setOrderType = companyData.orderTypes.includes('delivery') ? 'delivery' : companyData.orderTypes[0];
        _this3.$store.dispatch('setType', setOrderType);
        _this3.$store.dispatch('setCompany', companyData);
        _this3.$store.dispatch('setTimeZone', companyData.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna');
        _this3.$store.dispatch('setWorkingHours', companyData.openingDaysAndHours);
        document.title = companyData.name + ' Webshop';
        if (_this3.$route.params.resource !== oldResourceId) {
          window.location.reload(true);
        }
      });
    } else if (this.$storage.company) {
      var companyData = this.$storage.company;
      if (companyData.htmlHints) {
        this.htmlHints = companyData.htmlHints;
        this.formatHtmlHints();
      }
      var setOrderType = companyData.orderTypes.includes('delivery') ? 'delivery' : companyData.orderTypes[0];
      this.$store.dispatch('setType', setOrderType);
      document.title = companyData.name + ' Webshop';
    }
    if (this.$route.query.registered) {
      this.success = this.$lang.success.registrationSuccessfully;
    } else if (this.$route.query.passwordSet) {
      this.success = this.$lang.success.passSuccess;
    } else if (this.$route.query.orderSuccessful) {
      var fullLink = '';
      var ordercompletedlink = localStorage.ordercompletedlink ? JSON.parse(localStorage.ordercompletedlink) : false;
      if (ordercompletedlink) {
        fullLink = ordercompletedlink.backlink.replace('#orderId#', ordercompletedlink.orderId);
        fullLink = fullLink.replace('%23orderId%23', ordercompletedlink.orderId);
      }
      this.success = this.$lang.success.thankYou;
      this.orderBackLinkUrl = fullLink;
    } else if (this.$route.query.rateSuccessful) {
      this.success = this.$lang.success.rateOk;
    }
    if (this.success) {
      setTimeout(function () {
        _this3.success = '';
        _this3.orderBackLinkUrl = '';
      }, 180000);
    }
    var catalog = this.$storage.catalog;
    if (catalog) {
      this.$store.dispatch('setCatalog', catalog);
      this.loaded = true;
      // George asked to turn it off
      // this.initIntercom();
      return;
    }
    this.$webHelper.post('catalog/getcatalog', null, this.$router).then(function (res) {
      _this3.loaded = true;
      if (!res.success) {
        _this3.err = _this3.$lang.errors.failedCastalog;
        return;
      }
      _this3.$storage.catalog = res.body.catalog;
      _this3.$store.dispatch('setCatalog', res.body.catalog);
      // George asked to turn it off
      // this.initIntercom();
    });
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query).length > 0) {
      this.setupQuery();
    }
  }
});

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_webshop_modals_AddressSearchAt__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_webshop_modals_AddressSearchUk__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_webshop_modals_Allergens__ = __webpack_require__(46);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddressAt: __WEBPACK_IMPORTED_MODULE_6__components_webshop_modals_AddressSearchAt__["a" /* default */],
    AddressUk: __WEBPACK_IMPORTED_MODULE_7__components_webshop_modals_AddressSearchUk__["a" /* default */],
    Allergens: __WEBPACK_IMPORTED_MODULE_8__components_webshop_modals_Allergens__["a" /* default */]
  },
  props: ['successMessage'],
  data: function data() {
    var _this = this;

    return {
      isLoadingAddress: false,
      isLoading: false,
      showNav: false,
      orderType: '',
      postalcode: '',
      line1: '',
      comment: '',
      err: '',
      warn: '',
      success: '',
      successPostal: '',
      deliveryCharges: null,
      distanceInMiles: 0,
      total: 0,
      itemsTotal: 0,
      isValid: false,
      validPostal: null,
      selectAddress: null,
      selectAddressAT: null,
      calcTimeout: null,
      latitude: null,
      longitude: null,
      resourceId: null,
      commentRules: [function (v) {
        return !v || v.length < 1025 || _this.$lang.errors.commentShorter;
      }],
      postalCodes: [],
      search: null,
      searchAddress: null,
      hint: '',
      fromBack: false,
      chosenAddress: undefined,
      allergensDialog: false,
      allergens: [],
      showAddressFields: false,
      successTimeout: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    isFetchingUser: 'isFetchingUser',
    orderInfo: 'orderInfo',
    cart: 'cart',
    addresses: 'addresses',
    addressesAT: 'addressesAT',
    addressesSet: 'addressesSet',
    company: 'company',
    closedMessage: 'closedMessage',
    closed: 'closed',
    remainingWorkingRanges: 'remainingWorkingRanges',
    savedpostalCode: 'postalCode',
    storedComment: 'comment',
    width: 'width',
    catalog: 'catalog',
    goDark: 'goDark'
  }), {
    postalCodeRules: function postalCodeRules() {
      if (this.company && this.postalcode) {
        if (this.testPostalCodeRules(this.company.address.country, this.postalcode) !== true) this.startErrorAnimation('elPostalAutocomplete');
        return this.testPostalCodeRules(this.company.address.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesForLoggedInUser: function addressesForLoggedInUser() {
      var _this2 = this;

      var tempAddresses = [this.$lang.actions.addAddress];
      this.addresses.forEach(function (current) {
        if (current.latitude && current.longitude) {
          tempAddresses.push(_this2.generateFullAddress(current));
        }
      });
      return tempAddresses;
    },
    logoImage: function logoImage() {
      if (this.company && this.company.htmlHints && this.company.htmlHints.find(function (x) {
        return x.name === 'webshop.logo';
      })) {
        return this.company.htmlHints.find(function (x) {
          return x.name === 'webshop.logo';
        }).value;
      }
      return false;
    }
  }),
  watch: {
    search: {
      handler: function handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        this.getPostalCodes(val);
        if (!this.isLoggedIn()) {
          this.removeAddress();
        }
      },

      deep: true
    },
    searchAddress: {
      handler: function handler(val) {
        if (val) {
          this.searchAddress = this.searchAddress.trim();
        }
        // this.getPrefill(this.postalcode);
      },

      deep: true
    },
    cart: {
      handler: function handler() {
        this.$storage.order = this.cart;
        this.bufferCalculation();
      },

      deep: true
    },
    selectAddress: function selectAddress(newValue) {
      var _this3 = this;

      if (newValue === null) return;
      if (newValue === undefined) return;
      if (newValue === 'Add address' || newValue === 'Addresse hinzufügen') {
        this.showAddressFields = true;
        this.submitAddress(newValue, true);
        return;
      }
      this.addresses.forEach(function (current) {
        if (_this3.generateFullAddress(current) === newValue) {
          _this3.submitAddress(current, true);
        }
      });
    },
    selectAddressAT: function selectAddressAT(newValue) {
      var _this4 = this;

      if (newValue === null) return;
      this.addressesAT.forEach(function (current, index) {
        if (_this4.generateFullAddressAT(current) === newValue) {
          _this4.line1 = newValue.split(',')[0].trim();
          _this4.$store.dispatch('chooseAddress', index);
        }
      });
    },
    postalcode: function postalcode() {
      this.validPostal = null;
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
    },
    err: function err() {
      var _this5 = this;

      setTimeout(function () {
        _this5.err = '';
      }, 5000);
    },
    warn: function warn() {
      var _this6 = this;

      setTimeout(function () {
        _this6.warn = '';
      }, 5000);
    },
    success: function success() {
      var _this7 = this;

      this.successTimeout = setTimeout(function () {
        _this7.success = '';
        _this7.successPostal = false;
      }, 5000);
    },
    successMessage: function successMessage(newVal) {
      if (newVal) {
        clearTimeout(this.successTimeout);
        this.success = newVal;
      }
    }
  },
  methods: {
    closeDialog: function closeDialog(type) {
      this.$store.dispatch('setModal', false);
      if (type === 'address') {
        this.addressDialog = false;
      } else if (type === 'allergens') {
        this.allergens = [];
        this.allergensDialog = false;
      } else {
        this.timeDialog = false;
      }
    },
    checkAcceptingOrders: function checkAcceptingOrders() {
      if (this.company) {
        return !!this.company.acceptingOrders;
      }
      return true;
    },
    openAllergens: function openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    onBlurPostal: function onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        // this.getPrefill(this.postalcode);
      } else {
        this.startErrorAnimation('elPostalAutocomplete');
      }
    },
    submitAddress: function submitAddress(address) {
      var _this8 = this;

      var fromList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (address === 'Add address' || address === 'Addresse hinzufügen') {
        this.chosenAddress = null;
        this.line1 = null;
        this.latitude = null;
        this.longitude = null;
        this.search = null;
        this.postalCodes = [];
        this.postalcode = '';
        return;
      }
      this.chosenAddress = address;
      this.line1 = address.line1.trim();
      this.latitude = address.latitude;
      this.longitude = address.longitude;
      this.search = address.postalCode ? address.postalCode.toUpperCase() : '';
      this.postalCodes = address.postalCode ? [address.postalCode.toUpperCase()] : [];
      this.postalcode = address.postalCode;
      this.$store.dispatch('addPostal', {
        postalCode: this.postalcode,
        latitude: this.latitude,
        longitude: this.longitude
      });
      if (address.line1) {
        this.addPostal();
      }
      if (this.isLoggedIn() && !fromList && address.line1 !== '') {
        var tempAddresses = this.addresses;
        tempAddresses.push(address);
        this.$store.dispatch('setAddresses', tempAddresses);
        setTimeout(function () {
          _this8.selectAddress = _this8.generateFullAddress(address);
        }, 100);
      }
      this.$store.dispatch('setAddressesAT', [address]);
      this.$store.dispatch('chooseAddress', 0);
    },
    deleteAddress: function deleteAddress() {
      this.chosenAddress = undefined;
      this.selectAddress = '';
    },
    resetFromBack: function resetFromBack() {
      if (this.fromBack) {
        this.fromBack = false;
      }
    },
    getPrefill: function getPrefill(value) {
      var _this9 = this;

      if (!value) return;
      if (this.fromBack) {
        this.fromBack = false;
        return;
      }
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchAddress || this.searchAddress.length < 3) && this.company.address.country === 'AT') return;
      if (this.searchAddress && this.searchAddress.split(',').length === 4 && this.company.address.country === 'AT') return;
      var payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
      { postalCode: value.toUpperCase(), line1: this.searchAddress, country: this.company.address.country } : { postalCode: value.toUpperCase(), country: this.company.address.country };
      if (this.resourceId) {
        this.$webHelper.post('address/' + this.resourceId, payload).then(function (res) {
          if (res.body && res.status === 200 && res.body.addresses) {
            _this9.hint = _this9.$lang.success.postalSet;
            _this9.latitude = res.body.addresses[0].latitude;
            _this9.longitude = res.body.addresses[0].longitude;
            _this9.isLoading = false;
            _this9.$store.dispatch('addPostal', {
              postalCode: _this9.postalcode,
              latitude: _this9.latitude || res.body.addresses[0].latitude,
              longitude: _this9.longitude || res.body.addresses[0].longitude
            });
            _this9.$store.dispatch('setAddressesAT', res.body.addresses);
            if (_this9.company.address.country === 'UK') _this9.calcAll(true);
          } else {
            _this9.hint = res.body.statusText;
            _this9.isLoading = false;
          }
        }).catch(function (err) {
          _this9.err = err;
          _this9.isLoading = false;
        });
      }
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this10 = this;

      if (!code) return;
      code.trim().toUpperCase();
      this.hint = '';
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, {
        startswith: code.trim().toUpperCase()
      }).then(function (res) {
        if (res.body && res.status === 200) {
          if (res.body.postalCodes.length === 0) {
            _this10.hint = _this10.$lang.errors.noPostalFound;
            _this10.isLoading = false;
          } else {
            if (res.body.postalCodes.filter(function (x) {
              return x === _this10.postalcode;
            }).length === 0) {
              _this10.postalCodes = res.body.postalCodes;
            }
            _this10.isLoading = false;
          }
        }
      }).catch(function (err) {
        _this10.err = err;
        _this10.isLoading = false;
      });
    },
    setOrderType: function setOrderType(event) {
      this.$store.dispatch('setType', event);
      localStorage.setItem('delivery_method', event);
      if (event !== 'delivery') {
        this.distanceInMiles = 0;
        this.deliveryCharges = 0;
      }
    },
    bufferCalculation: function bufferCalculation() {
      var _this11 = this;

      if (this.calcTimeout !== null) {
        clearTimeout(this.calcTimeout);
      }
      this.calcTimeout = setTimeout(function () {
        _this11.calcTimeout = null;
        _this11.calcAll();
      }, 500);
    },
    headerSubmit: function headerSubmit() {
      this.$refs.shoppingBasket.scrollIntoView(true);
      this.submit();
    },
    handleScroll: function handleScroll() {
      if (window.scrollY > 500) {
        this.showNav = true;
      }
      if (window.scrollY < 500) {
        this.showNav = false;
      }
    },
    isLoggedIn: function isLoggedIn() {
      return __WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].isLoggedIn();
    },
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    generateFullAddress: function generateFullAddress(address) {
      if (address) {
        var lines = this.generateAddress([address.line1, address.line2, address.line3, address.line4]);
        var fullAdderss = lines;
        if (address.locality) {
          fullAdderss += ', ' + address.locality;
        }
        return fullAdderss + ', ' + address.townCity + ', ' + address.postalCode;
      }
      return '';
    },
    generateFullAddressAT: function generateFullAddressAT(address) {
      this.latitude = address.latitude;
      this.longitude = address.longitude;
      var lines = this.generateAddress([address.line1, address.line2, address.line3, address.line4]);
      var fullAdderss = lines;
      if (address.locality) {
        fullAdderss += ', ' + address.locality;
      }
      return fullAdderss + ', ' + address.townCity + ', ' + this.postalcode;
    },
    removeAddress: function removeAddress() {
      if (this.search && this.postalcode === this.search.trim()) return;
      this.chosenAddress = undefined;
      this.line1 = '';
      if (this.selectAddress) {
        var tempPostal = this.selectAddress.split(',')[4];
        if (tempPostal.trim() !== this.postalcode) {
          this.selectAddress = null;
          this.$store.dispatch('removeAddress');
        }
      }
    },
    addPostal: function addPostal() {
      var _this12 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this12.postalcode = _this12.postalcode.trim().toUpperCase();
        var payload = _this12.company.address.country === 'UK' ?
        // eslint-disable-next-line max-len
        { postalCode: _this12.postalcode, country: _this12.company.address.country } : {
          postalCode: _this12.postalcode,
          line1: _this12.line1,
          country: _this12.company.address.country
        };
        if (_this12.company.address.country === 'AT' && !_this12.line1) {
          _this12.err = _this12.$lang.errors.addressAT;
          resolve(false);
          return;
        }
        if (!_this12.resourceId) return;
        _this12.$webHelper.post('address/' + _this12.resourceId, payload).then(function (res) {
          if (!res.success) throw new Error(_this12.$lang.errors.invalidPostal);
          _this12.$store.dispatch('addPostal', {
            postalCode: _this12.postalcode,
            latitude: _this12.latitude || res.body.addresses[0].latitude,
            longitude: _this12.longitude || res.body.addresses[0].longitude
          });
          _this12.validPostal = true;
          if (_this12.cart.length > 0) _this12.success = _this12.$lang.success.deliveryCalculated;
          resolve(_this12.calcAll(true));
        }).catch(function (err) {
          _this12.err = err.message || _this12.$lang.errors.postalValidate;
          resolve(false);
        });
      });
    },
    selectCartItem: function selectCartItem(index) {
      this.$store.dispatch('selectItem', index);
    },
    editQuantity: function editQuantity(index, action) {
      var _this13 = this;

      this.$store.dispatch('editCartItemQuantity', { index: index, action: action }).then(function () {
        _this13.$storage.order = _this13.cart;
      });
    },
    calcDelivery: function calcDelivery() {
      var _this14 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (!_this14.latitude || !_this14.longitude) {
          resolve(false);
          return;
        }
        _this14.calcTotalWithoutDelivery().then(function (res) {
          if (res === null) return null;
          return _this14.$webHelper.post('order/calculatedeliverycharges', {
            country: _this14.company.address.country,
            latitude: _this14.latitude,
            longitude: _this14.longitude,
            postalCode: _this14.postalcode,
            totalAmount: res
          }, _this14.$router);
        }).then(function (res) {
          if (!res || !res.success) {
            if (res.body && res.body.statusText) {
              if (res.body.statusText === 'CalculateDeliveryCharges: Delivery to the requested Postal Code not configured in the Company.' || res.body.statusText === 'CalculateDeliveryCharges: Requested postal code is not allowed') {
                _this14.err = _this14.$lang.errors.codeOutsideArea;
              } else if (res.body.statusText.includes('CalculateDeliveryCharges: ')) {
                _this14.err = res.body.statusText.replace('CalculateDeliveryCharges: ', '');
              } else {
                _this14.err = res.body.statusText;
              }
            } else {
              _this14.err = _this14.$lang.errors.failedCalculate;
            }
            _this14.validPostal = false;
            _this14.distanceInMiles = 0;
            _this14.deliveryCharges = 0;
            resolve(false);
            return;
          }
          _this14.validPostal = true;
          _this14.postalcode = _this14.postalcode.charAt(0).toUpperCase() + _this14.postalcode.slice(1);
          _this14.distanceInMiles = res.body.distanceInMiles;
          _this14.deliveryCharges = res.body.deliveryCharges;
          resolve(true);
        }).catch(function () {
          resolve(false);
        });
      });
    },
    calcTotal: function calcTotal() {
      var _this15 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this15.cart.length === 0) {
          _this15.total = 0;
          resolve();
          return;
        }
        _this15.$webHelper.post('order/calculatetotalamount', {
          items: _this15.cart.map(function (current, index) {
            var item = current;
            item.itemId = index;
            return item;
          }),
          deliveryCharges: _this15.deliveryCharges,
          distanceInMiles: _this15.distanceInMiles,
          type: _this15.orderType
        }, _this15.$router).then(function (res) {
          if (!res.success) {
            _this15.warn = _this15.$lang.errors.calculateServer;
            resolve();
            return;
          }
          _this15.total = res.body.totalAmountWithoutDiscount;
          _this15.itemsTotal = res.body.itemsTotalAmount;
          resolve();
        });
      });
    },
    calcTotalOffline: function calcTotalOffline() {
      var _this16 = this;

      this.total = this.cart.length === 0 ? 0 : this.cart.reduce(function (total, current) {
        return total + _this16.$store.state.calculatePrice(current.selectedSize, current.selectedVariants, current.selectedOptions, current.quantity, current.quantityOfIncludedOptions);
      }, 0);
      this.itemsTotal = this.total;
    },
    calcTotalWithoutDelivery: function calcTotalWithoutDelivery() {
      var _this17 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var data = {
          items: _this17.cart.map(function (current, index) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, current, { itemId: index });
          }),
          type: _this17.orderType
        };
        _this17.$webHelper.post('order/calculatetotalamount', data, _this17.$router).then(function (res) {
          if (!res.success) {
            resolve(null);
            return;
          }
          resolve(res.body.itemsTotalAmount);
        }).catch(function () {
          resolve(null);
        });
      });
    },
    calcAll: function calcAll(delivery) {
      var _this18 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this18.cart.length === 0) {
          _this18.total = 0;
          _this18.deliveryCharges = 0;
          resolve(false);
          return;
        }
        if (delivery && !_this18.postalcode) {
          resolve(false);
          return;
        }
        _this18.calcTotalOffline();
        if (_this18.orderType === 'delivery' && _this18.postalcode && (_this18.deliveryCharges !== null || delivery)) {
          _this18.calcDelivery().then(function (res) {
            if (!res) {
              resolve(false);
              return;
            }
            _this18.calcTotal().then(function () {
              resolve(true);
            });
          });
        } else {
          _this18.distanceInMiles = 0;
          _this18.deliveryCharges = 0;
          _this18.calcTotal().then(function () {
            resolve(true);
          });
        }
      });
    },
    testPostalCodeRules: function testPostalCodeRules(country, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (country === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    clearPostalCodeSearch: function clearPostalCodeSearch() {
      this.search = null;
      this.postalCodes = [];
      this.hint = '';
    },
    isCompeteAddressCheck: function isCompeteAddressCheck() {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this19.company.address.country === 'AT')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', !!(_this19.chosenAddress && _this19.chosenAddress.line1 && _this19.chosenAddress.line1 !== '' && _this19.chosenAddress.line2 && _this19.chosenAddress.line2 !== '' && _this19.chosenAddress.townCity && _this19.chosenAddress.townCity !== ''));

              case 2:
                return _context.abrupt('return', !!(_this19.chosenAddress && _this19.chosenAddress.line1 && _this19.chosenAddress.line1 !== '' && _this19.chosenAddress.townCity && _this19.chosenAddress.townCity !== ''));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this19);
      }))();
    },
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    scrollToHeaderPostal: function scrollToHeaderPostal() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        setTimeout(function () {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }, 0);
      } else {
        setTimeout(function () {
          var cumulativeOffset = function cumulativeOffset(element) {
            var top = 0;
            var left = 0;
            do {
              top += element.offsetTop || 0;
              left += element.offsetLeft || 0;
              // eslint-disable-next-line no-param-reassign
              element = element.offsetParent;
            } while (element);
            return {
              top: top,
              left: left
            };
          };
          var postalElement = document.getElementById('elPostalAutocomplete');
          var postalPosition = cumulativeOffset(postalElement);
          window.scrollTo({
            top: postalPosition.top - 120,
            behavior: 'smooth'
          });
        }, 0);
      }
    },
    submit: function submit() {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isCompeteAddress;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this20.err = '';

                if (!(_this20.comment && _this20.comment.length > 1024)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                if (!((_this20.closed || _this20.closedMessage) && _this20.remainingWorkingRanges === 0)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return');

              case 5:
                if (_this20.company) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:
                if (!(_this20.company.webShopResourceStatus !== 'active')) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('return');

              case 9:
                if (!(_this20.orderType === 'delivery' && _this20.company.minDeliveryAmount && _this20.itemsTotal < parseFloat(_this20.company.minDeliveryAmount))) {
                  _context2.next = 12;
                  break;
                }

                _this20.err = _this20.$lang.errors.totalOver + ' ' + parseFloat(_this20.company.minDeliveryAmount).toFixed(2) + ' ' + _this20.$lang.errors.thisDelivery;
                return _context2.abrupt('return');

              case 12:
                _context2.next = 14;
                return _this20.isCompeteAddressCheck();

              case 14:
                isCompeteAddress = _context2.sent;

                if (!(_this20.orderType === 'delivery' && (!isCompeteAddress || !_this20.postalcode || _this20.validPostal === false))) {
                  _context2.next = 23;
                  break;
                }

                _this20.err = _this20.$lang.errors.validPostalOrAddress;
                _this20.startErrorAnimation('el-0');
                _this20.startErrorAnimation('el-1');
                _this20.startErrorAnimation('el-3');
                _this20.startErrorAnimation('elPostalAutocomplete');
                // document.getElementById('postalAutocomplete')
                //   .focus();
                _this20.scrollToHeaderPostal();
                return _context2.abrupt('return');

              case 23:
                if (!(_this20.cart.length === 0)) {
                  _context2.next = 26;
                  break;
                }

                _this20.err = _this20.$lang.errors.oneItemMinimum;
                return _context2.abrupt('return');

              case 26:
                _this20.$router.push({ name: 'orderInfo', params: { isCompeteAddress: isCompeteAddress } });

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this20);
      }))();
    },
    setOrderTypeOnLoad: function setOrderTypeOnLoad() {
      var type = localStorage.getItem('delivery_method');
      var orderTypes = null;
      if (this.company && this.company.orderTypes) {
        orderTypes = this.company.orderTypes;
      }
      if (type) return type;
      if (orderTypes) {
        if (orderTypes.includes('delivery')) return 'delivery';
        return orderTypes[0];
      }
      return 'delivery';
    }
  },
  created: function created() {
    var _this21 = this;

    var cart = this.$storage.order;
    this.orderType = this.setOrderTypeOnLoad();
    this.$store.dispatch('setType', this.orderType);
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (cart) {
      this.$store.dispatch('setCart', cart);
    }
    if (this.storedComment) {
      this.comment = this.storedComment;
    }
    if (this.savedpostalCode && this.orderType === 'delivery') {
      if (this.$route.params.fromBack) {
        this.fromBack = true;
        this.submitAddress(this.$route.params.address);
      }
      if (this.cart.length > 0) {
        this.calcAll(true);
      }
    }

    if (!__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].isLoggedIn()) return;
    if (__WEBPACK_IMPORTED_MODULE_5__auth__["a" /* default */].isAdmin()) return;
    // eslint-disable-next-line max-len
    if ((!this.addresses || this.addresses.length === 0) && !this.addressesSet && !this.isFetchingUser) {
      this.$webHelper.get('contact/fetchforauser', null, this.$router).then(function (res) {
        if (!res.success) {
          _this21.err = _this21.$lang.errors.failedContactInfo;
          return;
        }
        _this21.$store.dispatch('setAddresses', res.body.contact.address);
        _this21.$store.dispatch('setContact', {
          lastName: res.body.contact.lastName,
          phone: res.body.contact.phone
        });
        _this21.$store.dispatch('setIntercomUser', {
          lastName: res.body.contact.lastName,
          email: res.body.contact.email
        });
        if (_this21.$route.params.address !== '') {
          _this21.selectAddress = _this21.generateFullAddress(_this21.$route.params.address);
        }
      });
    } else if (this.$route.params.address !== '') {
      this.selectAddress = this.generateFullAddress(this.$route.params.address);
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddressLookupAT',
  props: ['address', 'fromBack'],
  data: function data() {
    return {
      isLoadingAddress: false,
      isLoading: false,
      showNav: false,
      orderType: '',
      fullAddress: null,
      postalcode: '',
      line1: '',
      line2: '',
      line3: '',
      townCity: '',
      locality: '',
      comment: '',
      err: '',
      warn: '',
      success: '',
      successPostal: '',
      deliveryCharges: null,
      distanceInMiles: 0,
      total: 0,
      itemsTotal: 0,
      validPostal: null,
      selectAddress: null,
      selectAddressAT: null,
      calcTimeout: null,
      latitude: null,
      longitude: null,
      resourceId: null,
      postalCodes: [],
      search: null,
      searchLine1: null,
      searchLine2: null,
      searchTownCity: null,
      searchAddress: null,
      hint: '',
      showAddressFields: false,
      addressesResult: [],
      country: null,
      init: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    postalCode: 'postalCode',
    company: 'company',
    goDark: 'goDark'
  }), {
    postalCodeRules: function postalCodeRules() {
      if (this.country && this.postalcode) {
        return this.testPostalCodeRules(this.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesLine1: function addressesLine1() {
      return this.filterUniqueFields(this.addressesResult, 'line1');
    },
    addressesLine2: function addressesLine2() {
      var _this = this;

      return this.filterUniqueFields(this.addressesResult.filter(function (x) {
        return x.line1 === _this.line1;
      }), 'line2');
    },
    addressesTownCity: function addressesTownCity() {
      if (this.filterUniqueFields(this.addressesResult, 'townCity').length === 1) {
        // eslint-disable-next-line prefer-destructuring,vue/no-side-effects-in-computed-properties
        this.townCity = this.filterUniqueFields(this.addressesResult, 'townCity')[0];
      }
      return this.filterUniqueFields(this.addressesResult, 'townCity');
    },
    isValid: function isValid() {
      var _this2 = this;

      var valid = this.addressesResult.find(function (x) {
        return x.postalCode === _this2.postalcode && x.line1 === _this2.line1 && x.line2 === _this2.line2 && x.townCity === _this2.townCity;
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (valid) {
        this.fullAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, valid, { line3: this.line3 || '' });
        this.$emit('submit', this.fullAddress);
      }
      if (!valid) {
        this.fullAddress = null;
      }
      return !!valid;
    }
  }),
  watch: {
    search: {
      handler: function handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        if (this.init) {
          this.searchLine1 = '';
          this.addressesResult = [];
          this.getPostalCodes(val);
        }
      },

      deep: true
    },
    searchLine1: {
      handler: function handler() {
        if (this.testPostalCodeRules(this.country, this.postalcode) === true && this.searchLine1 && this.searchLine1.length > 2 && this.init && !this.fromBack) {
          this.addressLookup(this.postalcode);
        }
        if (this.fromBack && this.searchLine1 && this.searchLine1.length > 2 && this.searchLine1 !== this.line1) {
          this.line1 = '';
          this.$emit('submit', 'Add address');
          this.addressLookup(this.postalcode);
        }
      },

      deep: true
    },
    searchLine2: {
      handler: function handler() {
        if (this.fromBack && this.line2 && this.searchLine2 && this.searchLine2 !== this.line2) {
          this.line2 = '';
          this.$emit('submit', 'Add address');
          this.addressLookup(this.postalcode);
        }
      },

      deep: true
    },
    postalcode: function postalcode() {
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
      if (this.testPostalCodeRules(this.country, this.postalcode) === true && this.init) {
        this.hint = this.$lang.success.postalSet;
        document.getElementById('postalCode').blur();
        document.getElementById('line1').click();
        document.getElementById('line1').focus();
        this.line1 = null;
        this.searchLine1 = null;
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line1: function line1() {
      if (!this.line1 && this.init) {
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line2: function line2() {
      if (!this.line2 && this.init) {
        this.line3 = null;
      }
    },
    townCity: function townCity() {
      if (this.townCity && this.searchTownCity && this.townCity === this.searchTownCity) {
        document.getElementById('townCity').focus();
        document.getElementById('townCity').blur();
      }
    }
  },
  methods: {
    showError: function showError(line) {
      this.startErrorAnimation(line);
      return 'Required!';
    },
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    moveToHouseNo: function moveToHouseNo() {
      document.getElementById('line1').blur();
      document.getElementById('line2').click();
      document.getElementById('line2').focus();
    },
    moveToLine1: function moveToLine1() {
      document.getElementById('postalCode').blur();
      document.getElementById('line1').click();
      document.getElementById('line1').focus();
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this3 = this;

      if (!this.init) return;
      if (!code) return;
      code.trim().toUpperCase();
      this.hint = '';
      if (this.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, {
        startswith: code.trim().toUpperCase()
      }).then(function (res) {
        if (res.data && res.status === 200) {
          if (res.data.postalCodes.length === 0) {
            _this3.hint = _this3.$lang.errors.noPostalFound;
            _this3.isLoading = false;
          } else {
            if (res.data.postalCodes.filter(function (x) {
              return x === _this3.postalcode;
            }).length === 0) {
              _this3.postalCodes = res.data.postalCodes;
              _this3.line1 = '';
              _this3.searchLine1 = '';
            }
            if (res.data.postalCodes.length === 1) {
              _this3.postalcode = _this3.postalCodes[0];
              _this3.hint = _this3.$lang.success.postalSet;
            }
            _this3.isLoading = false;
          }
        }
      }).catch(function (err) {
        _this3.err = err;
        _this3.isLoading = false;
      });
    },
    addressLookup: function addressLookup(value) {
      var _this4 = this;

      if (!this.init) return;
      if (!value) return;
      if (this.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchLine1 || this.searchLine1 && this.searchLine1.length < 3) && this.country === 'AT') return;
      this.isLoadingAddress = true;
      if (!this.fromBack) {
        this.addressesResult = [];
      }
      var payload = {
        postalCode: value.trim().toUpperCase(),
        line1: this.searchLine1,
        country: this.country
      };
      this.$webHelper.post('address/' + this.resourceId, payload).then(function (res) {
        if (res.data && res.status === 200 && res.data.addresses) {
          _this4.addressesResult = res.data.addresses || [];
          _this4.isLoadingAddress = false;
        } else {
          _this4.hint = res.data.statusText;
          _this4.isLoadingAddress = false;
        }
      }).catch(function (err) {
        _this4.err = err;
        _this4.isLoadingAddress = false;
      });
    },
    testPostalCodeRules: function testPostalCodeRules(countryToCheck, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!countryToCheck) return this.$lang.errors.countryRequired;
      if (countryToCheck === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    onBlurPostal: function onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        if (this.init) this.addressLookup(this.postalcode);
      }
    },
    onBlurLine2: function onBlurLine2() {
      if (this.searchLine2 && this.addressesLine2.includes(this.searchLine2.toUpperCase())) {
        this.line2 = this.searchLine2.toUpperCase();
      }
    },
    filterUniqueFields: function filterUniqueFields(addresses, property) {
      var filteredFieldList = addresses.map(function (address) {
        return address[property];
      });
      // eslint-disable-next-line max-len
      filteredFieldList = filteredFieldList.filter(function (item, index) {
        return filteredFieldList.indexOf(item) === index;
      }).filter(function (x) {
        return x !== undefined;
      }).sort();
      return filteredFieldList;
    }
  },
  mounted: function mounted() {
    this.country = this.company && this.company.address ? this.company.address.country : null;
  },
  created: function created() {
    var _this5 = this;

    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.address) {
      this.fullAddress = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.address);
      this.addressesResult = [this.address];
      this.postalCodes = [this.address.postalCode] || [];
      this.postalcode = this.address.postalCode;
      this.searchLine1 = this.address.line1;
      this.line1 = this.address.line1;
      this.searchLine2 = this.address.line2;
      this.line2 = this.address.line2;
      this.line3 = this.address.line3;
      this.townCity = this.address.townCity;
      setTimeout(function () {
        _this5.init = true;
      }, 100);
    } else {
      this.init = true;
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddressLookupUK',
  props: ['address', 'fromBack'],
  data: function data() {
    return {
      isLoadingAddress: false,
      isLoading: false,
      showNav: false,
      orderType: '',
      fullAddress: null,
      postalcode: '',
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      townCity: '',
      locality: '',
      comment: '',
      err: '',
      warn: '',
      success: '',
      successPostal: '',
      deliveryCharges: null,
      distanceInMiles: 0,
      total: 0,
      itemsTotal: 0,
      validPostal: null,
      selectAddress: null,
      selectAddressAT: null,
      calcTimeout: null,
      latitude: null,
      longitude: null,
      resourceId: null,
      postalCodes: [],
      search: null,
      searchLine1: null,
      searchLine2: null,
      searchLine3: null,
      searchTownCity: null,
      searchAddress: null,
      hint: '',
      showAddressFields: false,
      addressesResultFull: [],
      addressesResultFiltered: [],
      country: null,
      init: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    postalCode: 'postalCode',
    company: 'company',
    goDark: 'goDark'
  }), {
    postalCodeRules: function postalCodeRules() {
      if (this.country && this.postalcode) {
        return this.testPostalCodeRules(this.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    addressesLine1: function addressesLine1() {
      return this.filterUniqueFields(this.addressesResultFull, 'line1');
    },
    addressesLine2: function addressesLine2() {
      var _this = this;

      return this.filterUniqueFields(this.addressesResultFiltered.filter(function (x) {
        return x.line1 === _this.line1;
      }), 'line2');
    },
    addressesLine3: function addressesLine3() {
      var _this2 = this;

      return this.filterUniqueFields(this.addressesResultFiltered.filter(function (x) {
        return x.line1 === _this2.line1;
      }), 'line3');
    },
    addressesTownCity: function addressesTownCity() {
      return this.filterUniqueFields(this.addressesResultFiltered, 'townCity');
    },
    isValid: function isValid() {
      var _this3 = this;

      var valid = this.addressesResultFull.find(function (x) {
        return x.postalCode === _this3.postalcode && x.line1 === _this3.line1 && x.townCity === _this3.townCity;
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      if (valid) {
        this.fullAddress = valid;
        this.$emit('submit', this.fullAddress);
      }
      if (!valid) this.fullAddress = null;
      return !!valid;
    }
  }),
  watch: {
    fullAddress: {
      handler: function handler(val) {
        if (val) {
          this.line1 = val.line1;
          this.line2 = val.line2;
          this.line3 = val.line3;
          this.line4 = val.line4;
          this.townCity = val.townCity;
          this.locality = val.locality;
          this.latitude = val.latitude;
          this.longitude = val.longitude;
        }
      },

      deep: true
    },
    search: {
      handler: function handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        if (this.init) {
          this.searchLine1 = '';
          this.addressesResultFull = [];
          this.addressesResultFiltered = [];
          this.getPostalCodes(val);
        }
      },

      deep: true
    },
    postalcode: function postalcode() {
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
      if (this.testPostalCodeRules(this.country, this.postalcode) === true && this.init) {
        setTimeout(function () {
          setTimeout(function () {
            document.getElementById('line1').click();
            document.getElementById('line1').focus();
          }, 50);
        }, 50);
        this.line1 = null;
        this.searchLine1 = null;
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
      }
    },
    line1: function line1() {
      var _this4 = this;

      if (!this.line1 && this.init) {
        this.line2 = null;
        this.searchLine2 = null;
        this.townCity = null;
        this.line3 = null;
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line1 && this.init) {
        this.addressesResultFiltered = this.addressesResultFull.filter(function (x) {
          return x.line1 === _this4.line1;
        });
        if (this.addressesResultFiltered.length === 1) {
          setTimeout(function () {
            _this4.fullAddress = _this4.addressesResultFiltered[0];
            document.getElementById('line2').click();
            document.getElementById('line2').focus();
          }, 50);
        }
      }
    },
    line2: function line2() {
      var _this5 = this;

      if (!this.line2 && this.init) {
        this.line3 = null;
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line2 && this.init) {
        if (this.addressesResultFiltered.filter(function (x) {
          return x.line1 === _this5.line1;
        }).length === 1) {
          setTimeout(function () {
            _this5.line3 = _this5.addressesResultFiltered[0].line3;
            document.getElementById('line2').blur();
            document.getElementById('line3').click();
            document.getElementById('line3').focus();
          }, 50);
        }
        if (this.filterUniqueFields(this.addressesResultFiltered, 'townCity').length === 1) {
          this.townCity = this.filterUniqueFields(this.addressesResultFiltered, 'townCity')[0];
        }
      }
    },
    line3: function line3() {
      if (!this.line3 && this.init) {
        this.addressesResultFiltered = this.addressesResultFull;
      }
      if (this.line3 && this.init) {
        if (this.filterUniqueFields(this.addressesResultFiltered, 'townCity').length === 1) {
          this.townCity = this.filterUniqueFields(this.addressesResultFiltered, 'townCity')[0];
        }
        document.getElementById('line3').blur();
        document.getElementById('townCity').click();
        document.getElementById('townCity').focus();
      }
    }
  },
  methods: {
    showError: function showError(line) {
      this.startErrorAnimation(line);
      return 'Required!';
    },
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    filterAddresses: function filterAddresses(value, target) {
      var _this6 = this;

      if (this.addressesResultFull.length === 0) return;
      if (!value) {
        this.addressesResultFiltered = this.addressesResultFull;
        return;
      }
      if (target === 'line2' && this.line1 !== '') {
        this.addressesResultFiltered = this.addressesResultFull.filter(function (address) {
          if (address[target] && address.line1 === _this6.line1) return address;
          return false;
        });
        return;
      }
      this.addressesResultFiltered = this.addressesResultFull.filter(function (address) {
        if (address[target] && address[target].toLowerCase().includes(value.toLowerCase().trim())) {
          return address;
        }
        return false;
      });
    },
    generateAddress: function generateAddress(input) {
      // if (this.line1) return input.line1;
      var address = '';
      var tempKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(input);
      tempKeys.forEach(function (key, index) {
        if (['latitude', 'longitude', 'country'].includes(key)) {
          address += '';
        } else if (input[key]) address += tempKeys.length !== index - 1 ? ', ' + input[key].trim() : '' + input[key].trim();
      });
      address = address.substring(2, address.length);
      return address;
    },
    moveToHouseNo: function moveToHouseNo() {
      document.getElementById('line1').blur();
      document.getElementById('line2').click();
      document.getElementById('line2').focus();
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this7 = this;

      if (!this.init) return;
      if (!code) return;
      code.trim().toUpperCase();
      this.hint = '';
      if (this.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      this.isLoading = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, {
        startswith: code.trim().toUpperCase()
      }).then(function (res) {
        if (res.data && res.status === 200) {
          if (res.data.postalCodes.length === 0) {
            _this7.hint = _this7.$lang.errors.noPostalFound;
            _this7.isLoading = false;
          } else {
            _this7.postalCodes = res.data.postalCodes;
            _this7.line1 = '';
            _this7.searchLine1 = '';
            if (res.data.postalCodes.length === 1) {
              _this7.postalcode = _this7.postalCodes[0];
            }
            _this7.isLoading = false;
          }
        }
      }).catch(function (err) {
        _this7.err = err;
        _this7.isLoading = false;
      });
    },
    addressLookup: function addressLookup(value) {
      var _this8 = this;

      if (!this.init) return;
      if (!value) return;
      if (this.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      this.isLoadingAddress = true;
      // this.addressesResultFull = [];
      // this.addressesResultFiltered = [];
      var payload = {
        postalCode: value.trim().toUpperCase(),
        country: this.country
      };
      this.$webHelper.post('address/' + this.resourceId, payload).then(function (res) {
        if (res.data && res.status === 200 && res.data.addresses) {
          _this8.hint = _this8.$lang.success.postalSet;
          _this8.addressesResultFull = res.data.addresses || [];
          _this8.addressesResultFiltered = res.data.addresses || [];
          _this8.isLoadingAddress = false;
        } else {
          _this8.hint = res.data.statusText;
          _this8.isLoadingAddress = false;
        }
      }).catch(function (err) {
        _this8.err = err;
        _this8.isLoadingAddress = false;
      });
    },
    testPostalCodeRules: function testPostalCodeRules(countryToCheck, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!countryToCheck) return this.$lang.errors.countryRequired;
      if (countryToCheck === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (countryToCheck === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    onBlurLine2: function onBlurLine2() {
      if (this.searchLine2 && this.addressesLine2.includes(this.searchLine2.toUpperCase())) {
        this.line2 = this.searchLine2.toUpperCase();
      }
    },
    onBlurLine3: function onBlurLine3() {
      if (this.searchLine3 && this.addressesLine3.includes(this.searchLine3.toUpperCase())) {
        this.line3 = this.searchLine3.toUpperCase();
      }
    },
    filterUniqueFields: function filterUniqueFields(addresses, property) {
      if (addresses && addresses.length > 0) {
        var filteredFieldList = addresses.map(function (address) {
          return address[property];
        });
        // eslint-disable-next-line max-len
        filteredFieldList = filteredFieldList.filter(function (item, index) {
          return filteredFieldList.indexOf(item) === index;
        }).filter(function (x) {
          return x !== undefined;
        }).sort();
        return filteredFieldList;
      }
      return [];
    }
  },
  mounted: function mounted() {
    this.country = this.company && this.company.address ? this.company.address.country : null;
  },
  created: function created() {
    var _this9 = this;

    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.address) {
      this.fullAddress = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.address);
      this.addressesResultFull = [this.address];
      this.addressesResultFiltered = [this.address];
      this.postalCodes = [this.address.postalCode] || [];
      this.postalcode = this.address.postalCode;
      this.searchLine1 = this.address.line1;
      this.line1 = this.address.line1;
      this.searchLine2 = this.address.line2;
      this.line2 = this.address.line2;
      this.line3 = this.address.line3;
      this.townCity = this.address.townCity;
      setTimeout(function () {
        _this9.init = true;
      }, 100);
    } else {
      this.init = true;
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['catalogAllergens', 'allergens'],
  data: function data() {
    return {
      err: '',
      warning: ''
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    company: 'company'
  }),
  watch: {},
  methods: {
    formatAllergen: function formatAllergen(id) {
      // eslint-disable-next-line max-len
      return this.catalogAllergens.filter(function (x) {
        return x.allergenId === id;
      })[0].name[this.$route.lang] || this.catalogAllergens.filter(function (x) {
        return x.allergenId === id;
      })[0].name[this.company.defaultLanguage];
    }
  },
  created: function created() {}
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__terms_and_privacy_contact_tracking__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactTracking',
  data: function data() {
    var _this = this;

    return {
      infoDialog: false,
      success: null,
      err: null,
      valid: false,
      form: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        table: ''
      },
      dateTime: new Date(),
      tableRules: [function (v) {
        return !!v || _this.$lang.errors.required;
      }],
      nameRules: [function (v) {
        return !!v || _this.$lang.errors.nameMustHaveCharacters;
      }, function (v) {
        return v && v.length <= 35 || _this.$lang.errors.nameLess;
      }],
      emailRules: [function (v) {
        return !!v || _this.$lang.errors.requiredEmail;
      },
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }],
      dataHtml: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company'
  }), {
    phoneNumberRules: function phoneNumberRules() {
      if (this.company && (this.form.phone || this.form.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.form.phone);
      }
      return this.$lang.errors.requiredPhone;
    }
  }),
  watch: {
    company: {
      handler: function handler(val) {
        if (val && val.address && val.address.country && val.address.country === 'UK') {
          this.$router.push('/');
        }
      }
    }
  },
  methods: {
    testPhoneNumberRules: function testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      var tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
      if (tempPhone.substring(0, 2) === '00') {
        tempPhone = tempPhone.substring(2, tempPhone.length);
      }
      if (tempPhone.substring(0, 2) === '43') {
        tempPhone = '0' + tempPhone.substring(2, tempPhone.length);
      }
      var checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
      if (!checkPhone) {
        checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
      }
      return checkPhone || this.$lang.errors.notValidPhone;
    },
    formatDateTime: function formatDateTime(time) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).format('DD/MM/YYYY HH:mm');
    },
    submit: function submit() {
      var _this2 = this;

      this.$webHelper.post('visit/' + this.$route.params.resourceId, this.form).then(function (res) {
        if (!res.success) {
          _this2.err = res.body.statusText;
          _this2.infoDialog = true;
          return;
        }
        _this2.success = _this2.$lang.success.visitOk;
        _this2.infoDialog = true;
      });
    }
  },
  created: function created() {
    this.dataHtml = __WEBPACK_IMPORTED_MODULE_3__terms_and_privacy_contact_tracking__["a" /* default */];
    if (__WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].isLoggedIn()) {
      var userData = JSON.parse(localStorage.customerData) || {};
      this.form = {
        firstName: userData.first || '',
        lastName: userData.last || '',
        phone: userData.phone || '',
        email: userData.email || '',
        table: ''
      };
    }
    if (this.$route.params.tableName) this.form.table = this.$route.params.tableName;
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      loginProcessStarted: false,
      email: '',
      password: '',
      passwordRules: [function (v) {
        return !!v || _this.$lang.errors.requiredPassword;
      }, function (v) {
        return v && v.length >= 6 && v.length <= 35 || _this.$lang.errors.passwordConditions;
      }],
      emailRules: [function (v) {
        return !!v || _this.$lang.errors.requiredEmail;
      },
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }],
      err: ''
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  }),
  methods: {
    submit: function submit() {
      var _this2 = this;

      this.loginProcessStarted = true;
      this.err = '';
      if (!this.email || !this.password) {
        this.err = this.$lang.errors.enterCredentials;
        this.loginProcessStarted = false;
        return;
      }
      this.email = this.email.trim();
      __WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].login(this, { userName: this.email, password: this.password }).then(function (res) {
        if (!res || !res.success) {
          // eslint-disable-next-line max-len
          _this2.err = res && res.body ? res.body.statusText || _this2.$lang.errors.failedLogin : _this2.$lang.errors.failedLogin;
          _this2.loginProcessStarted = false;
          return null;
        }
        _this2.loginProcessStarted = false;
        if (__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].isAdmin()) {
          _this2.$router.push({ name: 'webShop' });
          return null;
        }
        return _this2.$webHelper.get('contact/fetchforauser', null, _this2.$router);
      }).then(function (res) {
        if (res === null) return;
        if (!res.success) {
          _this2.err = _this2.$lang.errors.failedContactInfo;
          _this2.loginProcessStarted = false;
          return;
        }
        _this2.$store.dispatch('setUserData', undefined);
        _this2.$store.dispatch('setAddresses', res.body.contact.address);
        _this2.$store.dispatch('setContact', {
          lastName: res.body.contact.lastName,
          phone: res.body.contact.phone
        });
        var data = {
          first: res.body.contact.lastName.split(' ')[0] || '',
          last: res.body.contact.lastName.split(' ')[1] || '',
          email: res.body.contact.email || '',
          phone: res.body.contact.phone || ''
        };
        localStorage.customerData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
        window.Intercom('shutdown');
        _this2.$store.dispatch('setIntercomUser', {
          lastName: res.body.contact.lastName,
          email: res.body.contact.email
        });
        _this2.loginProcessStarted = false;
        _this2.$router.push({ name: 'webShop' });
      });
    }
  },
  created: function created() {
    if (this.$route.query['session-expired']) {
      this.err = this.$lang.errors.sessionExpired;
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      valid: false,
      password: '',
      repassword: '',
      passwordRules: [function (v) {
        return !!v || _this.$lang.errors.requiredPassword;
      }, function (v) {
        return v && v.length >= 6 && v.length <= 35 || _this.$lang.errors.passwordConditions;
      }],
      err: ''
    };
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      if (!this.valid) return;
      this.err = '';
      if (this.password !== this.repassword) {
        this.err = this.$lang.errors.matchPasswords;
        return;
      }
      this.$webHelper.post('user/resetpassword', {
        resetPasswordToken: this.$route.params.id,
        password: this.password
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this2.err = _this2.$lang.errors.failedPassword;
          return null;
        }
        __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].manualLogin(res.body.uuid);
        _this2.$storage.catalog = null;
        _this2.$storage.order = null;
        _this2.$store.dispatch('clearCart');
        _this2.$storage.company = null;
        _this2.$store.dispatch('setCompany', null);
        return _this2.$webHelper.get('webshopresource/fetchbyexternalid/' + _this2.$route.params.resourceId, null, _this2.$router);
      }).then(function (res) {
        if (res === null) return;
        if (!res.success) {
          _this2.err = _this2.$lang.errors.failedCompanyPassword;
          return;
        }
        var companyData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.webShopResource);
        _this2.$storage.company = companyData;
        _this2.$store.dispatch('setCompany', companyData);
        _this2.$router.push({ name: 'webShop', query: { passwordSet: true } });
      });
    }
  },
  created: function created() {
    if (!this.$route.params.resourceId || !this.$route.params.id) {
      this.$router.push({ name: 'webShop' });
      return;
    }
    localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      method: 'email',
      valid: false,
      email: this.$route.query.email || '',
      phone: this.$route.query.phone || '',
      emailField: undefined,
      phoneField: undefined,
      emailRules: [
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }],
      err: '',
      success: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    company: 'company'
  }), {
    phoneNumberRules: function phoneNumberRules() {
      if (this.company && (this.phone || this.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.phone);
      }
      return this.$lang.errors.requiredPhone;
    },
    isValid: function isValid() {
      return !this[this.method + 'Field'] ? false : this[this.method + 'Field'].valid;
    }
  }),
  methods: {
    testPhoneNumberRules: function testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return [10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) && /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone) || this.$lang.errors.notValidPhone;
      }
      if (country === 'AT') {
        var tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
        if (tempPhone.substring(0, 2) === '00') {
          tempPhone = tempPhone.substring(2, tempPhone.length);
        }
        if (tempPhone.substring(0, 2) === '43') {
          tempPhone = '0' + tempPhone.substring(2, tempPhone.length);
        }
        var checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
        if (!checkPhone) {
          checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
        }
        return checkPhone || this.$lang.errors.notValidPhone;
      }
      return this.$lang.errors.countryUnsupported;
    },
    submit: function submit() {
      var _this2 = this;

      if (!this.isValid) return;
      if (!this.email && !this.phone) {
        this.err = this.$lang.errors.phoneOrEmail;
        return;
      }
      this.err = '';
      var data = {};
      if (this.method === 'email' && this.email) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { email: this.email });
      }
      if (this.method === 'phone' && this.phone) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(data, { phone: this.phone });
      }
      this.$webHelper.post('user/sendemailforresetpassword', data, this.$router).then(function (res) {
        if (!res.success) {
          // eslint-disable-next-line max-len
          _this2.err = res.body && res.body.statusText ? res.body.statusText : _this2.$lang.errors.failToSend;
          return;
        }
        _this2.success = _this2.$lang.success.sendSuccess;
        setTimeout(function () {
          _this2.success = '';
        }, 5000);
      });
    }
  },
  mounted: function mounted() {
    this.emailField = this.$refs.form.inputs.find(function (input) {
      return input.label === 'Email';
    });
    this.phoneField = this.$refs.form.inputs.find(function (input) {
      return input.label === 'Phone';
    });
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      name: '',
      email: this.$route.query.email || '',
      phone: '',
      checkbox: false,
      valid: false,
      nameRules: [function (v) {
        return !!v || _this.$lang.errors.nameMustHaveCharacters;
      }, function (v) {
        return v && v.length <= 35 || _this.$lang.errors.nameLess;
      }],
      emailRules: [function (v) {
        return !!v || _this.$lang.errors.requiredEmail;
      },
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }],
      err: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company'
  }), {
    phoneNumberRules: function phoneNumberRules() {
      if (this.company && (this.phone || this.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.phone);
      }
      return this.$lang.errors.requiredPhone;
    }
  }),
  methods: {
    testPhoneNumberRules: function testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return [10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) && /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone) || this.$lang.errors.notValidPhone;
      }
      if (country === 'AT') {
        var tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
        if (tempPhone.substring(0, 2) === '00') {
          tempPhone = tempPhone.substring(2, tempPhone.length);
        }
        if (tempPhone.substring(0, 2) === '43') {
          tempPhone = '0' + tempPhone.substring(2, tempPhone.length);
        }
        var checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
        if (!checkPhone) {
          checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
        }
        return checkPhone || this.$lang.errors.notValidPhone;
      }
      return this.$lang.errors.countryUnsupported;
    },
    inNewTab: function inNewTab(name) {
      var routeData = this.$router.resolve({ name: name, params: { lang: this.$lang.current_lang } });
      window.open(routeData.href, '_blank');
    },
    registerUser: function registerUser() {
      var _this2 = this;

      this.err = '';
      if (!this.valid) {
        if (!this.email || !this.phone || !this.name) {
          this.err = this.$lang.errors.enterData;
        }
        return;
      }
      if (!this.checkbox) {
        this.err = this.$lang.errors.acceptPolicy;
        return;
      }
      this.$webHelper.post('user/register', {
        phone: this.phone,
        name: this.name,
        userName: this.email,
        language: this.$lang.current_lang
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this2.err = res.body.statusText || _this2.$lang.errors.failedRegistration;
          return;
        }
        _this2.$router.push({ name: 'webShop', query: { registered: true } });
      });
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      valid: false,
      password: '',
      confirmPassword: '',
      invalid: false,
      passwordRules: [function (v) {
        return !!v || _this.$lang.errors.requiredPassword;
      }, function (v) {
        return v && v.length >= 6 && v.length <= 35 || _this.$lang.errors.passwordConditions;
      }],
      err: ''
    };
  },

  methods: {
    setPassword: function setPassword() {
      var _this2 = this;

      if (this.password !== this.confirmPassword) {
        this.err = this.$lang.errors.matchPasswords;
        return;
      }
      this.$webHelper.post('user/submitpassword', {
        activationId: this.$route.params.hash,
        password: this.password
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this2.err = _this2.$lang.errors.failedPassword;
          return;
        }
        __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].manualLogin(res.body.uuid);
        _this2.$router.push({ name: 'webShop', query: { passwordSet: true } });
      });
    }
  },
  created: function created() {
    var _this3 = this;

    if (!this.$route.params.resourceId || !this.$route.params.hash) {
      this.$router.push({ name: 'webShop' });
      return;
    }
    this.$webHelper.post('activation/activateuser', { activationId: this.$route.params.hash }, this.$router).then(function (res) {
      if (!res.success) {
        _this3.err = _this3.$lang.errors.invalidKey;
        _this3.invalid = true;
      }
    });
    this.$storage.catalog = null;
    this.$storage.order = null;
    this.$store.dispatch('clearCart');
    this.$storage.company = null;
    this.$store.dispatch('setCompany', null);
    localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
    this.$webHelper.get('webshopresource/fetchbyexternalid/' + this.$route.params.resourceId, null, this.$router).then(function (res) {
      if (!res.success) {
        _this3.err = _this3.$lang.errors.failedCompany;
        return;
      }
      var companyData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, res.body.company, res.body.webShopResource);
      _this3.$storage.company = companyData;
      _this3.$store.dispatch('setCompany', companyData);
    });
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Address__ = __webpack_require__(339);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Address: __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Address__["a" /* default */]
  },
  data: function data() {
    return {
      lastName: '',
      dialog: false,
      err: '',
      success: '',
      currentAddresses: [],
      phone: null,
      addressToEdit: undefined
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    contact: 'contact',
    addresses: 'addresses',
    addressesSet: 'addressesSet',
    width: 'width',
    company: 'company',
    goDark: 'goDark'
  }),
  methods: {
    addAddress: function addAddress() {
      this.dialog = true;
    },
    deleteAddress: function deleteAddress(index) {
      this.currentAddresses.splice(index, 1);
    },
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    editAddress: function editAddress(address, index) {
      this.addressToEdit = address;
      this.addressIndex = index;
      this.dialog = true;
    },
    closeDialog: function closeDialog() {
      this.addressToEdit = undefined;
      this.addressIndex = undefined;
      this.dialog = false;
    },
    submitAddress: function submitAddress(payload) {
      var address = payload;
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload);
      keys.forEach(function (key) {
        if (!address[key]) delete address[key];
      });
      if (typeof this.addressIndex !== 'undefined') {
        this.currentAddresses[this.addressIndex] = address;
      } else {
        this.currentAddresses.push(address);
      }
      this.closeDialog();
    },
    submit: function submit() {
      var _this = this;

      if (!this.phone || this.phone === '') {
        this.err = this.$lang.errors.requiredPhone;
        return;
      }
      if (!this.lastName || this.lastName === '') {
        this.err = this.$lang.errors.requiredName;
        return;
      }
      if (this.lastName.length > 34) {
        this.err = this.$lang.errors.nameLess;
        return;
      }
      this.$webHelper.post('contact/update', {
        address: this.currentAddresses,
        phone: this.phone,
        lastName: this.lastName
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this.err = _this.$lang.errors.failedAddress;
          return;
        }
        _this.$store.dispatch('setAddresses', _this.currentAddresses);
        _this.$store.dispatch('setContact', {
          lastName: _this.lastName,
          phone: _this.phone
        });
        _this.success = _this.$lang.success.addressUpdated;
      });
    }
  },
  watch: {
    err: function err() {
      var _this2 = this;

      setTimeout(function () {
        _this2.err = '';
      }, 3000);
    },
    success: function success() {
      var _this3 = this;

      setTimeout(function () {
        _this3.success = '';
      }, 3000);
    }
  },
  created: function created() {
    var _this4 = this;

    if (!__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].isLoggedIn()) {
      this.$router.push('/login');
      return;
    }
    if (this.addresses.length === 0 && !this.addressesSet) {
      this.$webHelper.get('contact/fetchforauser', null, this.$router).then(function (res) {
        if (!res.success) {
          _this4.err = _this4.$lang.errors.failedContactInfo;
          return;
        }
        _this4.currentAddresses = res.body.contact.address;
        _this4.phone = res.body.contact.phone;
        _this4.lastName = res.body.contact.lastName;
        _this4.$store.dispatch('setAddresses', _this4.currentAddresses);
        _this4.$store.dispatch('setContact', {
          lastName: _this4.lastName,
          phone: _this4.phone
        });
      });
    } else if (this.addressesSet) {
      this.currentAddresses = this.addresses;
      this.phone = this.contact.phone;
      this.lastName = this.contact.lastName;
    }
  },
  destroyed: function destroyed() {
    this.currentAddresses = [];
    this.phone = null;
    this.lastName = '';
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['address', 'postal'],
  data: function data() {
    var _this = this;

    return {
      resourceId: null,
      postalCodes: [],
      isLoadingAddress: false,
      formData: {
        country: '',
        postalCode: '',
        line1: '',
        line2: '',
        line3: '',
        line4: '',
        locality: '',
        townCity: '',
        latitude: '',
        longitude: ''
      },
      lastGoodPostal: '',
      validPostal: false,
      filtering: null,
      prefill: {
        original: [],
        filtered: []
      },
      linesUK: [{
        property: 'postalCode',
        label: this.$lang.labels.postalCode,
        required: true
      }, {
        property: 'line1',
        label: this.$lang.labels.line1,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2,
        required: false
      }, {
        property: 'line3',
        label: this.$lang.labels.line3,
        required: false
      }, {
        property: 'line4',
        label: this.$lang.labels.line4,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'locality',
        label: this.$lang.labels.locality,
        required: false
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      linesAT: [{
        property: 'postalCode',
        label: this.$lang.labels.postalCode,
        required: true
      }, {
        property: 'line1',
        label: this.$lang.labels.line1AT,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2AT,
        required: true
      }, {
        property: 'line3',
        label: this.$lang.labels.line3AT,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      required: [function (v) {
        return !!v || _this.$lang.errors.required;
      }],
      valid: false,
      err: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    postalCode: 'postalCode',
    company: 'company',
    goDark: 'goDark'
  }), {
    filteredLines: function filteredLines() {
      if (this.company.address.country === 'AT') {
        return this.linesAT.filter(function (line) {
          return ['postalCode', 'line1', 'line2', 'line3', 'townCity'].includes(line.property);
        });
      }
      return this.linesUK;
    }
  }),
  methods: {
    submit: function submit() {
      var _this2 = this;

      this.err = '';
      if (!this.validPostal) {
        this.err = this.$lang.errors.validPostalOrAddress;
        return;
      }
      var checkAddress = [];
      if (this.company.address.country === 'AT') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.line2 === address.line2 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (this.company.address.country === 'UK') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (checkAddress.length === 0 || checkAddress.length > 1) {
        this.err = this.$lang.errors.validPostalOrAddress;
        return;
      }
      if (!this.formData.country) {
        this.formData.country = this.company.address.country;
      }
      this.$emit('submit', this.formData);
      if (this.postalCode) {
        this.$store.dispatch('clearPostal');
      }
    },
    filterPrefill: function filterPrefill(value, target) {
      var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.prefill.original.length === 0) return;
      if (this.company.address.country === 'AT' && ['line3'].includes(target)) return;
      this.filtering = target;
      if (!value) {
        this.prefill.filtered = [];
        this.filtering = null;
        return;
      }
      // console.log('filter preffill 2', this.formData.postalCode);
      if (value === 'ALL_VALUES') {
        if (clear) {
          this.formData[target] = '';
        }
        this.prefill.filtered = this.prefill.original;
        return;
      }
      this.prefill.filtered = this.prefill.original.filter(function (address) {
        // eslint-disable-next-line max-len
        if (address[target] && address[target].toLowerCase().includes(value.toLowerCase().trim())) return address;
        return false;
      });
      // console.log('filter preffill 4', this.formData.postalCode);
    },
    getPrefill: function getPrefill(value, valueEvent, target) {
      var _this3 = this;

      if (target === 'postalCode') {
        this.getPostalCodes(valueEvent);
        return;
      }
      this.validPostal = false;
      this.prefill = {
        original: [],
        filtered: []
      };
      this.err = '';
      if (this.lastGoodPostal !== '' && this.lastGoodPostal !== value) {
        this.lastGoodPostal = '';
        this.formData.line1 = '';
        if (this.company.address.country === 'AT') {
          this.formData.line2 = '';
          this.formData.line3 = '';
          this.formData.townCity = '';
        }
      }
      if (!value) return;
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || this.formData.line1.length < 3) && this.company.address.country === 'AT') return;
      var payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
      { postalCode: value.trim().toUpperCase(), line1: this.formData.line1, country: this.company.address.country } : { postalCode: value.trim().toUpperCase(), country: this.company.address.country };
      this.formData.postalCode = value.trim().toUpperCase();
      var resourceId = localStorage.getItem('webShopResourceId');
      if (resourceId) {
        this.isLoadingAddress = true;
        this.$webHelper.post('address/' + resourceId, payload).then(function (res) {
          if (res.success) {
            _this3.validPostal = true;
            _this3.lastGoodPostal = value;
            _this3.formData.postalCode = _this3.formData.postalCode.charAt(0).toUpperCase() + _this3.formData.postalCode.slice(1);
            _this3.prefill.original = res.body.addresses.map(function (current) {
              var address = current;
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(address).forEach(function (key) {
                address[key] = address[key].trim();
              });
              return address;
            });
            if (_this3.company.address.country === 'AT') {
              _this3.$store.dispatch('setAddressesAT', res.body.addresses);
              if (_this3.filterUniqueFields(_this3.prefill.original, 'townCity').length === 1) {
                _this3.formData.townCity = _this3.filterUniqueFields(_this3.prefill.original, 'townCity')[0];
              }
            }
            _this3.isLoadingAddress = false;
            _this3.filterPrefill(valueEvent, target);
            return;
          }
          _this3.isLoadingAddress = false;
          _this3.validPostal = false;
        });
      }
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this4 = this;

      this.validPostal = false;
      if (!code) return;
      if (!this.resourceId) return;
      code.trim().toUpperCase();
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoadingAddress = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, { startswith: code.trim().toUpperCase() }).then(function (res) {
        if (res.body && res.status === 200) {
          if (res.body.postalCodes.length === 0) {
            _this4.isLoadingAddress = false;
            _this4.filtering = null;
            _this4.postalCodes = [];
          } else {
            if (res.body.postalCodes.filter(function (x) {
              return x === _this4.formData.postalCode;
            }).length === 0) {
              _this4.filtering = 'postalCode';
              _this4.postalCodes = res.body.postalCodes.sort();
            } else {
              setTimeout(function () {
                document.getElementById('1').focus();
              }, 50);
            }
            _this4.isLoadingAddress = false;
          }
        }
      }).catch(function (err) {
        _this4.err = err;
        _this4.isLoadingAddress = false;
      });
    },
    setPostalCode: function setPostalCode(code) {
      this.validPostal = true;
      this.lastGoodPostal = code;
      this.formData.postalCode = code;
      this.formData.line1 = '';
      this.formData.line2 = '';
      this.formData.line3 = '';
      this.formData.latitude = '';
      this.formData.longitude = '';
      this.filtering = 'line1';
      this.getPrefill(this.formData.postalCode, '', 'line1');
      setTimeout(function () {
        document.getElementById('1').focus();
      }, 500);
    },
    replaceAddress: function replaceAddress(address, property) {
      var _this5 = this;

      this.err = '';
      if (this.company.address.country === 'UK') {
        this.linesUK.forEach(function (input) {
          if (!address[input.property]) return;
          _this5.formData[input.property] = address[input.property];
        });
      } else if (this.company.address.country === 'AT') {
        this.formData[property] = address;
        switch (property) {
          case 'line1':
            this.formData.line2 = '';
            this.formData.line3 = '';
            this.formData.latitude = '';
            this.formData.longitude = '';
            setTimeout(function () {
              document.getElementById('2').focus();
            }, 50);
            break;
          // eslint-disable-next-line no-case-declarations
          case 'line2':
            this.formData.line3 = '';
            // eslint-disable-next-line max-len
            var chosenAddress = this.prefill.original.filter(function (x) {
              return x.line1 === _this5.formData.line1 && x.line2 === address;
            });
            if (chosenAddress.length === 0) {
              this.filtering = null;
              this.err = this.$lang.errors.validPostalOrAddress;
              return;
            }
            this.formData.latitude = chosenAddress[0].latitude;
            this.formData.longitude = chosenAddress[0].longitude;
            break;
          case 'line3':
            // code block
            break;
          case 'townCity':
            // code block
            break;
          default:
          // code block
        }
      }
      this.filtering = null;
    },
    filterUniqueFields: function filterUniqueFields(addresses, property) {
      if (this.company.address.country === 'UK') return addresses;
      var filteredFieldList = addresses.map(function (address) {
        return address[property];
      });
      // eslint-disable-next-line max-len
      filteredFieldList = filteredFieldList.filter(function (item, index) {
        return filteredFieldList.indexOf(item) === index;
      });
      return filteredFieldList;
    },
    generateAddress: function generateAddress(input) {
      var address = '';
      var tempKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(input);
      tempKeys.forEach(function (key, index) {
        if (['latitude', 'longitude', 'country'].includes(key)) address += '';else if (input[key]) address += tempKeys.length !== index - 1 ? ', ' + input[key].trim() : '' + input[key].trim();
      });
      address = address.substring(2, address.length);
      return address;
    }
  },
  created: function created() {
    var _this6 = this;

    this.resourceId = localStorage.getItem('webShopResourceId');
    if (typeof this.address !== 'undefined') {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.address).forEach(function (key) {
        _this6.formData[key] = _this6.address[key];
      });
      this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      return;
    }
    if (this.postalCode && this.postalCode.postalCode) {
      this.formData.postalCode = this.postalCode.postalCode.toUpperCase();
      this.formData.latitude = this.postalCode.latitude;
      this.formData.longitude = this.postalCode.longitude;
      this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      setTimeout(function () {
        document.getElementById('1').focus();
      }, 800);
    }
    if (this.postal) {
      this.formData.postalCode = this.postal.toUpperCase();
      this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      setTimeout(function () {
        document.getElementById('1').focus();
      }, 50);
    } else {
      setTimeout(function () {
        document.getElementById('0').focus();
      }, 200);
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_webshop_modals_AddressInline__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_webshop_modals_Allergens__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_webshop_modals_Time__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__auth__ = __webpack_require__(7);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddressInline: __WEBPACK_IMPORTED_MODULE_8__components_webshop_modals_AddressInline__["a" /* default */],
    Time: __WEBPACK_IMPORTED_MODULE_10__components_webshop_modals_Time__["a" /* default */],
    Allergens: __WEBPACK_IMPORTED_MODULE_9__components_webshop_modals_Allergens__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      isLoading: false,
      firstNameRules: [function (v) {
        return v && v.length <= 35 || v === '' || _this.$lang.errors.nameLess;
      }],
      lastNameRules: [function (v) {
        return !!v || _this.$lang.errors.required;
      }, function (v) {
        return v && v.length <= 35 || _this.$lang.errors.nameLess;
      }],
      emailRules: [function (v) {
        return !!v || _this.$lang.errors.requiredEmail;
      },
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }],
      err: '',
      success: '',
      total: 0,
      select: null,
      submitted: false,
      validPostal: false,
      chosenAddress: undefined,
      contact: undefined,
      email: '',
      phone: '',
      agreement: false,
      firstName: '',
      lastName: '',
      valid: true,
      deliveryCharges: 0,
      distanceInMiles: 0,
      orderTime: -1,
      timeDialog: false,
      paymentMethod: undefined,
      selectAddress: '',
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_11__auth__["a" /* default */].isLoggedIn(),
      items: [],
      discount: 0,
      description: '',
      totalAmountWithoutDiscount: 0,
      discountRuleName: '',
      voucher: '',
      zone: __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz.guess(),
      canGoIntoNextDay: false,
      htmlHints: [],
      formatedHtmlHints: {},
      allergensDialog: false,
      allergens: [],
      postalCodes: [],
      search: null,
      searchAddress: null,
      hint: '',
      postalcode: '',
      resourceId: null,
      defaultPaymentType: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])({
    orderInfo: 'orderInfo',
    width: 'width',
    company: 'company',
    addresses: 'addresses',
    addressesAT: 'addressesAT',
    selectedAddress: 'selectedAddress',
    closed: 'closed',
    closedMessage: 'closedMessage',
    postalCode: 'postalCode',
    remainingWorkingRanges: 'remainingWorkingRanges',
    workingHours: 'currentWorkingHours',
    tomorrowsWorkingHours: 'tomorrowsWorkingHours',
    userData: 'userData',
    catalog: 'catalog',
    goDark: 'goDark'
  }), {
    postalCodeRules: function postalCodeRules() {
      if (this.company && this.postalcode) {
        if (this.testPostalCodeRules(this.company.address.country, this.postalcode) !== true) this.startErrorAnimation('elPostalAutocomplete');
        return this.testPostalCodeRules(this.company.address.country, this.postalcode);
      }
      return this.$lang.errors.invalidZip;
    },
    phoneNumberRules: function phoneNumberRules() {
      if (this.company && (this.phone || this.phone !== '')) {
        return this.testPhoneNumberRules(this.company.address.country, this.phone);
      }
      return this.$lang.errors.requiredPhone;
    },
    showInfoPre: function showInfoPre() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page2.prefix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page2.prefix.de'];
      }
      return false;
    },
    showInfoPost: function showInfoPost() {
      if (this.$lang.current_lang === 'en') {
        return !!this.formatedHtmlHints['webshop.page2.postfix.en'];
      }
      if (this.$lang.current_lang === 'de') {
        return !!this.formatedHtmlHints['webshop.page2.postfix.de'];
      }
      return false;
    }
  }),
  methods: {
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this2 = this;

      if (!code) return;
      code.trim().toUpperCase();
      this.hint = '';
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoading = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, {
        startswith: code.trim().toUpperCase()
      }).then(function (res) {
        if (res.body && res.status === 200) {
          if (res.body.postalCodes.length === 0) {
            _this2.hint = _this2.$lang.errors.noPostalFound;
            _this2.isLoading = false;
          } else {
            if (res.body.postalCodes.filter(function (x) {
              return x === _this2.postalcode;
            }).length === 0) {
              _this2.postalCodes = res.body.postalCodes;
            }
            _this2.isLoading = false;
          }
        }
      }).catch(function (err) {
        _this2.err = err;
        _this2.isLoading = false;
      });
    },
    getPrefill: function getPrefill(value) {
      var _this3 = this;

      if (!value) return;
      if (this.fromBack) {
        this.fromBack = false;
        return;
      }
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || !this.searchAddress || this.searchAddress.length < 3) && this.company.address.country === 'AT') return;
      if (this.searchAddress && this.searchAddress.split(',').length === 4 && this.company.address.country === 'AT') return;
      var payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
      { postalCode: value.toUpperCase(), line1: this.searchAddress, country: this.company.address.country } : { postalCode: value.toUpperCase(), country: this.company.address.country };
      if (this.resourceId) {
        this.$webHelper.post('address/' + this.resourceId, payload).then(function (res) {
          if (res.body && res.status === 200 && res.body.addresses) {
            _this3.hint = _this3.$lang.success.postalSet;
            _this3.latitude = res.body.addresses[0].latitude;
            _this3.longitude = res.body.addresses[0].longitude;
            _this3.isLoading = false;
            _this3.$store.dispatch('addPostal', {
              postalCode: _this3.postalcode,
              latitude: _this3.latitude || res.body.addresses[0].latitude,
              longitude: _this3.longitude || res.body.addresses[0].longitude
            });
            _this3.$store.dispatch('setAddressesAT', res.body.addresses);
          } else {
            _this3.hint = res.body.statusText;
            _this3.isLoading = false;
          }
        }).catch(function (err) {
          _this3.err = err;
          _this3.isLoading = false;
        });
      }
    },
    onBlurPostal: function onBlurPostal() {
      if (this.postalCodes.includes(this.search)) {
        this.postalcode = this.search;
        this.getPrefill(this.postalcode);
      }
    },
    testPostalCodeRules: function testPostalCodeRules(country, zip) {
      if (!zip) return this.$lang.errors.zipRequired;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return zip.length > 5 && zip.length < 16;
      }
      if (country === 'AT') {
        return zip.length === 4;
      }
      return this.$lang.errors.countryUnsupported;
    },
    openAllergens: function openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    selectCartItem: function selectCartItem(index) {
      this.$store.dispatch('selectItem', index);
    },
    formatHtmlHints: function formatHtmlHints() {
      for (var i = 0; i < this.htmlHints.length; i += 1) {
        this.formatedHtmlHints[this.htmlHints[i].name] = '<v-flex xs1><i class="material-icons pr-3">info</i></v-flex><v-flex xs11>' + this.htmlHints[i].value + '</v-flex>';
      }
    },
    testPhoneNumberRules: function testPhoneNumberRules(country, phone) {
      if (!phone) return this.$lang.errors.requiredPhone;
      if (!country) return this.$lang.errors.countryRequired;
      if (country === 'UK') {
        return [10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) && /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone) || this.$lang.errors.notValidPhone;
      }
      if (country === 'AT') {
        var tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
        if (tempPhone.substring(0, 2) === '00') {
          tempPhone = tempPhone.substring(2, tempPhone.length);
        }
        if (tempPhone.substring(0, 2) === '43') {
          tempPhone = '0' + tempPhone.substring(2, tempPhone.length);
        }
        var checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
        if (!checkPhone) {
          checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
        }
        return checkPhone || this.$lang.errors.notValidPhone;
      }
      return this.$lang.errors.countryUnsupported;
    },
    formatOrderTime: function formatOrderTime(time) {
      if (time === -1) return this.$lang.labels.asSoon;
      return time.format('HH:mm');
    },
    inNewTab: function inNewTab(name) {
      var routeData = this.$router.resolve({ name: name });
      window.open(routeData.href, '_blank');
    },
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    orderTimeLabel: function orderTimeLabel() {
      return this.$lang.actions[this.orderInfo.orderType];
    },
    checkExistingAddress: function checkExistingAddress(address) {
      var _this4 = this;

      var addressFound = false;
      if (this.addresses && this.addresses.length > 0) {
        this.addresses.forEach(function (current) {
          // eslint-disable-next-line max-len
          if (_this4.generateFullAddress(address) === _this4.generateFullAddress(current)) addressFound = true;
        });
      }
      return addressFound;
    },
    generateFullAddress: function generateFullAddress(address) {
      var lines = this.generateAddress([address.line1, address.line2, address.line3, address.line4]);
      var fullAdderss = lines;
      if (address.locality) {
        fullAdderss += ', ' + address.locality;
      }
      return fullAdderss + ', ' + address.townCity + ', ' + address.postalCode;
    },
    submitAddress: function submitAddress(address) {
      this.chosenAddress = address;
      this.$store.dispatch('addPostal', {
        postalCode: this.postalcode,
        latitude: this.latitude,
        longitude: this.longitude
      });
      this.$store.dispatch('setAddressesAT', [address]);
      this.$store.dispatch('chooseAddress', 0);
      this.closeDialog('address');
    },
    submitTime: function submitTime(time) {
      this.orderTime = time;
      this.closeDialog('time');
    },
    deleteAddress: function deleteAddress() {
      this.chosenAddress = undefined;
      this.deliveryCharges = 0;
      this.selectAddress = '';
    },
    closeDialog: function closeDialog(type) {
      this.$store.dispatch('setModal', false);
      if (type === 'allergens') {
        this.allergens = [];
        this.allergensDialog = false;
      } else {
        this.timeDialog = false;
      }
    },
    goBack: function goBack() {
      this.$router.push({ name: 'webShop', params: { fromBack: true, address: this.chosenAddress } });
    },
    findNextWorkingTime: function findNextWorkingTime(picked) {
      var foundHours = void 0;
      this.workingHours.forEach(function (range) {
        if (!foundHours && (__WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(range.startDate).isAfter(picked) || range.startDate === picked.toISOString())) {
          foundHours = range.start;
        }
      });
      return foundHours;
    },
    doubleDigits: function doubleDigits(time) {
      return ('' + time).length === 1 ? '0' + time : time;
    },
    isInWorkingHours: function isInWorkingHours(picked) {
      var _this5 = this;

      var inside = false;
      this.workingHours.forEach(function (entry) {
        var start = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(entry.startDate);
        var end = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(entry.endDate);
        if (picked.isBetween(start, end) || picked.toISOString() === entry.startDate) {
          inside = true;
        }
        if (!inside && start.isBefore(picked) && entry.end === 2359 && _this5.canGoIntoNextDay) {
          inside = true;
        }
      });
      return inside;
    },
    cleanUp: function cleanUp() {
      this.submitted = false;
      this.$storage.order = null;
      this.$store.dispatch('clearCart');
      this.$router.push({ name: 'webShop', query: { orderSuccessful: true } });
    },
    submit: function submit() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isLoggedIn, data, durationFrom, currentTime, foundHours, now, orderHours, totalCalc, order, items, contact, phone, total, res, ordercompletedlink, addAddress, postAddresses, payload, form, payloadKeys, i, input;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this6.err = '';

                if (!(_this6.closed && _this6.remainingWorkingRanges === 0 || _this6.submitted)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                if (!(_this6.company.webShopResourceStatus !== 'active')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                isLoggedIn = __WEBPACK_IMPORTED_MODULE_11__auth__["a" /* default */].isLoggedIn();

                if (!(isLoggedIn && !_this6.contact)) {
                  _context.next = 9;
                  break;
                }

                _this6.err = _this6.$lang.errors.choseContact;
                return _context.abrupt('return');

              case 9:
                if (!(!isLoggedIn && !_this6.agreement)) {
                  _context.next = 12;
                  break;
                }

                _this6.err = _this6.$lang.errors.acceptAgreement;
                return _context.abrupt('return');

              case 12:
                if (!(_this6.orderInfo.orderType === 'delivery')) {
                  _context.next = 22;
                  break;
                }

                if (_this6.chosenAddress) {
                  _context.next = 16;
                  break;
                }

                _this6.err = _this6.$lang.errors.addAddress;
                return _context.abrupt('return');

              case 16:
                if (_this6.validPostal) {
                  _context.next = 19;
                  break;
                }

                _this6.err = _this6.$lang.errors.validPostal;
                return _context.abrupt('return');

              case 19:
                if (!(_this6.company && _this6.company.minDeliveryAmount && _this6.total < parseFloat(_this6.company.minDeliveryAmount))) {
                  _context.next = 22;
                  break;
                }

                _this6.err = _this6.$lang.errors.totalOver + ' ' + parseFloat(_this6.company.minDeliveryAmount).toFixed(2) + ' ' + _this6.$lang.errors.thisDelivery;
                return _context.abrupt('return');

              case 22:
                if (isLoggedIn) {
                  _context.next = 36;
                  break;
                }

                if (_this6.phone) {
                  _context.next = 26;
                  break;
                }

                _this6.err = _this6.$lang.errors.enterPhone;
                return _context.abrupt('return');

              case 26:
                if (_this6.email) {
                  _context.next = 29;
                  break;
                }

                _this6.err = _this6.$lang.errors.enterEmail;
                return _context.abrupt('return');

              case 29:
                if (_this6.lastName) {
                  _context.next = 32;
                  break;
                }

                _this6.err = _this6.$lang.errors.enterLastName;
                return _context.abrupt('return');

              case 32:
                if (_this6.valid) {
                  _context.next = 34;
                  break;
                }

                return _context.abrupt('return');

              case 34:
                data = {
                  first: _this6.firstName || '',
                  last: _this6.lastName || '',
                  email: _this6.email || '',
                  phone: _this6.phone || ''
                };

                localStorage.customerData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data);

              case 36:
                if (_this6.paymentMethod) {
                  _context.next = 39;
                  break;
                }

                _this6.err = _this6.$lang.errors.enterPayment;
                return _context.abrupt('return');

              case 39:
                _this6.submitted = true;

                if (!(_this6.orderTime !== -1 && !_this6.isInWorkingHours(_this6.orderTime))) {
                  _context.next = 44;
                  break;
                }

                _this6.err = _this6.$lang.errors.workingHours;
                _this6.submitted = false;
                return _context.abrupt('return');

              case 44:
                durationFrom = _this6.company.deliveryDurationFrom;

                if (!(_this6.orderTime === -1)) {
                  _context.next = 61;
                  break;
                }

                _this6.orderTime = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()().add(durationFrom, 'minutes');
                currentTime = _this6.orderTime;

                if (_this6.isInWorkingHours(currentTime)) {
                  _context.next = 61;
                  break;
                }

                foundHours = _this6.findNextWorkingTime(currentTime);

                if (foundHours) {
                  _context.next = 54;
                  break;
                }

                _this6.err = _this6.$lang.errors.restaurantReceiving;
                _this6.submitted = false;
                return _context.abrupt('return');

              case 54:
                now = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()();
                orderHours = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(now.format('YYYY-MM-DD') + ' ' + foundHours, 'YYYY-MM-DD HH:mm').add(durationFrom, 'minutes');

                if (_this6.isInWorkingHours(orderHours)) {
                  _context.next = 60;
                  break;
                }

                _this6.err = _this6.$lang.errors.restaurantReceiving;
                _this6.submitted = false;
                return _context.abrupt('return');

              case 60:
                _this6.orderTime = orderHours;

              case 61:
                _context.next = 63;
                return _this6.calcAll(true);

              case 63:
                totalCalc = _context.sent;

                if (totalCalc) {
                  _context.next = 67;
                  break;
                }

                _this6.submitted = false;
                return _context.abrupt('return');

              case 67:
                order = {};
                items = _this6.orderInfo.items.map(function (current, index) {
                  var item = current;
                  item.itemId = index;
                  return item;
                });

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(order, {
                  items: items,
                  comment: _this6.orderInfo.comment || '',
                  type: _this6.orderInfo.orderType
                });
                contact = {};
                phone = _this6.phone.replace(/\//g, '-');

                if (_this6.orderInfo.orderType === 'delivery') {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, { address: _this6.chosenAddress });
                }
                if (_this6.contact) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, {
                    contactId: _this6.contact.id,
                    firstName: _this6.contact.firstName,
                    lastName: _this6.contact.lastName,
                    phone: _this6.contact.phone.replace(/\//g, '-'),
                    email: _this6.contact.email
                  });
                } else {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, { lastName: _this6.lastName });
                  if (_this6.firstName) {
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, { firstName: _this6.firstName });
                  }
                  if (_this6.email) {
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, { email: _this6.email });
                  }
                  if (_this6.phone) {
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(contact, { phone: phone });
                  }
                  _this6.$store.dispatch('setUserData', {
                    firstName: _this6.firstName,
                    lastName: _this6.lastName,
                    phone: phone,
                    email: _this6.email
                  });
                }
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(order, {
                  contact: contact,
                  deliveryTime: _this6.orderTime.toISOString(),
                  driverNote: '',
                  deliveryCharges: _this6.deliveryCharges,
                  distanceInMiles: _this6.distanceInMiles
                });
                total = _this6.total.toFixed(2);

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(order, {
                  payments: [{
                    paymentType: _this6.paymentMethod,
                    amount: total
                  }],
                  totalAmount: parseFloat(total)
                });
                if (_this6.voucher) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(order, {
                    voucher: _this6.voucher,
                    discount: _this6.discount,
                    discountRuleName: _this6.discountRuleName,
                    totalAmountWithoutDiscount: _this6.totalAmountWithoutDiscount.toFixed(2)
                  });
                }
                if (localStorage.tokenId) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(order, {
                    tokenId: JSON.parse(localStorage.tokenId).tokenId
                  });
                }
                _context.next = 81;
                return _this6.$webHelper.post('order/create', order, _this6.$router);

              case 81:
                res = _context.sent;

                if (res.success) {
                  _context.next = 86;
                  break;
                }

                // eslint-disable-next-line max-len
                _this6.err = res.body && res.body.statusText ? res.body.statusText : _this6.$lang.errors.failedOrder;
                _this6.submitted = false;
                return _context.abrupt('return');

              case 86:
                localStorage.removeItem('webshop_voucher');
                ordercompletedlink = localStorage.ordercompletedlink ? JSON.parse(localStorage.ordercompletedlink) : false;

                if (ordercompletedlink) {
                  ordercompletedlink.orderId = res.body.orderId;
                  localStorage.ordercompletedlink = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(ordercompletedlink);
                }
                if (isLoggedIn && _this6.orderInfo.orderType === 'delivery') {
                  addAddress = _this6.checkExistingAddress(_this6.chosenAddress);

                  if (!addAddress) {
                    postAddresses = _this6.addresses;

                    postAddresses.push(_this6.chosenAddress);
                    _this6.$webHelper.post('contact/update', {
                      address: postAddresses,
                      phone: phone,
                      lastName: _this6.contact.lastName
                    }, _this6.$router).then(function (res2) {
                      if (!res2.success) {
                        _this6.err = _this6.$lang.errors.failedAddress;
                      }
                    });
                  }
                }

                if (!(_this6.paymentMethod.toLowerCase() === 'card' && _this6.company.paymentGateway !== null && res.body.hostedPaymentFormURL)) {
                  _context.next = 94;
                  break;
                }

                if (res.body.paymentMethod === 'GET') {
                  window.location = res.body.hostedPaymentFormURL;
                }
                if (res.body.paymentMethod === 'POST' && res.body.paymentParameters !== null) {
                  payload = res.body.paymentParameters;
                  form = document.createElement('form');

                  form.style.visibility = 'hidden'; // no user interaction is necessary
                  form.method = 'POST'; // forms by default use GET query strings
                  form.action = res.body.hostedPaymentFormURL;
                  payloadKeys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload);
                  // eslint-disable-next-line no-undef,guard-for-in,no-restricted-syntax

                  for (i = 0; i < payloadKeys.length; i += 1) {
                    input = document.createElement('input');

                    input.name = payloadKeys[i];
                    input.value = payload[payloadKeys[i]];
                    form.appendChild(input); // add key/value pair to form
                  }
                  document.body.appendChild(form); // forms cannot be submitted outside of body
                  form.submit(); // send the payload and navigate
                }
                return _context.abrupt('return');

              case 94:
                _this6.cleanUp();

              case 95:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    calcDelivery: function calcDelivery() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var totalAmount, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this7.calcTotalWithoutDelivery();

              case 2:
                totalAmount = _context2.sent;

                if (!(totalAmount === null)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', true);

              case 5:
                _context2.next = 7;
                return _this7.$webHelper.post('order/calculatedeliverycharges', {
                  latitude: _this7.chosenAddress ? _this7.chosenAddress.latitude : _this7.postalCode.latitude,
                  longitude: _this7.chosenAddress ? _this7.chosenAddress.longitude : _this7.postalCode.longitude,
                  postalCode: _this7.chosenAddress ? _this7.chosenAddress.postalCode : _this7.postalCode.postalCode,
                  country: _this7.chosenAddress ? _this7.chosenAddress.country : _this7.company.address.country,
                  totalAmount: totalAmount
                }, _this7.$router);

              case 7:
                res = _context2.sent;

                if (res.success) {
                  _context2.next = 14;
                  break;
                }

                _this7.validPostal = false;
                _this7.err = _this7.$lang.errors.failedCalculate2;
                _this7.distanceInMiles = 0;
                _this7.deliveryCharges = 0;
                return _context2.abrupt('return', false);

              case 14:
                _this7.validPostal = true;
                _this7.distanceInMiles = res.body.distanceInMiles;
                _this7.deliveryCharges = res.body.deliveryCharges;
                return _context2.abrupt('return', true);

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    calcTotalWithoutDelivery: function calcTotalWithoutDelivery() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = {
                  items: _this8.orderInfo.items.map(function (current, index) {
                    var item = current;
                    item.itemId = index;
                    return item;
                  }),
                  type: _this8.orderInfo.orderType,
                  paymentMethod: _this8.paymentMethod
                };
                _context3.next = 3;
                return _this8.$webHelper.post('order/calculatetotalamount', data, _this8.$router);

              case 3:
                res = _context3.sent;
                return _context3.abrupt('return', !res.success ? null : res.body.itemsTotalAmount);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },
    calcTotal: function calcTotal(isSubmit) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = {
                  items: _this9.orderInfo.items.map(function (current, index) {
                    var item = current;
                    item.itemId = index;
                    return item;
                  }),
                  deliveryCharges: _this9.deliveryCharges,
                  distanceInMiles: _this9.distanceInMiles,
                  type: _this9.orderInfo.orderType,
                  paymentMethod: _this9.paymentMethod
                };

                if (_this9.voucher) {
                  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data, { voucher: _this9.voucher });
                }
                _context4.next = 4;
                return _this9.$webHelper.post('order/calculatetotalamount', data, _this9.$router);

              case 4:
                res = _context4.sent;

                if (res.success) {
                  _context4.next = 9;
                  break;
                }

                if (res.body && res.body.statusText && res.body.statusText.includes('Invalid Voucher')) {
                  localStorage.removeItem('webshop_voucher');
                }
                if (isSubmit) {
                  // eslint-disable-next-line max-len
                  _this9.err = res.body && res.body.statusText ? res.body.statusText : _this9.$lang.errors.calculateServer;
                } else {
                  _this9.warn = _this9.$lang.errors.calculateServer;
                }
                return _context4.abrupt('return', false);

              case 9:
                _this9.total = res.body.totalAmount;
                _this9.totalAmountWithoutDiscount = res.body.totalAmountWithoutDiscount;
                _this9.discount = res.body.totalDiscountAmount;
                _this9.discountRuleName = res.body.discountRuleName;
                _this9.description = res.body.discountRuleDescription;
                if (_this9.voucher) {
                  localStorage.setItem('webshop_voucher', _this9.voucher);
                } else {
                  localStorage.removeItem('webshop_voucher');
                }
                return _context4.abrupt('return', true);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    calcTotalOffline: function calcTotalOffline() {
      var _this10 = this;

      this.total = this.orderInfo.items.length === 0 ? 0 : this.orderInfo.items.reduce(function (total, current) {
        return total + _this10.$store.state.calculatePrice(current.selectedSize, current.selectedVariants, current.selectedOptions, current.quantity, current.quantityOfIncludedOptions);
      }, 0);
      this.totalAmountWithoutDiscount = this.total;
    },
    calcAll: function calcAll() {
      var _this11 = this;

      var isSubmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var deliveryRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this11.orderInfo.orderType === 'delivery' && (_this11.postalCode || _this11.chosenAddress && _this11.chosenAddress.postalCode))) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 3;
                return _this11.calcDelivery();

              case 3:
                deliveryRes = _context5.sent;

                if (deliveryRes) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt('return', false);

              case 6:
                return _context5.abrupt('return', _this11.calcTotal(isSubmit));

              case 7:
                _this11.distanceInMiles = 0;
                _this11.deliveryCharges = 0;
                return _context5.abrupt('return', _this11.calcTotal(isSubmit));

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    setPayment: function setPayment() {
      if (!this.company.paymentTypes) return;
      if (this.company.defaultPaymentType) this.paymentMethod = this.company.defaultPaymentType;
      if (this.company.defaultPaymentType) {
        this.paymentMethod = this.company.defaultPaymentType;
      } else {
        this.paymentMethod = this.company.paymentTypes[0];
      }
    },
    removeAddress: function removeAddress() {
      if (this.search && this.postalcode === this.search.trim()) return;
      this.chosenAddress = undefined;
      this.line1 = '';
      if (this.selectAddress) {
        var tempPostal = this.selectAddress.split(',')[4];
        if (tempPostal.trim() !== this.postalcode) {
          this.selectAddress = null;
          this.$store.dispatch('removeAddress');
        }
      }
    },

    // eslint-disable-next-line consistent-return
    findPos: function findPos(obj) {
      var curtop = 0;
      if (obj.offsetParent) {
        // eslint-disable-next-line no-cond-assign
        do {
          curtop += obj.offsetTop;
          // eslint-disable-next-line no-param-reassign
        } while (obj = obj.offsetParent);
        return [curtop];
      }
      return [curtop];
    }
  },
  watch: {
    search: {
      handler: function handler(val) {
        if (val) {
          this.search = this.search.trim();
        }
        this.getPostalCodes(val);
        if (!__WEBPACK_IMPORTED_MODULE_11__auth__["a" /* default */].isLoggedIn()) {
          this.removeAddress();
        }
      },

      deep: true
    },
    searchAddress: {
      handler: function handler(val) {
        if (val) {
          this.searchAddress = this.searchAddress.trim();
        }
        this.getPrefill(this.postalcode);
      },

      deep: true
    },
    selectAddress: function selectAddress(newValue) {
      var _this12 = this;

      this.contact.address.forEach(function (current) {
        if (_this12.generateFullAddress(current) === newValue) {
          _this12.chosenAddress = current;
        }
      });
    },
    chosenAddress: function chosenAddress() {
      if (this.chosenAddress !== undefined) {
        this.calcAll();
      }
    },
    paymentMethod: function paymentMethod() {
      this.calcAll();
    },
    postalcode: function postalcode() {
      this.validPostal = null;
      this.postalcode = this.postalcode ? this.postalcode.trim() : '';
    },
    err: function err() {
      var _this13 = this;

      setTimeout(function () {
        _this13.err = '';
      }, 7000);
    }
  },
  created: function created() {
    var _this14 = this;

    setTimeout(function () {
      window.scroll(0, _this14.findPos(document.getElementById('headerCard')) - 8);
    }, 400);
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (this.company && this.company.htmlHints) {
      this.htmlHints = this.company.htmlHints;
      this.formatHtmlHints();
    }
    if (this.orderInfo.items.length === 0 || (this.closed || this.closedMessage) && this.remainingWorkingRanges.length === 0 || this.orderInfo.orderType === 'delivery' && !this.postalCode && this.selectedAddress === null) {
      this.$router.push({ name: 'webShop' });
      return;
    }
    if (this.userData) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.userData).forEach(function (key) {
        _this14[key] = _this14.userData[key] !== 'undefined' ? _this14.userData[key] : '';
      });
    }
    this.setPayment();
    var day1End = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(this.workingHours[this.workingHours.length - 1].endDate);
    if (this.tomorrowsWorkingHours[0]) {
      var day2Start = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default()(this.tomorrowsWorkingHours[0].startDate).add(1, 'day');
      var duration = __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.duration(day2Start.diff(day1End)).asMinutes();
      this.canGoIntoNextDay = duration === 1;
    }
    var voucher = localStorage.getItem('webshop_voucher');
    if (voucher) {
      this.voucher = voucher;
    }
    this.calcAll();
    if (__WEBPACK_IMPORTED_MODULE_11__auth__["a" /* default */].isLoggedIn()) {
      this.$webHelper.get('contact/fetchforauser', null, this.$router).then(function (res) {
        if (!res.success) {
          _this14.err = _this14.$lang.errors.failedContactInfo;
          return;
        }
        _this14.contact = res.body.contact;
        var data = {
          first: _this14.contact.firstName || '',
          last: _this14.contact.lastName || '',
          email: _this14.contact.email || '',
          phone: _this14.contact.phone || ''
        };
        localStorage.customerData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data);
        _this14.phone = res.body.contact.phone;
      });
      if (this.selectedAddress !== null) {
        this.chosenAddress = this.addressesAT[0];
        this.chosenAddress.postalCode = this.postalCode.postalCode;
        this.postalcode = this.postalCode.postalCode;
      }
    } else if (this.selectedAddress !== null) {
      if (this.$route.params.isCompeteAddress) {
        this.chosenAddress = this.addressesAT.find(function (x) {
          return x.latitude === _this14.postalCode.latitude && x.longitude === _this14.postalCode.longitude;
        });
      } else {
        this.chosenAddress = {};
      }
      this.chosenAddress.postalCode = this.postalCode.postalCode;
      this.postalCodes = [this.postalCode.postalCode];
      this.postalcode = this.postalCode.postalCode;
    }
    if (!__WEBPACK_IMPORTED_MODULE_11__auth__["a" /* default */].isLoggedIn()) {
      if (localStorage.customerData) {
        var data = JSON.parse(localStorage.customerData);
        this.firstName = data.first || '';
        this.lastName = data.last || '';
        this.email = data.email || '';
        this.phone = data.phone || '';
        setTimeout(function () {
          document.getElementById('firstName').focus();
        }, 20);
        setTimeout(function () {
          document.getElementById('lastName').focus();
        }, 40);
        setTimeout(function () {
          document.getElementById('email').focus();
        }, 60);
        setTimeout(function () {
          document.getElementById('phone').focus();
        }, 80);
        setTimeout(function () {
          document.getElementById('firstName').focus();
        }, 100);
      }
    }
  },
  destroyed: function destroyed() {
    this.$store.dispatch('setModal', false);
    if (this.success) {
      this.cleanUp();
    } else {
      this.$store.dispatch('setUserData', {
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        email: this.email
      });
    }
  }
});

/***/ }),
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['address', 'postal', 'fullAddress', 'fromBack'],
  data: function data() {
    var _this = this;

    return {
      fullAddressLocal: false,
      resourceId: null,
      postalCodes: [],
      isLoadingAddress: false,
      formData: {
        country: '',
        postalCode: '',
        line1: '',
        line2: '',
        line3: '',
        line4: '',
        locality: '',
        townCity: '',
        latitude: '',
        longitude: ''
      },
      lastGoodPostal: '',
      validPostal: false,
      filtering: null,
      prefill: {
        original: [],
        filtered: []
      },
      linesUK: [{
        property: 'line1',
        label: this.$lang.labels.line1,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2,
        required: false
      }, {
        property: 'line3',
        label: this.$lang.labels.line3,
        required: false
      }, {
        property: 'line4',
        label: this.$lang.labels.line4,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'locality',
        label: this.$lang.labels.locality,
        required: false
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      linesAT: [{
        property: 'line1',
        label: this.$lang.labels.line1AT,
        required: true
      }, {
        property: 'line2',
        label: this.$lang.labels.line2AT,
        required: true
      }, {
        property: 'line3',
        label: this.$lang.labels.line3AT,
        required: false
      }, {
        property: 'townCity',
        label: this.$lang.labels.townCity,
        required: true
      }, {
        property: 'latitude',
        label: this.$lang.labels.latitude,
        required: true
      }, {
        property: 'longitude',
        label: this.$lang.labels.longitude,
        required: true
      }],
      required: [function (v) {
        return !!v || _this.$lang.errors.required;
      }],
      valid: false,
      err: '',
      onReplaceAddressUK: false,
      onlyOnce: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    postalCode: 'postalCode',
    company: 'company',
    goDark: 'goDark'
  }), {
    filteredLines: function filteredLines() {
      if (this.company && this.company.address.country === 'AT') {
        return this.linesAT.filter(function (line) {
          return ['postalCode', 'line1', 'line2', 'line3', 'townCity'].includes(line.property);
        });
      }
      return this.linesUK;
    }
  }),
  watch: {
    postal: {
      handler: function handler(val) {
        if (val) {
          this.formData.postalCode = this.postal;
          this.validPostal = true;
          this.getPrefill(this.formData.postalCode, '', 'line1');
        }
      },

      deep: true
    },
    valid: {
      handler: function handler(val) {
        if (val) {
          this.submit();
        }
      },

      deep: true
    },
    address: {
      handler: function handler(val) {
        if (val && this.onlyOnce) {
          this.onlyOnce = false;
          this.initAddress();
        }
      },

      deep: true
    }
  },
  methods: {
    requiredCheck: function requiredCheck(line, index) {
      if (this.formData[line] !== '') return true;
      this.startErrorAnimation('el-' + index);
      return 'Required!';
    },
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.err = '';
      if (!this.formData.postalCode && this.formData.line1 !== '' && this.formData.line2 !== '' && this.formData.townCity !== '') {
        if (!this.fromBack) {
          this.err = this.$lang.errors.validPostalOrAddress;
          return;
        }
      }
      var checkAddress = [];
      if (this.company && this.company.address.country === 'AT') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.line2 === address.line2 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (this.company && this.company.address.country === 'UK') {
        // eslint-disable-next-line max-len
        checkAddress = this.prefill.original.filter(function (address) {
          return _this2.formData.line1 === address.line1 && _this2.formData.townCity === address.townCity && _this2.formData.latitude === address.latitude && _this2.formData.longitude === address.longitude;
        });
      }
      if (!this.fullAddressLocal && (checkAddress.length === 0 || checkAddress.length > 1) && this.formData.line1 !== '' && this.formData.line2 !== '' && this.formData.townCity !== '') {
        if (!this.fromBack) {
          this.err = this.$lang.errors.validPostalOrAddress;
          if (this.company && this.company.address.country === 'UK') {
            this.startErrorAnimation('el-0');
            this.startErrorAnimation('el-4');
          } else {
            this.startErrorAnimation('el-0');
            this.startErrorAnimation('el-1');
            this.startErrorAnimation('el-3');
          }
          return;
        }
      }
      if (this.fromBack) {
        this.filtering = null;
      }
      if (!this.formData.country) {
        this.formData.country = this.company.address.country;
      }
      this.$emit('submit', this.formData);
      if (this.postalCode) {
        this.$store.dispatch('clearPostal');
      }
    },
    filterPrefill: function filterPrefill(value, target) {
      var _this3 = this;

      var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.prefill.original.length === 0) return;
      if (!this.company || this.company.address.country === 'AT' && ['line3'].includes(target)) return;
      this.filtering = target;
      if (!value) {
        this.prefill.filtered = [];
        this.filtering = null;
        return;
      }
      if (value === 'ALL_VALUES') {
        if (clear) {
          this.formData[target] = '';
        }
        if (target === 'line2' && this.formData.line1 !== '') {
          this.prefill.filtered = this.prefill.original.filter(function (address) {
            // eslint-disable-next-line max-len
            if (address[target] && address.line1 === _this3.formData.line1) return address;
            return false;
          });
          return;
        }
        this.prefill.filtered = this.prefill.original;
        return;
      }
      this.prefill.filtered = this.prefill.original.filter(function (address) {
        // eslint-disable-next-line max-len
        if (address[target] && address[target].toLowerCase().includes(value.toLowerCase().trim())) {
          return address;
        }
        return false;
      });
    },
    getPrefill: function getPrefill(value, valueEvent, target) {
      var _this4 = this;

      if (target === 'postalCode') {
        this.getPostalCodes(valueEvent);
        return;
      }
      if (this.company.address.country === 'UK' && this.onReplaceAddressUK) {
        this.onReplaceAddressUK = false;
        return;
      }
      this.validPostal = false;
      this.prefill = {
        original: [],
        filtered: []
      };
      this.err = '';
      if (this.lastGoodPostal !== '' && this.lastGoodPostal !== value) {
        this.lastGoodPostal = '';
        this.formData.line1 = '';
        if (this.company.address.country === 'AT') {
          this.formData.line2 = '';
          this.formData.line3 = '';
          this.formData.townCity = '';
        }
      }
      if (!value) return;
      if (this.company.address.country === 'UK' && (value.length < 5 || value.length > 16)) return;
      if (this.company.address.country === 'AT' && value.length !== 4) return;
      if ((!value || this.formData.line1.length < 3) && this.company.address.country === 'AT') return;
      var payload = this.company.address.country === 'AT' ?
      // eslint-disable-next-line max-len
      {
        postalCode: value.trim().toUpperCase(),
        line1: this.formData.line1,
        country: this.company.address.country
      } : {
        postalCode: value.trim().toUpperCase(),
        country: this.company.address.country
      };
      this.formData.postalCode = value.trim().toUpperCase();
      var resourceId = localStorage.getItem('webShopResourceId');
      if (resourceId) {
        this.isLoadingAddress = true;
        this.$webHelper.post('address/' + resourceId, payload).then(function (res) {
          if (res.success) {
            _this4.validPostal = true;
            _this4.fullAddressLocal = false;
            _this4.lastGoodPostal = value;
            _this4.formData.postalCode = _this4.formData.postalCode.charAt(0).toUpperCase() + _this4.formData.postalCode.slice(1);
            _this4.isLoadingAddress = false;
            _this4.prefill.original = res.body.addresses.map(function (current) {
              var address = current;
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(address).forEach(function (key) {
                address[key] = address[key].trim();
              });
              return address;
            });
            if (_this4.company.address.country === 'AT') {
              _this4.$store.dispatch('setAddressesAT', res.body.addresses);
              if (_this4.filterUniqueFields(_this4.prefill.original, 'townCity').length === 1) {
                _this4.formData.townCity = _this4.filterUniqueFields(_this4.prefill.original, 'townCity')[0];
                _this4.replaceAddress(_this4.formData.townCity, 'townCity');
              }
            }
            if (!_this4.fromBack) {
              _this4.filterPrefill(valueEvent, target);
            }
            if (_this4.fromBack) {
              _this4.$emit('resetFromBack', true);
            }
            return;
          }
          _this4.isLoadingAddress = false;
          _this4.validPostal = false;
        });
      }
    },
    getPostalCodes: function getPostalCodes(code) {
      var _this5 = this;

      this.validPostal = false;
      if (!code) return;
      if (!this.resourceId) return;
      code.trim().toUpperCase();
      if (this.company.address.country === 'UK' && (code.length < 4 || code.length > 16)) return;
      if (this.company.address.country === 'AT' && code.length !== 4) return;
      this.isLoadingAddress = true;
      this.$webHelper.get('address/postalcodes/' + this.resourceId, {
        startswith: code.trim().toUpperCase()
      }).then(function (res) {
        if (res.body && res.status === 200) {
          if (res.body.postalCodes.length === 0) {
            _this5.isLoadingAddress = false;
            _this5.filtering = null;
            _this5.postalCodes = [];
          } else {
            if (res.body.postalCodes.filter(function (x) {
              return x === _this5.formData.postalCode;
            }).length === 0) {
              _this5.filtering = 'postalCode';
              _this5.postalCodes = res.body.postalCodes.sort();
            }
            _this5.isLoadingAddress = false;
          }
        }
      }).catch(function (err) {
        _this5.err = err;
        _this5.isLoadingAddress = false;
      });
    },
    replaceAddress: function replaceAddress(address, property) {
      var _this6 = this;

      this.err = '';
      if (this.company.address.country === 'UK') {
        this.onReplaceAddressUK = true;
        this.linesUK.forEach(function (input) {
          if (!address[input.property]) return;
          _this6.formData[input.property] = address[input.property];
        });
      } else if (this.company.address.country === 'AT') {
        this.formData[property] = address;
        switch (property) {
          case 'line1':
            this.formData.line2 = '';
            this.formData.line3 = '';
            this.formData.latitude = '';
            this.formData.longitude = '';
            setTimeout(function () {
              document.getElementById('1').focus();
            }, 50);
            break;
          // eslint-disable-next-line no-case-declarations
          case 'line2':
            this.formData.line3 = '';
            // eslint-disable-next-line max-len
            var chosenAddress = this.prefill.original.filter(function (x) {
              return x.line1 === _this6.formData.line1 && x.line2 === address;
            });
            if (chosenAddress.length === 0) {
              this.filtering = null;
              this.err = this.$lang.errors.validPostalOrAddress;
              return;
            }
            this.formData.latitude = chosenAddress[0].latitude;
            this.formData.longitude = chosenAddress[0].longitude;
            this.submit();
            break;
          case 'line3':
            // code block
            break;
          case 'townCity':
            // code block
            break;
          default:
          // code block
        }
      }
      this.filtering = null;
    },
    filterUniqueFields: function filterUniqueFields(addresses, property) {
      if (this.company.address.country === 'UK') return addresses;
      var filteredFieldList = addresses.map(function (address) {
        return address[property];
      });
      // eslint-disable-next-line max-len
      filteredFieldList = filteredFieldList.filter(function (item, index) {
        return filteredFieldList.indexOf(item) === index;
      });
      return filteredFieldList;
    },
    generateAddress: function generateAddress(input) {
      var address = '';
      var tempKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(input);
      tempKeys.forEach(function (key, index) {
        if (['latitude', 'longitude', 'country'].includes(key)) {
          address += '';
        } else if (input[key]) address += tempKeys.length !== index - 1 ? ', ' + input[key].trim() : '' + input[key].trim();
      });
      address = address.substring(2, address.length);
      return address;
    },
    initAddress: function initAddress() {
      var _this7 = this;

      if (typeof this.address !== 'undefined') {
        if (this.address === null) {
          this.formData = {
            country: '',
            postalCode: '',
            line1: '',
            line2: '',
            line3: '',
            line4: '',
            locality: '',
            townCity: '',
            latitude: '',
            longitude: ''
          };
          return;
        }
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.address).forEach(function (key) {
          _this7.formData[key] = _this7.address[key];
        });
        this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      }
    }
  },
  created: function created() {
    var _this8 = this;

    this.fullAddressLocal = this.fullAddress;
    this.resourceId = localStorage.getItem('webShopResourceId');
    if (typeof this.address !== 'undefined') {
      if (this.address === null) {
        this.formData = {
          country: '',
          postalCode: '',
          line1: '',
          line2: '',
          line3: '',
          line4: '',
          locality: '',
          townCity: '',
          latitude: '',
          longitude: ''
        };
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.address).forEach(function (key) {
        _this8.formData[key] = _this8.address[key];
      });
      if (this.fullAddressLocal) this.getPrefill(this.formData.postalCode, 'ALL_VALUES', 'line1');
      return;
    }
    if (this.postalCode && this.postalCode.postalCode) {
      this.formData.postalCode = this.postalCode.postalCode.toUpperCase();
      this.formData.latitude = this.postalCode.latitude;
      this.formData.longitude = this.postalCode.longitude;
    }
    if (this.postal) {
      this.formData.postalCode = this.postal.toUpperCase();
    }
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['time'],
  data: function data() {
    return {
      hour: null,
      minutes: null,
      maxHour: 24,
      overHours: 0,
      maxMinutes: 60,
      minHour: 0,
      minMinutes: 0,
      currentMinMinutes: 0,
      err: '',
      warning: '',
      valid: false,
      canGoIntoNextDay: false,
      formHours: []
    };
  },

  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    company: 'company',
    workingHours: 'currentWorkingHours',
    tomorrowsWorkingHours: 'tomorrowsWorkingHours'
  }),
  watch: {
    hour: function hour() {
      this.checkIfValidTime();
    },
    minutes: function minutes() {
      this.checkIfValidTime();
    }
  },
  methods: {
    selectHour: function selectHour(hour) {
      this.warning = '';
      this.currentMinMinutes = parseInt(hour.text, 10) === this.minHour ? this.minMinutes : 0;
      this.minutes = this.currentMinMinutes;
      this.checkIfValidTime();
    },
    doubleDigits: function doubleDigits(time) {
      return ('' + time).length === 1 ? '0' + time : time;
    },
    isInWorkingHours: function isInWorkingHours(picked) {
      var _this = this;

      var inside = false;
      this.workingHours.forEach(function (entry) {
        var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entry.startDate);
        var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()(entry.endDate);
        if (picked.isBetween(start, end) || picked.toISOString() === entry.startDate) {
          inside = true;
        }
        if (!inside && start.isBefore(picked) && entry.end === 2359 && _this.canGoIntoNextDay) {
          inside = true;
        }
      });
      return inside;
    },
    findNextWorkingTime: function findNextWorkingTime(picked) {
      var foundHours = void 0;
      this.workingHours.forEach(function (range) {
        if (!foundHours && (__WEBPACK_IMPORTED_MODULE_1_moment___default()(range.startDate).isAfter(picked) || range.startDate === picked.toISOString())) {
          foundHours = __WEBPACK_IMPORTED_MODULE_1_moment___default()(range.startDate);
        }
      });
      return foundHours;
    },
    checkIfValidTime: function checkIfValidTime(init) {
      if (this.minutes === null) return;
      this.err = '';
      this.valid = false;
      var chosen = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.hour);
      chosen.set('minutes', this.minutes);
      if (!this.isInWorkingHours(chosen)) {
        this.err = init ? this.$lang.errors.bizzHours : this.$lang.errors.bizzHours2;
        return;
      }
      var durationFrom = this.company.deliveryDurationFrom;
      if (chosen.isBefore(__WEBPACK_IMPORTED_MODULE_1_moment___default()().add(durationFrom - 1, 'minutes'))) {
        this.err = this.$lang.errors.chosenTime + ' ' + durationFrom + ' ' + this.$lang.errors.minutes;
        return;
      }
      this.valid = true;
    },
    submit: function submit() {
      if (!this.valid) return;
      var chosen = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.hour);
      chosen.set('minutes', this.minutes);
      this.$emit('submit', chosen);
      this.$emit('close');
    },
    generateFormHours: function generateFormHours(min, max, overHours) {
      var _this2 = this;

      var isToday = true;
      var maximum = max === 0 ? 24 : max;
      var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD');
      var tomorrow = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'day').format('YYYY-MM-DD');
      var hours = new Array(maximum - min + overHours).fill('x').map(function (val, index) {
        var hour = min + index;
        if (hour === 24) isToday = false;
        return {
          text: _this2.doubleDigits(hour === 24 ? 0 : hour),
          value: __WEBPACK_IMPORTED_MODULE_1_moment___default()((isToday ? now : tomorrow) + ' ' + (hour === 24 ? 0 : hour) + ':00').toISOString()
        };
      });
      hours.sort(function (a, b) {
        if (a.startDate < b.startDate) return -1;
        return a.startDate > b.startDate ? 1 : 0;
      });
      return hours;
    }
  },
  created: function created() {
    if (this.workingHours.length === 0) {
      this.err = this.$lang.errors.restaurantClosedToday;
      return;
    }
    var now = new Date();
    var day1End = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.workingHours[this.workingHours.length - 1].endDate);
    if (this.tomorrowsWorkingHours[0]) {
      var day2Start = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.tomorrowsWorkingHours[0].startDate).add(1, 'day');
      var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(day2Start.diff(day1End)).asMinutes();
      this.canGoIntoNextDay = duration === 1;
    }
    this.maxHour = parseInt(this.workingHours[this.workingHours.length - 1].end.split(':')[0], 10);
    if (parseInt(this.workingHours[this.workingHours.length - 1].end.split(':')[1], 10) > 0) {
      this.overHours = 1;
    }
    var durationFrom = this.company.deliveryDurationFrom;
    var currentTime = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(durationFrom, 'minutes');
    if (!this.isInWorkingHours(currentTime)) {
      var foundHours = this.findNextWorkingTime(currentTime);
      this.minHour = parseInt(foundHours.format('HH'), 10);
    } else {
      this.minHour = now.getHours();
    }
    this.formHours = this.generateFormHours(this.minHour, this.maxHour, this.overHours);
    var time = this.time;
    if (time === -1) {
      time = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(durationFrom, 'minutes');
    }
    if (!this.isInWorkingHours(time)) {
      time = this.findNextWorkingTime(time);
      if (!time) return;
    }
    this.hour = __WEBPACK_IMPORTED_MODULE_1_moment___default()(time.format('YYYY-MM-DD HH') + ':00').toISOString();
    this.minMinutes = time.format('HH') === this.minHour ? now.getMinutes() : 0;
    this.minutes = time.format('mm');
    this.currentMinMinutes = this.minMinutes;
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__terms_and_privacy_terms__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terms_and_privacy_privacy__ = __webpack_require__(359);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: '',
      body: ''
    };
  },
  methods: {
    setContent: function setContent() {
      this.title = this.$route.name === 'terms' ? this.$lang.header.tearmsConditions : this.$lang.header.cookiePrivacy;
      this.body = this.$route.name === 'terms' ? __WEBPACK_IMPORTED_MODULE_0__terms_and_privacy_terms__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__terms_and_privacy_privacy__["a" /* default */];
    }
  },
  watch: {
    $route: function $route() {
      this.setContent();
    }
  },
  created: function created() {
    this.setContent();
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      err: '',
      success: '',
      interval: null
    };
  },
  methods: {
    orderFailed: function orderFailed() {
      var _this = this;

      clearInterval(this.interval);
      this.err = this.$lang.errors.paymentFailed;
      setTimeout(function () {
        _this.$router.push({ name: 'orderInfo' });
      }, 30000);
    },
    fetchOrderStatus: function fetchOrderStatus(orderId, resourceId) {
      var _this2 = this;

      this.$webHelper.get('payment/fetchpaymentstatus/' + resourceId + '/' + orderId, null, this.$router).then(function (res) {
        if (!res.success || !res.body.paymentStatus) {
          _this2.orderFailed();
          return;
        }
        switch (res.body.paymentStatus.toLowerCase()) {
          case 'open':
          case 'inprocess':
            setTimeout(function () {
              _this2.fetchOrderStatus(orderId, resourceId);
            }, 7000);
            break;
          case 'success':
            _this2.success = _this2.$lang.success.paymentOrderOk;
            clearInterval(_this2.interval);
            _this2.$storage.order = null;
            _this2.$store.dispatch('clearCart');
            setTimeout(function () {
              _this2.$router.push({
                name: 'resourceSet',
                props: { resource: resourceId },
                query: { nologout: true }
              });
            }, 15000);
            break;
          case 'failed':
          case 'statusnotknown':
          default:
            {
              _this2.orderFailed();
            }
        }
      });
    },
    setOrderStatusInterval: function setOrderStatusInterval() {
      this.fetchOrderStatus(this.$route.params.orderId, this.$route.params.resourceId);
    },
    paymentsenseSubmitPaymentStatus: function paymentsenseSubmitPaymentStatus() {
      var _this3 = this;

      var query = this.$route.query;
      if (!query.HashDigest || !query.MerchantID || !query.CrossReference || !query.OrderID) {
        this.err = this.$lang.errors.malformedPayment;
        setTimeout(function () {
          _this3.$router.push({ name: 'webShop' });
        }, 3000);
        return;
      }
      this.$webHelper.post('payment/submithostedpaymentformresult', {
        hashDigest: query.HashDigest,
        merchantId: query.MerchantID,
        crossReference: query.CrossReference,
        orderId: query.OrderID
      }, this.$router).then(function (res) {
        if (!res.success) {
          // eslint-disable-next-line max-len
          _this3.err = res.body && res.body.statusText ? res.body.statusText : _this3.$lang.errors.submitFailed;
          return;
        }
        _this3.setOrderStatusInterval();
      });
    },
    connectEPaymentStatus: function connectEPaymentStatus(id) {
      this.$webHelper.get('payment/fetchconnectepaymentinfo/' + id, null, this.$router).then(function (res) {
        console.log(res);
        // if (!res.success || !res.body.paymentStatus) {
        //   this.orderFailed();
        //   return;
        // }
        // switch (res.body.paymentStatus.toLowerCase()) {
        //   case 'open':
        //   case 'inprocess':
        //     setTimeout(() => {
        //       this.fetchOrderStatus(orderId, resourceId);
        //     }, 7000);
        //     break;
        //   case 'success':
        //     this.success = this.$lang.success.paymentOrderOk;
        //     clearInterval(this.interval);
        //     this.$storage.order = null;
        //     this.$store.dispatch('clearCart');
        //     setTimeout(() => {
        //       this.$router.push({
        //         name: 'resourceSet',
        //         props: { resource: resourceId },
        //         query: { nologout: true },
        //       });
        //     }, 15000);
        //     break;
        //   case 'failed':
        //   case 'statusnotknown':
        //   default: {
        //     this.orderFailed();
        //   }
        // }
      });
    }
  },
  created: function created() {
    if (this.$route.params.resourceId) {
      localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
    }
    var company = JSON.parse(localStorage.company);
    if (company.paymentGateway === 'paymentsense') {
      this.paymentsenseSubmitPaymentStatus();
    }
    if (company.paymentGateway === 'firstdata') {
      this.setOrderStatusInterval();
    }
    if (company.paymentGateway === 'connect-e') {
      this.connectEPaymentStatus();
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    orderDetails: function orderDetails() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 49));
    }
  },
  data: function data() {
    return {
      err: '',
      search: '',
      loading: true,
      orderDetails: false,
      orderData: null,
      orderHistory: [],
      pagination: {
        sortBy: 'createdOn',
        descending: true
      },
      headers: [{ text: this.$lang.labels.createdOn, value: 'createdOn', align: 'left' }, { text: this.$lang.labels.deliveryType, value: 'type', align: 'left' }, { text: this.$lang.labels.totalAmount, value: 'totalAmount', align: 'left' }, { text: this.$lang.labels.actions, value: 'actions', sortable: false, align: 'center' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    goDark: 'goDark'
  })),
  methods: {
    showModal: function showModal(order) {
      this.order = order;
      this.orderDetails = true;
    },
    formatDate: function formatDate(time) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(time).format('YYYY-MM-DD HH:mm');
    }
  },
  created: function created() {
    var _this = this;

    if (!__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* default */].isLoggedIn()) {
      this.$router.push('/' + this.$lang.current_lang + '/login');
      return;
    }
    this.$http.get('order/getforuser').then(function (res) {
      if (res.body.status === 'Success') {
        _this.loading = false;
        _this.orderHistory = res.body.details;
        if (_this.orderHistory.length === 0) {
          _this.loading = false;
        }
        return;
      }
      _this.err = res.body.statusText;
    }, function (err) {
      _this.loading = false;
      _this.err = err.body.statusText || err.body.message;
    });
  },
  destroyed: function destroyed() {
    this.orderHistory = [];
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import auth from '../auth';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminPanel',
  data: function data() {
    var _this = this;

    return {
      searchType: 'visits',
      err: '',
      loading: false,
      fromDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(14, 'd').startOf('d').toISOString(),
      menuFrom: false,
      toDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('d').toISOString(),
      menuTill: false,
      visits: null,
      loginProcessStarted: false,
      email: '',
      password: '',
      passwordRules: [function (v) {
        return !!v || _this.$lang.errors.requiredPassword;
      }, function (v) {
        return v && v.length >= 6 && v.length <= 35 || _this.$lang.errors.passwordConditions;
      }],
      emailRules: [function (v) {
        return !!v || _this.$lang.errors.requiredEmail;
      },
      // eslint-disable-next-line
      function (v) {
        return v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase()) || _this.$lang.errors.notValidEmail;
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  })),
  methods: {
    formatDate: function formatDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD') : this.$lang.actions.selectDate;
    },
    formatDateTime: function formatDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD/MM/YYYY HH:mm');
    },
    saveVisit: function saveVisit(visit) {
      var _this2 = this;

      // eslint-disable-next-line no-param-reassign
      visit.isLoading = true;
      this.$webHelper.post('visit/update/' + visit.id, visit).then(function (res) {
        if (res.body && res.status === 200) {
          // eslint-disable-next-line no-param-reassign
          visit.isLoading = false;
        } else {
          _this2.err = res.body.statusText;
          setTimeout(function () {
            _this2.err = '';
          }, 6000);
          // eslint-disable-next-line no-param-reassign
          visit.isLoading = false;
        }
      }).catch(function (err) {
        _this2.err = err;
        setTimeout(function () {
          _this2.err = '';
        }, 6000);
        // eslint-disable-next-line no-param-reassign
        visit.isLoading = false;
      });
    },
    search: function search() {
      var _this3 = this;

      this.err = '';
      this.ordersResult = [];
      this.searchType = 'visits';
      if (!this.fromDate || !this.toDate) {
        this.err = 'Please select both dates';
        setTimeout(function () {
          _this3.err = '';
        }, 6000);
        return;
      }
      this.visits = null;
      this.loading = true;
      this.$webHelper.post('visit/search', {
        fromDate: this.fromDate,
        toDate: this.toDate
      }).then(function (res) {
        if (res.body && res.status === 200) {
          _this3.visits = res.body.visits.map(function (current) {
            var visit = current;
            visit.isLoading = false;
            return visit;
          });
          _this3.loading = false;
        } else {
          _this3.err = res.body.statusText;
          setTimeout(function () {
            _this3.err = '';
          }, 6000);
          _this3.loading = false;
        }
      }).catch(function (err) {
        _this3.err = err;
        setTimeout(function () {
          _this3.err = '';
        }, 6000);
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.search();
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Orders',
  data: function data() {
    return {
      active: null,
      menu: [{
        title: this.$lang.labels.ordersSearch,
        to: {
          name: 'ordersSearch'
        }
      }, {
        title: this.$lang.labels.blacklist,
        to: {
          name: 'blacklist'
        }
      }],
      err: '',
      successMessage: '',
      loading: false,
      isInit: false,
      snackbarTime: 6000,
      snackbar: false,
      snackbarType: 'success',
      message: ''
    };
  },

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  })),
  methods: {},
  created: function created() {}
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import auth from '../auth';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrdersSearch',
  components: {
    orderDetails: function orderDetails() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 49));
    }
  },
  data: function data() {
    return {
      order: null,
      orderDetails: false,
      searchType: 'orders',
      err: '',
      loading: false,
      fromDateOrders: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(14, 'd').startOf('d').toISOString(),
      menuFromOrders: false,
      toDateOrders: __WEBPACK_IMPORTED_MODULE_2_moment___default()().endOf('d').toISOString(),
      menuTillOrders: false,
      ordersResult: null,
      pagination: {},
      totalOrdersResult: 0,
      headers: [{
        text: this.$lang.header.deliveryTime,
        align: 'left',
        sortable: false,
        value: 'deliveryTime'
      }, {
        text: this.$lang.header.customer,
        align: 'left',
        sortable: false,
        value: 'contact.firstName'
      }, {
        text: this.$lang.labels.deliveryType,
        align: 'left',
        sortable: false,
        value: 'type'
      }, {
        text: this.$lang.global.total,
        align: 'left',
        sortable: false,
        value: 'totalAmount'
      }, {
        text: this.$lang.header.rating,
        align: 'left',
        sortable: false,
        value: 'stars'
      }, {
        text: this.$lang.labels.actions,
        align: 'left',
        sortable: false,
        value: 'id'
      }],
      initialOrderSearch: true
    };
  },

  watch: {
    pagination: {
      handler: function handler() {
        if (!this.initialOrderSearch && !this.loading) {
          this.searchOrders();
        } else {
          this.initialOrderSearch = false;
        }
      },

      immediate: false,
      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  })),
  methods: {
    generateAddress: function generateAddress(lines) {
      return lines.filter(function (line) {
        return !!line;
      }).join(', ');
    },
    formatDate: function formatDate(date) {
      return date ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('YYYY-MM-DD') : this.$lang.actions.selectDate;
    },
    formatDateTime: function formatDateTime(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).format('DD/MM/YYYY HH:mm');
    },
    searchOrders: function searchOrders() {
      var _this = this;

      this.ordersResult = null;
      this.err = '';
      this.searchType = 'orders';
      if (!this.fromDateOrders || !this.toDateOrders) {
        this.err = 'Please select both dates';
        setTimeout(function () {
          _this.err = '';
        }, 6000);
        return;
      }
      this.loading = true;
      this.$webHelper.get('order/list?from=' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.fromDateOrders).toISOString() + '&to=' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.toDateOrders).toISOString() + '&page=' + (this.pagination.page || 1)).then(function (res) {
        if (res.body && res.status === 200) {
          _this.ordersResult = res.body.details.sort(function (a, b) {
            var keyA = new Date(a.deliveryTime);
            var keyB = new Date(b.deliveryTime);
            // Compare the 2 dates
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
          });
          _this.totalOrdersResult = res.body.pagesCount * 50;
          setTimeout(function () {
            _this.loading = false;
          }, 50);
        } else {
          _this.err = res.body.statusText;
          setTimeout(function () {
            _this.err = '';
          }, 6000);
          _this.loading = false;
        }
      }).catch(function (err) {
        _this.err = err;
        setTimeout(function () {
          _this.err = '';
        }, 6000);
        _this.loading = false;
      });
    }
  },
  created: function created() {
    this.searchOrders();
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrdersSearch',
  components: {
    orderDetails: function orderDetails() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 49));
    }
  },
  data: function data() {
    return {
      order: null,
      orderDetails: false,
      searchType: 'orders',
      err: '',
      loading: false,
      blacklistResult: null,
      headers: [{
        text: this.$lang.header.value,
        align: 'left',
        sortable: false,
        value: 'value'
      }, {
        text: this.$lang.header.type,
        align: 'left',
        sortable: false,
        value: 'type'
      }, {
        text: this.$lang.labels.actions,
        align: 'left',
        sortable: false,
        value: 'id'
      }],
      blacklistType: 'all'
    };
  },

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  })),
  methods: {
    removeBlacklist: function removeBlacklist(item) {
      var _this = this;

      this.$webHelper.post('blacklist/delete/' + item.id).then(function (res) {
        if (res.body && res.status === 200) {
          _this.searchBlacklist();
        } else {
          _this.err = res.body.statusText;
          setTimeout(function () {
            _this.err = '';
          }, 6000);
          _this.loading = false;
        }
      }).catch(function (err) {
        _this.err = err;
        setTimeout(function () {
          _this.err = '';
        }, 6000);
        _this.loading = false;
      });
    },
    searchBlacklist: function searchBlacklist() {
      var _this2 = this;

      this.blacklistResult = null;
      this.err = '';
      this.loading = true;
      this.$webHelper.get('blacklist' + (this.blacklistType !== 'all' ? '?type=' + this.blacklistType : '')).then(function (res) {
        if (res.body && res.status === 200) {
          _this2.blacklistResult = res.body.blacklist.sort(function (a, b) {
            var keyA = new Date(a.createdOn);
            var keyB = new Date(b.createdOn);
            // Compare the 2 dates
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
          });
          setTimeout(function () {
            _this2.loading = false;
          }, 50);
        } else {
          _this2.err = res.body.statusText;
          setTimeout(function () {
            _this2.err = '';
          }, 6000);
          _this2.loading = false;
        }
      }).catch(function (err) {
        _this2.err = err;
        setTimeout(function () {
          _this2.err = '';
        }, 6000);
        _this2.loading = false;
      });
    }
  },
  created: function created() {
    this.searchBlacklist();
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AdminPanel',
  data: function data() {
    return {
      gold: [true, true, false, false, false, false],
      goldSet: null,
      err: '',
      success: '',
      comment: '',
      loading: false,
      loginProcessStarted: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    companyActive: 'companyActive'
  })),
  methods: {
    starGold: function starGold(index) {
      var _this = this;

      this.gold = this.gold.map(function (x, i) {
        var item = x;
        item = _this.goldSet ? i <= _this.goldSet : i <= index;
        return item;
      });
    },
    rate: function rate() {
      var _this2 = this;

      if (!this.comment) {
        this.startErrorAnimation('commentField');
        return;
      }
      this.err = '';
      this.success = '';
      this.$webHelper.post('rating/' + this.$route.params.hash, {
        stars: this.goldSet,
        comment: this.comment
      }).then(function (res) {
        if (res.body && res.status === 200) {
          _this2.$router.push({ name: 'webShop', query: { rateSuccessful: true } });
        } else {
          _this2.err = res.body.statusText;
        }
      }).catch(function (err) {
        _this2.err = err;
      });
    },
    checkRate: function checkRate() {
      var _this3 = this;

      this.$webHelper.get('rating/' + this.$route.params.hash).then(function (res) {
        if (res.status !== 200) {
          _this3.err = res.body.statusText;
        }
      }).catch(function (err) {
        _this3.err = err;
        setTimeout(function () {
          _this3.err = '';
        }, 6000);
      });
    },
    startErrorAnimation: function startErrorAnimation(elementId) {
      var el = document.getElementById(elementId);
      if (el) {
        el.classList.add('ahashakeheartache');
        setTimeout(function () {
          el.classList.remove('ahashakeheartache');
        }, 800);
      }
    }
  },
  created: function created() {
    this.checkRate();
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      success: '',
      itemSuccess: '',
      err: '',
      loaded: false,
      catalogItems: null,
      pageYOffset: 0,
      duration: 800,
      easing: 'easeInOutCubic',
      selectedCat: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    width: 'width',
    goDark: 'goDark'
  }), {
    stickyScrollDesktop: function stickyScrollDesktop() {
      if (this.pageYOffset > 170) return 10;
      return 170 - this.pageYOffset;
    },
    stickyScrollMobile: function stickyScrollMobile() {
      if (this.pageYOffset > 150 && this.width >= 676 && this.width < 993) return 0;
      if (this.pageYOffset > 170 && this.width > 600 && this.width < 676) return 0;
      if (this.pageYOffset > 310 && this.width < 676) return 0;
      if (this.width > 600 && this.width < 676) return 170 - this.pageYOffset;
      if (this.width <= 600) return this.width / 2 + 120 - this.pageYOffset;
      return 150 - this.pageYOffset;
    },
    options: function options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing
      };
    },
    offset: function offset() {
      if (this.isImage(this.selectedCat, 'webpage-itemlist-banner')) return 270;
      return 50;
    }
  }),
  methods: {
    isImage: function isImage(item, label) {
      return !!(item.images && item.images.filter(function (x) {
        return x.label === label;
      }).length > 0);
    },
    runOnScroll: function runOnScroll() {
      this.pageYOffset = window.pageYOffset;
    },
    init: function init() {
      var _this = this;

      if (this.$route.query && this.$route.query.webShopResourceId) {
        localStorage.webShopResourceId = this.$route.query.webShopResourceId;
      }
      this.$webHelper.post('catalog/getcatalog', {
        webShopResourceId: localStorage.webShopResourceId || this.$route.query.webShopResourceId,
        view: 'webpage'
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this.err = _this.$lang.errors.failedCastalog;
          return;
        }
        _this.catalogItems = res.body.catalog.itemsList;
        _this.loaded = true;
      });
    }
  },
  created: function created() {
    if (localStorage.webShopResourceId) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.runOnScroll);
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.runOnScroll, { passive: true });
  }
});

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports) {

module.exports = {
  noCharges: 'Kostenlose Lieferung.',
  from: 'Von',
  to: 'bis',
  miles: 'Meilen',
  km: 'Km',
  chargesPerMile: 'Kosten per Meile',
  chargesByMiles: 'Kosten per Meilen',
  chargesPerKm: 'Kosten per Kilometer',
  chargesByKms: 'Kosten per Kilometers',
  chargesByInvoice: 'Liefergebühren abhängig von Bestellungssumme',
  defaultCharges: 'Standardgebühr'
};

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = {
  noCharges: 'No delivery charges',
  from: 'From',
  to: 'to',
  miles: 'miles',
  km: 'Km',
  chargesPerMile: 'Charges per mile',
  chargesByMiles: 'Charges by miles',
  chargesPerKm: 'Charges per kilometer',
  chargesByKms: 'Charges by kilometers',
  chargesByInvoice: 'Charges by invoice amount',
  defaultCharges: 'Default charges'
};

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Order__ = __webpack_require__(241);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['itemsList', 'notNested', 'nested'],
  data: function data() {
    return {
      search: null,
      dialog: false,
      item: null,
      companyId: null,
      env: 'null',
      panel: [],
      showList: false
    };
  },
  components: {
    Order: __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Order__["a" /* default */]
  },
  watch: {
    dialog: function dialog(val) {
      if (val) {
        this.$store.dispatch('blockScroll', true);
      } else {
        this.$store.dispatch('blockScroll', false);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    itemsInSingleList: 'itemsList',
    categories: 'categories',
    company: 'company',
    width: 'width'
  }), {
    formattedItemsList: function formattedItemsList() {
      var _this = this;

      var returnArray = [];
      var returnFunct = function returnFunct(item) {
        returnArray.push(_this.returnSearchArray(item));
        if (item.items && item.items.length > 0) {
          item.items.forEach(function (x) {
            return returnFunct(x);
          });
        }
      };
      this.itemsInSingleList.forEach(function (y) {
        return returnFunct(y);
      });
      return returnArray.filter(function (element) {
        return element !== undefined;
      });
    }
  }),
  created: function created() {
    this.companyId = localStorage.getItem('webShopResourceId');
    this.env = "production";
    this.panel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.itemsList).map(function () {
      return null;
    });
    this.panel[0] = 0;
    this.showList = true;
  },

  methods: {
    returnSearchArray: function returnSearchArray(item) {
      if (item.items && item.items.length > 0) return undefined;
      if (!isNaN(item.price) && !item.shouldOpenModal) {
        return { text: (item.name[this.$lang.current_lang] ? item.name[this.$lang.current_lang] : item.name.en) + ' - ' + (this.company ? this.company.currencySymbol : '') + item.price, value: item };
      }
      if (item.name[this.$lang.current_lang]) {
        return { text: item.name[this.$lang.current_lang], value: item };
      }
      return { text: item.name.en, value: item };
    },
    flashSuccess: function flashSuccess(event) {
      this.$emit('success', event);
    },
    togglePanel: function togglePanel(index) {
      var element = document.getElementById('abc-' + index);
      var elLi = document.getElementById('cba-' + index).parentElement;
      if (this.panel[index] === null) {
        element.classList.add('v-expansion-panel__container--active');
        elLi.style.display = 'block';
        this.panel[index] = 0;
      } else {
        element.classList.remove('v-expansion-panel__container--active');
        elLi.style.display = 'none';
        this.panel[index] = null;
      }
    },
    isImage: function isImage(item, label) {
      if (item.images) {
        return item.images.filter(function (x) {
          return x.label === label;
        }).length > 0;
      }
      return false;
    },
    handleSearch: function handleSearch(val) {
      if (val === null) return;
      this.openDetails(val);
      this.$refs.search.selectItem(null);
    },
    scrollToHeader: function scrollToHeader(index) {
      var element = document.getElementById('abc-' + index);
      var elementPosition = element.getBoundingClientRect().top;
      var bodyRect = document.body.getBoundingClientRect();
      var offset = elementPosition - bodyRect.top;
      setTimeout(function () {
        window.scrollTo({
          top: offset - 60,
          behavior: 'smooth'
        });
      }, 125);
    },
    closeModal: function closeModal() {
      this.item = null;
      this.dialog = false;
    },
    openDetails: function openDetails(item) {
      if (!item.shouldOpenModal) {
        var getCheapest = function getCheapest(list) {
          var base = 0;
          var index = 0;
          if (Array.isArray(list) && list.length > 0) {
            base = list[0].price;
            list.forEach(function (listItem, i) {
              if (listItem.price < base) {
                base = listItem.price;
                index = i;
              }
            });
            return list[index];
          }
          if (Array.isArray(list) && list.length === 0) {
            return null;
          }
          return list;
        };
        var defaultStyle = void 0;
        var defaultSize = void 0;
        var defaultVariant = void 0;
        var defaultOptions = [];
        if (item.styles.length > 1) {
          item.styles.forEach(function (style) {
            if (style.isDefault) defaultStyle = style;
          });
        }
        if (item.sizes.length > 1) {
          item.sizes.forEach(function (size) {
            if (size.isDefault) defaultSize = size;
          });
        }
        if (item.variants.length > 1) {
          item.variants.forEach(function (variant) {
            if (variant.isDefault) defaultVariant = variant;
          });
        }

        if (item.options.length > 0) {
          item.options.forEach(function (option) {
            if (option.isDefault) defaultOptions.push(option);
          });
        }

        var itemObj = {
          catalogItemId: item.itemId,
          quantity: 1,
          abbr: item.abbr,
          name: item.name,
          desc: item.desc,
          vatRate: item.vatRate,
          selectedStyle: defaultStyle || item.styles[0],
          selectedOptions: defaultOptions,
          selectedVariants: defaultVariant || getCheapest(item.variants),
          selectedSize: defaultSize || getCheapest(item.sizes),
          selected: false,
          detailsOpened: false,
          sizes: item.sizes,
          variants: item.variants,
          options: item.options,
          styles: item.styles,
          images: item.images || [],
          allergens: item.allergens || [],
          quantityOfIncludedOptions: item.quantityOfIncludedOptions
        };
        this.itemSubmit(itemObj);
        return;
      }
      this.dialog = true;
      this.item = item;
    },
    itemSubmit: function itemSubmit(item) {
      this.$store.dispatch('addCartItem', item);
      this.$emit('success', (item.name[this.$lang.current_lang] ? item.name[this.$lang.current_lang] : item.name.en) + ' ' + this.$lang.success.addedToCart);
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e04fca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__(423);
function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e04fca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_webshop_modals_Allergens__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Allergens: __WEBPACK_IMPORTED_MODULE_2__components_webshop_modals_Allergens__["a" /* default */]
  },
  props: ['item'],
  data: function data() {
    return {
      selectedStyle: null,
      selectedSize: null,
      selectedVariant: null,
      quantity: 1,
      comment: '',
      options: [],
      err: '',
      total: '',
      allergensDialog: false,
      allergens: []
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    company: 'company',
    width: 'width',
    catalog: 'catalog',
    goDark: 'goDark'
  }),
  methods: {
    openAllergens: function openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    formatAllergen: function formatAllergen(id) {
      // eslint-disable-next-line max-len
      return this.catalog.allergens.filter(function (x) {
        return x.allergenId === id;
      })[0].name[this.$route.lang] || this.catalog.allergens.filter(function (x) {
        return x.allergenId === id;
      })[0].name[this.company.defaultLanguage];
    },
    changeOptionQty: function changeOptionQty(option, quantity) {
      if (quantity < 1) return;
      this.$set(option, 'quantity', quantity);
      this.calculatePrice();
    },
    changeQty: function changeQty(q) {
      if (q === 0) return;
      this.quantity = q;
      this.calculatePrice();
    },
    calculatePriceOffline: function calculatePriceOffline(item) {
      this.total = parseFloat(this.$store.state.calculatePrice(item.selectedSize, item.selectedVariants, item.selectedOptions, item.quantity, item.quantityOfIncludedOptions)).toFixed(2);
    },
    calculatePrice: function calculatePrice() {
      var _this = this;

      if (this.selectedStyle === null || this.selectedVariant === null || this.selectedSize === null) return;
      var options = this.options.filter(function (current) {
        return current.selected;
      }).map(function (current) {
        var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, current);
        delete option.selected;
        option.quantity = !option.quantity ? 1 : option.quantity;
        return option;
      });
      var item = {
        itemId: 0,
        catalogItemId: this.item.itemId,
        quantity: this.quantity,
        comment: this.comment,
        abbr: this.item.abbr,
        name: this.item.name,
        desc: this.item.desc,
        vatRate: this.item.vatRate,
        sizes: this.item.sizes,
        variants: this.item.variants,
        options: this.item.options,
        styles: this.item.styles,
        quantityOfIncludedOptions: this.item.quantityOfIncludedOptions
      };
      item.selectedStyle = this.item.styles[this.selectedStyle];
      item.selectedOptions = options || null;
      item.selectedVariants = this.item.variants[this.selectedVariant] || null;
      item.selectedSize = this.item.sizes[this.selectedSize];

      this.$webHelper.post('order/calculatetotalamount', {
        items: [item],
        deliveryCharges: 0,
        distanceInMiles: 0
      }, this.$router).then(function (res) {
        if (!res.success) {
          _this.warn = _this.$lang.errors.calculateServer;
          _this.calculatePriceOffline(item);
          return;
        }
        _this.total = res.body.itemsTotalAmount;
      });
    },
    toCart: function toCart() {
      this.err = '';
      var options = this.options.filter(function (current) {
        return current.selected;
      }).map(function (current) {
        var option = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, current);
        delete option.selected;
        option.quantity = !option.quantity ? 1 : option.quantity;
        return option;
      });
      if (this.selectedStyle === null) {
        this.err = this.$lang.errors.mustSelectStyle;
        return;
      }

      if (this.selectedSize === null) {
        this.err = this.$lang.errors.mustSelectSize;
        return;
      }

      if (this.item.variants && this.item.variants.length !== 0) {
        if (this.selectedVariant === null) {
          this.err = this.$lang.errors.mustSelectVariant;
          return;
        }
      }
      var modal = {
        itemId: null,
        catalogItemId: this.item.itemId,
        quantity: this.quantity,
        comment: this.comment,
        abbr: this.item.abbr,
        name: this.item.name,
        desc: this.item.desc,
        vatRate: this.item.vatRate,
        sizes: this.item.sizes,
        variants: this.item.variants,
        options: this.item.options,
        styles: this.item.styles,
        quantityOfIncludedOptions: this.item.quantityOfIncludedOptions
      };
      modal.allergens = this.item.allergens && this.item.allergens.length > 0 ? this.item.allergens : [];
      modal.selectedStyle = this.item.styles[this.selectedStyle];
      modal.selectedOptions = options || null;
      modal.selectedVariants = this.item.variants[this.selectedVariant] || null;
      modal.selectedSize = this.item.sizes[this.selectedSize];
      var event = this.isEdit ? 'edit' : 'submit';
      this.$emit(event, modal);
      this.$emit('close');
    },
    closeDialog: function closeDialog() {
      this.allergens = [];
      this.allergensDialog = false;
    }
  },
  created: function created() {
    var _this2 = this;

    this.quantity = this.item.quantity || 1;
    if (this.item.options) {
      this.item.options.forEach(function (option) {
        _this2.options.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, option, { selected: option.isDefault || false, quantity: 1 }));
      });
    }
    if (this.item.styles && this.item.styles.length === 1) {
      this.selectedStyle = 0;
    } else if (this.item.styles && this.item.styles.length > 1) {
      var isStyleFound = false;
      this.item.styles.forEach(function (style, index) {
        if (style.isDefault && !isStyleFound) {
          isStyleFound = true;
          _this2.selectedStyle = index;
        }
      });
    }
    if (this.item.sizes && this.item.sizes.length === 1) {
      this.selectedSize = 0;
    } else if (this.item.sizes && this.item.sizes.length > 1) {
      var isSizeFound = false;
      this.item.sizes.forEach(function (size, index) {
        if (size.isDefault && !isSizeFound) {
          isSizeFound = true;
          _this2.selectedSize = index;
        }
      });
    }
    if (this.item.variants && this.item.variants.length === 1) {
      this.selectedVariant = 0;
    } else if (this.item.variants && this.item.variants.length > 1) {
      var isVariantFound = false;
      this.item.variants.forEach(function (variant, index) {
        if (variant.isDefault && !isVariantFound) {
          isVariantFound = true;
          _this2.selectedVariant = index;
        }
      });
    }
    this.calculatePrice();
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['items', 'env', 'nested'],
  data: function data() {
    return {
      companyId: null,
      allergensDialog: false,
      allergens: []
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    company: 'company',
    catalog: 'catalog',
    width: 'width',
    goDark: 'goDark'
  }),
  watch: {
    allergensDialog: function allergensDialog() {
      var _this = this;

      setTimeout(function () {
        if (_this.allergensDialog) _this.allergensDialog = false;
      }, 100);
    }
  },
  created: function created() {
    this.companyId = localStorage.getItem('webShopResourceId');
  },

  methods: {
    flashSuccess: function flashSuccess(event) {
      this.$emit('success', event);
    },
    openAllergens: function openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    closeDialog: function closeDialog() {
      this.allergens = [];
      this.allergensDialog = false;
    },
    cardElevate: function cardElevate(index) {
      var el = document.getElementById('card-' + index);
      el.classList.remove('elevation-1');
      el.classList.add('elevation-6');
    },
    cardDeElevate: function cardDeElevate(index) {
      var el = document.getElementById('card-' + index);
      el.classList.remove('elevation-6');
      el.classList.add('elevation-1');
    },
    isImage: function isImage(item, label) {
      if (item.images) {
        return item.images.filter(function (x) {
          return x.label === label;
        }).length > 0;
      }
      return false;
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Order__ = __webpack_require__(241);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['itemsList'],
  data: function data() {
    return {
      search: null,
      dialog: false,
      item: null,
      companyId: null,
      env: 'null',
      panel: [],
      showList: false
    };
  },
  components: {
    Order: __WEBPACK_IMPORTED_MODULE_3__components_webshop_modals_Order__["a" /* default */]
  },
  watch: {
    dialog: function dialog(val) {
      if (val) {
        this.$store.dispatch('blockScroll', true);
      } else {
        this.$store.dispatch('blockScroll', false);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])({
    itemsInSingleList: 'itemsList',
    categories: 'categories',
    company: 'company',
    width: 'width'
  }), {
    formattedItemsList: function formattedItemsList() {
      var _this = this;

      var returnArray = [];
      var returnFunct = function returnFunct(item) {
        returnArray.push(_this.returnSearchArray(item));
        if (item.items && item.items.length > 0) {
          item.items.forEach(function (x) {
            return returnFunct(x);
          });
        }
      };
      this.itemsInSingleList.forEach(function (y) {
        return returnFunct(y);
      });
      return returnArray.filter(function (element) {
        return element !== undefined;
      });
    }
  }),
  created: function created() {
    this.companyId = localStorage.getItem('webShopResourceId');
    this.env = "production";
    this.panel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.itemsList).map(function () {
      return null;
    });
    this.panel[0] = 0;
    this.showList = true;
  },

  methods: {
    isImage: function isImage(item, label) {
      if (item.images) {
        return item.images.filter(function (x) {
          return x.label === label;
        }).length > 0;
      }
      return false;
    },
    scrollToHeader: function scrollToHeader(index) {
      var element = document.getElementById('abc-' + index);
      var elementPosition = element.getBoundingClientRect().top;
      var bodyRect = document.body.getBoundingClientRect();
      var offset = elementPosition - bodyRect.top;
      setTimeout(function () {
        window.scrollTo({
          top: offset - 60,
          behavior: 'smooth'
        });
      }, 125);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['items', 'env', 'nested'],
  data: function data() {
    return {
      companyId: null,
      allergensDialog: false,
      allergens: []
    };
  },
  computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])({
    company: 'company',
    catalog: 'catalog',
    width: 'width',
    goDark: 'goDark'
  }),
  watch: {
    allergensDialog: function allergensDialog() {
      var _this = this;

      setTimeout(function () {
        if (_this.allergensDialog) _this.allergensDialog = false;
      }, 100);
    }
  },
  created: function created() {
    this.companyId = localStorage.getItem('webShopResourceId');
  },

  methods: {
    findCheapestOptions: function findCheapestOptions(list) {
      var quantityOfIncludedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (!list || list.length === 0) {
        return 0;
      }
      var cumulativePrice = 0;
      if (Array.isArray(list) && list.length > 0) {
        var isDeafaultPrice = list.filter(function (x) {
          return x.isDefault === true;
        }).sort(function (a, b) {
          return a.price - b.price;
        });
        if (isDeafaultPrice.length > 0 && quantityOfIncludedOptions > 0) {
          isDeafaultPrice.forEach(function (option, index) {
            if (index + 1 > quantityOfIncludedOptions || option.maxIncludedQuantity === 0) {
              cumulativePrice += option.price;
            }
          });
          return cumulativePrice;
        } else if (isDeafaultPrice.length > 0 && quantityOfIncludedOptions === 0) {
          return isDeafaultPrice.reduce(function (a, b) {
            return a + (b.price || 0);
          }, 0);
        }
        return cumulativePrice;
      }
      return cumulativePrice;
    },
    findCheapest: function findCheapest(list) {
      if (!list || list.length === 0) {
        return 0;
      }
      var base = 0;
      if (Array.isArray(list) && list.length > 0) {
        base = list[0].price;
        var isDeafaultPrice = list.filter(function (x) {
          return x.isDefault === true;
        });
        if (isDeafaultPrice.length === 1) {
          return isDeafaultPrice[0].price;
        }
        list.forEach(function (item) {
          if (item.price < base) {
            base = item.price;
          }
        });
      } else {
        base = list.price;
      }
      return parseFloat(base);
    },
    formatPrice: function formatPrice(priceToClacl, k) {
      var price = this.calculatePrice(priceToClacl, k);
      if (price === '') return '';
      if (price === 0) return '';
      price = Number(price).toFixed(2);
      return price;
    },
    calculatePrice: function calculatePrice(item) {
      var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (k !== null) {
        // eslint-disable-next-line max-len
        return this.findCheapest(item.variants) + this.findCheapestOptions(item.options, item.quantityOfIncludedOptions) + (item.sizes[k].price || 0);
      }
      if (item.sizes.length > 1 && k !== 0) return '';
      // eslint-disable-next-line max-len
      return this.findCheapest(item.variants) + this.findCheapestOptions(item.options, item.quantityOfIncludedOptions) + this.findCheapest(item.sizes);
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_localization__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_localization___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_localization__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_icons_font_bootstrap_icons_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_icons_font_bootstrap_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_icons_font_bootstrap_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_web__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_storage__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_time__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_webshop_Categories__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_webshop_Items__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_webshop_MenuCategories__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_webshop_MenuItems__ = __webpack_require__(431);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





















new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 50));

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: '#efa546',
    secondary: '#efa546',
    accent: '#efa546',
    error: '#d84315',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FF8F00'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root =  true ? '/webshopplanet' : '/api';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.xhr = { withCredentials: true };
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.credentials = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a);

// Vue localization
__WEBPACK_IMPORTED_MODULE_5_vuejs_localization___default.a.requireAll(__webpack_require__(434));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuejs_localization___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__helpers_web__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__helpers_time__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__helpers_storage__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Categories', __WEBPACK_IMPORTED_MODULE_14__components_webshop_Categories__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Items', __WEBPACK_IMPORTED_MODULE_15__components_webshop_Items__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('MenuCategories', __WEBPACK_IMPORTED_MODULE_16__components_webshop_MenuCategories__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('MenuItems', __WEBPACK_IMPORTED_MODULE_17__components_webshop_MenuItems__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: Object(__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */])(),
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */] }
});

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac43107c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(294);
function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac43107c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422153d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(289);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-422153d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422153d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */,
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 58,
	"./af.js": 58,
	"./ar": 59,
	"./ar-dz": 60,
	"./ar-dz.js": 60,
	"./ar-kw": 61,
	"./ar-kw.js": 61,
	"./ar-ly": 62,
	"./ar-ly.js": 62,
	"./ar-ma": 63,
	"./ar-ma.js": 63,
	"./ar-sa": 64,
	"./ar-sa.js": 64,
	"./ar-tn": 65,
	"./ar-tn.js": 65,
	"./ar.js": 59,
	"./az": 66,
	"./az.js": 66,
	"./be": 67,
	"./be.js": 67,
	"./bg": 68,
	"./bg.js": 68,
	"./bm": 69,
	"./bm.js": 69,
	"./bn": 70,
	"./bn-bd": 71,
	"./bn-bd.js": 71,
	"./bn.js": 70,
	"./bo": 72,
	"./bo.js": 72,
	"./br": 73,
	"./br.js": 73,
	"./bs": 74,
	"./bs.js": 74,
	"./ca": 75,
	"./ca.js": 75,
	"./cs": 76,
	"./cs.js": 76,
	"./cv": 77,
	"./cv.js": 77,
	"./cy": 78,
	"./cy.js": 78,
	"./da": 79,
	"./da.js": 79,
	"./de": 80,
	"./de-at": 81,
	"./de-at.js": 81,
	"./de-ch": 82,
	"./de-ch.js": 82,
	"./de.js": 80,
	"./dv": 83,
	"./dv.js": 83,
	"./el": 84,
	"./el.js": 84,
	"./en-au": 85,
	"./en-au.js": 85,
	"./en-ca": 86,
	"./en-ca.js": 86,
	"./en-gb": 87,
	"./en-gb.js": 87,
	"./en-ie": 88,
	"./en-ie.js": 88,
	"./en-il": 89,
	"./en-il.js": 89,
	"./en-in": 90,
	"./en-in.js": 90,
	"./en-nz": 91,
	"./en-nz.js": 91,
	"./en-sg": 92,
	"./en-sg.js": 92,
	"./eo": 93,
	"./eo.js": 93,
	"./es": 94,
	"./es-do": 95,
	"./es-do.js": 95,
	"./es-mx": 96,
	"./es-mx.js": 96,
	"./es-us": 97,
	"./es-us.js": 97,
	"./es.js": 94,
	"./et": 98,
	"./et.js": 98,
	"./eu": 99,
	"./eu.js": 99,
	"./fa": 100,
	"./fa.js": 100,
	"./fi": 101,
	"./fi.js": 101,
	"./fil": 102,
	"./fil.js": 102,
	"./fo": 103,
	"./fo.js": 103,
	"./fr": 104,
	"./fr-ca": 105,
	"./fr-ca.js": 105,
	"./fr-ch": 106,
	"./fr-ch.js": 106,
	"./fr.js": 104,
	"./fy": 107,
	"./fy.js": 107,
	"./ga": 108,
	"./ga.js": 108,
	"./gd": 109,
	"./gd.js": 109,
	"./gl": 110,
	"./gl.js": 110,
	"./gom-deva": 111,
	"./gom-deva.js": 111,
	"./gom-latn": 112,
	"./gom-latn.js": 112,
	"./gu": 113,
	"./gu.js": 113,
	"./he": 114,
	"./he.js": 114,
	"./hi": 115,
	"./hi.js": 115,
	"./hr": 116,
	"./hr.js": 116,
	"./hu": 117,
	"./hu.js": 117,
	"./hy-am": 118,
	"./hy-am.js": 118,
	"./id": 119,
	"./id.js": 119,
	"./is": 120,
	"./is.js": 120,
	"./it": 121,
	"./it-ch": 122,
	"./it-ch.js": 122,
	"./it.js": 121,
	"./ja": 123,
	"./ja.js": 123,
	"./jv": 124,
	"./jv.js": 124,
	"./ka": 125,
	"./ka.js": 125,
	"./kk": 126,
	"./kk.js": 126,
	"./km": 127,
	"./km.js": 127,
	"./kn": 128,
	"./kn.js": 128,
	"./ko": 129,
	"./ko.js": 129,
	"./ku": 130,
	"./ku.js": 130,
	"./ky": 131,
	"./ky.js": 131,
	"./lb": 132,
	"./lb.js": 132,
	"./lo": 133,
	"./lo.js": 133,
	"./lt": 134,
	"./lt.js": 134,
	"./lv": 135,
	"./lv.js": 135,
	"./me": 136,
	"./me.js": 136,
	"./mi": 137,
	"./mi.js": 137,
	"./mk": 138,
	"./mk.js": 138,
	"./ml": 139,
	"./ml.js": 139,
	"./mn": 140,
	"./mn.js": 140,
	"./mr": 141,
	"./mr.js": 141,
	"./ms": 142,
	"./ms-my": 143,
	"./ms-my.js": 143,
	"./ms.js": 142,
	"./mt": 144,
	"./mt.js": 144,
	"./my": 145,
	"./my.js": 145,
	"./nb": 146,
	"./nb.js": 146,
	"./ne": 147,
	"./ne.js": 147,
	"./nl": 148,
	"./nl-be": 149,
	"./nl-be.js": 149,
	"./nl.js": 148,
	"./nn": 150,
	"./nn.js": 150,
	"./oc-lnc": 151,
	"./oc-lnc.js": 151,
	"./pa-in": 152,
	"./pa-in.js": 152,
	"./pl": 153,
	"./pl.js": 153,
	"./pt": 154,
	"./pt-br": 155,
	"./pt-br.js": 155,
	"./pt.js": 154,
	"./ro": 156,
	"./ro.js": 156,
	"./ru": 157,
	"./ru.js": 157,
	"./sd": 158,
	"./sd.js": 158,
	"./se": 159,
	"./se.js": 159,
	"./si": 160,
	"./si.js": 160,
	"./sk": 161,
	"./sk.js": 161,
	"./sl": 162,
	"./sl.js": 162,
	"./sq": 163,
	"./sq.js": 163,
	"./sr": 164,
	"./sr-cyrl": 165,
	"./sr-cyrl.js": 165,
	"./sr.js": 164,
	"./ss": 166,
	"./ss.js": 166,
	"./sv": 167,
	"./sv.js": 167,
	"./sw": 168,
	"./sw.js": 168,
	"./ta": 169,
	"./ta.js": 169,
	"./te": 170,
	"./te.js": 170,
	"./tet": 171,
	"./tet.js": 171,
	"./tg": 172,
	"./tg.js": 172,
	"./th": 173,
	"./th.js": 173,
	"./tk": 174,
	"./tk.js": 174,
	"./tl-ph": 175,
	"./tl-ph.js": 175,
	"./tlh": 176,
	"./tlh.js": 176,
	"./tr": 177,
	"./tr.js": 177,
	"./tzl": 178,
	"./tzl.js": 178,
	"./tzm": 179,
	"./tzm-latn": 180,
	"./tzm-latn.js": 180,
	"./tzm.js": 179,
	"./ug-cn": 181,
	"./ug-cn.js": 181,
	"./uk": 182,
	"./uk.js": 182,
	"./ur": 183,
	"./ur.js": 183,
	"./uz": 184,
	"./uz-latn": 185,
	"./uz-latn.js": 185,
	"./uz.js": 184,
	"./vi": 186,
	"./vi.js": 186,
	"./x-pseudo": 187,
	"./x-pseudo.js": 187,
	"./yo": 188,
	"./yo.js": 188,
	"./zh-cn": 189,
	"./zh-cn.js": 189,
	"./zh-hk": 190,
	"./zh-hk.js": 190,
	"./zh-mo": 191,
	"./zh-mo.js": 191,
	"./zh-tw": 192,
	"./zh-tw.js": 192
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mb-3"},[(!_vm.cookieAccepted)?_c('div',{staticClass:"cookie-message pa-4",style:(("background-color: " + (_vm.goDark ? '#424242' : 'white')))},[_vm._v("\n    "+_vm._s(_vm.$lang.header.cookie_1)+" "),_c('a',{staticClass:"primary--text",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.inNewTab('data-protection')}}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))]),_vm._v(".\n    "+_vm._s(_vm.$lang.header.cookie_2)+".\n    "),_c('v-btn',{staticClass:"primary elevation-0",on:{"click":function($event){return _vm.acceptCookies()}}},[_vm._v(_vm._s(_vm.$lang.header.accept))])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{class:{'header-move': _vm.backlink && _vm.$vuetify.breakpoint.smAndUp},staticStyle:{"max-width":"1440px"},attrs:{"xs12":"","pl-4":_vm.$vuetify.breakpoint.lgAndUp}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[(_vm.backlink && _vm.$vuetify.breakpoint.smAndUp)?_c('v-flex',{staticClass:"backlink-style",attrs:{"xs12":"","pl-4":_vm.$vuetify.breakpoint.lgAndUp}},[_c('v-layout',{staticStyle:{"max-width":"1440px","margin":"auto"},attrs:{"row":"","wrap":"","fill-height":"","align-center":"","justify-center":""}},[_c('v-flex',{staticStyle:{"max-width":"1440px","padding-left":"24px"},attrs:{"grow":""}},[_c('h4',{staticClass:"primary-text-color"},[_c('a',{attrs:{"href":_vm.backlinkUrl}},[_c('v-icon',{staticClass:"pr-2",attrs:{"color":"#efa546","size":"16"}},[_vm._v("keyboard_arrow_left")]),_vm._v(_vm._s(_vm.$lang.global.backTo)+" "+_vm._s(_vm.backlink.toUpperCase()))],1)])])],1)],1):_vm._e(),_vm._v(" "),(_vm.companyActive !== false)?_c('v-flex',{staticClass:"text-xs-center text-sm-right actions",staticStyle:{"max-width":"100vw"},attrs:{"order-xs0":"","order-sm1":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":_vm.backlink && _vm.$vuetify.breakpoint.xsOnly,"justify-center":!_vm.backlink && _vm.$vuetify.breakpoint.smAndDown,"justify-end":_vm.$vuetify.breakpoint.mdAndUp}},[(_vm.backlink && _vm.$vuetify.breakpoint.xsOnly)?_c('div',{staticClass:"d-inline-flex align-center text-xs-right"},[_c('span',{staticClass:"primary-text-color"},[_c('a',{staticStyle:{"line-height":"24px"},attrs:{"href":_vm.backlinkUrl}},[_c('v-icon',{staticClass:"pr-2",attrs:{"color":"#efa546","size":"16"}},[_vm._v("keyboard_arrow_left")]),_vm._v(_vm._s((_vm.$lang.actions.back).toUpperCase()))],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-inline-flex align-center text-xs-right",staticStyle:{"max-width":"100vw"}},[(_vm.intercomVisible)?_c('v-btn',{staticClass:"hidden-on-phone",attrs:{"id":"chat","flat":"","small":"","color":"primary ma-0"},on:{"click":_vm.activateIntercom}},[_c('v-icon',[_vm._v("chat_bubble_outline")]),_vm._v("  "+_vm._s(_vm.$lang.labels.chat)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && _vm.isAdmin)?_c('v-btn',{attrs:{"id":"visits","flat":"","small":"","color":"primary ma-0"},on:{"click":_vm.toVisits}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("admin_panel_settings")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.besuche)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && _vm.isAdmin)?_c('v-btn',{attrs:{"id":"orders","flat":"","small":"","color":"primary ma-0"},on:{"click":_vm.toOrders}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("admin_panel_settings")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.orders)+"\n              ")],1):_vm._e(),_vm._v(" "),(!_vm.isLoggedIn && _vm.$route.name !== 'registration' && _vm.$route.name !== 'ContactTracking')?_c('v-btn',{attrs:{"id":"register","flat":"","small":"","color":"primary ma-0"},on:{"click":_vm.toRegistration}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("person_outline")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.register)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && _vm.$route.name !== 'registration' && _vm.$route.name !== 'login')?_c('v-btn',{attrs:{"id":"orderHistory","flat":"","small":"","color":"primary ma-0"},on:{"click":function($event){return _vm.$router.push({ name: 'orderHistory' })}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("list")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.history)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && _vm.$route.name !== 'registration' && _vm.$route.name !== 'login')?_c('v-btn',{attrs:{"id":"settings","flat":"","small":"","color":"primary ma-0"},on:{"click":_vm.toAddresses}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("settings")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.settings)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.isLoggedIn && _vm.$route.name !== 'login')?_c('v-btn',{attrs:{"flat":"","small":"","color":"primary ma-0 ml-4"},on:{"click":_vm.logout}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("exit_to_app")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.logout)+"\n              ")],1):(!_vm.isLoggedIn && _vm.$route.name !== 'login' && _vm.$route.name !== 'ContactTracking')?_c('v-btn',{attrs:{"id":"login","flat":"","small":"","color":"primary ma-0 ml-4"},on:{"click":_vm.toLogin}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("person")]),_vm._v("\n                "+_vm._s(_vm.$lang.header.login)+"\n              ")],1):_vm._e()],1)])],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"header-image",attrs:{"row":"","wrap":""}},[(_vm.headerImage)?_c('v-img',{staticClass:"header-image",staticStyle:{"max-height":"350px","width":"90vw","margin":"auto"},attrs:{"contain":"","src":_vm.headerImage}}):_vm._e()],1),_vm._v(" "),(_vm.company)?_c('v-layout',{staticClass:"mobile-card px-2",staticStyle:{"margin-top":"10px"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-card',{staticClass:"pa-4",staticStyle:{"min-height":"140px"},attrs:{"id":"headerCard"}},[_c('v-layout',{staticClass:"mb-3 mb-sm-0 layout-fix",attrs:{"row":""}},[(_vm.logoImage)?_c('img',{staticStyle:{"max-height":"120px","max-width":"120px","background-position":"unset"},attrs:{"src":_vm.logoImage}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rest-desc text-xs-left pl-4"},[_c('h3',{staticClass:"mb-2",on:{"click":function($event){return _vm.$router.push({ name: 'webShop' })}}},[_vm._v(_vm._s(_vm.company.name.toUpperCase()))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                  "+_vm._s(_vm.generateAddress([
                      _vm.company.address.line1,
                      _vm.company.address.line2,
                      _vm.company.address.line3,
                      _vm.company.address.line4 ])))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                  "+_vm._s(_vm.company.address.locality ? _vm.company.address.locality + ', ' : '')+"\n                  "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.townCity : _vm.company.address.postalCode)+",\n                  "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.postalCode : _vm.company.address.townCity)+"\n                ")])])]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mb-sm-0 phone-layout-fix",attrs:{"column":"","justify-end":""}},[(_vm.company.phone)?_c('a',{staticClass:"hidden-on-phone",staticStyle:{"text-decoration":"none","font-size":"16px"},attrs:{"href":("tel:" + (_vm.company.phone))}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v("phone")]),_vm._v("\n                "+_vm._s(_vm.company.phone)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.company.email)?_c('div',{staticClass:"hidden-on-phone",staticStyle:{"font-size":"16px"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v("email")]),_vm._v("\n                "+_vm._s(_vm.company.email)+"\n              ")],1):_vm._e()])],1)],1):_vm._e(),_vm._v(" "),(_vm.company)?_c('v-layout',{staticClass:"desktop-card",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-layout',{staticClass:"mb-3 mb-sm-0 layout-fix",attrs:{"row":""}},[(_vm.logoImage)?_c('img',{staticClass:"mr-4",staticStyle:{"max-height":"90px","max-width":"350px"},attrs:{"src":_vm.logoImage}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rest-desc"},[_c('h2',{on:{"click":function($event){return _vm.$router.push({ name: 'webShop' })}}},[_vm._v(_vm._s(_vm.company.name))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                  "+_vm._s(_vm.generateAddress([
                      _vm.company.address.line1,
                      _vm.company.address.line2,
                      _vm.company.address.line3,
                      _vm.company.address.line4 ])))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                  "+_vm._s(_vm.company.address.locality ? _vm.company.address.locality + ', ' : '')+"\n                  "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.townCity : _vm.company.address.postalCode)+",\n                  "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.postalCode : _vm.company.address.townCity)+"\n                ")])])]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mb-sm-0 phone-layout-fix",attrs:{"column":"","justify-end":""}},[(_vm.company.phone)?_c('a',{staticClass:"hidden-on-phone",staticStyle:{"text-decoration":"none","font-size":"16px"},attrs:{"href":("tel:" + (_vm.company.phone))}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v("phone")]),_vm._v("\n                "+_vm._s(_vm.company.phone)+"\n              ")],1):_vm._e(),_vm._v(" "),(_vm.company.email)?_c('div',{staticClass:"hidden-on-phone",staticStyle:{"font-size":"16px"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v("email")]),_vm._v("\n                "+_vm._s(_vm.company.email)+"\n              ")],1):_vm._e()])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.success)?_c('v-alert',{staticClass:"success",attrs:{"color":"success","icon":"check","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.company && _vm.company.webShopResourceStatus !== 'active')?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.$lang.header.notActive)+"\n          ")]):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9ecb2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(291)
  __webpack_require__(292)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d9ecb2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d9ecb2f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-4 pt-4"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-layout',{staticStyle:{"max-width":"1440px"},attrs:{"px-4":"","pb-4":"","row":"","wrap":"","justify-space-between":""}},[(_vm.company)?_c('v-flex',{staticClass:"text-xs-center text-sm-left mt-3"},[(_vm.company.paymentTypes)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.paymentMethods)+": ")]),_vm._v(" "),_vm._l((_vm.company.paymentTypes),function(method,index){return _c('span',{key:index},[_vm._v("\n            "+_vm._s(_vm.$lang.global[method])+_vm._s(index + 1 === _vm.company.paymentTypes.length ? '' : ', ')+"\n          ")])})],2):_vm._e(),_vm._v(" "),(_vm.company.orderTypes)?_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.deliveryMethods)+":")]),_vm._v(" "),_vm._l((_vm.company.orderTypes),function(type,index){return _c('span',{key:index},[_vm._v(_vm._s(index === 0 ? ' ' : ', ')+_vm._s(_vm.$lang.actions[type]))])})],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$lang.global.sysVersion)+": "+_vm._s(_vm.company.systemVersion))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.global.feVersion)+": "+_vm._s(_vm.feVersion))]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$lang.global.resourceId)+": "+_vm._s(_vm.resource))])]):_vm._e(),_vm._v(" "),(_vm.company && _vm.company.orderTypes && _vm.company.orderTypes.includes('delivery'))?_c('v-flex',{staticClass:"text-xs-center text-sm-left mt-3 pl-2"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.orderFees)+":")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.deliveryCharges)}})]):_vm._e(),_vm._v(" "),(_vm.workingHours)?_c('v-flex',{staticClass:"text-xs-center text-sm-left mt-3 pl-2"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.openingHours)+":")])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.workingHours)}})]):_vm._e(),_vm._v(" "),(_vm.companyActive !== false)?_c('v-flex',{class:{
        'quicklinks text-xs-center text-sm-left pl-2': true,
         'mt-3': !_vm.isLoggedIn
         }},[(!_vm.isLoggedIn)?_c('div',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.quickLinks)+":")])]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'login' }}},[_vm._v(_vm._s(_vm.$lang.header.login))]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'registration' }}},[_vm._v(_vm._s(_vm.$lang.header.register))]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'forgotPassword' }}},[_vm._v(_vm._s(_vm.$lang.global.forgotPassword))])],1):_vm._e(),_vm._v(" "),_c('p',{staticClass:"pt-2 mt-1"},[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.language)+":")])]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.langChange('de')}}},[_vm._v(_vm._s(_vm.$lang.global.german))]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.langChange('en')}}},[_vm._v(_vm._s(_vm.$lang.global.english))]),_vm._v(" "),_c('p',{staticClass:"pt-2 mt-1"},[_c('strong',[_vm._v(_vm._s(_vm.$lang.global.theme)+":")])]),_vm._v(" "),_c('p',{on:{"click":function($event){return _vm.changeTheme()}}},[_vm._v("\n          "+_vm._s(_vm.goDark ? _vm.$lang.global.light : _vm.$lang.global.dark)+"\n        ")])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"copyright"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","fill-height":"","align-center":""}},[_c('v-layout',{staticStyle:{"max-width":"1440px"},attrs:{"px-4":"","row":"","wrap":"","justify-space-between":"","fill-height":"","align-center":""}},[_c('v-flex',{attrs:{"sm6":""}},[(_vm.formatedHtmlHints['webshop.footer.copyright-html'])?_c('p',{staticClass:"mr-3 mb-0",domProps:{"innerHTML":_vm._s(_vm.formatedHtmlHints['webshop.footer.copyright-html'])}}):_vm._e(),_vm._v(" "),(_vm.company && !_vm.formatedHtmlHints['webshop.footer.copyright-html'])?_c('p',{staticClass:"mr-3 mb-0"},[_vm._v("\n            "+_vm._s(new Date().getFullYear())+" © "+_vm._s(_vm.company.name)+" "+_vm._s(_vm.$lang.global.allRights)+".\n          ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"text-sm-right":"","sm6":""}},[_c('p',{staticClass:"mb-0"},[(_vm.formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link'])?_c('a',{staticClass:"mr-3",attrs:{"href":("/" + (_vm.$route.params.lang) + "/" + (_vm.formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link'])),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))]):_c('a',{staticClass:"mr-3",attrs:{"href":("/" + (_vm.$route.params.lang) + "/data-protection-policy"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))]),_vm._v(" "),(_vm.formatedHtmlHints['webshop.footer.termins-and-conditions-link'])?_c('a',{attrs:{"href":("/" + (_vm.$route.params.lang) + "/" + (_vm.formatedHtmlHints['webshop.footer.termins-and-conditions-link'])),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.tearmsConditions))]):_c('a',{attrs:{"href":("/" + (_vm.$route.params.lang) + "/terms-and-Conditions"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.tearmsConditions))])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'disable-scroll': _vm.modal },attrs:{"id":"app"}},[_c('div',{},[_c('v-app',{attrs:{"dark":_vm.goDark}},[_c('v-layout',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'padding: 16px 10px' : ''),attrs:{"column":"","py-2":"","px-4":_vm.$vuetify.breakpoint.mdAndUp}},[(_vm.$route.name !== 'passwordReset')?_c('Header'):_vm._e(),_vm._v(" "),(_vm.companyActive !== false)?[_c('router-view')]:_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.$lang.global.notAvailable)+"\n        ")])],2),_vm._v(" "),(_vm.$route.name !== 'passwordReset')?_c('Footer'):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContactTracking__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_webshop_Login__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_webshop_Password_reset__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_webshop_Password_forgot__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_webshop_Registration__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_webshop_Activate__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_webshop_Addresses__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_webshop_Order_info__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_404__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Protection_terms__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Payments__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_webshop_userOrderHistory_OrderHistory__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_VisitsSearch__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_OrdersAdmin_Orders__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_OrdersAdmin_OrdersSearch__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_OrdersAdmin_Blacklist__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Rate__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_webshop_Menu__ = __webpack_require__(382);

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var lang = function lang() {
  var company = localStorage.company ? JSON.parse(localStorage.company) : null;
  if (company) {
    return localStorage.getItem('lang') || company.defaultLanguage || 'en';
  }
  return localStorage.getItem('lang') || 'en';
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/id/:resource',
    redirect: '/' + lang() + '/id/:resource'
  }, {
    path: '/payment/:resourceId/:orderId',
    redirect: function redirect(from) {
      return {
        path: '/' + lang() + '/payment/:resourceId/:orderId',
        query: from.query
      };
    }
  }, {
    path: '/reset/:resourceId/:id',
    redirect: function redirect(from) {
      return {
        path: '/' + lang() + '/reset/:resourceId/:id',
        query: from.query
      };
    }
  }, {
    path: '/activate/:resourceId/:hash',
    redirect: function redirect(from) {
      return {
        path: '/' + lang() + '/activate/:resourceId/:hash',
        query: from.query
      };
    }
  }, {
    path: '/contact-tracking/:resourceId?/:tableName?',
    redirect: function redirect(from) {
      return {
        path: '/' + lang() + '/contact-tracking/:resourceId?/:tableName?',
        query: from.query
      };
    }
  }, {
    path: '/menu',
    redirect: function redirect(from) {
      return {
        path: '/' + lang() + '/menu',
        query: from.query
      };
    }
  }, {
    path: '/',
    redirect: '/' + lang()
  }, {
    path: '/:lang',
    component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
      props: true,
      name: 'webShop'
    }, {
      path: 'contact-tracking/:resourceId?/:tableName?',
      component: __WEBPACK_IMPORTED_MODULE_3__components_ContactTracking__["a" /* default */],
      props: true,
      name: 'ContactTracking'
    }, {
      path: 'rate/:resourceId/:hash',
      component: __WEBPACK_IMPORTED_MODULE_20__components_Rate__["a" /* default */],
      props: true,
      name: 'Rate'
    }, {
      path: 'visits',
      component: __WEBPACK_IMPORTED_MODULE_16__components_VisitsSearch__["a" /* default */],
      name: 'VisitsSearch'
    }, {
      path: 'orders',
      component: __WEBPACK_IMPORTED_MODULE_17__components_OrdersAdmin_Orders__["a" /* default */],
      children: [{
        path: '',
        redirect: {
          name: 'ordersSearch'
        }
      }, {
        path: 'search',
        component: __WEBPACK_IMPORTED_MODULE_18__components_OrdersAdmin_OrdersSearch__["a" /* default */],
        name: 'ordersSearch'
      }, {
        path: 'blacklist',
        component: __WEBPACK_IMPORTED_MODULE_19__components_OrdersAdmin_Blacklist__["a" /* default */],
        name: 'blacklist'
      }]
    }, {
      path: 'addresses',
      component: __WEBPACK_IMPORTED_MODULE_10__components_webshop_Addresses__["a" /* default */],
      name: 'addresses'
    }, {
      path: 'order-info',
      component: __WEBPACK_IMPORTED_MODULE_11__components_webshop_Order_info__["a" /* default */],
      name: 'orderInfo'
    }, {
      path: 'login',
      component: __WEBPACK_IMPORTED_MODULE_5__components_webshop_Login__["a" /* default */],
      name: 'login'
    }, {
      path: 'reset',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        name: 'forgotPassword',
        component: __WEBPACK_IMPORTED_MODULE_7__components_webshop_Password_forgot__["a" /* default */]
      }, {
        path: ':resourceId/:id',
        name: 'passwordReset',
        component: __WEBPACK_IMPORTED_MODULE_6__components_webshop_Password_reset__["a" /* default */]
      }]
    }, {
      path: 'registration',
      component: __WEBPACK_IMPORTED_MODULE_8__components_webshop_Registration__["a" /* default */],
      name: 'registration'
    }, {
      path: 'activate',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        redirect: { name: 'login' }
      }, {
        path: ':resourceId/:hash',
        component: __WEBPACK_IMPORTED_MODULE_9__components_webshop_Activate__["a" /* default */],
        name: 'activate'
      }]
    }, {
      path: 'terms-and-Conditions',
      name: 'terms',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Protection_terms__["a" /* default */]
    }, {
      path: 'data-protection-policy',
      name: 'data-protection',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Protection_terms__["a" /* default */]
    }, {
      path: 'payment',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        redirect: { path: '/' + lang() }
      }, {
        path: ':resourceId/:orderId',
        name: 'payment',
        component: __WEBPACK_IMPORTED_MODULE_14__components_Payments__["a" /* default */]
      }]
    }, {
      path: 'id',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        redirect: { name: 'webShop' }
      }, {
        path: ':resource',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
        name: 'resourceSet'
      }]
    }, {
      path: 'order-history',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_15__components_webshop_userOrderHistory_OrderHistory__["a" /* default */],
        name: 'orderHistory'
      }]
    }, {
      path: 'menu',
      component: __WEBPACK_IMPORTED_MODULE_4__components_EmptyLayout__["a" /* default */],
      children: [{
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_21__components_webshop_Menu__["a" /* default */],
        name: 'menu'
      }]
    }, {
      path: ':resource',
      component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
      name: 'resourceSet2'
    }, {
      path: '/*',
      name: '404',
      component: __WEBPACK_IMPORTED_MODULE_12__components_404__["a" /* default */]
    }]
  }],
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history'
});

// eslint-disable-next-line no-unused-vars
// router.beforeEach((to, from, next) => {
//   window.Intercom('update');
// });

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ef4024_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(315);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ef4024_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingBasket_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326b75a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingBasket_vue__ = __webpack_require__(314);
function injectStyle (ssrContext) {
  __webpack_require__(302)
  __webpack_require__(303)
  __webpack_require__(304)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-326b75a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShoppingBasket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326b75a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShoppingBasket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchAt_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9647d3ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchAt_vue__ = __webpack_require__(309);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9647d3ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchAt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9647d3ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchAt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-0 ma-0",style:(_vm.$vuetify.breakpoint.smAndDown ? 'background-color: transparent; overflow: unset' : 'overflow: unset'),attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"id":"postalCode","clearable":"","hide-selected":"","items":_vm.postalCodes,"loading":_vm.isLoading,"search-input":_vm.search,"hide-no-data":"","validate-on-blur":"","rules":[_vm.postalCodeRules],"label":_vm.$lang.labels.postalCode,"placeholder":_vm.$lang.labels.startTyping,"hint":_vm.hint},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event},"blur":function($event){return _vm.onBlurPostal()},"input":function($event){return _vm.moveToLine1()}},model:{value:(_vm.postalcode),callback:function ($$v) {_vm.postalcode=$$v},expression:"postalcode"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"line1","clearable":"","hide-selected":"","validate-on-blur":"","loading":_vm.isLoadingAddress,"search-input":_vm.searchLine1,"items":_vm.addressesLine1,"hide-no-data":"","rules":[function (v) { return _vm.addressesLine1.includes(v) || _vm.showError('line1'); }],"label":_vm.$lang.labels.line1AT,"placeholder":_vm.$lang.labels.startTyping},on:{"update:searchInput":function($event){_vm.searchLine1=$event},"update:search-input":function($event){_vm.searchLine1=$event},"input":function($event){return _vm.moveToHouseNo()}},model:{value:(_vm.line1),callback:function ($$v) {_vm.line1=$$v},expression:"line1"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"line2","clearable":"","hide-selected":"","validate-on-blur":"","search-input":_vm.searchLine2,"items":_vm.addressesLine2,"hide-no-data":"","rules":[function (v) { return _vm.addressesLine2.includes(v) || _vm.showError('line2'); }],"label":_vm.$lang.labels.line2AT,"placeholder":_vm.$lang.labels.startTyping},on:{"update:searchInput":function($event){_vm.searchLine2=$event},"update:search-input":function($event){_vm.searchLine2=$event},"blur":function($event){return _vm.onBlurLine2()}},model:{value:(_vm.line2),callback:function ($$v) {_vm.line2=$$v},expression:"line2"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"id":"line3","label":_vm.$lang.labels.line3AT},model:{value:(_vm.line3),callback:function ($$v) {_vm.line3=$$v},expression:"line3"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"townCity","clearable":"","hide-selected":"","validate-on-blur":"","search-input":_vm.searchTownCity,"items":_vm.addressesTownCity,"hide-no-data":"","rules":[function (v) { return _vm.addressesTownCity.includes(v) || _vm.showError('townCity'); }],"label":_vm.$lang.labels.townCity,"placeholder":_vm.$lang.labels.startTyping},on:{"update:searchInput":function($event){_vm.searchTownCity=$event},"update:search-input":function($event){_vm.searchTownCity=$event}},model:{value:(_vm.townCity),callback:function ($$v) {_vm.townCity=$$v},expression:"townCity"}})],1),_vm._v(" "),_c('p',{staticStyle:{"display":"none !important"}},[_vm._v(_vm._s(_vm.isValid))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchUk_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eeb35bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchUk_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eeb35bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSearchUk_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eeb35bc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSearchUk_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-0 ma-0",style:(_vm.$vuetify.breakpoint.smAndDown ? 'background-color: transparent; overflow: unset' : 'overflow: unset'),attrs:{"flat":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"id":"postalCode","clearable":"","hide-selected":"","items":_vm.postalCodes,"loading":_vm.isLoading,"search-input":_vm.search,"hide-no-data":"","rules":[_vm.postalCodeRules],"label":_vm.$lang.labels.postalCode,"placeholder":_vm.$lang.labels.startTyping,"hint":_vm.hint},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.postalcode),callback:function ($$v) {_vm.postalcode=$$v},expression:"postalcode"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"line1","clearable":"","hide-selected":"","validate-on-blur":"","loading":_vm.isLoadingAddress,"search-input":_vm.searchLine1,"items":_vm.addressesResultFiltered,"item-text":_vm.line1 ? 'line1' : function (v) { return _vm.generateAddress(v); },"item-value":"line1","hide-no-data":"","rules":[function (v) { return _vm.addressesResultFiltered.map(function (y) { return y.line1; }).includes(v) || _vm.showError('line1'); }],"label":_vm.$lang.labels.line1,"placeholder":_vm.addressesResultFiltered && _vm.addressesResultFiltered.length > 0 ? _vm.$lang.labels.startTyping : 'Nothing to search'},on:{"focus":function($event){_vm.line1 = null; _vm.addressLookup(_vm.postalcode)}},model:{value:(_vm.line1),callback:function ($$v) {_vm.line1=$$v},expression:"line1"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"line2","clearable":"","hide-selected":"","search-input":_vm.searchLine2,"items":_vm.addressesLine2,"hide-no-data":"","label":_vm.$lang.labels.line2,"placeholder":_vm.addressesLine2 && _vm.addressesLine2.length > 0 ? _vm.$lang.labels.startTyping : 'Nothing to search'},on:{"update:searchInput":function($event){_vm.searchLine2=$event},"update:search-input":function($event){_vm.searchLine2=$event},"blur":function($event){return _vm.onBlurLine2()}},model:{value:(_vm.line2),callback:function ($$v) {_vm.line2=$$v},expression:"line2"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"line3","clearable":"","hide-selected":"","search-input":_vm.searchLine3,"items":_vm.addressesLine3,"hide-no-data":"","label":_vm.$lang.labels.line3,"placeholder":_vm.addressesLine3 && _vm.addressesLine3.length > 0 ? _vm.$lang.labels.startTyping : 'Nothing to search'},on:{"update:searchInput":function($event){_vm.searchLine3=$event},"update:search-input":function($event){_vm.searchLine3=$event}},model:{value:(_vm.line3),callback:function ($$v) {_vm.line3=$$v},expression:"line3"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"id":"line4","label":_vm.$lang.labels.line4},model:{value:(_vm.line4),callback:function ($$v) {_vm.line4=$$v},expression:"line4"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"id":"townCity","clearable":"","hide-selected":"","items":_vm.addressesTownCity,"hide-no-data":"","validate-on-blur":"","rules":[function (v) { return _vm.addressesTownCity.includes(v) || _vm.showError('townCity'); }],"label":_vm.$lang.labels.townCity,"placeholder":_vm.addressesTownCity && _vm.addressesTownCity.length > 0 ? _vm.$lang.labels.startTyping : 'Nothing to search'},model:{value:(_vm.townCity),callback:function ($$v) {_vm.townCity=$$v},expression:"townCity"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-1",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"id":"locality","label":_vm.$lang.labels.locality},model:{value:(_vm.locality),callback:function ($$v) {_vm.locality=$$v},expression:"locality"}})],1),_vm._v(" "),_c('p',{staticStyle:{"display":"none !important"}},[_vm._v(_vm._s(_vm.isValid))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-layout',{staticStyle:{"max-height":"64px"},attrs:{"row":"","justify-space-between":"","pl-4":"","pb-3":""}},[_c('h2',{staticClass:"pt-2 mt-1"},[_vm._v(_vm._s(_vm.$lang.labels.allergens))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","dark":"","color":"secondary","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("X\n    ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":"","pl-4":"","align-start":"","fill-height":""}},[_vm._l((_vm.allergens),function(item,index){return [_c('v-flex',{key:index,attrs:{"xs12":"","pb-1":""}},[_c('span',{staticClass:"p-0 m-0"},[_vm._v("- "+_vm._s(_vm.formatAllergen(item)))])])]})],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-end":"","pb-1":"","pt-3":""}},[_c('v-btn',{attrs:{"small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("OK\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showNav)?_c('v-toolbar',{staticClass:"mini-shopping-basket align-center",attrs:{"fixed":"","light":""}},[(_vm.company && _vm.logoImage)?_c('img',{staticClass:"mobile-card",staticStyle:{"max-height":"42px","max-width":"120px","background-position":"unset"},attrs:{"src":_vm.logoImage,"alt":"Logo"}}):_vm._e(),_vm._v(" "),(_vm.company)?_c('h5',{class:{'short-name': true, 'desktop-card': _vm.logoImage}},[_vm._v(_vm._s(_vm.company.name))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-layout',{staticStyle:{"height":"56px"},attrs:{"row":"","align-center":"","justify-end":""}},[_c('div',{staticClass:"text-xs-right"},[_c('span',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$lang.labels.total)+":")]),_vm._v(" "),_c('span',{staticClass:"price no-min",attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : '₤'}},[_vm._v(_vm._s(_vm.total.toFixed(2)))])]),_vm._v(" "),_c('v-btn',{staticClass:"elevation-0 sticky-button",attrs:{"color":"primary"},on:{"click":_vm.headerSubmit}},[_vm._v(_vm._s(_vm.$lang.actions.checkout))])],1)],1):_vm._e()],1),_vm._v(" "),_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$lang.global.shoppingBasket))]),_vm._v(" "),_c('v-layout',{ref:"shoppingBasket",attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"sub-header"},[_c('p',{staticClass:"inline"},[_vm._v(_vm._s(_vm.$lang.global.deliveryMethod)+":")])]),_vm._v(" "),_c('v-flex',{staticClass:"radio-wrap"},[_c('v-radio-group',{staticClass:"pt-0",on:{"change":_vm.setOrderType},model:{value:(_vm.orderType),callback:function ($$v) {_vm.orderType=$$v},expression:"orderType"}},[(_vm.company)?_c('v-layout',{staticClass:"radio-wrap pt-0",attrs:{"row":"","wrap":"","justify-start":"","align-center":""}},_vm._l((_vm.company.orderTypes),function(type,index){return _c('v-flex',{key:index},[_c('v-radio',{staticClass:"single-radio",attrs:{"type":"radio","label":_vm.$lang.actions[type],"value":type}})],1)}),1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.orderType === 'delivery')?_c('v-layout',{attrs:{"column":""}},[(_vm.isLoggedIn())?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.addressesForLoggedInUser,"label":_vm.$lang.labels.selectAddress,"single-line":""},model:{value:(_vm.selectAddress),callback:function ($$v) {_vm.selectAddress=$$v},expression:"selectAddress"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isLoggedIn() || _vm.showAddressFields)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":"","wrap":"","align-center":""}},[(_vm.company && _vm.company.address.country === 'AT')?_c('address-at',{attrs:{"address":_vm.chosenAddress,"fromBack":_vm.fromBack},on:{"submit":_vm.submitAddress,"resetFromBack":function($event){return _vm.resetFromBack()}}}):_vm._e(),_vm._v(" "),(_vm.company && _vm.company.address.country === 'UK')?_c('address-uk',{attrs:{"address":_vm.chosenAddress,"fromBack":_vm.fromBack},on:{"submit":_vm.submitAddress,"resetFromBack":function($event){return _vm.resetFromBack()}}}):_vm._e()],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.cart.length > 0)?_c('div',{staticClass:"v-table__overflow mb-4 "},[_c('table',{staticClass:"v-datatable v-table px-0"},[_c('thead',{staticClass:"pb-2"},[_c('tr',{style:(_vm.goDark ? 'background-color: #424242; color: white' : '')},[_c('th',{staticClass:"column total text-xs-left pl-3",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.quantity))]),_vm._v(" "),_c('th',{staticClass:"column total text-xs-left pl-1",attrs:{"colspan":"2","role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.name)+"\n          ")]),_vm._v(" "),_c('th',{staticClass:"column total text-xs-right pr-3",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.total))])]),_vm._v(" "),_c('tr',{staticClass:"v-datatable__progress"},[_c('th',{staticClass:"column",attrs:{"colspan":"100%"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.cart),function(item,index){return [_c('tr',{key:index,staticClass:"item",style:(_vm.goDark && index %2 ? 'background-color: #303030' : '')},[_c('td',{staticClass:"text-xs-left pa-3",staticStyle:{"min-width":"110px","width":"110px"}},[_c('v-btn',{attrs:{"dark":"","small":"","color":"primary mx-0 my-btn"},on:{"click":function($event){return _vm.editQuantity(index, 'dec')}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("remove")])],1),_vm._v(" "),_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","small":"","color":"accent mx-0 my-btn"},on:{"click":function($event){return _vm.editQuantity(index, 'asc')}}},[_c('v-icon',{attrs:{"id":"addMore","dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left py-3 px-1",attrs:{"colspan":"2"}},[_vm._v(_vm._s(item.name[_vm.$lang.current_lang] ? item.name[_vm.$lang.current_lang] : item.name.en)),_c('br'),_vm._v(" "),(item.selectedSize.name && !item.selectedSize.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v(_vm._s(_vm.$lang.labels.size)+": "+_vm._s(item.selectedSize.name[_vm.$lang.current_lang] ? item.selectedSize.name[_vm.$lang.current_lang] : item.selectedSize.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedStyle.name  && !item.selectedStyle.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[(item.selectedSize.name && !item.selectedSize.isDefault)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.$lang.labels.style)+": "+_vm._s(item.selectedStyle.name[_vm.$lang.current_lang] ? item.selectedStyle.name[_vm.$lang.current_lang] : item.selectedStyle.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedVariants && item.selectedVariants.name  && !item.selectedVariants.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[((item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault))?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$lang.labels.variant)+": "+_vm._s(item.selectedVariants.name[_vm.$lang.current_lang] ? item.selectedVariants.name[_vm.$lang.current_lang] : item.selectedVariants.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedOptions.length > 0)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[((item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault) || (item.selectedVariants.name && !item.selectedVariants.isDefault))?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(_vm.$lang.labels.options)+":\n                  "),_vm._l((item.selectedOptions),function(option,index){return _c('span',{key:index},[(item.selectedOptions.length > 1 && index !== 0)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v("\n                    "+_vm._s(option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en)+" x\n                    "+_vm._s(option.quantity)+"\n                  ")])})],2):_vm._e(),(item.allergens && item.allergens.length > 0)?_c('br'):_vm._e(),_vm._v(" "),(item.allergens && item.allergens.length > 0)?_c('span',{staticClass:"flex py-2 xs4 orangeTheme details"},[_c('span',{staticClass:"pointerCursor",on:{"click":function($event){return _vm.openAllergens(item.allergens)}}},[_vm._v("\n                "+_vm._s(_vm.$lang.labels.showAllergens)+"\n              ")])]):_vm._e(),_vm._v(" "),(item.comment)?_c('br'):_vm._e(),_vm._v(" "),(item.comment)?_c('span',{staticClass:"flex py-2 xs12 details",style:(_vm.goDark ? 'color: white' : '')},[_vm._v(_vm._s(_vm.$lang.labels.comment)+": "+_vm._s(item.comment))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-right pa-3 details"},[_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : '₤'}},[_vm._v(_vm._s(_vm.$store.state.calculatePrice(item.selectedSize, item.selectedVariants, item.selectedOptions, item.quantity, item.quantityOfIncludedOptions)
                    .toFixed(2)))])])])]}),_vm._v(" "),(_vm.deliveryCharges !== null && _vm.deliveryCharges > 0)?_c('tr',[_c('td',{staticClass:"text-xs-left",staticStyle:{"min-width":"110px","padding-left":"45px"}},[_c('span',{staticClass:"quantity"},[_vm._v("1")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left py-3 px-1",attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$lang.labels.deliveryCharges))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right py-3 px-3"},[_c('span',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : ''}},[_vm._v("\n            "+_vm._s(_vm.deliveryCharges.toFixed(2)))])])]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.success && _vm.width > 599)?_c('v-alert',{staticClass:"success display-1 text-center text-xs-center",attrs:{"color":"success","value":"true"}},[_vm._v(_vm._s(_vm.success)),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"letter-spacing":"3px !important"}},[_c('small',[_vm._v(_vm._s(_vm.$lang.labels.total)+": "+_vm._s(_vm.company.currencySymbol)+_vm._s(_vm.total.toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.success && _vm.width < 600)?_c('v-alert',{staticClass:"success notifications text-left text-xs-left",attrs:{"color":"success","value":"true","icon":"add"}},[_vm._v(_vm._s(_vm.success)),_c('br'),_vm._v(" "),_c('span',{staticClass:"headline",staticStyle:{"letter-spacing":"3px !important"}},[_c('small',[_vm._v(_vm._s(_vm.$lang.labels.total)+": "+_vm._s(_vm.company.currencySymbol)+_vm._s(_vm.total.toFixed(2)))])])]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.warn)?_c('v-alert',{staticClass:"warn",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.warn)+"\n        ")]):_vm._e()],1),_vm._v(" "),(_vm.orderType === 'delivery' && _vm.company &&
          _vm.company.minDeliveryAmount && _vm.total <
          parseFloat(_vm.company.minDeliveryAmount))?_c('v-btn',{attrs:{"color":"primary","dark":"","disabled":!_vm.checkAcceptingOrders()}},[_vm._v("\n        "+_vm._s(_vm.$lang.errors.minimalDelivery)+":\n        "),_c('span',{staticClass:"ml-1 price no-min",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : '₤'}},[_vm._v(_vm._s(parseFloat(_vm.company.minDeliveryAmount)
                .toFixed(2)))])]):(_vm.closed && _vm.remainingWorkingRanges.length > 0)?_c('v-btn',{attrs:{"type":"submit","color":"primary","disabled":!_vm.checkAcceptingOrders()},on:{"click":function($event){return _vm.submit()}}},[_vm._v(_vm._s(_vm.$lang.actions.preorder)+"\n      ")]):_c('v-btn',{attrs:{"type":"submit","dark":"","color":"primary mx-0","disabled":!_vm.checkAcceptingOrders()},on:{"click":function($event){return _vm.submit()}}},[(_vm.company && _vm.company.currencyPosition !== 'right' && _vm.total)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.company ? _vm.company.currencySymbol + _vm.total.toFixed(2) : ''))]):_vm._e(),_vm._v("\n        "+_vm._s(_vm.$lang.actions.checkout)+"\n        "),(_vm.company && _vm.company.currencyPosition === 'right' && _vm.total)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.company ? _vm.total.toFixed(2) + _vm.company.currencySymbol : ''))]):_vm._e()]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-4",attrs:{"label":_vm.$lang.labels.comment,"name":"comment","rules":_vm.commentRules,"rows":"1","auto-grow":""},on:{"blur":function($event){_vm.$store.dispatch('setComment', $event.target.value.substring(0, 1024))}},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)],1),_vm._v(" "),(_vm.allergensDialog)?_c('v-dialog',{attrs:{"scrollable":"","fullscreen":_vm.width < 768,"max-width":"200px"},model:{value:(_vm.allergensDialog),callback:function ($$v) {_vm.allergensDialog=$$v},expression:"allergensDialog"}},[_c('Allergens',{attrs:{"allergens":_vm.allergens,"catalogAllergens":_vm.catalog.allergens},on:{"close":function($event){return _vm.closeDialog('allergens')}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-layout',{staticStyle:{"max-width":"1440px"},attrs:{"row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.success)?_c('v-alert',{staticClass:"success notifications text-left text-xs-left",attrs:{"color":"success","icon":"check","value":"true"}},[_vm._v(_vm._s(_vm.success)),(_vm.orderBackLinkUrl)?_c('br'):_vm._e(),_vm._v(" "),(_vm.orderBackLinkUrl)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.orderBackLinkUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.success.continueTo)+" "+_vm._s(_vm.extractUrl(_vm.orderBackLinkUrl)))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.checkAcceptingOrders())?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v("\n        "+_vm._s(_vm.$lang.errors.acceptingOrders)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.closed)?_c('v-alert',{staticClass:"err",attrs:{"color":_vm.remainingWorkingRanges.length === 0 ? 'error': 'success',"icon":"warning","value":"true"}},[(_vm.remainingWorkingRanges.length === 0)?[_vm._v(_vm._s(_vm.$lang.errors.restaurantClosed))]:[_vm._v(_vm._s(_vm.$lang.errors.restaurantPreorder)+" "+_vm._s(_vm.remainingWorkingRanges[0].start))]],2):(_vm.closingMessage && !_vm.closedMessage)?_c('v-alert',{staticClass:"warning",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.$lang.errors.restaurantSoon)+"\n      ")]):(_vm.closedMessage)?_c('v-alert',{staticClass:"warning",attrs:{"color":"warning","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.$lang.errors.restaurantReceiving)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.deactivation.en'] && _vm.company && !_vm.company.acceptingOrders : !!_vm.formatedHtmlHints['webshop.deactivation.de'] && _vm.company && !_vm.company.acceptingOrders)?_c('v-alert',{staticClass:"info",attrs:{"color":"info","icon":"info","value":"true"},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.deactivation.en'] : _vm.formatedHtmlHints['webshop.deactivation.de'])}}):_vm._e(),_vm._v(" "),(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.page1.prefix.en'] : !!_vm.formatedHtmlHints['webshop.page1.prefix.de'])?_c('v-layout',{staticClass:"py-2 pr-2 pl-3 mb-2 elevation-2",staticStyle:{"background-color":"#2196f3 !important","width":"100%"},attrs:{"row":"","wrap":""},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.page1.prefix.en'] : _vm.formatedHtmlHints['webshop.page1.prefix.de'])}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"section categories",attrs:{"xs12":"","md7":"","lg8":"","pa-0":""}},[(!_vm.loaded)?_c('v-flex',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):(_vm.catalog)?_c('Categories',{attrs:{"itemsList":_vm.itemsList,"notNested":true},on:{"success":_vm.flashSuccess}}):_vm._e()],1),_vm._v(" "),(_vm.catalog)?_c('v-flex',{staticClass:"section shopping-basket mb-3",attrs:{"xs12":"","md5":"","lg4":""}},[_c('v-card',{class:{'pa-4': _vm.$vuetify.breakpoint.mdAndUp},style:(_vm.$vuetify.breakpoint.smAndDown ? 'background-color: transparent;' : ''),attrs:{"id":"vCardId","flat":_vm.$vuetify.breakpoint.smAndDown}},[_c('ShoppingBasket',{attrs:{"successMessage":_vm.itemSuccess}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":""}},[(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.page1.postfix.en'] : !!_vm.formatedHtmlHints['webshop.page1.postfix.de'])?_c('v-layout',{staticClass:"pa-2 mb-2 elevation-2",staticStyle:{"background-color":"#2196f3 !important","width":"100%"},attrs:{"row":"","wrap":""},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.page1.postfix.en'] : _vm.formatedHtmlHints['webshop.page1.postfix.de'])}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactTracking_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feb26dd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactTracking_vue__ = __webpack_require__(319);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-feb26dd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactTracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_feb26dd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactTracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var htmlHints = {};
var htmlHintsFormatted = {};

function formatHtmlHints() {
  if (htmlHints && htmlHints.length > 0) {
    for (var i = 0; i < htmlHints.length; i += 1) {
      htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
    }
  }
}

if (localStorage.company && localStorage.company !== 'null') {
  htmlHints = JSON.parse(localStorage.company).htmlHints || {};

  formatHtmlHints();
}

var partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
// const partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
var partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
// const partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

var data = {
  left: '\n    <div class="content" style="font-size: 11px; color: gray">\n        <p><strong>Datenschutzrechtliche Information nach Art. 13 DSGVO</strong></h6>\n        <p style="margin: 0 !important;"><strong>Zweck und Rechtsgrundlagen der Verarbeitung</strong></h6>\n        <p>Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19.<br>\n        Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen nat\xFCrlichen Person). \xA7 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020.<br>\n        Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung f\xFCr Contact Tracing im Zusammenhang mit Verdachtsf\xE4llen von COVID-19.</p>\n        <p style="margin: 0 !important;"><strong>Verantwortlicher f\xFCr die Verarbeitung der erhobenen personenbezogenen Daten</strong></p>\n        <p>' + partnerCompanyName + ', ' + partnerPostalAddress + ', an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden k\xF6nnen.</p>\n    </div>\n',
  right: '\n    <div class="content" style="font-size: 11px; color: gray">\n        <p style="margin: 0 !important;"><strong>Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empf\xE4nger weitergeleitet</strong></h6>\n        <p>Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19.<br>\n        Empf\xE4nger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.</p>\n        <p style="margin: 0 !important;"><strong>Hinweise</strong></h6>\n        <p>Ihre personenbezogenen Daten werden gem. \xA7 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung f\xFCr Contact Tracing im Zusammenhang mit Verdachtsf\xE4llen von COVID-19 4 Wochen nach ihrer Aufnahme gel\xF6scht.<br>\n        Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft \xFCber die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, L\xF6schung oder Einschr\xE4nkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.<br>\n        Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtm\xE4\xDFig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die M\xF6glichkeit einer Beschwerde bei der \xD6sterreichischen Datenschutzbeh\xF6rde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at.</p>\n    </div>\n'
};

/* harmony default export */ __webpack_exports__["a"] = (data);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md10":"","lg8":""}},[_c('v-card',{staticClass:"pa-4"},[_c('h2',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$lang.labels.customerTrackingTitle1))]),_vm._v(" "),_c('h4',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$lang.labels.customerTrackingTitle2))]),_vm._v(" "),_c('v-form',{staticStyle:{"width":"100%"},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","wrap":"","pb-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.firstName,"name":"firstName","rules":_vm.nameRules,"required":""},model:{value:(_vm.form.firstName),callback:function ($$v) {_vm.$set(_vm.form, "firstName", $$v)},expression:"form.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.lastName,"name":"lastName","rules":_vm.nameRules,"required":""},model:{value:(_vm.form.lastName),callback:function ($$v) {_vm.$set(_vm.form, "lastName", $$v)},expression:"form.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.phone,"name":"phone","rules":[_vm.phoneNumberRules],"required":""},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.email,"name":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","pr-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.tableName,"name":"table","rules":_vm.tableRules,"required":""},model:{value:(_vm.form.table),callback:function ($$v) {_vm.$set(_vm.form, "table", $$v)},expression:"form.table"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","pl-2":""}},[_c('v-text-field',{attrs:{"readonly":"","label":_vm.$lang.labels.dateTime,"placeholder":_vm.formatDateTime(_vm.dateTime),"name":"dateTime"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"type":"submit","color":"primary mx-0"},on:{"click":function($event){return _vm.submit()}}},[_vm._v(_vm._s(_vm.$lang.actions.submit)+"\n          ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","pr-1":""}},[_c('div',{staticClass:"text-xs-left",domProps:{"innerHTML":_vm._s(_vm.dataHtml.left)}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","pl-1":""}},[_c('div',{staticClass:"text-xs-left",domProps:{"innerHTML":_vm._s(_vm.dataHtml.right)}})])],1)],1)],1),_vm._v(" "),(_vm.infoDialog)?_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.infoDialog),callback:function ($$v) {_vm.infoDialog=$$v},expression:"infoDialog"}},[_c('v-layout',{staticClass:"text-xs-center",staticStyle:{"background-color":"white"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","pb-2":""}},[(_vm.success)?_c('v-alert',{staticClass:"success ma-0",staticStyle:{"font-size":"28px"},attrs:{"color":"success","icon":"check","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n        ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","pb-2":""}},[_c('v-btn',{attrs:{"block":"","color":"info mx-0"},on:{"click":function($event){_vm.infoDialog = false; _vm.success = null; _vm.err = null}}},[_vm._v("OK\n        ")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ccc2ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyLayout_vue__ = __webpack_require__(321);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ccc2ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6a41ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab6a41ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6a41ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":"","py-4":""}},[_c('v-card',{staticClass:"login-wrap pa-4 mb-5"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.err))]),_vm._v(" "),(_vm.err.includes('Not found with userName'))?_c('div',[_c('v-btn',{staticClass:"mx-0",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$router.push({ name: 'registration', query: { email: _vm.email } })}}},[_vm._v("\n            "+_vm._s(this.$lang.actions.register)+"?\n          ")])],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('v-form',{nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.email,"name":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.labels.password,"name":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":_vm.loginProcessStarted,"color":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$lang.header.login))]),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"id":"forgotPassword","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$router.push({ name: 'forgotPassword' })}}},[_vm._v(_vm._s(_vm.$lang.actions.forgotPassword)+"?")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_reset_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2506bde6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_reset_vue__ = __webpack_require__(327);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2506bde6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2506bde6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":"","py-4":""}},[_c('v-card',{staticClass:"reset-wrap pa-4 mb-5"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-form',{nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{staticClass:"sub-header",attrs:{"xs12":""}},[_c('p',[_vm._v("Please enter the new password:")])]),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.actions.enterPassword,"name":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.actions.confirmPassword,"name":"repassword","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.repassword),callback:function ($$v) {_vm.repassword=$$v},expression:"repassword"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$lang.actions.resetPassword))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_forgot_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f50a88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_forgot_vue__ = __webpack_require__(330);
function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25f50a88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_forgot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f50a88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_forgot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":"","py-4":""}},[_c('v-card',{staticClass:"reset-wrap pa-4 mb-5"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.success)?_c('v-alert',{staticClass:"success",attrs:{"color":"success","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"column":"","justify-start":""}},[_c('v-flex',{staticClass:"sub-header"},[_c('p',{staticClass:"inline"},[_vm._v(_vm._s(_vm.$lang.global.selectMethod)+":")])]),_vm._v(" "),_c('v-flex',{staticClass:"radio-wrap"},[_c('v-radio-group',{staticClass:"pt-0",model:{value:(_vm.method),callback:function ($$v) {_vm.method=$$v},expression:"method"}},[_c('v-layout',{staticClass:"radio-wrap pt-0",attrs:{"row":"","wrap":"","justify-start":"","align-center":""}},[_c('v-flex',[_c('v-radio',{staticClass:"single-radio mb-2",attrs:{"type":"radio","label":_vm.$lang.global.byEmail,"value":"email"}})],1),_vm._v(" "),_c('v-flex',[_c('v-radio',{staticClass:"single-radio",attrs:{"type":"radio","label":_vm.$lang.global.byPhone,"value":"phone"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"form",nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submit()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.method === 'email'),expression:"method === 'email'"}],attrs:{"label":_vm.$lang.labels.email,"name":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.method === 'phone'),expression:"method === 'phone'"}],attrs:{"label":_vm.$lang.labels.phone,"name":"phone","rules":[_vm.phoneNumberRules],"required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"ma-0",attrs:{"color":"primary","type":"submit","disabled":!_vm.isValid}},[_vm._v(_vm._s(_vm.$lang.actions.send))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a1e375_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25a1e375"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25a1e375_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"registration-wrap pa-4 mb-5"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_c('v-layout',{attrs:{"column":""}},[_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.err))]),_vm._v(" "),(_vm.err === 'User:Register failed. Account found with same email')?_c('div',[_c('v-btn',{staticClass:"mx-0",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$router.push({ name: 'forgotPassword', query: { email: _vm.email } })}}},[_vm._v("\n              Reset password\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.err === 'User:Register failed. Account found with same phone')?_c('div',[_c('v-btn',{staticClass:"mx-0",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$router.push({ name: 'forgotPassword', query: { phone: _vm.phone } })}}},[_vm._v("\n              Reset password\n            ")])],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('v-form',{nativeOn:{"submit":function($event){$event.preventDefault();return _vm.registerUser()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.name,"name":"name","rules":_vm.nameRules,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.labels.email,"name":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.labels.phone,"name":"phone","rules":[_vm.phoneNumberRules],"required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('v-layout',{staticClass:"agreement text-xs-left",attrs:{"row":""}},[_c('v-checkbox',{staticStyle:{"max-width":"20px"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('p',{staticClass:"pl-2 text-xs-left"},[_vm._v(_vm._s(_vm.$lang.header.iAgree1)+" "),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.inNewTab('terms')}}},[_vm._v(_vm._s(_vm.$lang.header.tearmsConditions))]),_vm._v(" "+_vm._s(_vm.$lang.header.and)+" "),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.inNewTab('data-protection')}}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))])])],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"color":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$lang.actions.submit))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b808c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5b808c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Activate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5b808c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Activate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","justify-center":"","align-center":"","pa-4":""}},[(!_vm.invalid)?_c('v-card',{staticClass:"password-wrap pa-4 mb-4"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$lang.actions.enterPassword))]),_vm._v(" "),_c('v-form',{nativeOn:{"submit":function($event){$event.preventDefault();return _vm.setPassword()}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":_vm.$lang.actions.newPassword,"name":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$lang.actions.confirmPassword,"name":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v(" "),_c('v-btn',{staticClass:"ma-0",attrs:{"disabled":!_vm.valid,"color":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.$lang.actions.submit))])],1)],1):_c('v-card',{staticClass:"password-wrap pa-4 mb-4"},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Addresses_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54824d93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Addresses_vue__ = __webpack_require__(342);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54824d93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Addresses_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54824d93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Addresses_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Address_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6249164c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Address_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6249164c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Address_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6249164c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Address_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.address ? _vm.$lang.actions.edit : _vm.$lang.actions.add)+" "+_vm._s(_vm.$lang.actions.address)+"\n  ")]),_vm._v(" "),_c('v-card-text',[(!_vm.isLoadingAddress)?_c('div',{staticClass:"py-1",staticStyle:{"margin-top":"10px"}},[_vm._v("\n     \n    ")]):_vm._e(),_vm._v(" "),(_vm.isLoadingAddress)?_c('v-progress-linear',{staticClass:"my-3",attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.filteredLines),function(line,index){return _c('v-flex',{key:index,staticClass:"px-2 prefill",class:{'d-none': ['latitude', 'longitude'].includes(line.property)},attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-wrap",attrs:{"label":line.label,"rules":line.required ? _vm.required : [],"type":['latitude', 'longitude'].includes(line.property) ? 'number' : 'text',"color":"primary","id":String(index),"hint":line.property === 'line1' && _vm.formData[line.property] === '' ? _vm.$lang.labels.startTyping : '',"persistent-hint":""},on:{"dblclick":function($event){line.property !== 'postalCode' ? _vm.filterPrefill('ALL_VALUES', line.property, true) : ''},"focus":function($event){line.property === 'postalCode' || (_vm.company.address.country === 'AT' && line.property === 'line3') ? _vm.filtering = null : _vm.filterPrefill(_vm.company.address.country === 'UK' && _vm.formData[line.property] === '' ? 'ALL_VALUES' : _vm.formData[line.property], line.property)},"input":function($event){['postalCode', 'line1'].includes(line.property) ? _vm.getPrefill(_vm.formData.postalCode, $event, line.property) : _vm.filterPrefill($event, line.property)},"blur":function($event){['line2'].includes(line.property) && _vm.formData[line.property] !== '' ? _vm.replaceAddress(_vm.formData[line.property], line.property) : ''}},model:{value:(_vm.formData[line.property]),callback:function ($$v) {_vm.$set(_vm.formData, line.property, $$v)},expression:"formData[line.property]"}}),_vm._v(" "),(!(_vm.company.address.country === 'AT' && line.property === 'line3') &&
              _vm.filtering === line.property &&
              _vm.prefill.filtered.length > 0)?_c('ul',{style:(_vm.goDark ? 'background-color: #303030' : 'white')},_vm._l((_vm.filterUniqueFields(_vm.prefill.filtered, line.property)),function(filtered,index){return _c('li',{key:index,on:{"click":function($event){return _vm.replaceAddress(filtered, line.property)}}},[_vm._v("\n                "+_vm._s(_vm.company.address.country === 'UK' ? _vm.generateAddress(filtered) : filtered)+"\n              ")])}),0):_vm._e(),_vm._v(" "),(line.property === 'postalCode' &&
              _vm.filtering === line.property &&
              _vm.postalCodes.length > 0)?_c('ul',{style:(_vm.goDark ? 'background-color: #303030' : 'white')},_vm._l((_vm.postalCodes),function(filtered,index){return _c('li',{key:index,on:{"click":function($event){return _vm.setPostalCode(filtered)}}},[_vm._v("\n                "+_vm._s(filtered)+"\n              ")])}),0):_vm._e(),_vm._v(" "),(
              _vm.filtering === line.property &&
              _vm.prefill.filtered.length > 0)?_c('div',{staticClass:"focus-mask",on:{"click":function($event){_vm.filtering = null}}}):_vm._e()],1)}),1)],1)],1)],1),_vm._v(" "),(_vm.err)?_c('v-alert',{attrs:{"color":"error","icon":"warning","value":_vm.err !== ''}},[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v("\n      Cancel\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"id":"submit","color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.address ? _vm.$lang.actions.edit : _vm.$lang.actions.add)+" "+_vm._s(_vm.$lang.actions.address)+"\n    ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"addresses-wrap my-4",attrs:{"xs12":"","sm10":"","md8":""}},[_c('v-card',{staticClass:"pa-2"},[(_vm.err)?_c('v-alert',{staticClass:"ma-2",attrs:{"color":"error","icon":"warning","value":_vm.err !== ''}},[_vm._v("\n      "+_vm._s(_vm.err)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.success)?_c('v-alert',{staticClass:"ma-2",attrs:{"color":"success","icon":"warning","value":_vm.success !== ''}},[_vm._v("\n      "+_vm._s(_vm.success)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.name},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.phone},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)],1),_vm._v(" "),(_vm.width > 599)?_c('div',{staticClass:"v-table__overflow ma-2"},[_c('table',{staticClass:"v-datatable v-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.postalCode))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.address))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.locality))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.townCity))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-right actions",attrs:{"role":"columnheader","scope":"col"}})]),_vm._v(" "),_c('tr',{staticClass:"v-datatable__progress"},[_c('th',{staticClass:"column",attrs:{"colspan":"100%"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.currentAddresses),function(address,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(address.postalCode))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.generateAddress([address.line1, address.line2, address.line3, address.line4]))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(address.locality))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(address.townCity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right actions"},[_c('v-btn',{staticClass:"mx-0 mr-2",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editAddress(address, index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteAddress(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1)],1)])}),0)])]):_vm._e(),_vm._v(" "),(_vm.width < 600)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":"","align-start":"","pa-2":""}},[_vm._l((_vm.currentAddresses),function(address,index){return [_c('v-card',{staticClass:"pa-4 my-1",style:(("background-color: " + (_vm.goDark ? '#212121' : ''))),attrs:{"hover":"","min-width":"100%"}},[_c('v-layout',{key:index,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.generateAddress([address.line1, address.line2, address.line3, address.line4])))]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                "+_vm._s(_vm.company.address.locality ? _vm.company.address.locality + ', ' : '')+"\n                "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.townCity : _vm.company.address.postalCode)+",\n                "+_vm._s(_vm.company.address.country === 'UK' ? _vm.company.address.postalCode : _vm.company.address.townCity)+"\n              ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"mx-0 mr-2",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editAddress(address, index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteAddress(index)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1)],1)],1)],1)]})],2):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":""}},[_c('v-btn',{staticClass:"primary ma-2",attrs:{"id":"addAddress"},on:{"click":_vm.addAddress}},[_vm._v("\n        "+_vm._s(_vm.$lang.actions.addAddress)+"\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary ma-2",attrs:{"id":"submitAddresses"},on:{"click":_vm.submit}},[_vm._v("\n        "+_vm._s(_vm.$lang.actions.submit)+"\n      ")])],1)],1),_vm._v(" "),(_vm.dialog)?_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Address',{attrs:{"address":_vm.addressToEdit},on:{"close":_vm.closeDialog,"submit":_vm.submitAddress}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_info_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a39178_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_info_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(344)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a39178_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */,
/* 346 */
/***/ (function(module, exports) {

module.exports = {"version":"2020d","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressInline_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72d0157e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressInline_vue__ = __webpack_require__(349);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72d0157e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressInline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72d0157e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressInline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-0 ma-0",style:(_vm.$vuetify.breakpoint.smAndDown ? 'background-color: transparent; overflow: unset' : 'overflow: unset'),attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-0 ma-0"},[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.filteredLines),function(line,index){return _c('v-flex',{key:index,staticClass:"pr-2 prefill",class:{'d-none': ['latitude', 'longitude'].includes(line.property)},attrs:{"id":("el-" + index),"xs12":"","sm6":""}},[_c('v-text-field',{staticClass:"input-wrap",attrs:{"label":line.label,"rules":line.required ? [_vm.requiredCheck(line.property, index)] : [],"type":['latitude', 'longitude'].includes(line.property) ? 'number' : 'text',"color":"primary","id":String(index),"hint":line.property === 'line1' && _vm.formData[line.property] === '' ? _vm.$lang.labels.startTyping : '',"persistent-hint":""},on:{"dblclick":function($event){return _vm.filterPrefill('ALL_VALUES', line.property, true)},"focus":function($event){_vm.company.address.country === 'AT' && line.property === 'line3' ? _vm.filtering = null : _vm.filterPrefill(_vm.company.address.country === 'UK' ? 'ALL_VALUES' : _vm.formData[line.property], line.property)},"input":function($event){['line1'].includes(line.property) ? _vm.getPrefill(_vm.formData.postalCode, $event, line.property) : _vm.filterPrefill($event, line.property)},"blur":function($event){['line2'].includes(line.property) && _vm.formData[line.property] !== '' ? _vm.replaceAddress(_vm.formData[line.property], line.property) : _vm.requiredCheck(line.property, index)}},model:{value:(_vm.formData[line.property]),callback:function ($$v) {_vm.$set(_vm.formData, line.property, $$v)},expression:"formData[line.property]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.company.address.country === 'AT' && line.property === 'line3') &&
              _vm.filtering === line.property &&
              _vm.prefill.filtered.length > 0),expression:"!(company.address.country === 'AT' && line.property === 'line3') &&\n              filtering === line.property &&\n              prefill.filtered.length > 0"}],staticStyle:{"position":"relative"}},[_c('ul',{style:(_vm.goDark ? 'background-color: #212121' : 'background-color: white')},_vm._l((_vm.filterUniqueFields(_vm.prefill.filtered, line.property)),function(filtered,index){return _c('li',{key:index,class:{'dark-hover': _vm.goDark},on:{"click":function($event){return _vm.replaceAddress(filtered, line.property)}}},[_vm._v("\n                  "+_vm._s(_vm.company.address.country === 'UK' ? _vm.generateAddress(filtered) : filtered)+"\n                ")])}),0)]),_vm._v(" "),(
              _vm.filtering === line.property &&
              _vm.prefill.filtered.length > 0)?_c('div',{staticClass:"focus-mask",on:{"click":function($event){_vm.filtering = null}}}):_vm._e()],1)}),1)],1)],1)],1),_vm._v(" "),(_vm.isLoadingAddress)?_c('v-progress-linear',{staticClass:"my-3",attrs:{"indeterminate":"","color":"primary"}}):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{attrs:{"color":"error","icon":"warning","value":_vm.err !== ''}},[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Time_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13bb2f99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Time_vue__ = __webpack_require__(351);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Time_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13bb2f99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Time_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$lang.global.selectTime))]),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('label',{attrs:{"for":"hours"}},[_vm._v(_vm._s(_vm.$lang.labels.hour))]),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.formHours,"label":_vm.$lang.labels.selectHours,"single-line":""},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('label',{attrs:{"for":"minutes"}},[_vm._v(_vm._s(_vm.$lang.labels.minute))]),_vm._v(" "),(_vm.maxMinutes)?_c('v-select',{attrs:{"items":new Array(60).fill('x').map(function (val, index) { return (index < 10 ? ("0" + index) : ("" + index)); }),"label":_vm.$lang.labels.selectMinute,"single-line":""},model:{value:(_vm.minutes),callback:function ($$v) {_vm.minutes=$$v},expression:"minutes"}}):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),(_vm.err)?_c('v-alert',{attrs:{"color":"error","icon":"warning","value":_vm.err !== ''}},[_vm._v("\n    "+_vm._s(_vm.err)+"\n  ")]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$lang.actions.cancel))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n      "+_vm._s(_vm.$lang.actions.submit)+"\n    ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-layout',{staticStyle:{"max-width":"1440px"},attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.deactivation.en'] && !_vm.company.acceptingOrders : !!_vm.formatedHtmlHints['webshop.deactivation.de'] && !_vm.company.acceptingOrders)?_c('v-alert',{staticClass:"info",attrs:{"color":"info","icon":"info","value":"true"},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.deactivation.en'] : _vm.formatedHtmlHints['webshop.deactivation.de'])}}):_vm._e(),_vm._v(" "),(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.page2.prefix.en'] : !!_vm.formatedHtmlHints['webshop.page2.prefix.de'])?_c('v-layout',{staticClass:"py-2 pr-2 pl-3 mb-2 elevation-2",staticStyle:{"background-color":"#2196f3 !important","width":"100%"},attrs:{"row":"","wrap":""},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.page2.prefix.en'] : _vm.formatedHtmlHints['webshop.page2.prefix.de'])}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"section table-wrap",attrs:{"xs12":"","md7":"","lg8":""}},[_c('v-flex',[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$lang.global.attention)+":")]),_vm._v(" "+_vm._s(_vm.$lang.global.foodAllergy)+"\n          "),_c('a',{attrs:{"href":("tel:" + (_vm.company.phone))}},[_vm._v(_vm._s(_vm.$lang.global.callRestaurant))])])]),_vm._v(" "),_c('div',{staticClass:"v-table__overflow mb-4 pt-4"},[_c('table',{staticClass:"v-datatable v-table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"column text-xs-left",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.quantity))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-left",attrs:{"colspan":"2","role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.name))]),_vm._v(" "),_c('th',{staticClass:"column text-xs-right",attrs:{"role":"columnheader","scope":"col"}},[_vm._v(_vm._s(_vm.$lang.labels.total))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.orderInfo.items),function(item,index){return [_c('tr',{key:index},[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left",attrs:{"colspan":"2"}},[_vm._v(_vm._s(item.name[_vm.$lang.current_lang] ? item.name[_vm.$lang.current_lang] :
                      item.name.en)+"\n                "),_c('br'),_vm._v(" "),(item.selectedSize.name && !item.selectedSize.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v(_vm._s(_vm.$lang.labels.size)+": "+_vm._s(item.selectedSize.name[_vm.$lang.current_lang] ? item.selectedSize.name[_vm.$lang.current_lang] : item.selectedSize.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedStyle.name  && !item.selectedStyle.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[(item.selectedSize.name && !item.selectedSize.isDefault)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.$lang.labels.style)+": "+_vm._s(item.selectedStyle.name[_vm.$lang.current_lang] ? item.selectedStyle.name[_vm.$lang.current_lang] : item.selectedStyle.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedVariants && item.selectedVariants.name  && !item.selectedVariants.isDefault)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[((item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault))?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v("\n                "+_vm._s(_vm.$lang.labels.variant)+": "+_vm._s(item.selectedVariants.name[_vm.$lang.current_lang] ? item.selectedVariants.name[_vm.$lang.current_lang] : item.selectedVariants.name.en)+"\n              ")]):_vm._e(),_vm._v(" "),(item.selectedOptions.length > 0)?_c('span',{staticClass:"flex py-2 xs4 details",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[((item.selectedSize.name && !item.selectedSize.isDefault) || (item.selectedStyle.name && !item.selectedStyle.isDefault) || (item.selectedVariants.name && !item.selectedVariants.isDefault))?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v(_vm._s(_vm.$lang.labels.options)+":\n                  "),_vm._l((item.selectedOptions),function(option,index){return _c('span',{key:index},[(item.selectedOptions.length > 1 && index !== 0)?_c('span',[_vm._v(", ")]):_vm._e(),_vm._v("\n                    "+_vm._s(option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en)+" x\n                    "+_vm._s(option.quantity)+"\n                  ")])})],2):_vm._e(),(item.allergens && item.allergens.length > 0)?_c('br'):_vm._e(),_vm._v(" "),(item.allergens && item.allergens.length > 0)?_c('span',{staticClass:"flex py-2 xs4 orangeTheme details"},[_c('span',{staticClass:"pointerCursor",on:{"click":function($event){return _vm.openAllergens(item.allergens)}}},[_vm._v(_vm._s(_vm.$lang.labels.showAllergens))])]):_vm._e(),(item.comment)?_c('br'):_vm._e(),_vm._v(" "),(item.comment)?_c('span',{staticClass:"flex py-2 xs12 details"},[_vm._v(_vm._s(_vm.$lang.labels.comment)+": "+_vm._s(item.comment))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : ''}},[_vm._v("\n                  "+_vm._s(_vm.$store.state.calculatePrice(item.selectedSize, item.selectedVariants,
                        item.selectedOptions, item.quantity, item.quantityOfIncludedOptions)
                        .toFixed(2))+"\n                ")])])]),_vm._v(" "),(item.selected)?_c('tr',{key:index + 10000},[_c('td',{attrs:{"colspan":"4"}},[_c('ul',{staticClass:"layout row wrap"},[(item.selectedSize.name)?_c('li',{staticClass:"flex py-2 xs6",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.$lang.labels.size)+": "+_vm._s(item.selectedSize.name[_vm.$lang.current_lang] ? item.selectedSize.name[_vm.$lang.current_lang] : item.selectedSize.name.en)+"\n                  ")]):_vm._e(),_vm._v(" "),(item.selectedStyle.name)?_c('li',{staticClass:"flex py-2 xs6",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.$lang.labels.style)+": "+_vm._s(item.selectedStyle.name[_vm.$lang.current_lang] ? item.selectedStyle.name[_vm.$lang.current_lang] : item.selectedStyle.name.en)+"\n                  ")]):_vm._e(),_vm._v(" "),(item.selectedVariants && item.selectedVariants.name)?_c('li',{staticClass:"flex py-2 xs6",attrs:{"xs6":""}},[_vm._v("\n                    "+_vm._s(_vm.$lang.labels.variant)+": "+_vm._s(item.selectedVariants.name[_vm.$lang.current_lang] ? item.selectedVariants.name[_vm.$lang.current_lang] : item.selectedVariants.name.en)+"\n                  ")]):_vm._e(),_vm._v(" "),(item.selectedOptions.length > 0)?_c('li',{staticClass:"flex py-2 xs6",attrs:{"xs6":""}},[_vm._v("\n                    "+_vm._s(_vm.$lang.labels.options)+":\n                    "),_c('ul',{staticClass:"pl-4"},_vm._l((item.selectedOptions),function(option,index){return _c('li',{key:index},[_vm._v("\n                        "+_vm._s(option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en)+" x\n                        "+_vm._s(option.quantity)+"\n                      ")])}),0)]):_vm._e(),_vm._v(" "),(item.comment)?_c('li',{staticClass:"flex py-2 xs12",attrs:{"md12":""}},[_vm._v(_vm._s(_vm.$lang.labels.comment)+": "+_vm._s(item.comment)+"\n                  ")]):_vm._e(),_vm._v(" "),(item.allergens && item.allergens.length > 0)?_c('li',{staticClass:"flex py-2 xs6 pointerCursor orangeTheme",on:{"click":function($event){return _vm.openAllergens(item.allergens)}}},[_vm._v("\n                    "+_vm._s(_vm.$lang.labels.allergens)+"\n                  ")]):_vm._e(),_vm._v(" "),(item.vatRate && item.vatRate > 0)?_c('li',{staticClass:"flex py-2 xs6"},[_vm._v(_vm._s(_vm.$lang.labels.vatRate)+":\n                    "+_vm._s(item.vatRate)+"%\n                  ")]):_vm._e()])])]):_vm._e()]}),_vm._v(" "),(_vm.deliveryCharges > 0)?_c('tr',[_c('td',{staticClass:"text-xs-left",staticStyle:{"min-width":"130px"}},[_c('span',{staticClass:"quantity"},[_vm._v("1")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$lang.labels.deliveryCharges))]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : ''}},[_vm._v("\n                "+_vm._s(_vm.deliveryCharges.toFixed(2))+"\n              ")])])]):_vm._e(),_vm._v(" "),(_vm.discount || _vm.description || _vm.discountRuleName)?_c('tr',{attrs:{"id":"discount"}},[_c('td',{staticClass:"text-xs-left",attrs:{"colspan":"3"}},[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._v(_vm._s(_vm.$lang.labels.discount)),(_vm.discountRuleName)?_c('span',[_vm._v(": "+_vm._s(_vm.discountRuleName))]):_vm._e()])]),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.description))]):_vm._e()]),_vm._v(" "),(_vm.discount)?_c('td',{staticClass:"text-xs-right"},[_vm._v("-\n              "),_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-currency":_vm.company ? _vm.company.currencySymbol : ''}},[_vm._v("\n                "+_vm._s(_vm.discount.toFixed(2))+"\n              ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-xs-left",attrs:{"colspan":"3"}},[_c('strong',[_vm._v(_vm._s(_vm.$lang.labels.total))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-price":_vm.total.toFixed(2),"data-currency":_vm.company ? _vm.company.currencySymbol : ''}},[_vm._v("\n              "+_vm._s(_vm.total.toFixed(2)))])])])],2)])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","pt-4":""}},[_c('p',{staticClass:"inline mb-0 sub-title mr-3"},[_vm._v(_vm._s(_vm.$lang.labels.deliveryMethod)+":")]),_vm._v(" "),_c('p',{staticClass:"inline mb-0 mr-3"},[_vm._v(_vm._s(_vm.$lang.actions[_vm.orderInfo.orderType]))]),_vm._v(" "),(_vm.company && _vm.company.orderTypes && _vm.company.orderTypes.length > 1)?_c('p',{staticClass:"inline mb-0"},[_vm._v("("),_c('a',{staticClass:"inline",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goBack($event)}}},[_vm._v(_vm._s(_vm.$lang.labels.change))]),_vm._v(")")]):_vm._e()]),_vm._v(" "),(_vm.orderInfo.comment)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('p',{staticClass:"inline sub-title mr-3"},[_vm._v(_vm._s(_vm.$lang.labels.comment)+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderInfo.comment))])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"section order-wrap",attrs:{"xs12":"","md5":"","lg4":""}},[_c('v-card',{staticClass:"pa-4"},[_c('v-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.calcAll($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(_vm.orderInfo.orderType === 'delivery')?[_c('v-flex',{staticClass:"mb-0",attrs:{"xs12":""}},[_c('p',{staticClass:"sub-title inline mr-1"},[_vm._v(_vm._s(_vm.$lang.labels.address)+":")])]),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"mb-0 pr-2",attrs:{"xs11":""}},[(_vm.chosenAddress)?_c('p',[_vm._v(_vm._s(_vm.generateFullAddress(_vm.chosenAddress)))]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"mb-0 pb-4",attrs:{"xs1":""}},[_c('v-btn',{staticClass:"mx-0 mr-2",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.goBack($event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1)],1)],1)]:_vm._e(),_vm._v(" "),(!_vm.isLoggedIn)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"px-2 mb-1 sub-title"},[_vm._v(_vm._s(_vm.$lang.labels.contactInfo)+":")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"id":"firstName","label":_vm.$lang.labels.first,"name":"firstName","rules":_vm.firstNameRules},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"id":"lastName","label":_vm.$lang.labels.last,"name":"lastName","rules":_vm.lastNameRules,"required":""},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"id":"phone","label":_vm.$lang.labels.phone,"name":"phone","rules":[_vm.phoneNumberRules],"required":""},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"id":"email","label":_vm.$lang.labels.email,"name":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"px-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mt-3",attrs:{"row":"","wrap":"","justify-start":""}},[_c('v-flex',{staticClass:"payment-method"},[_c('p',{staticClass:"inline sub-title mr-3"},[_vm._v(_vm._s(_vm.$lang.labels.paymentMethod)+":")])]),_vm._v(" "),_c('v-flex',{staticClass:"radio-wrap"},[_c('v-radio-group',{staticClass:"pt-0",model:{value:(_vm.paymentMethod),callback:function ($$v) {_vm.paymentMethod=$$v},expression:"paymentMethod"}},[(_vm.company && _vm.company.paymentTypes)?_c('v-layout',{staticClass:"radio-wrap pt-0",attrs:{"row":"","wrap":"","justify-start":"","align-center":""}},_vm._l((_vm.company.paymentTypes),function(method,index){return _c('v-flex',{key:index},[_c('v-radio',{staticClass:"single-radio",attrs:{"type":"radio","label":_vm.$lang.global[method],"value":method}})],1)}),1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.voucher,"name":"voucher"},on:{"blur":_vm.calcAll},model:{value:(_vm.voucher),callback:function ($$v) {_vm.voucher=$$v},expression:"voucher"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('p',{staticClass:"mb-0 mr-3 sub-title inline"},[_vm._v(_vm._s(_vm.orderTimeLabel())+" "+_vm._s(_vm.$lang.labels.time)+":")]),_vm._v(" "),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(_vm.formatOrderTime(_vm.orderTime)))]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0 mr-2",attrs:{"fab":"","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.timeDialog = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),(!_vm.isLoggedIn)?_c('v-layout',{staticClass:"agreement px-2",attrs:{"row":"","justify-start":""}},[_c('v-checkbox',{model:{value:(_vm.agreement),callback:function ($$v) {_vm.agreement=$$v},expression:"agreement"}}),_vm._v(" "),_c('p',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.$lang.header.iAgree1)+" "),(_vm.formatedHtmlHints['webshop.footer.termins-and-conditions-link'])?_c('a',{attrs:{"href":("/" + (_vm.$route.params.lang) + "/" + (_vm.formatedHtmlHints['webshop.footer.termins-and-conditions-link'])),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.tearmsConditions))]):_c('a',{attrs:{"href":("/" + (_vm.$route.params.lang) + "/terms-and-Conditions"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.tearmsConditions))]),_vm._v("\n              "+_vm._s(_vm.$lang.header.and)+"\n              "),(_vm.formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link'])?_c('a',{staticClass:"mr-3",attrs:{"href":("/" + (_vm.$route.params.lang) + "/" + (_vm.formatedHtmlHints['webshop.footer.privacy-and-cookies-policy-link'])),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))]):_c('a',{staticClass:"mr-3",attrs:{"href":("/" + (_vm.$route.params.lang) + "/data-protection-policy"),"target":"_blank"}},[_vm._v(_vm._s(_vm.$lang.header.cookiePrivacy))]),_vm._v("\n              "+_vm._s(_vm.$lang.header.iAgree2)+"\n            ")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-2":""}},[(_vm.success)?_c('v-alert',{staticClass:"success",attrs:{"color":"success","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{staticClass:"px-2",attrs:{"row":"","justify-space-between":""}},[_c('v-btn',{staticClass:"ma-0",on:{"click":_vm.goBack}},[_vm._v("\n              "+_vm._s(_vm.$lang.actions.back)+"\n            ")]),_vm._v(" "),(_vm.closed && _vm.remainingWorkingRanges.length > 0)?_c('v-btn',{attrs:{"id":"order","color":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$lang.actions.preorder)+"\n            ")]):_c('v-btn',{staticClass:"ma-0",attrs:{"id":"order","disabled":_vm.submitted,"color":"primary"},on:{"click":_vm.submit}},[_vm._v("\n              "+_vm._s(_vm.$lang.actions.placeOrder)+"\n            ")])],1)],2)],1),_vm._v(" "),(_vm.timeDialog)?_c('v-dialog',{attrs:{"max-width":"600px"},model:{value:(_vm.timeDialog),callback:function ($$v) {_vm.timeDialog=$$v},expression:"timeDialog"}},[_c('Time',{attrs:{"time":_vm.orderTime},on:{"close":function($event){return _vm.closeDialog('time')},"submit":_vm.submitTime}})],1):_vm._e(),_vm._v(" "),(_vm.allergensDialog)?_c('v-dialog',{attrs:{"scrollable":"","fullscreen":_vm.width < 768,"max-width":"200px"},model:{value:(_vm.allergensDialog),callback:function ($$v) {_vm.allergensDialog=$$v},expression:"allergensDialog"}},[_c('Allergens',{attrs:{"allergens":_vm.allergens,"catalogAllergens":_vm.catalog.allergens},on:{"close":function($event){return _vm.closeDialog('allergens')}}})],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-0":""}},[(_vm.$lang.current_lang === 'en' ? !!_vm.formatedHtmlHints['webshop.page2.postfix.en'] : !!_vm.formatedHtmlHints['webshop.page2.postfix.de'])?_c('v-layout',{staticClass:"py-2 pr-2 pl-3 mb-2 elevation-2",staticStyle:{"background-color":"#2196f3 !important","width":"100%"},attrs:{"row":"","wrap":""},domProps:{"innerHTML":_vm._s(_vm.$lang.current_lang === 'en' ? _vm.formatedHtmlHints['webshop.page2.postfix.en'] : _vm.formatedHtmlHints['webshop.page2.postfix.de'])}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4291d802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(355);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4291d802"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4291d802_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('v-container',{staticClass:"content-header",attrs:{"grid-list-xl":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset-sm1":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('div',{staticClass:"error-page"},[_c('h1',{staticClass:"hudge"},[_vm._v("404")]),_vm._v(" "),_c('span',{staticClass:"grey--text error-massage"},[_vm._v(_vm._s(_vm.$lang.errors.pageNotFound)+"!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$lang.actions.click)+" "),_c('router-link',{attrs:{"tag":"a","to":{ name: 'webShop' }}},[_vm._v(_vm._s(_vm.$lang.actions.here))]),_vm._v(" "+_vm._s(_vm.$lang.actions.goBack))],1)])])],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protection_terms_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef689742_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protection_terms_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Protection_terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef689742_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Protection_terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var htmlHints = {};
var htmlHintsFormatted = {};

function formatHtmlHints() {
    if (htmlHints && htmlHints.length > 0) {
        for (var i = 0; i < htmlHints.length; i += 1) {
            htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
        }
    }
}

if (localStorage.company && localStorage.company !== 'null') {
    htmlHints = JSON.parse(localStorage.company).htmlHints || {};

    formatHtmlHints();
}

var partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
var partnerVatNumber = htmlHintsFormatted['webshop.partner.vat-number'] || '';
var partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
var partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
var partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

var country = localStorage.company && JSON.parse(localStorage.company) && JSON.parse(localStorage.company).address.country || 'UK';

var data = {
    // FOR UK !
    UK: '\n<div class="content">\n    <h4>1. Introduction</h4>\n    <ol>\n        <li>These terms and conditions (together with our privacy and cookies policy) set out the terms and conditions\n            under which we provide access to our website and any mobile application through which you order products\n            (together, the "website").\n        </li>\n        <li>By ordering through our website, you agree to be bound to these Terms and Conditions. You will be asked to\n            give your express agreement to these terms and conditions before you place an order on our website.\n        </li>\n        <li>Any usage of the website is also subject to these Terms and Conditions.\n        </li>\n        <li>This document does not affect any statutory rights you may have as a consumer (such as rights under the\n            Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 or the Consumer\n            Rights Act 2015).\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>2. Interpretation</h4>\n    <ol>\n        <li>In these terms and conditions:\n            <ul>\n                <li>"we" means ' + partnerCompanyName + '; and</li>\n                <li>"restaurant" means the restaurant with whom you place your order with; and</li>\n                <li>"you" means customer or prospective customer,</li>\n            </ul>\n            and "us", "our" and "your" should be construed accordingly.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>3. Order process</h4>\n    <ol>\n        <li>The advertising of products on our website constitutes an "invitation to treat" rather than a contractual\n            offer.\n        </li>\n        <li>No contract will come into force between you and us. We provide a way for you to review, select and place\n            order for products to delivery or collection (=takeaway) restaurants. The legal contract for the supply and\n            purchase of products is between you and the restaurant that you place your order with and we conclude the\n            sale of products on behalf of, and agent for, the restaurants in all cases.\n        </li>\n        <li>To enter into a contract with the restaurant through our website, the following steps must be taken:\n            <ul>\n                <li>you must add the products you wish to purchase to your shopping cart, and then proceed to the\n                    checkout;\n                </li>\n                <li>if you are a new customer, you can either continue the order as guest (without registration) or\n                    create an account with and log in with that account;\n                </li>\n                <li>if you already have a registered account, you can enter your login details enabling to use your\n                    pre-stored settings rather than having to enter them;\n                </li>\n                <li>depending on the above, you must select your preferred method of delivery and - if needed for the\n                    selected order type - either enter or select your name, address, phone number and email address.\n                </li>\n                <li>optionally, you can request a certain delivery or collections/takeaway time; neither we nor the\n                    restaurant guarantees that orders will be delivered or will be available at that time.\n                </li>\n                <li>confirm your order and your consent to the terms of this document;</li>\n                <li>depending on the payment method you selected, you will - if necessary - be transferred to the\n                    restaurants payment service provider\'s website, and the restaurant payment service provider will\n                    handle your payment;\n                </li>\n                <li>we will then send you an initial acknowledgement; any confirmation page that you may see on the\n                    website and any email confirmation that you may receive each confirm that you have a contract for\n                    the sale of products with the restaurant but does not necessarily mean that your order will be\n                    fulfilled by the restaurant. We encourage all restaurants to accept all orders and communicate any\n                    rejection promptly. We will (generally by email) inform you as soon as reasonably practicable if a\n                    restaurant rejects your order. Restaurants are entitled to reject orders at any time because of\n                    weather conditions, unavailable ingredients, too many orders or any other reason. In doing so, they\n                    will be in breach of their agreement with you and any payment made in respect of the order will be\n                    returned to you in accordance with the paragraph 6.\n                </li>\n            </ul>\n        </li>\n        <li>You will have the opportunity to identify and correct input errors prior to making your order. The system\n            will provide details within the error messages displayed in such cases.\n        </li>\n        <li>Once you have submitted your order - and (if applicable) your payment has been authorized - you are not\n            entitled to change or cancel your order nor eligible for a refund. If you wish to change or cancel your\n            order, you may contact the restaurant. There is no guarantee that the restaurant will be available nor that\n            the restaurant will agree as they may have already started processing your order.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>4. Products</h4>\n    <ol>\n        <li>The products (their categorization, name, description, price, tax, photograph, video, ingredients,\n            allergenic and heat warnings and any other detail) listed on our website are provided by the restaurant.\n        </li>\n        <li>The restaurant may periodically change the products available on our website, and neither the restaurant nor\n            we do undertake to continue to supply any particular product or type of product.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>5. Prices</h4>\n    <ol>\n        <li>The product prices are quoted on our website.</li>\n        <li>The restaurant will from time to time change the prices quoted on our website, but this will not affect\n            contracts that have previously come into force.\n        </li>\n        <li>It is possible that prices on the website may be incorrectly quoted; accordingly, the restaurant will verify\n            prices as part of the sale procedures so that the correct price will be notified to you before the contract\n            comes into force.\n        </li>\n        <li>In addition to the price of the products, you may have to pay a delivery charge, which will be notified to\n            you before the contract of sale comes into force.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>6. Payments</h4>\n    <ol>\n        <li>The available payment methods are defined by the restaurant.</li>\n        <li>Payments are charged by the restaurant and are made using either:\n            <ul>\n                <li>credit or debit cards; or</li>\n                <li>coupon; or</li>\n                <li>in cash.</li>\n            </ul>\n        </li>\n        <li>Unauthorized or unsuccessful payments in case of online payments stop the processing of the associated\n            order. Such orders are not communicated to the restaurant.\n        </li>\n        <li>If you pay by credit or debit card, you may be required to show the card to the restaurant at the time of\n            delivery or collection/takeaway as proof of identification.\n        </li>\n        <li>Cancellations and refunds follow the policy defined by the restaurant and are handled by the restaurant.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>7. Deliveries</h4>\n    <ol>\n        <li>The policies and procedures relating to the delivery of products are set out by the restaurant.</li>\n        <li>Estimated times for delivery and collections/takeaway are only estimates and not guaranteed neither by us\n            nor the restaurant.\n        </li>\n        <li>If your order includes any alcohol, tobacco or any other smoking product, you will be asked to provide proof\n            of your age on delivery or collection of your order. If you are unable to provide this proof, the restaurant\n            reserves the right not to complete the delivery of the alcohol, tobacco or any other smoking products to\n            you.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>8. Distance contracts: cancellation right</h4>\n    <ol>\n        <li>Cancellations follow the restaurants cancellation policy and are handled by the restaurant.</li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>9. Warranties and representations</h4>\n    <ol>\n        <li>You warrant and represent to us that:\n            <ul>\n                <li>you are legally capable of entering into binding contracts;</li>\n                <li>you have full authority, power and capacity to agree to these terms and conditions;</li>\n                <li>all the information that you provide to us in connection with your order is true, accurate, complete\n                    and non-misleading; and\n                </li>\n                <li>you are at least 18 years old; and</li>\n                <li>you do not buy, or attempt to buy, alcohol, tobacco or any other smoking product on behalf of any\n                    person who is under the age of 18;\n                </li>\n                <li>you will be able to take delivery of the products in accordance with these terms and condition and\n                    the restaurants delivery policy.\n                </li>\n            </ul>\n        </li>\n        <li>We warrant and represent to you that:\n            <ul>\n                <li>we have the right to list the products on behalf of and as agent for the restaurants;\n                </li>\n                <li>we have no control over the restaurant, the quality of their products and services they provide,\n                    their actions or omissions.\n                </li>\n            </ul>\n        </li>\n        <li>All of our warranties and representations relating to the supply of products are set out in these terms and\n            conditions. To the maximum extent permitted by applicable law and subject to Section 10.1, all other\n            warranties and representations are expressly excluded.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>10. Limitations and exclusions of liability</h4>\n    <ol>\n        <li>Nothing in these terms and conditions will:\n            <ul>\n                <li>limit or exclude any liability for death or personal injury resulting from negligence;</li>\n                <li>limit or exclude any liability for fraud or fraudulent misrepresentation;</li>\n                <li>limit any liabilities in any way that is not permitted under applicable law; or</li>\n                <li>exclude any liabilities that may not be excluded under applicable law,</li>\n                <li>and, if you are a consumer, your statutory rights will not be excluded or limited by these terms and\n                conditions, except to the extent permitted by law.</li>\n            </ul>\n        </li>\n        <li>The limitations and exclusions of liability set out in this Section 10 and elsewhere in these terms and\n            conditions:\n            <ul>\n                <li>are subject to Section 10.1; and</li>\n                <li>govern all liabilities arising under these terms and conditions or relating to the subject matter of\n                    these terms and conditions, including liabilities arising in contract, in tort (including\n                    negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in\n                    these terms and conditions.\n                </li>\n            </ul>\n        </li>\n        <li>We will not be liable to you in respect of any losses arising out of any event or events beyond our\n            reasonable control.\n        </li>\n        <li>We will not be liable to you in respect of any business losses, including (without limitation):\n            <ul>\n                <li>loss of or damage to profits, income, revenue, use, production, anticipated savings, business,\n                    contracts, commercial opportunities or goodwill; and\n                </li>\n                <li>loss or corruption of any data, database or software.\n                </li>\n            </ul>\n        </li>\n        <li>You accept that we have an interest in limiting the personal liability of our officers and employees and,\n            having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you\n            will not bring any claim personally against our officers or employees in respect of any losses you suffer in\n            connection with the website or these terms and conditions (this will not, of course, limit or exclude the\n            liability of the limited liability entity itself for the acts and omissions of our officers and employees).\n        </li>\n        <li>We are not liable for any product related information as they are provided by the restaurant subject to\n            Section 4, 5 and 6. If you are in doubt, please confirm with the restaurant directly before placing the\n            order.\n        </li>\n        <li>We are not liable for providing any compensation to you on behalf of any restaurant.</li>\n        <li>Our aggregate liability to you in respect of any contract under these terms and conditions shall not exceed\n            the greater of:\n            <ul>\n                <li>\xA3 250; and</li>\n                <li>the total amount paid and payable to us under the contract.</li>\n            </ul>\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>11. Cancellation and suspension of account</h4>\n    <ol>\n        <li>We may:\n            <ul>\n                <li>suspend your account; or</li>\n                <li>cancel your account at any time in our sole discretion without notice or explanation.</li>\n            </ul>\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>12. Scope</h4>\n    <ol>\n        <li>These terms and conditions shall not constitute or effect any assignment or licence of any intellectual\n            property rights.\n        </li>\n        <li>These terms and conditions shall not govern the licensing of works (including software and literary works)\n            comprised or stored in products.\n        </li>\n        <li>These terms and conditions shall not govern the provision of any services by us or any third party in\n            relation to the products.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>13. Variation</h4>\n    <ol>\n        <li>We may revise these terms and conditions from time to time by publishing a new version on our website.</li>\n        <li>A revision of these terms and conditions will apply to contracts entered into at any time following the time\n            of the revision, but will not affect contracts made before the time of the revision.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>14. Assignment</h4>\n    <ol>\n        <li>You hereby agree that we may assign, transfer, sub-contract or otherwise deal with our rights and/or\n            obligations under these terms and conditions - providing, if you are a consumer, that such action does not\n            serve to reduce the guarantees benefiting you under these terms and conditions.\n        </li>\n        <li>You may not without our prior written consent assign, transfer, sub-contract or otherwise deal with any of\n            your rights and/or obligations under these terms and conditions.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>15. No waivers</h4>\n    <ol>\n        <li>No breach of any provision of a contract under these terms and conditions will be waived except with the\n            express written consent of the party not in breach.\n        </li>\n        <li>No waiver of any breach of any provision of a contract under these terms and conditions shall be construed\n            as a further or continuing waiver of any other breach of that provision or any breach of any other provision\n            of that contract.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>16. Severability</h4>\n    <ol>\n        <li>If a provision of these terms and conditions is determined by any court or other competent authority to be\n            unlawful and/or unenforceable, the other provisions will continue in effect.\n        </li>\n        <li>If any unlawful and/or unenforceable provision of these terms and conditions would be lawful or enforceable\n            if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will\n            continue in effect.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>17. Third party rights</h4>\n    <ol>\n        <li>The exercise of the parties\' rights under a contract under these terms and conditions is not subject to the\n            consent of any third party.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>18. Entire agreement</h4>\n    <ol>\n        <li>Subject to Section 10.1, these terms and conditions, together with our privacy and cookies policy, shall\n            constitute the entire agreement between you and us and shall supersede all previous agreements between you\n            and us.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>19. Law and jurisdiction</h4>\n    <ol>\n        <li>These terms and conditions shall be governed by and construed in accordance with English law.</li>\n        <li>Any disputes relating to these terms and conditions shall be subject to the exclusive jurisdiction of the\n            courts of England.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>20. Statutory and regulatory disclosures</h4>\n    <ol>\n        <li>We will not file a copy of these terms and conditions specifically in relation to each user or customer and,\n            if we update these terms and conditions, the version to which you originally agreed will no longer be\n            available on our website. We recommend that you consider saving a copy of these terms and conditions for\n            future reference.\n        </li>\n        <li>These terms and conditions are available in the English language only.</li>\n        <li>Our VAT number is ' + partnerVatNumber + '.</li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>21. Our details</h4>\n    <ol>\n        <li>This website is owned and operated by ' + partnerCompanyName + '.</li>\n        <li>We are registered in England and Wales under registration number ' + partnerRegNumber + ', and our registered office is at\n            ' + partnerPostalAddress + '.\n        </li>\n        <li>Our principal place of business is at ' + partnerPostalAddress + '.\n        </li>\n        <li>You can contact us:\n            <ul>\n                <li>by post, using the postal address given above;</li>\n                <li>by email addressed to: <a href="mailto:' + partnerEmailAddress + '">' + partnerEmailAddress + '</a></li>\n                <li>by telephone, on the contact number published on our website from time to time; or</li>\n                <li>by email, using the email address published on our website from time to time.</li>\n            </ul>\n        </li>\n    </ol>\n</div>\n',
    // FOR AT !
    AT: '\n<div class="content">\n    <h4>1. Einf\xFChrung</h4>\n    <ol>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen (zusammen mit unserer Datenschutz- und Cookie-Richtlinie) legen die\n            Allgemeinen Gesch\xE4ftsbedingungen fest, unter denen wir Zugriff auf unsere Website und jede mobile Anwendung\n            gew\xE4hren, \xFCber die Sie Produkte bestellen (im Folgenden, zusammen die "Website").\n        </li>\n        <li>Durch die Bestellung \xFCber unsere Website erkl\xE4ren sie sich mit diesen Allgemeinen Gesch\xE4ftsbedingungen\n            einverstanden. Sie werden gebeten, diesen Gesch\xE4ftsbedingungen ausdr\xFCcklich zuzustimmen, bevor sie eine\n            Bestellung auf unserer Website aufgeben.\n        </li>\n        <li>Jede Nutzung der Website unterliegt ebenfalls diesen Allgemeinen Gesch\xE4ftsbedingungen.\n        </li>\n        <li>Dieses Dokument ber\xFChrt nicht die gesetzlichen Rechte, die sie als Verbraucher haben.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>2. Bezeichnungen</h4>\n    <ol>\n        <li>In diesen Gesch\xE4ftsbedingungen:\n            <ul>\n                <li>"wir" bedeutet ' + partnerCompanyName + '; und</li>\n                <li>"Restaurant" bezeichnet das Restaurant, bei dem Sie Ihre Bestellung aufgeben; und</li>\n                <li>"sie" bedeutet Kunde oder potenzieller Kunde,</li>\n            </ul>\n            und "wir", "unser" und "ihr" sollten entsprechend ausgelegt werden.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>3. Bestellprozess</h4>\n    <ol>\n        <li>Die Bewerbung unserer Produkte auf unserer Webseite stellen weder eine Aufforderung zur Offertstellung, noch\n            ein Angebot, noch eine Empfehlung zum Erwerb, noch zum T\xE4tigen irgendwelcher Transaktionen dar.\n        </li>\n        <li>Zwischen Ihnen und uns tritt kein Vertrag in Kraft. Wir bieten Ihnen die M\xF6glichkeit, Produkte zu\n            \xFCberpr\xFCfen, auszuw\xE4hlen und zu bestellen, damit sie geliefert oder abgeholt (=zum Mitnehmen) werden. Der\n            gesetzliche Vertrag \xFCber die Lieferung und den Kauf von Produkten kommt zwischen Ihnen und dem Restaurant\n            zustande, bei dem sie Ihre Bestellung aufgeben, und wir schlie\xDFen den Verkauf von Produkten in jedem Fall im\n            Namen und in Vertretung der Restaurants ab.\n        </li>\n        <li>Um \xFCber unsere Website einen Vertrag mit dem Restaurant abzuschlie\xDFen, m\xFCssen folgende Schritte unternommen\n            werden:\n            <ul>\n                <li>sie m\xFCssen die Produkte, die Sie kaufen m\xF6chten, in Ihren Warenkorb legen und dann zur Kasse gehen;\n                </li>\n                <li>wenn Sie ein neuer Kunde sind, k\xF6nnen sie entweder die Bestellung als Gast fortsetzen (ohne\n                    Registrierung) oder ein Konto erstellen und sich mit diesem Konto anmelden;\n                </li>\n                <li>wenn Sie bereits ein registriertes Konto haben, k\xF6nnen Sie Ihre Anmeldedaten eingeben, um Ihre\n                    vorgespeicherten Einstellungen zu verwenden, anstatt sie eingeben zu m\xFCssen;\n                </li>\n                <li>abh\xE4ngig davon m\xFCssen Sie Ihre bevorzugte Zustellart ausw\xE4hlen und - falls erforderlich f\xFCr den\n                    ausgew\xE4hlten Auftragstyp - entweder ihren Namen, ihre Adresse, ihre Telefonnummer und ihre\n                    E-Mail-Adresse eingeben oder ausw\xE4hlen.\n                </li>\n                <li>Optional k\xF6nnen Sie eine bestimmte Liefer- oder Abhol- / Abholzeit anfordern. Weder wir noch das\n                    Restaurant garantieren, dass Bestellungen geliefert werden oder zu diesem Zeitpunkt verf\xFCgbar sind.\n                </li>\n                <li>best\xE4tigen sie Ihre Bestellung und ihre Zustimmung zu den Bestimmungen dieses Dokuments;</li>\n                <li>abh\xE4ngig von der von Ihnen ausgew\xE4hlten Zahlungsmethode werden sie - falls erforderlich - auf die\n                    Website des Zahlungsdienstleisters des Restaurants weitergeleitet, und der Zahlungsdienstleister des\n                    Restaurants \xFCbernimmt ihre Zahlungsabwicklung;\n                </li>\n                <li>Wir senden ihnen dann eine erste Best\xE4tigung. Jede Best\xE4tigungsseite, die Sie m\xF6glicherweise auf der\n                    Website sehen, und jede E-Mail-Best\xE4tigung, die sie m\xF6glicherweise erhalten, best\xE4tigen, dass Sie\n                    einen Vertrag \xFCber den Verkauf von Produkten mit dem Restaurant haben, dies bedeutet jedoch nicht\n                    unbedingt, dass Ihre Bestellung vom Restaurant ausgef\xFChrt wird. Wir empfehlen allen Restaurants,\n                    alle Bestellungen anzunehmen und Ablehnungen unverz\xFCglich mitzuteilen. Wir werden sie (in der Regel\n                    per E-Mail) so schnell wie m\xF6glich informieren, wenn ein Restaurant ihre Bestellung ablehnt.\n                    Restaurants sind berechtigt, Bestellungen aufgrund von Wetterbedingungen, nicht verf\xFCgbaren Zutaten,\n                    zu vielen Bestellungen oder aus anderen Gr\xFCnden jederzeit abzulehnen. Dabei versto\xDFen sie gegen ihre\n                    Vereinbarung mit ihnen und jede Zahlung in Bezug auf die Bestellung wird ihnen gem\xE4\xDF Absatz 6\n                    zur\xFCckerstattet.\n                </li>\n            </ul>\n        </li>\n        <li>Sie haben die M\xF6glichkeit, Eingabefehler zu identifizieren und zu korrigieren, bevor sie Ihre Bestellung\n            aufgeben. Das System wird Details in den in solchen F\xE4llen erscheinenden Fehlermeldungen anzeigen.\n        </li>\n        <li>Sobald Sie Ihre Bestellung abgeschickt haben - und (falls zutreffend) ihre Zahlung autorisiert wurde - sind\n            sie weder berechtigt, ihre Bestellung zu \xE4ndern oder zu stornieren, noch haben sie Anspruch auf eine\n            R\xFCckerstattung. Wenn sie Ihre Bestellung \xE4ndern oder stornieren m\xF6chten, k\xF6nnen sie sich an das Restaurant\n            wenden. Es gibt keine Garantie daf\xFCr, dass das Restaurant verf\xFCgbar ist oder dass das Restaurant zustimmt,\n            da es m\xF6glicherweise bereits mit der Bearbeitung ihrer Bestellung begonnen hat.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>4. Produkte</h4>\n    <ol>\n        <li>Die auf unserer Website aufgef\xFChrten Produkte (deren Kategorisierung, Name, Beschreibung, Preis, Steuern,\n            Foto, Video, Zutaten, Allergen- und Hitzewarnungen sowie sonstige Details) werden vom Restaurant\n            bereitgestellt.\n        </li>\n        <li>Das Restaurant kann die auf unserer Website verf\xFCgbaren Produkte regelm\xE4\xDFig \xE4ndern, und weder das Restaurant\n            noch wir verpflichten uns, weiterhin bestimmte Produkte oder Produkttypen zu liefern.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>5. Preise</h4>\n    <ol>\n        <li>Die Produktpreise sind auf unserer Website angegeben.</li>\n        <li>Das Restaurant wird von Zeit zu Zeit die auf unserer Website angegebenen Preise \xE4ndern. Dies hat jedoch\n            keine Auswirkungen auf Vertr\xE4ge, die zuvor in Kraft getreten sind.\n        </li>\n        <li>Es ist m\xF6glich, dass die Preise auf der Website falsch angegeben sind. Dementsprechend \xFCberpr\xFCft das\n            Restaurant die Preise im Rahmen des Verkaufsverfahrens, sodass Sie vor Inkrafttreten des Vertrags \xFCber den\n            korrekten Preis informiert werden.\n        </li>\n        <li>Zus\xE4tzlich zum Preis der Produkte m\xFCssen sie m\xF6glicherweise Lieferkosten bezahlen, die ihnen vor\n            Inkrafttreten des Kaufvertrags mitgeteilt werden.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>6. Zahlungen</h4>\n    <ol>\n        <li>Die verf\xFCgbaren Zahlungsmethoden werden vom Restaurant festgelegt.</li>\n        <li>Zahlungen werden vom Restaurant verrechnet und erfolgen entweder \xFCber:\n            <ul>\n                <li>Kredit-oder Debitkarten; oder</li>\n                <li>Gutscheinen; oder</li>\n                <li>in Bar.</li>\n            </ul>\n        </li>\n        <li>Nicht autorisierte oder erfolglose Zahlungen bei Online-Zahlungen stoppen die Bearbeitung der zugeh\xF6rigen\n            Bestellung. Solche Bestellungen werden dem Restaurant nicht \xFCbermittelt.\n        </li>\n        <li>Wenn Sie mit Kredit- oder Debitkarte bezahlen, m\xFCssen Sie die Karte m\xF6glicherweise zum Zeitpunkt der\n            Lieferung oder Abholung / Mitnahme als Identit\xE4tsnachweis dem Restaurant vorlegen.\n        </li>\n        <li>Stornierungen und R\xFCckerstattungen richten sich nach den vom Restaurant festgelegten Richtlinien und werden\n            vom Restaurant durchgef\xFChrt.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>7. Lieferungen</h4>\n    <ol>\n        <li>Die Richtlinien und Verfahren f\xFCr die Lieferung von Produkten werden vom Restaurant festgelegt.</li>\n        <li>Die gesch\xE4tzten Liefer- und Abholzeiten sind nur Sch\xE4tzungen und werden weder von uns noch vom Restaurant\n            garantiert.\n        </li>\n        <li>Wenn Ihre Bestellung ein Produkt enth\xE4lt das einem Altersnachweis vorraussetzt, werden Sie gebeten, bei\n            Lieferung oder Abholung Ihrer Bestellung einen Altersnachweis vorzulegen. Wenn Sie diesen Nachweis nicht\n            erbringen k\xF6nnen, beh\xE4lt sich das Restaurant das Recht vor, die Lieferung der Produkte an Sie nicht\n            abzuschlie\xDFen.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>8. Fernvertr\xE4ge: Widerrufsrecht</h4>\n    <ol>\n        <li>Stornierungen folgen den Stornierungsbedingungen des Restaurants und werden vom Restaurant abgewickelt.</li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>9. Garantien und Zusicherungen</h4>\n    <ol>\n        <li>Sie garantieren und best\xE4tigen uns gegen\xFCber:\n            <ul>\n                <li>Sie sind rechtlich in der Lage, verbindliche Vertr\xE4ge abzuschlie\xDFen;</li>\n                <li>Sie haben die volle Autorit\xE4t, Befugnis und F\xE4higkeit, diesen Gesch\xE4ftsbedingungen zuzustimmen;</li>\n                <li>Alle Informationen, die Sie uns im Zusammenhang mit Ihrer Bestellung zur Verf\xFCgung stellen, sind\n                    wahr, genau, vollst\xE4ndig und nicht irref\xFChrend; und\n                </li>\n                <li>Sie sind mindestens 18 Jahre alt; und</li>\n                <li>Sie kaufen oder versuchen nicht, Alkohol, Tabak oder andere Raucherprodukte f\xFCr Personen zu kaufen,\n                    die j\xFCnger als 18 Jahre sind.\n                </li>\n                <li>Sie k\xF6nnen die Produkte gem\xE4\xDF diesen Gesch\xE4ftsbedingungen und den Lieferrichtlinien des Restaurants\n                    abholen bzw. entgegen zu nehmen.\n                </li>\n            </ul>\n        </li>\n        <li>Wir garantieren und vertreten Ihnen gegen\xFCber:\n            <ul>\n                <li>Wir haben das Recht, die Produkte im Namen und als Vertreter der Restaurants aufzulisten;\n                </li>\n                <li>Wir haben keine Kontrolle \xFCber das Restaurant, die Qualit\xE4t ihrer Produkte und Dienstleistungen,\n                    ihre Handlungen oder Unterlassungen.\n                </li>\n            </ul>\n        </li>\n        <li>Alle unsere Garantien und Zusicherungen in Bezug auf die Lieferung von Produkten sind in diesen Allgemeinen\n            Gesch\xE4ftsbedingungen aufgef\xFChrt. Soweit gesetzlich zul\xE4ssig und vorbehaltlich Ziffer 10.1, sind alle anderen\n            Gew\xE4hrleistungen und Zusicherungen ausdr\xFCcklich ausgeschlossen.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>10. Haftungsbeschr\xE4nkungen und -ausschl\xFCsse</h4>\n    <ol>\n        <li>Nichts in diesen Gesch\xE4ftsbedingungen wird:\n            <ul>\n                <li>Beschr\xE4nkung oder Ausschluss jeglicher Haftung f\xFCr Tod oder K\xF6rperverletzung aufgrund von\n                    Fahrl\xE4ssigkeit;\n                </li>\n                <li>Beschr\xE4nkung oder Ausschluss jeglicher Haftung f\xFCr Betrug oder betr\xFCgerische Falschdarstellung;</li>\n                <li>Verbindlichkeiten auf eine Weise begrenzen, die nach geltendem Recht nicht zul\xE4ssig ist; oder</li>\n                <li>jegliche Verbindlichkeiten ausschlie\xDFen, die nach geltendem Recht nicht ausgeschlossen werden\n                    d\xFCrfen,\n                </li>\n                <li>und wenn Sie Verbraucher sind, werden Ihre gesetzlichen Rechte durch diese Gesch\xE4ftsbedingungen\n                    nicht ausgeschlossen oder eingeschr\xE4nkt, bis auf etwaige gesetzlich m\xF6glichen Ausnahmen.\n                </li>\n            </ul>\n        </li>\n        <li>Die in diesem Abschnitt 10 und an anderer Stelle in diesen Gesch\xE4ftsbedingungen aufgef\xFChrten\n            Haftungsbeschr\xE4nkungen und -ausschl\xFCsse:\n            <ul>\n                <li>unterliegen Abschnitt 10.1; und</li>\n                <li>regeln alle Verbindlichkeiten, die sich aus diesen Gesch\xE4ftsbedingungen ergeben oder sich auf den\n                    Gegenstand dieser Gesch\xE4ftsbedingungen beziehen, einschlie\xDFlich Verbindlichkeiten, die sich aus\n                    vertraglichen, unerlaubten Handlungen (einschlie\xDFlich Fahrl\xE4ssigkeit) und wegen Verletzung\n                    gesetzlicher Pflichten ergeben, sofern in diesen Bedingungen nicht ausdr\xFCcklich etwas anderes\n                    bestimmt ist.\n                </li>\n            </ul>\n        </li>\n        <li>Wir haften Ihnen gegen\xFCber nicht f\xFCr Verluste, die sich aus Ereignissen oder Ereignissen ergeben, die\n            au\xDFerhalb unserer Kontrolle liegen.\n        </li>\n        <li>Wir haften Ihnen gegen\xFCber nicht f\xFCr gesch\xE4ftliche Verluste, einschlie\xDFlich (ohne Einschr\xE4nkung):\n            <ul>\n                <li>Verlust oder Besch\xE4digung von Gewinnen, Einnahmen, Einnahmen, Nutzung, Produktion, erwarteten\n                    Einsparungen, Gesch\xE4ften, Vertr\xE4gen, Gesch\xE4ftsm\xF6glichkeiten oder Wohlwollen; und\n                </li>\n                <li>Verlust oder Besch\xE4digung von Daten, Datenbanken oder Software.\n                </li>\n            </ul>\n        </li>\n        <li>Sie akzeptieren, dass wir ein Interesse daran haben, die pers\xF6nliche Haftung unserer leitenden Angestellten\n            und Mitarbeiter zu begrenzen und unter Ber\xFCcksichtigung dieses Interesses erkennen Sie an, dass wir eine\n            Gesellschaft mit beschr\xE4nkter Haftung sind. Sie erkl\xE4ren sich damit einverstanden, dass Sie keine\n            pers\xF6nlichen Anspr\xFCche gegen unsere leitenden Angestellten oder Mitarbeiter in Bezug auf Verluste geltend\n            machen, die Sie im Zusammenhang mit der Website oder diesen Allgemeinen Gesch\xE4ftsbedingungen erleiden (dies\n            wird nat\xFCrlich die Haftung der Gesellschaft mit beschr\xE4nkter Haftung nicht einschr\xE4nken oder ausschlie\xDFen\n            selbst f\xFCr die Handlungen und Unterlassungen unserer leitenden Angestellten und Mitarbeiter).\n        </li>\n        <li>Wir haften nicht f\xFCr produktbezogene Informationen, da diese vom Restaurant gem\xE4\xDF den Abschnitten 4, 5 und 6\n            bereitgestellt werden. Wenn Sie Zweifel haben, best\xE4tigen Sie dies bitte direkt vor der Bestellung mit dem\n            Restaurant.\n        </li>\n        <li>Wir haften nicht daf\xFCr, Ihnen im Namen eines Restaurants Entsch\xE4digung zu gew\xE4hren.</li>\n        <li>Unsere Gesamthaftung Ihnen gegen\xFCber in Bezug auf Vertr\xE4ge unter diesen Gesch\xE4ftsbedingungen darf den\n            h\xF6heren Betrag von nicht \xFCberschreiten:\n            <ul>\n                <li>\u20AC 250; und</li>\n                <li>den Gesamtbetrag, der im Rahmen des Vertrags an uns gezahlt wurde oder zu zahlen w\xE4re.</li>\n            </ul>\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>11. K\xFCndigung und Sperrung des Kontos</h4>\n    <ol>\n        <li>Wir k\xF6nnen:\n            <ul>\n                <li>Ihr Konto sperren; oder</li>\n                <li>Sie k\xF6nnen Ihr Konto jederzeit nach eigenem Ermessen ohne vorherige Ank\xFCndigung oder Erkl\xE4rung\n                    k\xFCndigen.\n                </li>\n            </ul>\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>12. Umfang und G\xFCltigkeit</h4>\n    <ol>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen stellen keine Abtretung oder Lizenz von Rechten an geistigem Eigentum\n            dar noch bewirken sie dies.\n        </li>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen gelten nicht f\xFCr die Lizenzierung von Werken (einschlie\xDFlich Software\n            und literarischen Werken), die in Produkten enthalten oder in diesen gespeichert sind.\n        </li>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen regeln nicht die Erbringung von Dienstleistungen durch uns oder\n            Dritte in Bezug auf die Produkte.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>13. \xC4nderungen</h4>\n    <ol>\n        <li>Wir k\xF6nnen diese Allgemeinen Gesch\xE4ftsbedingungen von Zeit zu Zeit \xFCberarbeiten, indem wir eine neue Version\n            auf unserer Website ver\xF6ffentlichen.\n        </li>\n        <li>Eine \xDCberarbeitung dieser Allgemeinen Gesch\xE4ftsbedingungen gilt f\xFCr Vertr\xE4ge, die zu einem beliebigen\n            Zeitpunkt nach dem Zeitpunkt der \xDCberarbeitung geschlossen werden, hat jedoch keine Auswirkungen auf\n            Vertr\xE4ge, die vor dem Zeitpunkt der \xDCberarbeitung abgeschlossen wurden.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>14. Zuteilung</h4>\n    <ol>\n        <li>Sie erkl\xE4ren sich hiermit einverstanden, dass wir unsere Rechte und / oder Pflichten unter diesen\n            Gesch\xE4ftsbedingungen abtreten, \xFCbertragen, untervergeben oder anderweitig behandeln k\xF6nnen. Falls Sie\n            Verbraucher sind, dient diese Ma\xDFnahme nicht dazu, die Rechte oder Garantien zu verringern, die Ihnen\n            gem\xE4\xDF diesen Allgemeinen Gesch\xE4ftsbedingungen zustehen.\n        </li>\n        <li>Ohne unsere vorherige schriftliche Zustimmung d\xFCrfen Sie Ihre Rechte und / oder Pflichten unter diesen\n            Gesch\xE4ftsbedingungen nicht abtreten, \xFCbertragen, untervergeben oder anderweitig behandeln.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>15. Keine Verzichtserkl\xE4rung</h4>\n    <ol>\n        <li>Ein Versto\xDF gegen eine Bestimmung eines Vertrags unter diesen Gesch\xE4ftsbedingungen wird nur mit\n            ausdr\xFCcklicher schriftlicher Zustimmung der Partei, die nicht gegen das Gesetz verst\xF6\xDFt, aufgehoben.\n        </li>\n        <li>Kein Verzicht auf einen Versto\xDF gegen eine Bestimmung eines Vertrags gem\xE4\xDF diesen Gesch\xE4ftsbedingungen ist\n            als weiterer oder fortgesetzter Verzicht auf einen anderen Versto\xDF gegen diese Bestimmung oder einen Versto\xDF\n            gegen eine andere Bestimmung dieses Vertrags zu verstehen.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>16. Salvatorische Klausel</h4>\n    <ol>\n        <li>Wenn eine Bestimmung dieser Allgemeinen Gesch\xE4ftsbedingungen von einem Gericht oder einer anderen\n            zust\xE4ndigen Beh\xF6rde als rechtswidrig und / oder nicht durchsetzbar eingestuft wird, bleiben die anderen\n            Bestimmungen in Kraft.\n        </li>\n        <li>Wenn eine rechtswidrige und / oder nicht durchsetzbare Bestimmung dieser Allgemeinen Gesch\xE4ftsbedingungen\n            rechtm\xE4\xDFig oder durchsetzbar w\xE4re, wenn ein Teil davon ung\xFCltig werden w\xFCrde, gilt dieser Teil als ung\xFCltig\n            und der Rest der Bestimmung bleibt in Kraft.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>17. Rechte Dritter</h4>\n    <ol>\n        <li>Die Aus\xFCbung der Rechte der Parteien aus einem Vertrag unter diesen Gesch\xE4ftsbedingungen bedarf nicht der\n            Zustimmung Dritter.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>18. Gesamte Vereinbarung</h4>\n    <ol>\n        <li>Vorbehaltlich des Abschnitts 10.1 stellen diese Allgemeinen Gesch\xE4ftsbedingungen zusammen mit unserer\n            Datenschutz- und Cookie-Richtlinie die gesamte Vereinbarung zwischen Ihnen und uns dar und ersetzen alle\n            vorherigen Vereinbarungen zwischen Ihnen und uns.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>19. Recht und Gerichtsbarkeit</h4>\n    <ol>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen unterliegen \xF6sterreichischem Recht und werden in \xDCbereinstimmung mit\n            diesem ausgelegt.\n        </li>\n        <li>F\xFCr alle Streitigkeiten im Zusammenhang mit diesen Gesch\xE4ftsbedingungen sind ausschlie\xDFlich die\n            \xF6sterreichischen Gerichte zust\xE4ndig.\n        </li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>20. Gesetzliche und beh\xF6rdliche Offenlegungen</h4>\n    <ol>\n        <li>Wir werden keine Kopie dieser Allgemeinen Gesch\xE4ftsbedingungen speziell f\xFCr jeden Benutzer oder Kunden\n            einreichen. Wenn wir diese Allgemeinen Gesch\xE4ftsbedingungen aktualisieren, ist die Version, der Sie\n            urspr\xFCnglich zugestimmt haben, nicht mehr auf unserer Website verf\xFCgbar. Wir empfehlen Ihnen, eine Kopie\n            dieser Allgemeinen Gesch\xE4ftsbedingungen zum sp\xE4teren Nachschlagen aufzubewahren.\n        </li>\n        <li>Diese Allgemeinen Gesch\xE4ftsbedingungen sind nur in deutscher Sprache verf\xFCgbar.</li>\n        <li>Unsere Umsatzsteuer-Identifikationsnummer lautet ' + partnerVatNumber + '.</li>\n    </ol>\n</div>\n\n<div class="content">\n    <h4>21. Unsere Daten</h4>\n    <ol>\n        <li>Diese Website geh\xF6rt und wird betrieben von ' + partnerCompanyName + '.</li>\n        <li>Wir sind in \xD6sterreich registriert unter ' + partnerRegNumber + ' und unser Sitz ist in der\n            ' + partnerPostalAddress + '.\n        </li>\n        <li>Unser Hauptgesch\xE4ftssitz befindet sich in ' + partnerPostalAddress + '.\n        </li>\n        <li>Sie k\xF6nnen uns kontaktieren:\n            <ul>\n                <li>per Post unter Verwendung der oben angegebenen Postanschrift;</li>\n                <li>per E-Mail adressiert an: <a href="mailto:' + partnerEmailAddress + '">' + partnerEmailAddress + '</a></li>\n                <li>telefonisch unter der von Zeit zu Zeit auf unserer Website ver\xF6ffentlichten Kontaktnummer; oder</li>\n                <li>per E-Mail unter Verwendung der von Zeit zu Zeit auf unserer Website ver\xF6ffentlichten E-Mail-Adresse.</li>\n            </ul>\n        </li>\n    </ol>\n</div>\n'
};

/* harmony default export */ __webpack_exports__["a"] = (data[country]);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var htmlHints = {};
var htmlHintsFormatted = {};

function formatHtmlHints() {
    if (htmlHints && htmlHints.length > 0) {
        for (var i = 0; i < htmlHints.length; i += 1) {
            htmlHintsFormatted[htmlHints[i].name] = htmlHints[i].value;
        }
    }
}

if (localStorage.company && localStorage.company !== 'null') {
    htmlHints = JSON.parse(localStorage.company).htmlHints || {};

    formatHtmlHints();
}

var partnerCompanyName = htmlHintsFormatted['webshop.partner.company-name'] || '';
var partnerRegNumber = htmlHintsFormatted['webshop.partner.registration-number'] || '';
var partnerPostalAddress = htmlHintsFormatted['webshop.partner.postall-address'] || '';
var partnerEmailAddress = htmlHintsFormatted['webshop.partner.email-address'] || '';

var country = localStorage.company && JSON.parse(localStorage.company) && JSON.parse(localStorage.company).address.country || 'UK';

var data = {
    // FOR UK !
    UK: '\n    <div class="content">\n        <h4>1. Introduction</h4>\n        <ol>\n            <li>We are committed to safeguarding the privacy of our website visitors and service users.</li>\n            <li>This policy applies where we are acting as a data controller with respect to the personal data of our\n                website visitors and service users; in other words, where we determine the purposes and means of the\n                processing of that personal data\n            </li>\n            <li>By using our website and agreeing to this policy, you consent to our use of cookies in accordance with\n                the terms of this policy.\n            </li>\n            <li>In this policy, "we", "us" and "our" refer to ' + partnerCompanyName + '. For more information about us, see\n                Section\n                18.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>2. How we use your personal data</h4>\n        <ol>\n            <li>In this Section 2 we have set out:\n                <ul>\n                    <li>the general categories of personal data that we may process;</li>\n                    <li>the purposes for which we may process personal data; and</li>\n                    <li>the legal bases of the processing.</li>\n                </ul>\n            </li>\n            <li>We may process data about your use of our website and services ("usage data"). The usage data may\n                include your IP address, geographical location, browser type and version, operating system, referral\n                source, length of visit, page views and website\n                navigation paths, as well as information about the timing, frequency and pattern of your service use.\n                The source of the usage data is our Google Analytics. This usage data may be processed for the purposes\n                of analysing the use of the website\n                and services. The legal basis for this processing is consent.\n            </li>\n            <li>We may process your personal data that are provided in the course of the use of our services ("service\n                data"). The service data may include your name, email address, telephone number, comments and further\n                data you enter. The source of the service\n                data is you. The service data may be processed for the purposes of operating our website, providing our\n                services, ensuring the security of our website and services, maintaining back-ups of our databases and\n                communicating with you. The legal\n                basis for this processing is consent and the performance of a contract between you and us and/or taking\n                steps, at your request, to enter into such a contract.\n            </li>\n            <li>We may process information contained in any enquiry you submit to us regarding goods and/or services\n                ("enquiry data"). The enquiry data may be processed for the purposes of offering, marketing and selling\n                relevant goods and/or services to you.\n                The legal basis for this processing is consent.\n            </li>\n            <li>We may process information that you provide to us for the purpose of subscribing to our email\n                notifications and/or newsletters ("notification data"). The notification data may be processed for the\n                purposes of sending you the relevant notifications\n                and/or newsletters. The legal basis for this processing is consent.\n            </li>\n            <li>We may process information contained in or relating to any communication that you send to us\n                ("correspondence data"). The correspondence data may include the communication content and metadata\n                associated with the communication. Our website will\n                generate the metadata associated with communications made using the website contact forms. The\n                correspondence data may be processed for the purposes of communicating with you and record-keeping.\n                The legal basis for this processing is our\n                legitimate interests, namely the proper administration of our website and business and communications\n                with users.\n            </li>\n            <li>We may process any of your personal data identified in this policy where necessary for the\n                establishment, exercise or defence of legal claims, whether in court proceedings or in an administrative\n                or out-of-court procedure. The legal basis for\n                this processing is our legitimate interests, namely the protection and assertion of our legal rights,\n                your legal rights and the legal rights of others.\n            </li>\n            <li>We may process any of your personal data identified in this policy where necessary for the purposes of\n                obtaining or maintaining insurance coverage, managing risks, or obtaining professional advice. The legal\n                basis for this processing is our legitimate\n                interests, namely the proper protection of our business against risks.\n            </li>\n            <li>In addition to the specific purposes for which we may process your personal data set out in this Section\n                2, we may also process any of your personal data where such processing is necessary for compliance with\n                a legal obligation to which we are\n                subject, or in order to protect your vital interests or the vital interests of another natural person.\n            </li>\n            <li>Please do not supply any other person\'s personal data to us, unless we prompt you to do so.</li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>3. Automated decision-making</h4>\n        <ol>\n            <li>We will not use your personal data for the purposes of automated decision-making.</li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>4. Providing your personal data to others</h4>\n        <ol>\n            <li>We may disclose your personal data to any member of our group of companies (this means our subsidiaries,\n                our ultimate holding company and all its subsidiaries) insofar as reasonably necessary for the purposes,\n                and on the legal bases, set out in\n                this policy.\n            </li>\n            <li>We may disclose your personal data to our insurers and/or professional advisers insofar as reasonably\n                necessary for the purposes of obtaining or maintaining insurance coverage, managing risks, obtaining\n                professional advice, or the establishment,\n                exercise or defence of legal claims, whether in court proceedings or in an administrative or\n                out-of-court procedure.\n            </li>\n            <li>We may disclose specify personal data category or categories to our suppliers or subcontractors insofar\n                as reasonably necessary for developing, maintaining, improving and troubleshooting our services and\n                products.\n            </li>\n            <li>Financial transactions relating to our website and services may be handled by our payment services\n                providers. We will share transaction data with our payment services providers only to the extent\n                necessary for the purposes of processing your payments,\n                refunding such payments and dealing with complaints and queries relating to such payments and refunds.\n                You can find information about the payment services providers\' privacy policies and practices at\n                <a href="https://www.paymentsense.co.uk/legal/privacy/">https://www.paymentsense.co.uk/legal/privacy/</a>\n            respective <a href="https://www.telecash.de/datenschutz/">https://www.telecash.de/datenschutz/</a>.\n            </li>\n            <li>We may disclose your enquiry data to one or more of those selected third party suppliers of goods and\n                services identified on our website for the purpose of enabling them to contact you so that they can\n                offer, market and sell to you relevant goods\n                and/or services. Each such third party will act as a data controller in relation to the enquiry data\n                that we supply to it; and upon contacting you, each such third party will supply to you a copy of its\n                own privacy policy, which will govern\n                that third party\'s use of your personal data.\n            </li>\n            <li>In addition to the specific disclosures of personal data set out in this Section 4, we may disclose your\n                personal data where such disclosure is necessary for compliance with a legal obligation to which we are\n                subject, or in order to protect your\n                vital interests or the vital interests of another natural person. We may also disclose your personal\n                data where such disclosure is necessary for the establishment, exercise or defence of legal claims,\n                whether in court proceedings or in an administrative\n                or out-of-court procedure.\n            </li>\n            <li>We use third-party analytics services to help understand your usage of our services. In particular, we\n                provide a limited amount of your information (such as sign-up date and some personal information like\n                your email address) to Intercom, Inc. ("Intercom") and utilize Intercom to collect data for analytics\n                purposes when you visit our website or use our product. As a data processor acting on our behalf,\n                Intercom analyzes your use of our website and/or product and tracks our relationship by way of cookies\n                and similar technologies so that we can improve our service to you. For more information on Intercom\'s\n                use of cookies, please visit <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.\n                We may also use\n                Intercom as a medium for communications, either through email, or through messages within our\n                product(s). The Intercom Messenger Apps and Apps in Inbox products may also provide you with access to\n                other third party applications such as Stripe. You should consult these third parties\' privacy notices\n                for further information on their use of your personal data. As part of our service agreements, Intercom\n                collects publicly available contact and social information related to you, such as your email address,\n                gender, company, job title, photos, website URLs, social network handles and physical addresses, to\n                enhance your user experience. For more information on the privacy practices of Intercom, please visit\n                <a href="https://www.intercom.com/terms-and-policies#privacy">https://www.intercom.com/terms-and-policies#privacy</a>.\n                Intercom\'s services are governed by Intercom\'s\n                terms of use which can be found at <a href="https://www.intercom.com/terms-and-policies#terms">https://www.intercom.com/terms-and-policies#terms</a>.\n                If you would\n                like to opt out of having this information collected by or submitted to Intercom, please contact us.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>5. International transfers of your personal data</h4>\n        <ol>\n            <li>In this Section 5, we provide information about the circumstances in which your personal data may be\n                transferred to countries outside the European Economic Area (EEA).\n            </li>\n            <li>We and our other group companies have offices and facilities in United States and Canada. The European\n                Commission has made an "adequacy decision" with respect to the data protection laws of each of these\n                countries. Transfers to each of these countries\n                will be protected by appropriate safeguards, namely the use of standard data protection clauses adopted\n                or approved by the European Commission. The European Commission has made an "adequacy decision" with\n                respect to the data protection laws\n                of each of these countries.\n            </li>\n            <li>You acknowledge that personal data that you submit for publication through our website or services may\n                be available, via the internet, around the world. We cannot prevent the use (or misuse) of such personal\n                data by others.\n            </li>\n    </div>\n    <div class="content">\n        <h4>6. Retaining and deleting personal data</h4>\n        <ol>\n            <li>This Section 6 sets out our data retention policies and procedure, which are designed to help ensure\n                that we comply with our legal obligations in relation to the retention and deletion of personal data.\n            </li>\n            <li>Personal data that we process for any purpose or purposes shall not be kept for longer than is necessary\n                for that purpose or those purposes.\n            </li>\n            <li>We will retain your personal data as follows:\n                <ul>\n                    <li>personal data category will be retained for a minimum period of 1 day and for a maximum period\n                        of 30 days following their submit.\n                    </li>\n                </ul>\n            </li>\n            <li>Notwithstanding the other provisions of this Section 6, we may retain your personal data where such\n                retention is necessary for compliance with a legal obligation to which we are subject, or in order to\n                protect your vital interests or the vital\n                interests of another natural person.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>7. Security of personal data</h4>\n        <ol>\n            <li>We will take appropriate technical and organisational precautions to secure your personal data and to\n                prevent the loss, misuse or alteration of your personal data.\n            </li>\n            <li>We will store all your personal data on secure servers, personal computers and mobile devices, and in\n                secure manual record-keeping systems.\n            </li>\n            <li>Data relating to your enquiries and financial transactions that is sent from your web browser to our web\n                server, or from our web server to your web browser, will be protected using encryption technology.\n            </li>\n            <li>You acknowledge that the transmission of unencrypted (or inadequately encrypted) data over the internet\n                is inherently insecure, and we cannot guarantee the security of data sent over the internet.\n            </li>\n            <li>You should ensure that your password is not susceptible to being guessed, whether by a person or a\n                computer program. You are responsible for keeping the password you use for accessing our website\n                confidential and we will not ask you for your password\n                (except when you log in to our website).\n            </li>\n    </div>\n    <div class="content">\n        <h4>8. Amendments</h4>\n        <ol>\n            <li>We may update this policy from time to time by publishing a new version on our website.</li>\n            <li>You should check this page occasionally to ensure you are happy with any changes to this policy.</li>\n            <li>We may notify you of changes to this policy by email.</li>\n    </div>\n    <div class="content">\n        <h4>9. Your rights</h4>\n        <ol>\n            <li>In this Section 9, we have summarised the rights that you have under data protection law. Some of the\n                rights are complex, and not all of the details have been included in our summaries. Accordingly, you\n                should read the relevant laws and guidance\n                from the regulatory authorities for a full explanation of these rights.\n            </li>\n            <li>Your principal rights under data protection law are:\n                <ul>\n                    <li>the right to access;</li>\n                    <li>the right to rectification;</li>\n                    <li>the right to erasure;</li>\n                    <li>the right to restrict processing;</li>\n                    <li>the right to object to processing;</li>\n                    <li>the right to data portability;</li>\n                    <li>the right to complain to a supervisory authority; and</li>\n                    <li>the right to withdraw consent.</li>\n                </ul>\n            </li>\n            <li>You have the right to confirmation as to whether or not we process your personal data and, where we do,\n                access to the personal data, together with certain additional information. That additional information\n                includes details of the purposes of\n                the processing, the categories of personal data concerned and the recipients of the personal data.\n                Providing the rights and freedoms of others are not affected, we will supply to you a copy of your\n                personal data. The first copy will be provided\n                free of charge, but additional copies may be subject to a reasonable fee.\n            </li>\n            <li>You have the right to have any inaccurate personal data about you rectified and, taking into account the\n                purposes of the processing, to have any incomplete personal data about you completed.\n            </li>\n            <li>In some circumstances you have the right to the erasure of your personal data without undue delay. Those\n                circumstances include: the personal data are no longer necessary in relation to the purposes for which\n                they were collected or otherwise processed;\n                you withdraw consent to consent-based processing; you object to the processing under certain rules of\n                applicable data protection law; the processing is for direct marketing purposes; and the personal data\n                have been unlawfully processed. However,\n                there are exclusions of the right to erasure. The general exclusions include where processing is\n                necessary: for exercising the right of freedom of expression and information; for compliance with a\n                legal obligation; or for the establishment,\n                exercise or defence of legal claims.\n            </li>\n            <li>In some circumstances you have the right to restrict the processing of your personal data. Those\n                circumstances are: you contest the accuracy of the personal data; processing is unlawful but you oppose\n                erasure; we no longer need the personal data\n                for the purposes of our processing, but you require personal data for the establishment, exercise or\n                defence of legal claims; and you have objected to processing, pending the verification of that\n                objection. Where processing has been restricted\n                on this basis, we may continue to store your personal data. However, we will only otherwise process it:\n                with your consent; for the establishment, exercise or defence of legal claims; for the protection of the\n                rights of another natural or legal\n                person; or for reasons of important public interest.\n            </li>\n            <li>You have the right to object to our processing of your personal data on grounds relating to your\n                particular situation, but only to the extent that the legal basis for the processing is that the\n                processing is necessary for: the performance of a\n                task carried out in the public interest or in the exercise of any official authority vested in us; or\n                the purposes of the legitimate interests pursued by us or by a third party. If you make such an\n                objection, we will cease to process the personal\n                information unless we can demonstrate compelling legitimate grounds for the processing which override\n                your interests, rights and freedoms, or the processing is for the establishment, exercise or defence of\n                legal claims.\n            </li>\n            <li>You have the right to object to our processing of your personal data for direct marketing purposes\n                (including profiling for direct marketing purposes). If you make such an objection, we will cease to\n                process your personal data for this purpose.\n            </li>\n            <li>You have the right to object to our processing of your personal data for scientific or historical\n                research purposes or statistical purposes on grounds relating to your particular situation, unless the\n                processing is necessary for the performance\n                of a task carried out for reasons of public interest.\n            </li>\n            <li>To the extent that the legal basis for our processing of your personal data is:\n                <ul>\n                    <li>consent; or</li>\n                    <li>that the processing is necessary for the performance of a contract to which you are party or in\n                        order to take steps at your request prior to entering into a contract,\n                    </li>\n                </ul>\n                and such processing is carried out by automated means, you have the right to receive your personal data\n                from us in a structured, commonly used and machine-readable format. However, this right does not apply\n                where it would adversely affect the rights and\n                freedoms of others.\n            </li>\n            <li>If you consider that our processing of your personal information infringes data protection laws, you\n                have a legal right to lodge a complaint with a supervisory authority responsible for data protection.\n                You may do so in the EU member state of\n                your habitual residence, your place of work or the place of the alleged infringement.\n            </li>\n            <li>To the extent that the legal basis for our processing of your personal information is consent, you have\n                the right to withdraw that consent at any time. Withdrawal will not affect the lawfulness of processing\n                before the withdrawal.\n            </li>\n            <li>You may exercise any of your rights in relation to your personal data by written notice to us.</li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>10. Third party websites</h4>\n        <ol>\n            <li>Our website includes hyperlinks to, and details of, third party websites.</li>\n            <li>We have no control over, and are not responsible for, the privacy policies and practices of third\n                parties.\n            </li>\n            <li></li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>11. Personal data of children</h4>\n        <ol>\n            <li>Our website and services are targeted at persons over the age of 18.</li>\n            <li>If we have reason to believe that we hold personal data of a person under that age in our databases, we\n                will delete that personal data.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>12. Updating information</h4>\n        <ol>\n            <li>Please let us know if the personal information that we hold about you needs to be corrected or\n                updated.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>13. Acting as a data processor</h4>\n        <ol>\n            <li>Insofar as we act as a data processor rather than a data controller, this policy shall not apply. Our\n                legal obligations as a data processor are instead set out in the contract between us and the relevant\n                data controller.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>14. About cookies</h4>\n        <ol>\n            <li>A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web\n                server to a web browser and is stored by the browser. The identifier is then sent back to the server\n                each time the browser requests a page from\n                the server.\n            </li>\n            <li>Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a\n                web browser and will remain valid until its set expiry date, unless deleted by the user before the\n                expiry date; a session cookie, on the other\n                hand, will expire at the end of the user session, when the web browser is closed.\n            </li>\n            <li>Cookies do not typically contain any information that personally identifies a user, but personal\n                information that we store about you may be linked to the information stored in and obtained from\n                cookies.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>15. Cookies that we use</h4>\n        <ol>\n            <li>We use cookies to personalise your experience. We aim to offer you the best possible experience when\n                accessing and navigating through our website and using its features. For example, these cookies let us\n                recognize that you have created an account and have logged into that account to access the content.\n                They help us recognize how you customized the site.\n            </li>\n            <li>If you want to restrict or block the cookies that are set by our website, you can do so through your\n                browser setting. This might impact or entirely prevent the correct usage of our site.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>16. Cookies used by our service providers</h4>\n        <ol>\n            <li>Our service providers use cookies and those cookies may be stored on your computer when you visit our\n                website.\n            </li>\n            <li>We use Google Analytics to analyse the use of our website. Google Analytics gathers information about\n                website use by means of cookies. The information gathered relating to our website is used to create\n                reports about the use of our website. Google\'s privacy policy is available at:\n                <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>.\n            </li>\n            <li>We use services provided by Intercom, please refer to section 4. For more information on Intercom\'s\n                use of cookies, please visit\n                <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>17. Managing cookies</h4>\n        <ol>\n            <li>Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary\n                from browser to browser, and from version to version. You can however obtain up-to-date information\n                about blocking and deleting cookies via\n                these links:\n                <ul>\n                    <li>https://support.google.com/chrome/answer/95647?hl=en (Chrome);</li>\n                    <li>https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences (Firefox);\n                    </li>\n                    <li>http://www.opera.com/help/tutorials/security/cookies/ (Opera);</li>\n                    <li>https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies\n                        (Internet Explorer);\n                    </li>\n                    <li>https://support.apple.com/kb/PH21411 (Safari); and</li>\n                    <li>https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy (Edge).</li>\n                </ul>\n            </li>\n            <li>Blocking all cookies will have a negative impact upon the usability of many websites.</li>\n            <li>If you block cookies, you will not be able to use all the features on our website.</li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>18. Our details</h4>\n        <li>This website is owned and operated by ' + partnerCompanyName + '.</li>\n        <li>We are registered in England and Wales under registration number ' + partnerRegNumber + ', and our registered office\n            is at\n            ' + partnerPostalAddress + '.\n        </li>\n        <li>Our principal place of business is at ' + partnerPostalAddress + '.\n        </li>\n        <li>You can contact us:\n            <ul>\n                <li>by post, using the postal address given above;</li>\n                <li>by email addressed to: <a href="mailto:' + partnerEmailAddress + '">' + partnerEmailAddress + '</a></li>\n                <li>by telephone, on the contact number published on our website from time to time; or</li>\n                <li>by email, using the email address published on our website from time to time.</li>\n            </ul>\n        </li>\n        </ol>\n    </div>\n',
    // FOR AT !
    AT: '\n    <div class="content">\n        <h4>1. Einf\xFChrung</h4>\n        <ol>\n            <li>Wir verpflichten uns, die Privatsph\xE4re unserer Website-Besucher und Service-Benutzer zu sch\xFCtzen.</li>\n            <li>Diese Richtlinie gilt, wenn wir als Datenverantwortlicher in Bezug auf die personenbezogenen Daten unserer\n                Website-Besucher und Service-Benutzer t\xE4tig sind; mit anderen Worten, wo wir die Zwecke und Mittel der\n                Verarbeitung dieser personenbezogenen Daten bestimmen\n            </li>\n            <li>Durch die Nutzung unserer Website und die Zustimmung zu dieser Richtlinie stimmen Sie der Verwendung von\n                Cookies zu gem\xE4\xDF den Bedingungen dieser Richtlinie.\n            </li>\n            <li> In dieser Richtlinie beziehen sich "wir", "uns" und "unser" auf ' + partnerCompanyName + '. Weitere\n                Informationen \xFCber uns finden Sie im Abschnitt 18.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>2. Wie wir Ihre pers\xF6nlichen Daten verwenden</h4>\n        <ol>\n            <li>In diesem Abschnitt 2 legen wir dar:\n                <ul>\n                    <li>die allgemeinen Kategorien personenbezogener Daten, die wir verarbeiten d\xFCrfen;</li>\n                    <li>die Zwecke, f\xFCr die wir personenbezogene Daten verarbeiten d\xFCrfen; und</li>\n                    <li>die rechtlichen Grundlagen der Verarbeitung.</li>\n                </ul>\n            </li>\n            <li>Wir k\xF6nnen Daten \xFCber Ihre Nutzung unserer Website und unserer Dienste ("Nutzungsdaten") verarbeiten. Die\n                Nutzungsdaten k\xF6nnen beinhalten\n                Ihre IP-Adresse, Ihren geografischen Standort, den Browsertyp und die Browserversion, das Betriebssystem und\n                die Empfehlung an\n                Quelle, Besuchsdauer, Seitenaufrufe und Webseiten Navigationspfade sowie Informationen zu Zeitpunkt,\n                H\xE4ufigkeit und Muster Ihrer Dienstnutzung.\n                Die Quelle der Nutzungsdaten ist Google Analytics. Diese Nutzungsdaten k\xF6nnen zu diesen Zwecken verarbeitet\n                werden\n                der Nutzung der Website zu analysieren und Dienstleistungen. Rechtsgrundlage f\xFCr diese Verarbeitung ist die\n                Zustimmung.\n            </li>\n            <li>Wir k\xF6nnen Ihre personenbezogenen Daten verarbeiten, die im Rahmen der Nutzung unserer Dienste zur Verf\xFCgung\n                gestellt werden\n                ("Servicedaten"). Die Servicedaten k\xF6nnen Ihren Namen, Ihre E-Mail-Adresse, Ihre Telefonnummer, Kommentare\n                und weitere Informationen enthalten\n                Daten, die Sie eingeben. Die Quelle dieser Servicedaten sind sie. Die Servicedaten k\xF6nnen zum Zwecke des\n                Betriebs unserer Website\n                verarbeitet werden, sofern unsere Dienstleistungen, Gew\xE4hrleistung der Sicherheit unserer Website und\n                Dienstleistungen, Sicherung unserer Datenbanken und\n                mit dir kommunizieren. Die legale Grundlage f\xFCr diese Verarbeitung ist die Zustimmung und die Erf\xFCllung\n                eines Vertrages zwischen Ihnen und uns\n                und/oder das Durchf\xFChren von Schritten, auf Ihren Wunsch hin, einen solchen Vertrag abzuschlie\xDFen.\n            </li>\n            <li>Wir k\xF6nnen Informationen verarbeiten, die in einer von Ihnen an uns gesendeten Anfrage zu Waren und / oder\n                Dienstleistungen enthalten sind ("Anfragedaten"). Die Anfragedaten k\xF6nnen zum Zwecke des Angebots,\n                Marketings und Verkaufs verarbeitet\n                werden relevante Waren und / oder Dienstleistungen f\xFCr Sie. Rechtsgrundlage f\xFCr diese Verarbeitung ist Ihre\n                Zustimmung.\n            </li>\n            <li>\n                Wir k\xF6nnen Informationen, die Sie uns zur Verf\xFCgung stellen, verarbeiten um unsere E-Mail\n                Benachrichtigungen zu abonnieren und / oder Newsletter ("Benachrichtigungsdaten"). Die\n                Benachrichtigungsdaten k\xF6nnen f\xFCr verarbeitet werden zum Zwecke der Zusendung der entsprechenden\n                Benachrichtigungen und / oder Newsletter. Die Rechtsgrundlage f\xFCr diese Verarbeitung ist Ihre Zustimmung.\n            </li>\n            <li>\n                Wir k\xF6nnen Informationen, die in oder im Zusammenhang mit einer von Ihnen an uns gesendeten Mitteilung\n                enthalten sind, verarbeiten ("Korrespondenzdaten"). Die Korrespondenzdaten enthalten den\n                Kommunikationsinhalt und die mit der mit der Kommunikation verbundenen Metadaten. Unsere Website wird die\n                Kommunikations Metadaten \xFCber die Kontaktformulare der Website generieren.\n                Die Korrespondenzdaten werden zum Zwecke der Kommunikation mit Ihnen und der F\xFChrung von Aufzeichnungen\n                verarbeitet. Die Rechtsgrundlage f\xFCr diese Verarbeitung ist unser berechtigtes Interesse an der\n                ordnungsgem\xE4\xDFen Verwaltung unserer Website sowie gesch\xE4ftlichen T\xE4tigkeit und Kommunikation mit Benutzern.\n            </li>\n            <li>\n                Wir k\xF6nnen Ihre personenbezogenen Daten gem\xE4\xDF dieser Richtlinie verarbeiten zur Begr\xFCndung, Aus\xFCbung oder\n                Verteidigung von Rechtsanspr\xFCchen, sei es in Gerichtsverfahren oder in einem Verwaltungs-\n                oder au\xDFergerichtlichen Verfahren. Die Rechtsgrundlage f\xFCr diese Verarbeitung ist unser berechtigtes\n                Interesse\n                an dem Schutz und die Geltendmachung der gesetzlichen Rechte unserer, Ihrer und Dritter.\n            </li>\n            <li>Wir k\xF6nnen Ihre in dieser Richtlinie angegebenen personenbezogenen Daten zum Zwecke der Erhaltung und\n                Aufrechterhaltung von Versicherungsschutz, Risiko Management oder der Einholung von professioneller Beratung\n                verarbeiten.\n                Die legale Grundlage f\xFCr diese Verarbeitung ist unser Interesse an den angemessenen Schutz\n                unseres Gesch\xE4fts vor Risiken.\n            </li>\n            <li>\n                Zus\xE4tzlich zu den spezifischen Zwecken, f\xFCr die wir Ihre in diesem Abschnitt 2 genannten personenbezogenen\n                Daten verarbeiten k\xF6nnen, k\xF6nnen wir Ihre personenbezogenen Daten auch verarbeiten, wenn eine solche\n                Verarbeitung zur Erf\xFCllung einer gesetzlichen Verpflichtung der wir unterliegen, oder um Ihre wesentlichen\n                Interessen oder die wesentlichen Interessen einer anderen nat\xFCrlichen Person zu sch\xFCtzen.\n            </li>\n            <li>Bitte geben Sie keine personenbezogenen Daten einer anderen Person an uns weiter, es sei denn, wir fordern\n                Sie dazu auf.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>3. Automatisierte Entscheidungsfindung</h4>\n        <ol>\n            <li>Wir werden Ihre personenbezogenen Daten nicht zum Zwecke der automatisierten Entscheidungsfindung nutzen.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>4. Weitergabe Ihrer pers\xF6nlichen Daten an Dritte</h4>\n        <ol>\n            <li>Wir k\xF6nnen Ihre personenbezogenen Daten an jedes Mitglied unserer Unternehmensgruppe (daher an unsere\n                Tochterunternehmen, unsere oberste Holdinggesellschaft und alle ihre Tochterunternehmen) weitergeben, soweit\n                dies f\xFCr die in dieser Richtlinie dargelegten Zwecke und auf den rechtlichen Grundlagen dieser Richtlinie\n                vern\xFCnftigerweise erforderlich und zumutbar ist.\n            </li>\n            <li>\n                Wir k\xF6nnen Ihre personenbezogenen Daten an unsere Versicherer und / oder professionellen Berater weitergeben\n                soweit dies zum Zwecke des Abschlusses oder der Aufrechterhaltung des Versicherungsschutzes, des\n                Risikomanagements, der professionellen Beratung oder der Begr\xFCndung, Aus\xFCbung oder Verteidigung von\n                Rechtsanspr\xFCchen in Gerichtsverfahren zumutbar ist oder in einem administrativen oder au\xDFergerichtlichen\n                Verfahren.\n            </li>\n            <li>Wir k\xF6nnen unseren Lieferanten oder Subunternehmern bestimmte Kategorien oder Kategorien personenbezogener\n                Daten offenlegen, soweit dies f\xFCr die Entwicklung, Wartung, Verbesserung und Fehlerbehebung unserer\n                Dienstleistungen und Produkte zumutbar ist.\n            </li>\n            <li>Finanztransaktionen im Zusammenhang mit unserer Website und unseren Dienstleistungen k\xF6nnen von unseren\n                Zahlungsdienstleistern abgewickelt werden. Wir werden Transaktionsdaten nur in dem Umfang an unsere\n                Zahlungsdienstleister weitergeben, der f\xFCr die Verarbeitung Ihrer Zahlungen, die R\xFCckerstattung solcher\n                Zahlungen und die Bearbeitung von Beschwerden und Fragen im Zusammenhang mit solchen Zahlungen und\n                R\xFCckerstattungen erforderlich ist. Informationen zu den Datenschutzrichtlinien und -praktiken der\n                Zahlungsdienstleister finden Sie unter\n                <a href="https://www.paymentsense.co.uk/legal/privacy/">https://www.paymentsense.co.uk/legal/privacy/</a>\n                bzw. <a href="https://www.telecash.de/datenschutz/">https://www.telecash.de/datenschutz/</a>.\n            </li>\n            <li>Wir k\xF6nnen Ihre Anfragedaten an einen oder mehrere dieser ausgew\xE4hlten Drittanbieter von Waren und\n                Dienstleistungen weitergeben, die auf unserer Website angegeben sind, damit diese Sie kontaktieren k\xF6nnen,\n                damit sie Ihnen relevante Waren und / oder Dienstleistungen anbieten, vermarkten und verkaufen k\xF6nnen.\n                Jeder dieser Dritten fungiert als Datenverantwortlicher in Bezug auf die Anfragedaten, die wir ihm zur\n                Verf\xFCgung stellen. Wenn Sie kontaktiert werden, wird Ihnen jeder dieser Dritten eine Kopie seiner\n                eigenen Datenschutzrichtlinie zur Verf\xFCgung stellen, die die Verwendung Ihrer pers\xF6nlichen Daten durch\n                diese Dritten regelt.\n            </li>\n            <li>Zus\xE4tzlich zu den in diesem Abschnitt 4 aufgef\xFChrten spezifischen Offenlegungen personenbezogener Daten\n                k\xF6nnen wir Ihre personenbezogenen Daten offenlegen, wenn eine solche Offenlegung zur Erf\xFCllung einer\n                gesetzlichen Verpflichtung, der wir unterliegen, oder zum Schutz Ihrer wesentlichen Interessen oder der\n                wesentlichen Interessen einer anderen nat\xFCrlichen Person. Wir k\xF6nnen Ihre\n                personenbezogenen Daten auch dann offenlegen, wenn eine solche Offenlegung f\xFCr die Begr\xFCndung, Aus\xFCbung oder\n                Verteidigung von Rechtsanspr\xFCchen erforderlich ist, sei es in Gerichtsverfahren oder in einem\n                administrativen oder au\xDFergerichtlichen Verfahren.\n            </li>\n            <li>Wir verwenden Analysedienste von Drittanbietern, um Ihre Nutzung unserer Dienste zu verstehen. Insbesondere\n                stellen wir Intercom, Inc. ("Intercom") eine begrenzte Menge Ihrer Informationen (wie das Anmeldedatum und\n                einige pers\xF6nliche Informationen wie Ihre E-Mail-Adresse) zur Verf\xFCgung und verwenden Intercom, um Daten f\xFCr\n                Analysezwecke zu sammeln, wenn Sie unsere besuchen Website oder verwenden Sie unser Produkt. Als in unserem\n                Auftrag handelnder Datenverarbeiter analysiert Intercom Ihre Nutzung unserer Website und / oder unseres\n                Produkts und verfolgt unsere Beziehung mithilfe von Cookies und \xE4hnlichen Technologien, damit wir unseren\n                Service f\xFCr Sie verbessern k\xF6nnen. Weitere Informationen zur Verwendung von Cookies durch Intercom finden\n                Sie unter <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.\n                Wir k\xF6nnen Intercom auch als Kommunikationsmedium verwenden, entweder per E-Mail oder \xFCber Nachrichten\n                innerhalb unserer Produkte. Mit den Intercom Messenger-Apps und Apps in Inbox Produkten k\xF6nnen Sie\n                m\xF6glicherweise auch auf andere Anwendungen von Drittanbietern wie Stripe zugreifen. Weitere Informationen\n                zur Verwendung Ihrer personenbezogenen Daten finden Sie in den Datenschutzhinweisen dieser Dritten. Im\n                Rahmen unserer Servicevereinbarungen sammelt Intercom \xF6ffentlich zug\xE4ngliche Kontakt- und soziale\n                Informationen zu Ihnen, wie z. B. Ihre E-Mail-Adresse, Ihr Geschlecht, Ihr Unternehmen, Ihre\n                Berufsbezeichnung, Fotos, Website-URLs, Handles f\xFCr soziale Netzwerke und physische Adressen, um Ihre\n                Benutzererfahrung zu verbessern. Weitere Informationen zu den Datenschutzpraktiken von Intercom finden Sie\n                unter <a href="https://www.intercom.com/terms-and-policies#privacy">https://www.intercom.com/terms-and-policies#privacy</a>.\n                Die Dienste von Intercom unterliegen den Nutzungsbedingungen von Intercom, die unter\n                <a href="https://www.intercom.com/terms-and-policies#terms">https://www.intercom.com/terms-and-policies#terms</a>\n                zu finden sind.Wenn Sie nicht m\xF6chten, dass diese Informationen von Intercom\n                gesammelt oder an Intercom \xFCbermittelt werden, kontaktieren Sie uns bitte.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>5. Internationale \xDCbermittlung Ihrer pers\xF6nlichen Daten</h4>\n        <ol>\n            <li>In diesem Abschnitt 5 informieren wir Sie \xFCber die Umst\xE4nde, unter denen Ihre personenbezogenen Daten in\n                L\xE4nder au\xDFerhalb des Europ\xE4ischen Wirtschaftsraums (EWR) \xFCbertragen werden k\xF6nnen.\n            </li>\n            <li>Wir und unsere anderen Konzernunternehmen haben B\xFCros und Einrichtungen in den USA und Kanada. Die\n                Europ\xE4ische Kommission hat eine "Angemessenheitsentscheidung" in Bezug auf die Datenschutzgesetze jedes\n                dieser\n                L\xE4nder getroffen. \xDCbertragungen in jedes dieser L\xE4nder werden durch geeignete Schutzma\xDFnahmen gesch\xFCtzt,\n                n\xE4mlich\n                durch die Verwendung von Standard-Datenschutzklauseln, die von der Europ\xE4ischen Kommission angenommen oder\n                genehmigt wurden. Die Europ\xE4ische Kommission hat eine "Angemessenheitsentscheidung" in Bezug auf die\n                Datenschutzgesetze jedes dieser L\xE4nder getroffen.\n            </li>\n            <li>Sie erkennen an, dass personenbezogene Daten, die Sie zur Ver\xF6ffentlichung \xFCber unsere Website oder unsere\n                Dienste einreichen, m\xF6glicherweise \xFCber das Internet weltweit verf\xFCgbar sind. Wir k\xF6nnen die Verwendung\n                (oder\n                den Missbrauch) solcher personenbezogener Daten durch andere nicht verhindern.\n            </li>\n    </div>\n    <div class="content">\n        <h4>6. Speicherung und L\xF6schung personenbezogener Daten</h4>\n        <ol>\n            <li>In diesem Abschnitt werden unsere Richtlinien und Verfahren zur Vorratsdatenspeicherung aufgef\xFChrt, mit\n                denen sichergestellt werden soll, dass wir unseren gesetzlichen Verpflichtungen in Bezug auf die\n                Vorratsdatenspeicherung und L\xF6schung personenbezogener Daten nachkommen.\n            </li>\n            <li>Personenbezogene Daten, die wir f\xFCr einen oder mehrere Zwecke verarbeiten, werden nicht l\xE4nger aufbewahrt,\n                als dies f\xFCr diesen Zweck oder diese Zwecke erforderlich ist.\n            </li>\n            <li>Wir werden Ihre pers\xF6nlichen Daten wie folgt speichern:\n                <ul>\n                    <li>Die Kategorie der personenbezogenen Daten wird mindestens 1 Tag und h\xF6chstens 30 Tage nach ihrer\n                        \xDCbermittlung gespeichert.\n                    </li>\n                </ul>\n            </li>\n            <li>Ungeachtet der anderen Bestimmungen dieses Abschnitts k\xF6nnen wir Ihre personenbezogenen Daten\n                aufbewahren, wenn eine solche Aufbewahrung erforderlich ist um einer gesetzlichen Verpflichtung, der wir\n                unterliegen, nachzukommen oder um Ihre wichtigen Interessen oder die wichtigen Interessen einer anderen\n                nat\xFCrlichen Person zu sch\xFCtzen.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>7. Sicherheit personenbezogener Daten</h4>\n        <ol>\n            <li>Wir treffen geeignete technische und organisatorische Vorkehrungen, um Ihre pers\xF6nlichen Daten zu\n                sch\xFCtzen und den Verlust, den Missbrauch oder die \xC4nderung Ihrer pers\xF6nlichen Daten zu verhindern.\n            </li>\n            <li>Wir speichern alle Ihre pers\xF6nlichen Daten auf sicheren Servern, PCs und Mobilger\xE4ten sowie in sicheren\n                manuellen Aufzeichnungssystemen.\n            </li>\n            <li>Daten zu Ihren Anfragen und Finanztransaktionen, die von Ihrem Webbrowser an unseren Webserver oder von\n                unserem Webserver an Ihren Webbrowser gesendet werden, werden mithilfe der Verschl\xFCsselungstechnologie\n                gesch\xFCtzt.\n            </li>\n            <li>Sie erkennen an, dass die \xDCbertragung von unverschl\xFCsselten (oder unzureichend verschl\xFCsselten) Daten\n                \xFCber das Internet von Natur aus unsicher ist und wir die Sicherheit von Daten, die \xFCber das Internet\n                gesendet werden, nicht garantieren k\xF6nnen.\n            </li>\n            <li>Sie sollten sicherstellen, dass Ihr Passwort weder von einer Person noch von einem Computerprogramm\n                erraten werden kann. Sie sind daf\xFCr verantwortlich, das Passwort, dass Sie f\xFCr den Zugriff auf unsere\n                Website verwenden, vertraulich zu behandeln, und wir werden Sie nicht nach Ihrem Passwort fragen\n                (au\xDFer wenn Sie sich auf unserer Website anmelden).\n            </li>\n    </div>\n    <div class="content">\n        <h4>8. Erg\xE4nzungen</h4>\n        <ol>\n            <li>Wir k\xF6nnen diese Richtlinie von Zeit zu Zeit aktualisieren, indem wir eine neue Version auf unserer\n                Website ver\xF6ffentlichen.\n            </li>\n            <li>Sie sollten diese Seite gelegentlich \xFCberpr\xFCfen, um sicherzustellen, dass Sie mit \xC4nderungen an dieser\n                Richtlinie zufrieden sind.\n            </li>\n            <li>Wir k\xF6nnen Sie per E-Mail \xFCber \xC4nderungen dieser Richtlinie informieren.</li>\n    </div>\n    <div class="content">\n        <h4>9. Ihre Rechte</h4>\n        <ol>\n            <li>In diesem Abschnitt haben wir ihre datenschutzrechtlichen Rechte zusammengefasst. Einige dieser Rechte\n                sind komplex und nicht alle Details wurden in unsere Zusammenfassungen aufgenommen. Dementsprechend sollten\n                Sie die einschl\xE4gigen Gesetze und Richtlinien der Regulierungsbeh\xF6rden lesen, um eine vollst\xE4ndige\n                Erl\xE4uterung dieser Rechte zu erhalten.\n            </li>\n            <li>Ihre datenschutzrechtlichen prinzipiellen Rechte sind:\n                <ul>\n                    <li>das Recht auf Zugang;</li>\n                    <li>das Recht auf Berichtigung;</li>\n                    <li>das Recht auf L\xF6schung;</li>\n                    <li>das Recht, die Verarbeitung einzuschr\xE4nken;</li>\n                    <li>das Recht, der Verarbeitung zu widersprechen;</li>\n                    <li>das Recht auf Datenportabilit\xE4t;</li>\n                    <li>das Recht, sich bei einer Aufsichtsbeh\xF6rde zu beschweren; und</li>\n                    <li>das Recht, die Zustimmung zu widerrufen.</li>\n                </ul>\n            </li>\n            <li>Sie haben das Recht zu best\xE4tigen, ob wir Ihre personenbezogenen Daten verarbeiten oder nicht, und, wo\n                wir dies tun, auf die personenbezogenen Daten zuzugreifen, zusammen mit bestimmten zus\xE4tzlichen\n                Informationen. Diese zus\xE4tzlichen Informationen enthalten Einzelheiten zu den Zwecken der Verarbeitung, den\n                Kategorien der betreffenden personenbezogenen Daten und den Empf\xE4ngern der personenbezogenen Daten. Sofern\n                die Rechte und Freiheiten anderer nicht beeintr\xE4chtigt werden, stellen wir Ihnen eine Kopie Ihrer\n                pers\xF6nlichen Daten zur Verf\xFCgung. Das erste Exemplar wird kostenlos zur Verf\xFCgung gestellt, f\xFCr zus\xE4tzliche\n                Exemplare kann jedoch eine angemessene Geb\xFChr erhoben werden.\n            </li>\n            <li>Sie haben das Recht, ungenaue personenbezogene Daten \xFCber Sie korrigieren zu lassen und unter\n                Ber\xFCcksichtigung der Zwecke der Verarbeitung unvollst\xE4ndige personenbezogene Daten \xFCber Sie vervollst\xE4ndigen\n                zu lassen.\n            </li>\n            <li>Unter bestimmten Umst\xE4nden haben Sie das Recht, Ihre pers\xF6nlichen Daten unverz\xFCglich zu l\xF6schen. Zu\n                diesen Umst\xE4nden geh\xF6ren: die personenbezogenen Daten sind f\xFCr die Zwecke, f\xFCr die sie erhoben oder\n                anderweitig verarbeitet wurden, nicht mehr erforderlich; sie widerrufen die Einwilligung zur\n                einwilligungsbasierten Verarbeitung; sie widersprechen der Verarbeitung nach bestimmten Regeln des\n                geltenden Datenschutzrechts; die Verarbeitung erfolgt zu Direktmarketingzwecken; die personenbezogenen Daten\n                wurden rechtswidrig verarbeitet. Es gibt jedoch Ausschl\xFCsse vom Recht auf L\xF6schung. Zu den allgemeinen\n                Ausschl\xFCssen geh\xF6ren, wo eine Verarbeitung erforderlich ist: zur Aus\xFCbung des Rechts auf freie\n                Meinungs\xE4u\xDFerung und Information; zur Einhaltung einer gesetzlichen Verpflichtung; oder zur Begr\xFCndung,\n                Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen.\n            </li>\n            <li>Unter bestimmten Umst\xE4nden haben sie das Recht, die Verarbeitung Ihrer pers\xF6nlichen Daten\n                einzuschr\xE4nken. Diese Umst\xE4nde sind: sie bestreiten die Richtigkeit der personenbezogenen Daten; die\n                Verarbeitung ist rechtswidrig, sie lehnen jedoch das L\xF6schen ab; wir ben\xF6tigen die personenbezogenen Daten\n                nicht mehr f\xFCr die Zwecke unserer Verarbeitung, aber Sie ben\xF6tigen personenbezogene Daten f\xFCr die\n                Begr\xFCndung, Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen; und sie haben der Verarbeitung widersprochen,\n                bis der Einwand \xFCberpr\xFCft wurde. Wenn die Verarbeitung auf dieser Grundlage eingeschr\xE4nkt wurde, k\xF6nnen wir\n                Ihre pers\xF6nlichen Daten weiterhin speichern. Wir werden es jedoch nur anderweitig bearbeiten: mit Ihrer\n                Zustimmung; zur Begr\xFCndung, Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen; zum Schutz der Rechte einer\n                anderen nat\xFCrlichen oder juristischen Person; oder aus Gr\xFCnden des wichtigen \xF6ffentlichen Interesses.\n            </li>\n            <li>Sie haben das Recht, unserere Verarbeitung Ihrer personenbezogenen Daten aus Gr\xFCnden zu widersprechen,\n                die sich auf Ihre besondere Situation beziehen, jedoch nur insoweit, als die Rechtsgrundlage f\xFCr die\n                Verarbeitung darin besteht, dass die Verarbeitung erforderlich ist f\xFCr: die Erf\xFCllung einer in der\n                \xF6ffentliches Interesse oder die Aus\xFCbung einer uns \xFCbertragenen beh\xF6rdlichen Befugnis; oder die Zwecke der\n                berechtigten Interessen, die von uns oder von Dritten verfolgt werden. Wenn Sie einen solchen Widerspruch\n                einlegen, werden wir die Verarbeitung der personenbezogenen Daten einstellen, es sei denn, wir k\xF6nnen\n                zwingende berechtigte Gr\xFCnde f\xFCr die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten\n                au\xDFer Kraft setzen, oder die Verarbeitung dient der Begr\xFCndung, Aus\xFCbung oder Verteidigung von\n                Rechtsanspr\xFCchen.\n            </li>\n            <li>Sie haben das Recht, unserere Verarbeitung Ihrer personenbezogenen Daten f\xFCr Direktmarketingzwecke\n                (einschlie\xDFlich Profilerstellung f\xFCr Direktmarketingzwecke) zu widersprechen. Wenn Sie einen solchen\n                Widerspruch einlegen, werden wir Ihre personenbezogenen Daten zu diesem Zweck nicht mehr verarbeiten.\n            </li>\n            <li>Sie haben das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu wissenschaftlichen oder\n                historischen Forschungszwecken oder zu statistischen Zwecken aus Gr\xFCnden zu widersprechen, die sich auf Ihre\n                besondere Situation beziehen, es sei denn, die Verarbeitung ist f\xFCr die Erf\xFCllung einer Aufgabe aus Gr\xFCnden\n                des \xF6ffentlichen Interesses erforderlich.\n            </li>\n            <li>Soweit die Rechtsgrundlage f\xFCr unsere Verarbeitung Ihrer personenbezogenen Daten ist:\n                <ul>\n                    <li>Zustimmung; oder</li>\n                    <li>dass die Verarbeitung f\xFCr die Erf\xFCllung eines Vertrags erforderlich ist, an dem Sie beteiligt\n                        sind, oder um auf Ihren Wunsch vor Abschluss eines Vertrags Schritte zu unternehmen,\n                    </li>\n                </ul>\n                wenn diese Verarbeitung automatisiert erfolgt, haben Sie das Recht, Ihre pers\xF6nlichen Daten in einem\n                strukturierten, allgemein verwendeten und maschinenlesbaren Format von uns zu erhalten. Dieses Recht\n                gilt jedoch nicht, wenn es die Rechte und Freiheiten anderer beeintr\xE4chtigen w\xFCrde.\n            </li>\n            <li>Wenn Sie der Ansicht sind, dass unsere Verarbeitung Ihrer pers\xF6nlichen Daten gegen Datenschutzgesetze\n                verst\xF6\xDFt, haben Sie das Recht, eine Beschwerde bei einer f\xFCr den Datenschutz zust\xE4ndigen Aufsichtsbeh\xF6rde\n                einzureichen. Sie k\xF6nnen dies im EU-Mitgliedstaat Ihres gew\xF6hnlichen Aufenthalts, Ihres Arbeitsplatzes oder\n                des Ortes der mutma\xDFlichen Zuwiderhandlung tun.\n            </li>\n            <li>Soweit die Rechtsgrundlage f\xFCr unsere Verarbeitung Ihrer personenbezogenen Daten die Einwilligung ist,\n                haben Sie das Recht, diese Einwilligung jederzeit zu widerrufen. Der Widerruf hat keinen Einfluss auf die\n                Rechtm\xE4\xDFigkeit der Verarbeitung vor dem Widerruf.\n            </li>\n            <li>Sie k\xF6nnen alle Ihre Rechte in Bezug auf Ihre pers\xF6nlichen Daten durch schriftliche Mitteilung an uns\n                aus\xFCben.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>10. Websites von Drittanbietern</h4>\n        <ol>\n            <li>Unsere Website enth\xE4lt Hyperlinks zu und Details zu Websites Dritter.</li>\n            <li>Wir haben keine Kontrolle \xFCber die Datenschutzrichtlinien und -praktiken Dritter und sind nicht daf\xFCr\n                verantwortlich.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>11. Personenbezogene Daten von Kindern</h4>\n        <ol>\n            <li>Unsere Website und Dienstleistungen richten sich an Personen \xFCber 18 Jahre.</li>\n            <li>Wenn wir Grund zu der Annahme haben, dass wir personenbezogene Daten einer Person unter diesem Alter in\n                unseren Datenbanken speichern, werden wir diese personenbezogenen Daten l\xF6schen.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>12. Informationen aktualisieren</h4>\n        <ol>\n            <li>Bitte teilen Sie uns mit, ob die pers\xF6nlichen Daten, die wir \xFCber Sie gespeichert haben, korrigiert oder\n                aktualisiert werden m\xFCssen.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>13. Als Auftragsverarbeiter fungieren</h4>\n        <ol>\n            <li>Soweit wir als Datenverarbeiter und nicht als Datenverantwortlicher auftreten, gilt diese Richtlinie\n                nicht. Unsere gesetzlichen Verpflichtungen als Datenverarbeiter sind stattdessen im Vertrag zwischen uns und\n                dem jeweiligen f\xFCr die Verarbeitung Verantwortlichen festgelegt.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>14. \xDCber Cookies</h4>\n        <ol>\n            <li>Ein Cookie ist eine Datei mit einer Kennung (einer Folge von Buchstaben und Zahlen), die von einem Webserver\n                an einen Webbrowser gesendet und vom Browser gespeichert wird. Die Kennung wird dann jedes Mal an den Server\n                zur\xFCckgesendet, wenn der Browser eine Seite vom Server anfordert.\n            </li>\n            <li>Cookies k\xF6nnen entweder "dauerhafte" Cookies oder "Sitzungs"-Cookies sein: ein dauerhaftes Cookie wird von\n                einem Webbrowser gespeichert und bleibt bis zu seinem festgelegten Ablaufdatum g\xFCltig, sofern es nicht vom\n                Benutzer vor dem Ablaufdatum gel\xF6scht wird. Ein Sitzungscookie l\xE4uft dagegen am Ende der Benutzersitzung ab,\n                wenn der Webbrowser geschlossen wird.\n            </li>\n            <li>Cookies enthalten normalerweise keine Informationen, die einen Benutzer pers\xF6nlich identifizieren.\n                Pers\xF6nliche Informationen, die wir \xFCber Sie speichern, k\xF6nnen jedoch mit den in Cookies gespeicherten und\n                von diesen erhaltenen Informationen verkn\xFCpft sein.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>15. Von uns genutzte Cookies</h4>\n        <ol>\n            <li>Wir verwenden Cookies, um Ihre Erfahrung zu personalisieren. Wir m\xF6chten Ihnen die bestm\xF6gliche Erfahrung\n                beim Zugriff auf und beim Navigieren durch unsere Website und bei der Verwendung ihrer Funktionen bieten.\n                Mit diesen Cookies k\xF6nnen wir beispielsweise erkennen, dass sie ein Konto erstellt und sich bei diesem Konto\n                angemeldet haben, um auf den Inhalt zuzugreifen. Sie helfen uns zu erkennen, wie sie die Website angepasst\n                haben.\n            </li>\n            <li>Wenn sie die von unserer Website gesetzten Cookies einschr\xE4nken oder blockieren m\xF6chten, k\xF6nnen sie dies\n                \xFCber Ihre Browsereinstellung tun. Dies kann die korrekte Nutzung unserer Website beeintr\xE4chtigen oder ganz\n                verhindern.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>16. Von unseren Dienstleistern verwendete Cookies</h4>\n        <ol>\n            <li>Unsere Dienstleister verwenden Cookies. Diese Cookies werden m\xF6glicherweise auf Ihrem Computer gespeichert,\n                wenn Sie unsere Website besuchen.\n            </li>\n            <li>Wir verwenden Google Analytics, um die Nutzung unserer Website zu analysieren. Google Analytics sammelt\n                mithilfe von Cookies Informationen zur Nutzung der Website. Die im Zusammenhang mit unserer Website\n                gesammelten Informationen werden verwendet, um Berichte \xFCber die Nutzung unserer Website zu erstellen. Die\n                Datenschutzbestimmungen von Google finden Sie unter:\n                <a href="https://www.google.com/policies/privacy/">https://www.google.com/policies/privacy/</a>.\n            </li>\n            <li>Wir nutzen die von Intercom bereitgestellten Dienste. Weitere Informationen zur Verwendung von Cookies durch\n                Intercom finden Sie unter Abschnitt 4\n                <a href="https://www.intercom.com/terms-and-policies#cookie-policy">https://www.intercom.com/terms-and-policies#cookie-policy</a>.\n            </li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>17. Cookie Verwaltung</h4>\n        <ol>\n            <li>In den meisten Browsern k\xF6nnen Sie die Annahme von Cookies ablehnen und Cookies l\xF6schen. Die Methoden\n                hierf\xFCr variieren von Browser zu Browser und von Version zu Version. \xDCber diese Links erhalten sie jedoch\n                aktuelle Informationen zum Blockieren und L\xF6schen von Cookies:\n                <ul>\n                    <li>https://support.google.com/chrome/answer/95647?hl=de (Chrome);</li>\n                    <li>https://support.mozilla.org/de-DE/kb/enable-and-disable-cookies-website-preferences (Firefox);\n                    </li>\n                    <li>http://www.opera.com/help/tutorials/security/cookies/ (Opera);</li>\n                    <li>https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies\n                        (Internet Explorer);\n                    </li>\n                    <li>https://support.apple.com/kb/PH21411 (Safari); und</li>\n                    <li>https://privacy.microsoft.com/de-de/windows-10-microsoft-edge-and-privacy (Edge).</li>\n                </ul>\n            </li>\n            <li>Das Blockieren aller Cookies wirkt sich negativ auf die Benutzerfreundlichkeit vieler Websites aus.</li>\n            <li>Wenn sie Cookies blockieren, k\xF6nnen sie nicht alle Funktionen unserer Website nutzen.</li>\n        </ol>\n    </div>\n    <div class="content">\n        <h4>18. Unsere Details</h4>\n        <li>Diese Website geh\xF6rt und wird betrieben von ' + partnerCompanyName + '.</li>\n        <li>Wir sind in \xD6sterreich unter der Registrierungsnummer ' + partnerRegNumber + ' gemeldet und unsere Anschrift lautet\n            ' + partnerPostalAddress + '.\n        </li>\n        <li>Unser Hauptgesch\xE4ftssitz befindet sich in ' + partnerPostalAddress + '.\n        </li>\n        <li>Wir sind erreichbar\n            <ul>\n                <li>per Post unter Verwendung der oben angegebenen Postanschrift;</li>\n                <li>per E-Mail an: <a href="mailto:' + partnerEmailAddress + '">' + partnerEmailAddress + '</a></li>\n                <li>elefonisch unter der von Zeit zu Zeit auf unserer Website ver\xF6ffentlichten Kontaktnummer; oder</li>\n                <li>per E-Mail unter Verwendung der von Zeit zu Zeit auf unserer Website ver\xF6ffentlichten E-Mail-Adresse.\n                </li>\n            </ul>\n        </li>\n        </ol>\n    </div>\n'
};

/* harmony default export */ __webpack_exports__["a"] = (data[country]);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('v-container',{staticClass:"content-header",attrs:{"grid-list-xl":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":"","md8":"","offset-md2":""}},[_c('v-card',{staticClass:"pa-4"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"text-xs-left custom-body-html pa-2",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccec10f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ccec10f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccec10f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('v-container',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('v-card',{staticClass:"pa-4"},[(!_vm.err && !_vm.success)?[_c('h2',[_vm._v(_vm._s(_vm.$lang.global.paymentProgress))]),_vm._v(" "),_c('p',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.$lang.global.pleaseWait))]),_vm._v(" "),_c('div',{attrs:{"id":"loaderInner"}},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_vm._v(" "),_c('div',{staticClass:"bounce2"}),_vm._v(" "),_c('div',{staticClass:"bounce3"})])])]:[(_vm.success)?_c('v-alert',{staticClass:"success",attrs:{"color":"success","icon":"check","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n                        ")]):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n                        ")]):_vm._e()]],2)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb5cb61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fb5cb61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb5cb61_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[(_vm.err)?_c('v-flex',{attrs:{"xs12":"","px-4":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.err))])],1):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"py-2 px-4 layout row wrap align-end"},[_c('h3',[_vm._v(_vm._s(_vm.$lang.global.orderHistory))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"min-w max-w mx-2",attrs:{"append-icon":"search","label":_vm.$lang.labels.search,"hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.orderHistory,"search":_vm.search,"loading":_vm.loading,"pagination":_vm.pagination,"rows-per-page-items":[50, 100, 250, 500, { text:'All' , value: -1 }]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$lang.actions[props.item.type]))]),_vm._v(" "),_c('td',[_c('p',{staticClass:"price",style:(_vm.goDark ? 'color: white' : ''),attrs:{"data-price":parseFloat(props.item.totalAmount).toFixed(2),"data-currency":"₤"}},[_vm._v(_vm._s(parseFloat(props.item.totalAmount).toFixed(2)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"mx-0 elevation-0",attrs:{"name":"viewOrder","color":"primary"},on:{"click":function($event){return _vm.showModal(props.item)}}},[_vm._v("\n              "+_vm._s(_vm.$lang.actions.view)+"\n            ")])],1)]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","height":"6","color":"primary","indeterminate":""},slot:"progress"}),_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"warning","icon":"warning"},slot:"no-results"},[_vm._v("\n          "+_vm._s(_vm.$lang.errors.yourSearchFor)+" \""+_vm._s(_vm.search)+"\" "+_vm._s(_vm.$lang.errors.foundNo)+".\n        ")])],1)],1),_vm._v(" "),(_vm.orderDetails)?_c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.orderDetails),callback:function ($$v) {_vm.orderDetails=$$v},expression:"orderDetails"}},[_c('order-details',{attrs:{"order":_vm.order},on:{"close":function($event){_vm.orderDetails = false}}})],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitsSearch_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed604ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitsSearch_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ed604ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitsSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed604ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitsSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","fill-height":"","pb-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","mt-2":"","mb-2":"","pr-3":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-flex',{attrs:{"xs12":"","pr-3":_vm.$vuetify.breakpoint.mdAndUp}},[_c('v-card',{staticClass:"pa-2"},[_c('h2',[_vm._v(_vm._s(_vm.$lang.header.besuche))]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$lang.labels.from))]),_vm._v(" "),_c('v-menu',{ref:"menuFrom",attrs:{"close-on-content-click":false,"return-value":_vm.fromDate,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.fromDate=$event},"update:return-value":function($event){_vm.fromDate=$event}},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-btn',{staticClass:"ml-0 mr-auto",attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},slot:"activator"},[_vm._v(_vm._s(_vm.formatDate(_vm.fromDate))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"slot":"activator","fab":"","flat":"","dark":"","small":"","color":"primary"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","color":"primary"},on:{"input":function($event){return _vm.$refs.menuFrom.save(_vm.fromDate)}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.$lang.labels.to))]),_vm._v(" "),_c('v-menu',{ref:"menuTill",attrs:{"close-on-content-click":false,"return-value":_vm.toDate,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.toDate=$event},"update:return-value":function($event){_vm.toDate=$event}},model:{value:(_vm.menuTill),callback:function ($$v) {_vm.menuTill=$$v},expression:"menuTill"}},[_c('v-btn',{staticClass:"ml-0 mr-auto",attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},slot:"activator"},[_vm._v(_vm._s(_vm.formatDate(_vm.toDate))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"slot":"activator","fab":"","flat":"","dark":"","small":"","color":"primary"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","color":"primary"},on:{"input":function($event){return _vm.$refs.menuTill.save(_vm.toDate)}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":_vm.loading,"color":"primary"},on:{"click":function($event){return _vm.search()}}},[_vm._v("\n              "+_vm._s(_vm.$lang.labels.search)+"\n            ")])],1)])],1)],1)],1),_vm._v(" "),(!_vm.visits || _vm.visits.length === 0)?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":"","pr-3":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[(_vm.loading)?_c('v-flex',{attrs:{"xs12":""}},[_c('br'),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n        ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.visits && _vm.visits.length === 0 && _vm.searchType === 'visits')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v("No visits found.\n        ")])],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.visits && _vm.visits.length > 0)?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":"","pr-2":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[_vm._l((_vm.visits),function(visit,index){return [(_vm.visits && _vm.visits.length > 0)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","pt-2":""}},[_c('v-card',{key:visit.id,class:{
        'mb-2': true,
        'mr-3': _vm.$vuetify.breakpoint.mdAndUp,
        'mr-2': _vm.$vuetify.breakpoint.smAndDown,
        'pa-4': true
      }},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[(_vm.visits && _vm.visits.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"readonly":"","label":_vm.$lang.labels.created,"hide-details":"","placeholder":_vm.formatDateTime(visit.createdOn)}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.table,"hide-details":""},model:{value:(visit.table),callback:function ($$v) {_vm.$set(visit, "table", $$v)},expression:"visit.table"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.firstName,"hide-details":""},model:{value:(visit.firstName),callback:function ($$v) {_vm.$set(visit, "firstName", $$v)},expression:"visit.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.lastName,"hide-details":""},model:{value:(visit.lastName),callback:function ($$v) {_vm.$set(visit, "lastName", $$v)},expression:"visit.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.email,"hide-details":""},model:{value:(visit.email),callback:function ($$v) {_vm.$set(visit, "email", $$v)},expression:"visit.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pa-2":""}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.phone,"hide-details":""},model:{value:(visit.phone),callback:function ($$v) {_vm.$set(visit, "phone", $$v)},expression:"visit.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-2":"","pl-1":""}},[_c('v-checkbox',{attrs:{"label":_vm.$lang.labels.delete},model:{value:(visit.delete),callback:function ($$v) {_vm.$set(visit, "delete", $$v)},expression:"visit.delete"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","pr-1":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"loading":visit.isLoading,"color":"info"},on:{"click":function($event){return _vm.saveVisit(visit)}}},[_vm._v("\n                      "+_vm._s(_vm.$lang.labels.save)+"\n                    ")])],1)],1)],1):_vm._e()],1)],1)],1):_vm._e()]})],2)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e743d9d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e743d9d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e743d9d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Orders_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","px-2":""}},[(_vm.err || _vm.successMessage)?_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":"","mb-2":""}},[(_vm.err)?_c('v-flex',{attrs:{"xs12":"","px-3":""}},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v(_vm._s(_vm.err))])],1):_vm._e(),_vm._v(" "),(_vm.successMessage)?_c('v-flex',{attrs:{"xs12":"","px-3":""}},[_c('v-alert',{attrs:{"value":true,"type":"success"}},[_vm._v(_vm._s(_vm.successMessage))])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-tabs',{attrs:{"color":"","dark":"","slider-color":"primary"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.menu),function(item,index){return _c('v-tab',{key:index,attrs:{"to":{ name: item.to.name }}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])}),1),_vm._v(" "),_c('router-view',{staticStyle:{"display":"block !important"},on:{"error":function($event){_vm.err = $event},"success":function($event){_vm.successMessage = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersSearch_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b1d9ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersSearch_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0b1d9ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0b1d9ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","fill-height":"","pb-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","mt-2":"","mb-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pa-2"},[_c('div',{staticClass:"d-inline-flex"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$lang.labels.from))]),_vm._v(" "),_c('v-menu',{ref:"menuFromOrders",attrs:{"close-on-content-click":false,"return-value":_vm.fromDateOrders,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.fromDateOrders=$event},"update:return-value":function($event){_vm.fromDateOrders=$event}},model:{value:(_vm.menuFromOrders),callback:function ($$v) {_vm.menuFromOrders=$$v},expression:"menuFromOrders"}},[_c('v-btn',{staticClass:"ml-0 mr-auto",attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},slot:"activator"},[_vm._v(_vm._s(_vm.formatDate(_vm.fromDateOrders))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"slot":"activator","fab":"","flat":"","dark":"","small":"","color":"primary"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","color":"primary"},on:{"input":function($event){return _vm.$refs.menuFromOrders.save(_vm.fromDateOrders)}},model:{value:(_vm.fromDateOrders),callback:function ($$v) {_vm.fromDateOrders=$$v},expression:"fromDateOrders"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('span',{staticClass:"mx-2"},[_vm._v(_vm._s(_vm.$lang.labels.to))]),_vm._v(" "),_c('v-menu',{ref:"menuTillOrders",attrs:{"close-on-content-click":false,"return-value":_vm.toDateOrders,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.toDateOrders=$event},"update:return-value":function($event){_vm.toDateOrders=$event}},model:{value:(_vm.menuTillOrders),callback:function ($$v) {_vm.menuTillOrders=$$v},expression:"menuTillOrders"}},[_c('v-btn',{staticClass:"ml-0 mr-auto",attrs:{"slot":"activator","flat":"","outline":"","color":"primary"},slot:"activator"},[_vm._v(_vm._s(_vm.formatDate(_vm.toDateOrders))+"\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"slot":"activator","fab":"","flat":"","dark":"","small":"","color":"primary"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","color":"primary"},on:{"input":function($event){return _vm.$refs.menuTillOrders.save(_vm.toDateOrders)}},model:{value:(_vm.toDateOrders),callback:function ($$v) {_vm.toDateOrders=$$v},expression:"toDateOrders"}})],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":_vm.loading,"color":"primary"},on:{"click":function($event){_vm.initialOrderSearch = true; _vm.searchOrders()}}},[_vm._v("\n              "+_vm._s(_vm.$lang.labels.search)+"\n            ")])],1),_vm._v(" "),(!_vm.ordersResult || (_vm.ordersResult && _vm.ordersResult.length === 0))?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":""}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[(_vm.loading)?_c('v-flex',{attrs:{"xs12":""}},[_c('br'),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n                ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ordersResult && _vm.ordersResult.length === 0 && _vm.searchType === 'orders')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v("No orders found.\n                ")])],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.ordersResult && _vm.ordersResult.length > 0)?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":""}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.ordersResult,"rows-per-page-items":[50],"pagination":_vm.pagination,"total-items":_vm.totalOrdersResult,"disable-initial-sort":"","disable-sort":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.formatDateTime(props.item.deliveryTime)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('span',[_vm._v(_vm._s(props.item.contact.firstName)+" "+_vm._s(props.item.contact.lastName))]),_vm._v(" "),(props.item.contact.address)?_c('br'):_vm._e(),_vm._v(" "),(props.item.contact.address)?_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("\n                  "+_vm._s(_vm.generateAddress([
                              props.item.contact.address.line1,
                              props.item.contact.address.line2,
                              props.item.contact.address.line3,
                              props.item.contact.address.line4 ]))+"\n                  "),(props.item.contact.address)?_c('br'):_vm._e(),_vm._v("\n                  "+_vm._s(props.item.contact.address.locality ? props.item.contact.address.locality + ', ' : '')+"\n                  "+_vm._s(props.item.contact.address.country === 'UK' ? props.item.contact.address.townCity : props.item.contact.address.postalCode)+",\n                  "+_vm._s(props.item.contact.address.country === 'UK' ? props.item.contact.address.postalCode : props.item.contact.address.townCity)+"\n\n                  ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$lang.actions[props.item.type]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.company ? _vm.company.currencySymbol + props.item.totalAmount.toFixed(2) : ''))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._l((5),function(star){return [_c('v-icon',{key:star,attrs:{"size":"19","color":props.item.ratingStars >= star ? 'primary' : ''}},[_vm._v("star\n                          ")])]})],2),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.order = props.item;_vm.orderDetails = true;}}},[_vm._v(_vm._s(_vm.$lang.labels.details))])],1)]}}],null,false,3104889254)})],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.orderDetails)?_c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.orderDetails),callback:function ($$v) {_vm.orderDetails=$$v},expression:"orderDetails"}},[_c('order-details',{attrs:{"order":_vm.order},on:{"close":function($event){_vm.orderDetails = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blacklist_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21bee0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blacklist_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21bee0b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blacklist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21bee0b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blacklist_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","fill-height":"","pb-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","mt-2":"","mb-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pa-2"},[_c('div',{staticClass:"d-inline-flex"},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-radio-group',{staticClass:"pt-3 pl-2",attrs:{"row":""},model:{value:(_vm.blacklistType),callback:function ($$v) {_vm.blacklistType=$$v},expression:"blacklistType"}},[_c('v-radio',{attrs:{"type":"radio","label":_vm.$lang.labels.all,"value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"type":"radio","label":_vm.$lang.labels.phone,"value":"phone"}}),_vm._v(" "),_c('v-radio',{attrs:{"type":"radio","label":_vm.$lang.labels.email,"value":"email"}})],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":_vm.loading,"color":"primary"},on:{"click":function($event){return _vm.searchBlacklist()}}},[_vm._v("\n              "+_vm._s(_vm.$lang.labels.search)+"\n            ")])],1),_vm._v(" "),(!_vm.blacklistResult || (_vm.blacklistResult && _vm.blacklistResult.length === 0))?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":""}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[(_vm.loading)?_c('v-flex',{attrs:{"xs12":""}},[_c('br'),_vm._v(" "),_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n                ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.blacklistResult && _vm.blacklistResult.length === 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v("No blacklist found.\n                ")])],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.blacklistResult && _vm.blacklistResult.length > 0)?_c('v-flex',{attrs:{"xs12":"","pt-2":"","fill-height":""}},[_c('v-layout',{attrs:{"fow":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.blacklistResult,"disable-initial-sort":"","disable-sort":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.value))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(_vm.$lang.labels[props.item.type]))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-btn',{staticClass:"mx-0",attrs:{"color":"primary"},on:{"click":function($event){return _vm.removeBlacklist(props.item)}}},[_vm._v(_vm._s(_vm.$lang.actions.remove))])],1)]}}],null,false,3767411252)})],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.orderDetails)?_c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.orderDetails),callback:function ($$v) {_vm.orderDetails=$$v},expression:"orderDetails"}},[_c('order-details',{attrs:{"order":_vm.order},on:{"close":function($event){_vm.orderDetails = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a6fcd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65a6fcd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a6fcd9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","justify-center":"","pb-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","mt-4":""}},[_c('h1',[_vm._v(_vm._s(_vm.$lang.header.rateUs)+":")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","justify-center":"","pb-4":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","id":"commentField"}},[_c('v-text-field',{attrs:{"label":_vm.$lang.labels.comment,"hint":_vm.$lang.header.rateHint,"persistent-hint":"","required":""},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","justify-center":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","md6":""}},[_vm._l((5),function(star){return [_c('v-icon',{key:star,staticClass:"cursorPointer",attrs:{"size":_vm.$vuetify.breakpoint.smAndDown ? '72' : '86',"color":_vm.gold[star] ? 'primary' : ''},on:{"mouseenter":function($event){return _vm.starGold(star)},"click":function($event){_vm.goldSet = star; _vm.starGold(star)}}},[_vm._v("star\n          ")])]})],2)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-start":"","justify-center":"","pt-3":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-btn',{staticStyle:{"margin":"0 !important"},attrs:{"color":"primary","disabled":!_vm.comment || !_vm.goldSet},on:{"click":function($event){return _vm.rate()}}},[_vm._v(_vm._s(_vm.$lang.actions.submit))])],1)],1)],1),_vm._v(" "),(_vm.success)?_c('v-flex',{attrs:{"xs12":"","md8":"","mb-4":""}},[(_vm.success)?_c('v-alert',{staticClass:"success",attrs:{"color":"success","value":"true"}},[_vm._v(_vm._s(_vm.success)+"\n    ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.err)?_c('v-flex',{attrs:{"xs12":"","md8":"","mb-4":""}},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2f7d8d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2f7d8d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","fill-height":""}},[_c('v-layout',{staticStyle:{"max-width":"1440px"},attrs:{"row":"","wrap":"","justify-start":"","fill-height":""}},[(_vm.err)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.err)?_c('v-alert',{staticClass:"err",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"section categories",attrs:{"xs12":"","md10":"","lg8":"","offset-lg1":"","pa-0":""}},[(!_vm.loaded && !_vm.err)?_c('v-flex',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(_vm.loaded && !_vm.err)?_c('MenuCategories',{attrs:{"itemsList":_vm.catalogItems}}):_vm._e()],1),_vm._v(" "),(_vm.loaded && !_vm.err)?_c('div',{staticClass:"side-menu",style:(("top: " + _vm.stickyScrollDesktop + "px;"))},[_vm._l((_vm.catalogItems),function(category,index){return [(category.name)?_c('h3',{key:index,staticClass:"px-2 cursorHand",on:{"click":function($event){_vm.selectedCat = category; _vm.$vuetify.goTo('#abc-'+category.itemId, _vm.options)}}},[_vm._v("\n          "+_vm._s(category.name[_vm.$lang.current_lang] ? category.name[_vm.$lang.current_lang] : category.name.en)+"\n        ")]):_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.loaded && !_vm.err)?_c('div',{staticClass:"scrolling-wrapper",style:(("top: " + _vm.stickyScrollMobile + "px;background-color: " + (_vm.goDark ? '#303030' : '#fafafa')))},[_vm._l((_vm.catalogItems),function(category,index){return [(category.name)?_c('span',{key:index,staticClass:"px-2 cursorHand",on:{"click":function($event){_vm.selectedCat = category; _vm.$vuetify.goTo('#abc-'+category.itemId, _vm.options)}}},[_vm._v("\n          "+_vm._s(category.name[_vm.$lang.current_lang] ? category.name[_vm.$lang.current_lang] : category.name.en)+"\n        ")]):_vm._e()]})],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_catalog__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_cart__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_company__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_system__ = __webpack_require__(411);







var calculateOptionsPrice = function calculateOptionsPrice(list) {
  var quantityOfIncludedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!list || list.length === 0) {
    return 0;
  }
  var listFormatted = [];
  var cumulativeFree = {};
  var addedFree = 1;
  list.forEach(function (option) {
    if (option.name.en) {
      cumulativeFree[option.name.en] = 0;
    } else {
      cumulativeFree[option.name.de] = 0;
    }
    if (option.quantity === 1) {
      listFormatted.push(option);
    } else {
      for (var i = 0; i < option.quantity; i += 1) {
        listFormatted.push(option);
      }
    }
  });
  listFormatted = listFormatted.sort(function (a, b) {
    return a.price - b.price;
  });
  var cumulativePrice = 0;
  if (Array.isArray(list) && list.length > 0) {
    if (listFormatted.length > 0 && quantityOfIncludedOptions > 0) {
      listFormatted.forEach(function (option) {
        if (option.name.en) {
          cumulativeFree[option.name.en] += 1;
        } else {
          cumulativeFree[option.name.de] += 1;
        }
        // eslint-disable-next-line no-param-reassign
        if (option.maxIncludedQuantity === undefined) option.maxIncludedQuantity = 0;
        if (addedFree > quantityOfIncludedOptions || option.name.en && cumulativeFree[option.name.en] > option.maxIncludedQuantity || option.name.de && cumulativeFree[option.name.de] > option.maxIncludedQuantity) {
          cumulativePrice += option.price;
        } else {
          addedFree += 1;
        }
      });
      return cumulativePrice;
    } else if (listFormatted.length > 0 && quantityOfIncludedOptions === 0) {
      return listFormatted.reduce(function (a, b) {
        return a + (b.price || 0);
      }, 0);
    }
    return cumulativePrice;
  }
  return cumulativePrice;
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
    state: {
      err: '',
      baseUrl:  false ? 'http://localhost:3000/' : '/',
      isLoggedIn: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].isLoggedIn,
      logout: __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].logout,
      calculatePrice: function calculatePrice(size, variant, options, quantity) {
        var quantityOfIncludedOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

        var sizePrice = size.price;
        var variantPrice = variant ? variant.price || 0 : 0;
        var optionsPrice = calculateOptionsPrice(options || [], quantityOfIncludedOptions || 0);
        return (sizePrice + variantPrice + optionsPrice) * quantity;
      }
    },
    modules: {
      catalog: __WEBPACK_IMPORTED_MODULE_2__modules_catalog__["a" /* default */],
      cart: __WEBPACK_IMPORTED_MODULE_3__modules_cart__["a" /* default */],
      company: __WEBPACK_IMPORTED_MODULE_4__modules_company__["a" /* default */],
      system: __WEBPACK_IMPORTED_MODULE_5__modules_system__["a" /* default */]
    }
  });
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var storeState = {
  catalog: null,
  itemsList: [],
  categories: []
};

var findCheapest = function findCheapest(list) {
  if (!list || list.length === 0) {
    return 0;
  }
  var base = 0;
  if (Array.isArray(list) && list.length > 0) {
    base = list[0].price;
    list.forEach(function (item) {
      if (item.price < base) {
        base = item.price;
      }
    });
  } else {
    base = list.price;
  }
  return parseFloat(base);
};

var mergeTwo = function mergeTwo(child, parent) {
  var parentArray = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(parent));
  var merged = child.map(function (item) {
    var found = null;
    parentArray.forEach(function (item2, index) {
      if (item.name.en === item2.name.en) {
        found = index;
      }
    });
    if (found !== null) {
      parentArray.splice(found, 1);
    }
    return item;
  });
  return merged.concat(parentArray);
};
var shouldOpenModal = function shouldOpenModal(item) {
  if (item.settings && !item.settings.askDetails && item.sizes && item.sizes.length === 1 && item.styles && item.styles.length === 1 && (!item.options || item.options.length === 0) && item.variants && item.variants.length && item.variants.length === 1) {
    var defaultStyle = void 0;
    var defaultSize = void 0;
    var defaultVariant = void 0;
    if (item.styles.length > 1) {
      item.styles.forEach(function (style, index) {
        if (style.isDefault) defaultStyle = index;
      });
    }
    if (item.sizes.length > 1) {
      item.sizes.forEach(function (size, index) {
        if (size.isDefault) defaultSize = index;
      });
    }
    if (item.variants.length > 1) {
      item.variants.forEach(function (variant, index) {
        if (variant.isDefault) defaultVariant = index;
      });
    }
    if (!defaultStyle && item.styles.length !== 1 || !defaultSize && item.sizes.length !== 1 || !defaultVariant && item.variants.length !== 1) {
      return true;
    }
    return false;
  }
  return true;
};

var populateRequiredFields = function populateRequiredFields(original, baseSizes, baseVariants, baseOptions, baseStyles) {
  var sizes = baseSizes || [];
  var variants = baseVariants || [];
  var options = baseOptions || [];
  var styles = baseStyles || [];
  var item = original;
  if (!item.items || item.items && item.items.length === 0) {
    item.price = findCheapest(item.sizes) + findCheapest(item.variants);
    if (isNaN(item.price)) {
      item.price = '';
      item.disabled = true;
      item.warning = 'Sizes or Variants are not set for this item!';
    }
    if (!item.settings) {
      item.settings = {};
      item.settings.askDetails = false;
    }
    item.shouldOpenModal = shouldOpenModal(item);
  } else if (item.items && item.items.length) {
    item.items = item.items.map(function (current) {
      var currentItem = current;
      currentItem.sizes = currentItem.sizes && currentItem.sizes.length ? mergeTwo(currentItem.sizes, sizes) : sizes;
      currentItem.variants = currentItem.variants && currentItem.variants.length ? mergeTwo(currentItem.variants, variants) : variants;
      currentItem.options = currentItem.options && currentItem.options.length ? mergeTwo(currentItem.options, options) : options;
      currentItem.styles = currentItem.styles && currentItem.styles.length ? mergeTwo(currentItem.styles, styles) : styles;
      currentItem.options = currentItem.options.map(function (currentOption) {
        var option = currentOption;
        option.checked = false;
        return option;
      });
      if (currentItem.items && currentItem.items.length > 0) {
        currentItem.items = currentItem.items.map(function (childItem) {
          return populateRequiredFields(childItem, childItem.sizes, childItem.variants, childItem.options, childItem.styles);
        });
      } else {
        currentItem.price = findCheapest(currentItem.sizes) + findCheapest(currentItem.variants);
        if (isNaN(currentItem.price)) {
          currentItem.price = '';
          currentItem.disabled = true;
          currentItem.warning = 'Sizes or Variants are not set for this item!';
        }
        if (!currentItem.settings) {
          currentItem.settings = {};
          currentItem.settings.askDetails = false;
        }
        currentItem.shouldOpenModal = shouldOpenModal(currentItem);
      }
      return currentItem;
    });
  }
  return item;
};

var mutations = {
  setCatalog: function setCatalog(state, data) {
    if (!data) return;
    var catalog = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    var view = catalog.views.find(function (current) {
      return current.name.en === 'Webshop';
    });
    if (!view) return;
    // eslint-disable-next-line
    state.itemsList = [];
    // eslint-disable-next-line
    state.categories = [];
    var viewId = view.viewId;

    if (catalog.itemsList) {
      catalog.itemsList = catalog.itemsList.filter(function (current) {
        return current.views.includes(viewId) && current.items && current.items.length > 0;
      });
      catalog.itemsList.forEach(function (current) {
        state.categories.push(current.name.en);
      });
      catalog.itemsList = catalog.itemsList.map(function (item) {
        return populateRequiredFields(item, item.sizes, item.variants, item.options, item.styles);
      });
    }
    // eslint-disable-next-line
    state.catalog = catalog;
    state.catalog.itemsList.forEach(function (category) {
      category.items.forEach(function (item) {
        return state.itemsList.push(item);
      });
    });
  },
  editCatalog: function editCatalog(state, data) {
    // eslint-disable-next-line
    state.catalog[data.index] = data.catalog;
  }
};

var getters = {
  catalog: function catalog() {
    return storeState.catalog;
  },
  categories: function categories() {
    return storeState.categories;
  },
  items: function items() {
    return storeState.catalog.itemsList;
  },
  itemsList: function itemsList() {
    return storeState.itemsList;
  }
};

var actions = {
  setCatalog: function setCatalog(_ref, catalog) {
    var commit = _ref.commit;

    commit('setCatalog', catalog);
  },
  editCatalog: function editCatalog(_ref2, data) {
    var commit = _ref2.commit;

    commit('editCatalog', data);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: storeState,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names__);



// Objects comparing
/* eslint-disable dot-notation */
/* eslint-disable no-param-reassign */
Object.compare = function (obj1, obj2) {
  if (!obj1 || !obj2) {
    if (obj1 === obj2) {
      return true;
    }
    return false;
  }
  // Loop through properties in object 1
  var props1 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default()(obj1);
  var props2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_names___default()(obj2);
  if (props1.length !== props2.length) {
    // unequal number of props
    return false;
  }
  for (var i = 0; i < props1.length; i += 1) {
    var p = props1[i];
    // Check property exists on both objects
    if (Object.prototype.hasOwnProperty.call(obj1, p) !== Object.prototype.hasOwnProperty.call(obj2, p)) {
      // objects don't have same properties
      return false;
    }
    switch (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj1[p])) {
      // Deep compare objects
      case 'object':
        if (Array.isArray(obj1[p])) {
          if (obj1[p].length === 0 && obj2[p].length === 0) break;
          if (obj1[p].length !== obj2[p].length) {
            // unequal number of items in prop array
            return false;
          }
          var same = true;
          for (var j = 0; j < obj1[p].length; j += 1) {
            if (!Object.compare(obj1[p][j], obj2[p][j])) same = false;
          }
          if (!same) {
            // array items don't match
            return false;
          }
        } else {
          if (!Object.compare(obj1[p], obj2[p])) {
            // props don't match
            return false;
          }
          break;
        }
        break;
      // Compare values
      default:
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(obj1[p]) === 'object') {
          if (!Object.compare(obj1[p], obj2[p])) {
            // items don't match
            return false;
          }
        } else if (obj1[p] !== obj2[p]) {
          // props don't match
          return false;
        }
    }
  }
  return true;
};

var checkForMatch = function checkForMatch(item, cart) {
  var item1 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
  var itemFromCart = cart.find(function (itemCart) {
    return item1.catalogItemId === itemCart.catalogItemId;
  });
  if (!itemFromCart) return null;
  var elementPos = cart.map(function (x) {
    return x.catalogItemId;
  }).indexOf(item1.catalogItemId);
  var matchName = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item1.name) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(itemFromCart.name);
  var matchStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item1.selectedStyle) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(itemFromCart.selectedStyle);
  var matchSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item1.selectedSize) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(itemFromCart.selectedSize);
  var matchVariants = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item1.selectedVariants) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(itemFromCart.selectedVariants);
  var matchOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item1.selectedOptions) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(itemFromCart.selectedOptions);

  if (matchName && matchStyle && matchSize && matchVariants && matchOptions) return elementPos;
  return null;
};

var storeState = {
  cart: [],
  orderType: '',
  voucher: '',
  comment: '',
  postalCode: {},
  addresses: [],
  addressesAT: [],
  addressesSet: false,
  contact: null,
  selectedAddress: null,
  modal: false,
  userData: undefined,
  intercomUser: undefined,
  intercomVisible: false,
  isFetchingUser: false
};

var mutations = {
  pushCart: function pushCart(state, cart) {
    state.cart.push(cart);
  },
  setCart: function setCart(state, cart) {
    state.cart = cart.map(function (current) {
      var item = current;
      item.selected = false;
      return item;
    });
  },
  setUserData: function setUserData(state, data) {
    state.userData = data;
  },
  setIntercomUser: function setIntercomUser(state, data) {
    state.intercomUser = data;
  },
  setIntercomVisible: function setIntercomVisible(state, data) {
    state.intercomVisible = data;
  },
  setIsFetchingUser: function setIsFetchingUser(state, data) {
    state.isFetchingUser = data;
  },
  setComment: function setComment(state, comment) {
    state.comment = comment;
  },
  setType: function setType(state, type) {
    state.orderType = type;
  },
  setVoucher: function setVoucher(state, voucher) {
    state.orderVoucher = voucher;
  },
  setModal: function setModal(state, type) {
    state.modal = type;
  },
  setAddresses: function setAddresses(state, addresses) {
    state.addresses = addresses;
    state.addressesSet = true;
  },
  setAddressesAT: function setAddressesAT(state, addresses) {
    state.addressesAT = addresses;
  },
  setContact: function setContact(state, contact) {
    state.contact = contact;
  },
  chooseAddress: function chooseAddress(state, index) {
    state.selectedAddress = index;
  },
  removeAddress: function removeAddress(state) {
    state.selectedAddress = null;
  },
  editCartItem: function editCartItem(state, data) {
    state.cart[data.index] = data;
  },
  editCartItemQuantity: function editCartItemQuantity(state, data) {
    var current = state.cart[data.index].quantity;
    if (data.action === 'dec' && current === 1) {
      state.cart.splice(data.index, 1);
      return;
    }
    current = data.action === 'dec' ? current - 1 : current + 1;
    state.cart[data.index].quantity = current;
  },
  addCartItem: function addCartItem(state, data) {
    var matched = checkForMatch(data, state.cart);
    if (matched === null) {
      data.selected = false;
      state.cart.push(data);
    } else {
      state.cart[matched].quantity += data.quantity;
    }
  },
  selectItem: function selectItem(state, index) {
    state.cart = state.cart.map(function (current, i) {
      var item = current;
      item.selected = i === index && !item.selected;
      return item;
    });
  },
  clearCart: function clearCart(state) {
    state.cart = [];
    state.comment = '';
    state.postalCode = {};
  },
  addPostal: function addPostal(state, data) {
    state.postalCode = data;
  },
  clearPostal: function clearPostal(state) {
    state.postalCode = {};
  }
};

var getters = {
  cart: function cart() {
    return storeState.cart;
  },
  modal: function modal() {
    return storeState.modal;
  },
  userData: function userData() {
    return storeState.userData;
  },
  intercomUser: function intercomUser() {
    return storeState.intercomUser;
  },
  intercomVisible: function intercomVisible() {
    return storeState.intercomVisible;
  },
  isFetchingUser: function isFetchingUser() {
    return storeState.isFetchingUser;
  },
  addresses: function addresses() {
    return storeState.addresses;
  },
  addressesAT: function addressesAT() {
    return storeState.addressesAT;
  },
  addressesSet: function addressesSet() {
    return storeState.addressesSet;
  },
  contact: function contact() {
    return storeState.contact;
  },
  selectedAddress: function selectedAddress() {
    return storeState.selectedAddress;
  },
  orderType: function orderType() {
    return storeState.orderType;
  },
  postalCode: function postalCode() {
    return storeState.postalCode;
  },
  comment: function comment() {
    return storeState.comment;
  },
  orderInfo: function orderInfo() {
    return {
      items: storeState.cart,
      orderType: storeState.orderType,
      comment: storeState.comment,
      voucher: storeState.voucher
    };
  }
};

var actions = {
  setCart: function setCart(_ref, cart) {
    var commit = _ref.commit;

    commit('setCart', cart);
  },
  setUserData: function setUserData(_ref2, data) {
    var commit = _ref2.commit;

    commit('setUserData', data);
  },
  setIntercomUser: function setIntercomUser(_ref3, data) {
    var commit = _ref3.commit;

    commit('setIntercomUser', data);
  },
  setIntercomVisible: function setIntercomVisible(_ref4, data) {
    var commit = _ref4.commit;

    commit('setIntercomVisible', data);
  },
  setIsFetchingUser: function setIsFetchingUser(_ref5, data) {
    var commit = _ref5.commit;

    commit('setIsFetchingUser', data);
  },
  selectItem: function selectItem(_ref6, index) {
    var commit = _ref6.commit;

    commit('selectItem', index);
  },
  setType: function setType(_ref7, type) {
    var commit = _ref7.commit;

    commit('setType', type);
  },
  setVoucher: function setVoucher(_ref8, voucher) {
    var commit = _ref8.commit;

    commit('setVoucher', voucher);
  },
  setModal: function setModal(_ref9, type) {
    var commit = _ref9.commit;

    commit('setModal', type);
  },
  setAddresses: function setAddresses(_ref10, addresses) {
    var commit = _ref10.commit;

    commit('setAddresses', addresses);
  },
  setAddressesAT: function setAddressesAT(_ref11, addresses) {
    var commit = _ref11.commit;

    commit('setAddressesAT', addresses);
  },
  setContact: function setContact(_ref12, contact) {
    var commit = _ref12.commit;

    commit('setContact', contact);
  },
  chooseAddress: function chooseAddress(_ref13, index) {
    var commit = _ref13.commit;

    commit('chooseAddress', index);
  },
  removeAddress: function removeAddress(_ref14) {
    var commit = _ref14.commit;

    commit('removeAddress');
  },
  setComment: function setComment(_ref15, comment) {
    var commit = _ref15.commit;

    commit('setComment', comment);
  },
  pushCart: function pushCart(_ref16, cart) {
    var commit = _ref16.commit;

    commit('pushcart', cart);
  },
  editCartItem: function editCartItem(_ref17, data) {
    var commit = _ref17.commit;

    commit('editCartItem', data);
  },
  addCartItem: function addCartItem(_ref18, data) {
    var commit = _ref18.commit;

    commit('addCartItem', data);
  },
  clearCart: function clearCart(_ref19) {
    var commit = _ref19.commit;

    commit('clearCart');
  },
  editCartItemQuantity: function editCartItemQuantity(_ref20, data) {
    var commit = _ref20.commit;

    commit('editCartItemQuantity', data);
  },
  addPostal: function addPostal(_ref21, data) {
    var commit = _ref21.commit;

    commit('addPostal', data);
  },
  clearPostal: function clearPostal(_ref22) {
    var commit = _ref22.commit;

    commit('clearPostal');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: storeState,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);




var storeState = {
  company: null,
  closed: true,
  workingHours: null,
  remainingWorkingRanges: [],
  message: false,
  disableOrder: false,
  timeZone: 'Europe/Vienna'
};

var getHoursForDay = function getHoursForDay(workingHours, day) {
  if (!workingHours) return [];
  var ranges = [];
  workingHours.forEach(function (range) {
    if (range.day.toUpperCase() === day) {
      ranges.push(range);
    }
  });
  ranges.sort(function (a, b) {
    if (a.startDate < b.startDate) return -1;
    return a.startDate > b.startDate ? 1 : 0;
  });
  return ranges;
};

var companyFromStorage = localStorage.company ? JSON.parse(localStorage.company) : null;
//
// let timeZone = moment.tz.guess();
//
// if (companyFromStorage) {
//   timeZone = companyFromStorage.address.country === 'UK' ? 'Europe/London' : 'Europe/Vienna';
// }

var formatWorkingHours = function formatWorkingHours(workingHours) {
  var zone = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess();
  var currentDate = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().format('YYYY-MM-DD');
  return workingHours.map(function (range) {
    var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(currentDate + ' ' + range.start, 'YYYY-MM-DD HH:mm', storeState.timeZone).tz(zone);
    var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz(currentDate + ' ' + range.end, 'YYYY-MM-DD HH:mm', storeState.timeZone).tz(zone);
    return {
      start: start.format('HH:mm'),
      startDate: start.toISOString(),
      end: end.format('HH:mm'),
      endDate: end.toISOString(),
      day: range.day
    };
  });
};

var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var langGet = function langGet() {
  var fromUrl = window.location.pathname.split('/').filter(function (x) {
    return x !== '';
  });
  var enIndex = fromUrl.indexOf('en');
  var deIndex = fromUrl.indexOf('de');
  if (enIndex !== -1) return 'en';
  if (deIndex !== -1) return 'de';

  if (storeState.company) {
    return storeState.company.defaultLanguage;
  }
  if (companyFromStorage) {
    return localStorage.getItem('lang') || companyFromStorage.defaultLanguage || 'en';
  }
  return localStorage.getItem('lang') || 'en';
};

var daysByLAng = {
  MONDAY: { en: 'Monday', de: 'Montag' },
  TUESDAY: { en: 'Tuesday', de: 'Dienstag' },
  WEDNESDAY: { en: 'Wednesday', de: 'Mittwoch' },
  THURSDAY: { en: 'Thursday', de: 'Donnerstag' },
  FRIDAY: { en: 'Friday', de: 'Freitag' },
  SATURDAY: { en: 'Saturday', de: 'Samstag' },
  SUNDAY: { en: 'Sunday', de: 'Sonntag' },
  PUBLICHOLIDAY: { en: 'Public Holiday', de: 'Feiertags' }
};

var close = function close() {
  storeState.closed = true;
  storeState.disableOrder = false;
  storeState.message = false;
};

var checkWorkingHours = function checkWorkingHours() {
  if (storeState.company === null) {
    close();
    return;
  }
  var workingHours = storeState.workingHours;
  var curretnDay = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isoWeekday();
  var today = days[curretnDay - 1].toUpperCase();
  var tomorrow = days[curretnDay] ? days[curretnDay].toUpperCase() : days[0].toUpperCase();
  var ranges = getHoursForDay(workingHours, today);
  var ranges2 = getHoursForDay(workingHours, tomorrow);
  if (ranges.length === 0) {
    close();
    return;
  }
  var day1End = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(ranges[ranges.length - 1].endDate);
  var canGoIntoNextDay = void 0;
  if (ranges2[0]) {
    var day2Start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(ranges2[0].startDate).add(1, 'day');
    var duration = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.duration(day2Start.diff(day1End)).asMinutes();
    canGoIntoNextDay = duration === 1;
  } else {
    canGoIntoNextDay = false;
  }
  var now = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()();
  var remainingRanges = [];

  var _ranges$filter = ranges.filter(function (range) {
    var start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(range.startDate);
    var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(range.endDate);
    if (start.isAfter(now)) {
      remainingRanges.push(range);
    }
    return now.isBetween(start, end);
  }),
      _ranges$filter2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ranges$filter, 1),
      currentRange = _ranges$filter2[0];

  if (!currentRange) {
    close();
    if (remainingRanges.length > 0) {
      storeState.remainingWorkingRanges = remainingRanges.sort(function (a, b) {
        if (a.startDate < b.startDate) return -1;
        return a.startDate > b.startDate ? 1 : 0;
      });
    } else {
      storeState.remainingWorkingRanges = [];
    }
    return;
  }
  storeState.closed = false;
  var end = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(currentRange.endDate);
  var difference = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.duration(end.diff(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()())).asMinutes();
  if (canGoIntoNextDay) {
    var _day2Start = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(ranges2[0].startDate).add(1, 'day');
    var day2End = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(ranges2[0].endDate).add(1, 'day');
    var minutesTomorrow = ranges2[0] ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.duration(day2End.diff(_day2Start)).asMinutes() : 0;
    difference += minutesTomorrow;
  }
  var durationTo = storeState.company.deliverydurationTo;
  storeState.disableOrder = difference < durationTo;
  storeState.message = difference < durationTo + 15;
};

setInterval(function () {
  checkWorkingHours();
}, 60 * 1000);

var mutations = {
  setCompany: function setCompany(state, data) {
    // eslint-disable-next-line
    state.company = data;
    if (data) {
      // eslint-disable-next-line
      // state.workingHours = formatWorkingHours(storeState.company.openingDaysAndHours);
      checkWorkingHours();
    }
  },
  setWorkingHours: function setWorkingHours(state, data) {
    // eslint-disable-next-line no-param-reassign
    state.workingHours = formatWorkingHours(data);
  },
  setTimeZone: function setTimeZone(state, data) {
    // eslint-disable-next-line no-param-reassign
    state.timeZone = data;
  }
};

var doubleDigit = function doubleDigit(num) {
  var front = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (num.length === 1) {
    return front ? '0' + num : num + '0';
  }
  return num;
};

var formatTime = function formatTime(time) {
  var _time$split = time.split(':'),
      _time$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_time$split, 2),
      hours = _time$split2[0],
      minutes = _time$split2[1];

  return doubleDigit(hours) + ':' + doubleDigit(minutes, false);
};

// eslint-disable-next-line import/no-dynamic-require
var lang = __webpack_require__(410)("./" + langGet() + '/state');

var chargespermile = function chargespermile() {
  var distanceUnit = storeState.company.distanceUnit;
  var valuePerMile = distanceUnit === 'miles' ? storeState.company.deliveryCharges.chargesPerMile.toFixed(2) : (storeState.company.deliveryCharges.chargesPerMile / 1000).toFixed(2);
  return '<p>' + (distanceUnit === 'miles' ? lang.chargesPerMile : lang.chargesPerKm) + ': ' + storeState.company.currencySymbol + valuePerMile + '</p>';
};

var nodeliverycharges = function nodeliverycharges() {
  return '<p>' + lang.noCharges + '</p>';
};

var chargesbymiles = function chargesbymiles() {
  var distanceUnit = storeState.company.distanceUnit;
  var charges = storeState.company.deliveryCharges.chargesByMiles.sort(function (a, b) {
    return parseFloat(a.fromMiles) - parseFloat(b.fromMiles);
  }).map(function (current) {
    return '<p class="mb-0">' + lang.from + ' ' + (distanceUnit === 'miles' ? current.fromMiles : (current.fromMiles / 1000).toFixed(2)) + ' ' + lang.to + ' ' + (distanceUnit === 'miles' ? current.toMiles : (current.toMiles / 1000).toFixed(2)) + ' ' + (distanceUnit === 'miles' ? lang.miles : lang.km) + ' = ' + storeState.company.currencySymbol + current.charges + '</p>';
  });
  if (storeState.company.deliveryCharges.defaultCharges && storeState.company.deliveryCharges.defaultCharges !== 0) {
    charges.unshift('<div>' + lang.defaultCharges + ': ' + storeState.company.currencySymbol + storeState.company.deliveryCharges.defaultCharges + '</div>');
  }
  charges.unshift('<div>' + (distanceUnit === 'miles' ? lang.chargesByMiles : lang.chargesByKms) + '</div><br>');
  return charges.join('');
};

var chargesbyinvoiceamount = function chargesbyinvoiceamount() {
  var charges = storeState.company.deliveryCharges.chargesByInvoiceAmt.sort(function (a, b) {
    return parseFloat(a.fromAmount) - parseFloat(b.fromAmount);
  }).map(function (current) {
    return '<p class="mb-0">' + lang.from + ' ' + storeState.company.currencySymbol + current.fromAmount + ' ' + lang.to + ' ' + storeState.company.currencySymbol + current.toAmount + ' = ' + storeState.company.currencySymbol + current.charges + '</p>';
  });
  charges.unshift('<p>' + lang.chargesByInvoice + '</p>');
  return charges.join('');
};

var getters = {
  company: function company() {
    return storeState.company;
  },
  companyActive: function companyActive() {
    return storeState.company ? storeState.company.webShopResourceStatus === 'active' : null;
  },
  closed: function closed() {
    return storeState.closed;
  },
  remainingWorkingRanges: function remainingWorkingRanges() {
    return storeState.remainingWorkingRanges;
  },
  closingMessage: function closingMessage() {
    return storeState.message;
  },
  closedMessage: function closedMessage() {
    return storeState.disableOrder;
  },
  timeZone: function timeZone() {
    return storeState.timeZone;
  },
  workingHours: function workingHours() {
    if (!storeState.company || !storeState.company.openingDaysAndHours || storeState.company.openingDaysAndHours.length === 0 || !storeState.workingHours) return '';
    var schedule = {};
    storeState.workingHours.forEach(function (range) {
      var rangeObj = { start: range.start, end: range.end };
      if (!schedule[range.day]) {
        schedule[range.day] = [rangeObj];
      } else {
        schedule[range.day].push(rangeObj);
      }
    });
    var scheduleHTML = '';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(schedule).forEach(function (day) {
      var ranges = schedule[day].sort(function (a, b) {
        return parseInt(a.start.split(':').join(), 10) - parseInt(b.start.split(':').join(), 10);
      }).map(function (range) {
        return formatTime(range.start) + ' - ' + formatTime(range.end);
      }).join(' ' + (langGet() === 'en' ? 'and' : 'und') + ' ');
      scheduleHTML += '<p class="mb-0">' + daysByLAng[day][langGet()] + ' ' + ranges + '</p>';
    });
    checkWorkingHours();
    return scheduleHTML;
  },
  currentWorkingHours: function currentWorkingHours() {
    var workingHours = storeState.workingHours;
    var curretnDay = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isoWeekday();
    var today = days[curretnDay - 1].toUpperCase();
    return getHoursForDay(workingHours, today);
  },
  tomorrowsWorkingHours: function tomorrowsWorkingHours() {
    var workingHours = storeState.workingHours;
    var curretnDay = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().isoWeekday();
    var tomorrow = days[curretnDay] ? days[curretnDay].toUpperCase() : days[0].toUpperCase();
    return getHoursForDay(workingHours, tomorrow);
  },
  deliveryCharges: function deliveryCharges() {
    if (!storeState.company || !storeState.company.deliveryCharges || !storeState.company.deliveryCharges.type) return '';
    switch (storeState.company.deliveryCharges.type) {
      case 'chargespermile':
        {
          return chargespermile();
        }
      case 'nodeliverycharges':
        {
          return nodeliverycharges();
        }
      case 'chargesbymiles':
        {
          return chargesbymiles();
        }
      case 'chargesbyinvoiceamount':
        {
          return chargesbyinvoiceamount();
        }
      default:
        {
          return '';
        }
    }
  }
};

var actions = {
  setCompany: function setCompany(_ref, company) {
    var commit = _ref.commit;

    // console.log(company);
    commit('setCompany', company);
  },
  setWorkingHours: function setWorkingHours(_ref2, workingHours) {
    var commit = _ref2.commit;

    commit('setWorkingHours', workingHours);
  },
  setTimeZone: function setTimeZone(_ref3, timeZone) {
    var commit = _ref3.commit;

    commit('setTimeZone', timeZone);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: storeState,
  mutations: mutations,
  getters: getters,
  actions: actions
});

/***/ }),
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de/state": 238,
	"./en/state": 239
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var storeState = {
  width: window.innerWidth,
  scrollPosition: 0,
  goDark: false
};

window.addEventListener('resize', function () {
  storeState.width = window.innerWidth;
});

var mutations = {
  setPosition: function setPosition(state, data) {
    // eslint-disable-next-line
    state.scrollPosition = data;
  },
  goDark: function goDark(state, data) {
    // eslint-disable-next-line
    state.goDark = data;
  }
};
var actions = {
  goDark: function goDark(_ref, data) {
    var commit = _ref.commit;

    commit('goDark', data);
  },
  blockScroll: function blockScroll(_ref2, payload) {
    var commit = _ref2.commit;

    var html = document.getElementsByTagName('html')[0];
    var body = document.getElementsByTagName('body')[0];
    if (payload) {
      commit('setPosition', html.scrollTop);
    }
    var position = storeState.scrollPosition;
    var blockBody = function blockBody() {
      html.style.cssText = '\n        overflow:hidden;\n        position:fixed;\n        height:100%;';
      body.style.cssText = '\n        overflow:hidden;\n        position:fixed;\n        top: -' + position + 'px;\n        height:calc(100% + ' + position + 'px);';
    };
    var removeBLock = function removeBLock() {
      html.style.cssText = '';
      body.style.cssText = '';
      window.scroll(0, position);
      html.style.cssText = 'scroll-behavior: smooth;';
      body.style.cssText = 'scroll-behavior: smooth;';
    };
    if (payload) {
      blockBody();
    } else {
      removeBLock();
    }
  }
};
var getters = {
  width: function width() {
    return storeState.width;
  },
  goDark: function goDark() {
    return storeState.goDark;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: storeState,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);



var helper = function helper(vue) {
  return {
    get: function get(url, query, router) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var qs = query || {};
        vue.http.get(url, { params: qs }).then(function (res) {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        }).catch(function (err) {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(err, { success: false }));
        });
      });
    },
    post: function post(url, data, router) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reqData = data || {};
        var webShopResourceId = localStorage.getItem('webShopResourceId');
        if (webShopResourceId) {
          reqData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(reqData, {
            webShopResourceId: webShopResourceId
          });
        }
        vue.http.post(url, reqData).then(function (res) {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        }).catch(function (err) {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(err, { success: false }));
        });
      });
    },
    put: function put(url, data, router) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reqData = data || {};
        var webShopResourceId = localStorage.getItem('webShopResourceId');
        if (webShopResourceId) {
          reqData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(reqData, {
            webShopResourceId: webShopResourceId
          });
        }
        vue.http.put(url, reqData).then(function (res) {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        }).catch(function (err) {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(err, { success: false }));
        });
      });
    },
    delete: function _delete(url, data, router) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var reqData = data || {};
        var webShopResourceId = localStorage.getItem('webShopResourceId');
        if (webShopResourceId) {
          reqData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(reqData, {
            webShopResourceId: webShopResourceId
          });
        }
        vue.http.delete(url, { params: reqData }).then(function (res) {
          if (res.body.status !== 'Success') throw res;
          res.success = true;
          resolve(res);
        }).catch(function (err) {
          if (err.status === 403 && router) {
            vue.prototype.$cookie.set('uuid', null);
            router.push('/login?session-expired=true');
          }
          resolve(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(err, { success: false }));
        });
      });
    }
  };
};
/* eslint-disable */
var WebHelper = {
  install: function install(Vue, options) {
    Vue.prototype.$webHelper = helper(Vue);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (WebHelper);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);






var Storage = function () {
  function Storage() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Storage);

    this.catalogExpiration = 3;
    this.companyExpiration = 72;
    this.orderExpiration = 1;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Storage, [{
    key: 'catalog',
    set: function set(data) {
      var catalog = data;
      if (data !== null) {
        catalog.expires = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(this.catalogExpiration, 'hours').toISOString();
      }
      localStorage.setItem('catalog', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(catalog));
    },
    get: function get() {
      var data = localStorage.getItem('catalog');
      if (!data) return null;
      try {
        var catalog = JSON.parse(data);
        if ((typeof catalog === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(catalog)) !== 'object' || __WEBPACK_IMPORTED_MODULE_4_moment___default()(catalog.expires).isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()())) return null;
        return catalog;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: 'company',
    set: function set(data) {
      var company = data;
      if (data !== null) {
        company.expires = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(this.companyExpiration, 'hours').toISOString();
      }
      localStorage.setItem('company', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(company));
    },
    get: function get() {
      var data = localStorage.getItem('company');
      if (!data) return null;
      try {
        var company = JSON.parse(data);
        if ((typeof company === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(company)) !== 'object' || __WEBPACK_IMPORTED_MODULE_4_moment___default()(company.expires).isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()())) return null;
        return company;
      } catch (err) {
        return null;
      }
    }
  }, {
    key: 'order',
    set: function set(data) {
      var order = data;
      if (data !== null) {
        order.expires = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(this.orderExpiration, 'hours').toISOString();
      }
      localStorage.setItem('order', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(order));
    },
    get: function get() {
      var data = localStorage.getItem('order');
      if (!data) return null;
      try {
        var order = JSON.parse(data);
        if ((typeof order === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(order)) !== 'object' || __WEBPACK_IMPORTED_MODULE_4_moment___default()(order.expires).isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()())) return null;
        return order;
      } catch (err) {
        return null;
      }
    }
  }]);

  return Storage;
}();

/* eslint-disable */


var storage = {
  install: function install(Vue, options) {
    Vue.prototype.$storage = new Storage();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var helper = {
  format: function format(date, _format) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(_format);
  },
  isBeforeNow: function isBeforeNow(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()());
  }
};
/* eslint-disable */
var timeHelper = {
  install: function install(Vue, options) {
    Vue.prototype.$timeHelper = helper;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (timeHelper);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cef833_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__(424);
function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37cef833"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cef833_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3"},[_c('div',{staticClass:"cardOverflow"},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"grow":""}},[_c('p',{staticStyle:{"font-size":"18px","margin":"0"}},[_vm._v(_vm._s(_vm.item.name[_vm.$lang.current_lang] ? _vm.item.name[_vm.$lang.current_lang] : _vm.item.name.en))])]),_vm._v(" "),_c('v-flex',{attrs:{"shrink":""}},[_c('v-layout',{staticClass:"quantity-value",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"shrink":"","pr-2":"","pt-1":""}},[_c('span',[_vm._v(_vm._s(_vm.$lang.labels.quantity)+":")])]),_vm._v(" "),_c('v-flex',{staticClass:"quantity-wrap"},[_c('v-btn',{attrs:{"dark":"","small":"","color":"primary ma-0 my-btn"},on:{"click":function($event){return _vm.changeQty(_vm.quantity - 1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("remove")])],1),_vm._v(" "),_c('span',{staticClass:"quantity text-xs-center",staticStyle:{"min-width":"24px","width":"24px"}},[_vm._v(_vm._s(_vm.quantity))]),_vm._v(" "),_c('v-btn',{attrs:{"name":"add","dark":"","small":"","color":"accent ma-0 my-btn"},on:{"click":function($event){return _vm.changeQty(_vm.quantity + 1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),(_vm.item.desc)?_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"desc",style:(_vm.goDark ? 'color: white' : '')},[_vm._v(_vm._s(_vm.item.desc[_vm.$lang.current_lang] ? _vm.item.desc[_vm.$lang.current_lang] : _vm.item.desc.en))])]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"px-4",attrs:{"row":"","wrap":""}},[(_vm.item.sizes.length > 1)?_c('div',{staticClass:"order-section-wrap"},[_c('div',{staticClass:"mt-1"},[_vm._v("\n          "+_vm._s(_vm.$lang.labels.size)+":\n        ")]),_vm._v(" "),_c('v-flex',{attrs:{"ml-2":""}},[_c('v-radio-group',{staticClass:"pt-0",attrs:{"id":"size"},on:{"change":_vm.calculatePrice},model:{value:(_vm.selectedSize),callback:function ($$v) {_vm.selectedSize=$$v},expression:"selectedSize"}},_vm._l((_vm.item.sizes),function(size,index){return _c('v-radio',{key:index,attrs:{"label":((size.name[_vm.$lang.current_lang] ? size.name[_vm.$lang.current_lang] : size.name.en) + " " + (_vm.company ? _vm.company.currencySymbol : '') + (size.price.toFixed(2))),"value":index}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.item.variants.length > 1)?_c('div',{staticClass:"order-section-wrap pl-0 pl-sm-4"},[_c('div',{staticClass:"mt-1"},[_vm._v("\n          "+_vm._s(_vm.$lang.labels.variant)+":\n        ")]),_vm._v(" "),_c('v-flex',{attrs:{"ml-2":""}},[_c('v-radio-group',{staticClass:"pt-0",attrs:{"id":"variant"},on:{"change":_vm.calculatePrice},model:{value:(_vm.selectedVariant),callback:function ($$v) {_vm.selectedVariant=$$v},expression:"selectedVariant"}},_vm._l((_vm.item.variants),function(variant,index){return _c('v-radio',{key:index,attrs:{"label":((variant.name[_vm.$lang.current_lang] ? variant.name[_vm.$lang.current_lang] : variant.name.en) + " " + (_vm.company ? _vm.company.currencySymbol : '') + (variant.price.toFixed(2))),"value":index}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.item.styles.length > 1)?_c('div',{staticClass:"order-section-wrap pl-0 pl-sm-4"},[_c('div',{staticClass:"mt-1"},[_vm._v("\n          "+_vm._s(_vm.$lang.labels.style)+":\n        ")]),_vm._v(" "),_c('v-flex',{attrs:{"ml-2":""}},[_c('v-radio-group',{staticClass:"pt-0",attrs:{"id":"style"},on:{"change":_vm.calculatePrice},model:{value:(_vm.selectedStyle),callback:function ($$v) {_vm.selectedStyle=$$v},expression:"selectedStyle"}},_vm._l((_vm.item.styles),function(style,index){return _c('v-radio',{key:index,attrs:{"label":("" + (style.name[_vm.$lang.current_lang] ? style.name[_vm.$lang.current_lang] : style.name.en)),"value":index}})}),1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"order-section-wrap"},[(_vm.options.length > 0)?_c('div',{staticClass:"mt-1"},[_vm._v("\n          "+_vm._s(_vm.$lang.labels.options)+":\n        ")]):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"options",attrs:{"column":""}},_vm._l((_vm.options),function(option,index){return _c('v-flex',{key:index,staticClass:"single-option",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","ml-2":""}},[_c('v-checkbox',{attrs:{"hide-details":"","label":((option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en) + " " + (_vm.company ? _vm.company.currencySymbol : '') + (option.price.toFixed(2)))},on:{"change":_vm.calculatePrice},model:{value:(option.selected),callback:function ($$v) {_vm.$set(option, "selected", $$v)},expression:"option.selected"}}),_vm._v(" "),(option.selected)?_c('v-flex',{staticClass:"quantity-wrap"},[_c('v-btn',{attrs:{"dark":"","small":"","color":"primary ma-0 my-btn"},on:{"click":function($event){return _vm.changeOptionQty(option, option.quantity - 1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("remove")])],1),_vm._v(" "),_c('span',{staticClass:"quantity text-xs-center"},[_vm._v(_vm._s(option.quantity))]),_vm._v(" "),_c('v-btn',{attrs:{"name":"add","dark":"","small":"","color":"accent ma-0 my-btn"},on:{"click":function($event){return _vm.changeOptionQty(option, option.quantity + 1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1):_vm._e()],1)],1)}),1)],1)]),_vm._v(" "),(_vm.item.allergens && _vm.item.allergens.length > 0)?_c('v-layout',{staticClass:"px-3 pt-3 pb-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"desc",style:(_vm.goDark ? 'color: white' : '')},[_vm._v(_vm._s(_vm.$lang.labels.allergens)+": "),_vm._l((_vm.item.allergens),function(allergen,i){return _c('span',[_vm._v(_vm._s(_vm.formatAllergen(allergen))+_vm._s(i === _vm.item.allergens.length-1 ? '' : ', '))])})],2)])],1):_vm._e()],1),_vm._v(" "),_c('footer',{staticClass:"modal-footer pb-4",style:(("background-color: " + (_vm.goDark ? '#212121' : '')))},[(_vm.err)?_c('v-alert',{staticClass:"err mx-3",attrs:{"color":"error","icon":"warning","value":"true"}},[_vm._v(_vm._s(_vm.err)+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"px-3 pt-3",attrs:{"row":"","justify-space-between":"","align-center":""}},[_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$lang.actions.cancel))]),_vm._v(" "),_c('div',{staticClass:"d-inline-flex"},[(_vm.total)?_c('p',{staticStyle:{"margin":"0","padding-top":"15px"}},[_vm._v(_vm._s(_vm.$lang.labels.price)+": "+_vm._s(_vm.company ? _vm.company.currencySymbol : '')+_vm._s(_vm.total))]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary","dark":""},on:{"click":function($event){return _vm.toCart()}}},[_vm._v(_vm._s(_vm.$lang.actions.add))])],1)],1)],1),_vm._v(" "),(_vm.allergensDialog)?_c('v-dialog',{attrs:{"scrollable":"","fullscreen":_vm.width < 768,"max-width":"200px"},model:{value:(_vm.allergensDialog),callback:function ($$v) {_vm.allergensDialog=$$v},expression:"allergensDialog"}},[_c('Allergens',{attrs:{"allergens":_vm.allergens,"catalogAllergens":_vm.catalog.allergens},on:{"close":function($event){return _vm.closeDialog()}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showList)?_c('div',{class:{'items-wrap': true, 'px-4': _vm.$vuetify.breakpoint.mdAndUp && !_vm.nested, 'px-1': _vm.nested}},[(_vm.notNested)?_c('v-flex',{staticClass:"px-0",attrs:{"xs12":""}},[_c('v-autocomplete',{ref:"search",attrs:{"id":"searchField","items":_vm.formattedItemsList,"label":_vm.$lang.labels.search,"name":"search","solo":"","append-icon":"search","single-line":""},on:{"input":_vm.handleSearch},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_vm._l((_vm.itemsList),function(category,index){return [(_vm.isImage(category, 'webshop-itemlist-banner'))?_c('v-img',{staticClass:"imageBannerClass",attrs:{"src":_vm.env === 'development' ? ("/api/imageresource/" + (category.images.filter(function (x) { return x.label === 'webshop-itemlist-banner'; })[0].value))
              : ("/webshopplanet/imageresource/" + (category.images.filter(function (x) { return x.label === 'webshop-itemlist-banner'; })[0].value))},on:{"click":function($event){return _vm.togglePanel(index)}}}):_vm._e(),_vm._v(" "),_c('v-expansion-panel',{staticClass:"elevation-0",model:{value:(_vm.panel[index]),callback:function ($$v) {_vm.$set(_vm.panel, index, $$v)},expression:"panel[index]"}},[_c('v-expansion-panel-content',{key:index,attrs:{"id":'abc-'+category.itemId}},[_c('div',{staticClass:"header",staticStyle:{"margin":"-12px 0 -12px -24px !important","flex":"0 1 auto","white-space":"nowrap","text-overflow":"ellipsis","overflow":"hidden"},attrs:{"slot":"header"},on:{"click":function($event){return _vm.scrollToHeader(category.itemId)}},slot:"header"},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[(_vm.isImage(category, 'webshop-itemlist-icon'))?_c('v-img',{staticClass:"imageIconClass",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (category.images.filter(function (x) { return x.label === 'webshop-itemlist-icon'; })[0].value))
                       : ("/webshopplanet/imageresource/" + (category.images.filter(function (x) { return x.label === 'webshop-itemlist-icon'; })[0].value))}}):_vm._e(),_vm._v(" "),_c('span',{class:{ 'textItem pl-2 pt-1': _vm.isImage(category, 'webshop-itemlist-icon') }},[_vm._v("\n                "+_vm._s(category.name[_vm.$lang.current_lang] ? category.name[_vm.$lang.current_lang] : category.name.en)+"\n              ")])],1),_vm._v(" "),(category.desc && category.desc[_vm.$route.params.lang])?_c('v-layout',{attrs:{"row":"","wrap":"","justify-start":""}},[(category.desc && category.desc[_vm.$route.params.lang])?_c('span',{staticStyle:{"font-weight":"400"}},[_c('small',[_vm._v(_vm._s(category.desc[_vm.$route.params.lang]))])]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"items-list",attrs:{"id":'cba-'+index}},[_c('Items',{attrs:{"env":_vm.env,"items":category.items,"nested":_vm.nested},on:{"openItem":function($event){return _vm.openDetails($event)},"success":function($event){return _vm.$emit('success', $event)}}})],1)])],1)]})],2),_vm._v(" "),(_vm.item && _vm.dialog)?_c('v-dialog',{attrs:{"fullscreen":_vm.width < 768,"max-width":"960px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('Order',{attrs:{"item":_vm.item},on:{"close":_vm.closeModal,"submit":_vm.itemSubmit}})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d5528a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__ = __webpack_require__(427);
function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03d5528a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Items_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03d5528a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Items_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.items),function(item,index){return [(!item.items)?_c('v-flex',{key:index,attrs:{"xs6":_vm.$vuetify.breakpoint.lgOnly,"xs4":_vm.$vuetify.breakpoint.xlOnly,"pa-1":_vm.$vuetify.breakpoint.lgAndUp,"py-1":_vm.$vuetify.breakpoint.mdAndDown,"xs12":_vm.$vuetify.breakpoint.mdAndDown}},[_c('v-card',{staticClass:"pa-0 ma-0 elevation-1",staticStyle:{"height":"100%"},attrs:{"id":("card-" + (item.itemId))},on:{"mouseenter":function($event){return _vm.cardElevate(item.itemId)},"mouseleave":function($event){return _vm.cardDeElevate(item.itemId)}}},[(_vm.isImage(item, 'webshop-itemlist-banner'))?_c('v-img',{staticClass:"imageBannerClass",attrs:{"src":_vm.env === 'development' ? ("/api/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-banner'; })[0].value))
           : ("/webshopplanet/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-banner'; })[0].value))}}):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"cursorHand py-0 px-2",staticStyle:{"overflow":"hidden !important","height":"100%"},attrs:{"justify-start":"","row":"","wrap":""}},[(_vm.isImage(item, 'webshop-itemlist-icon'))?_c('v-flex',{staticStyle:{"min-width":"25px","max-width":"50px","min-height":"50px","max-height":"50px"},attrs:{"xs2":""}},[_c('v-img',{staticClass:"imageIconClass",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-icon'; })[0].value))
                       : ("/webshopplanet/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-icon'; })[0].value))}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"width":"calc(100% - 50px)"},attrs:{"xs12":!_vm.isImage(item, 'webshop-itemlist-icon')}},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":"","wrap":"","py-2":!_vm.isImage(item, 'webshop-itemlist-icon'),"pl-2":""}},[_c('v-flex',{staticStyle:{"height":"46px"},attrs:{"xs12":""},on:{"click":function($event){_vm.allergensDialog ? '' : _vm.$emit('openItem', item)}}},[_c('div',[_c('v-layout',{staticStyle:{"position":"relative"},attrs:{"row":"","wrap":"","justify-space-between":""}},[_c('span',{class:{ 'mb-1': !!item.desc && item.desc.en, 'mb-0': !item.desc || !item.desc.en, 'textItem': _vm.isImage(item, 'webshop-itemlist-icon') },staticStyle:{"float":"left","padding-top":"4px","margin-right":"20px"}},[_vm._v("\n                    "+_vm._s(item.name[_vm.$lang.current_lang] ? item.name[_vm.$lang.current_lang] : item.name.en)+"\n                  ")]),_vm._v(" "),_c('i',{staticClass:"desc bi-info-circle",staticStyle:{"position":"absolute","right":"-2px","top":"2px"},style:(_vm.goDark ? 'color: #ffffffb3' : ''),on:{"click":function($event){$event.preventDefault();_vm.allergensDialog = true; _vm.$emit('openItem', Object.assign({}, item, {shouldOpenModal: true}))}}})]),_vm._v(" "),_c('span',{staticClass:"d-inline-flex",on:{"click":function($event){return _vm.$emit('openItem', item)}}},[_c('span',[(_vm.isImage(item, 'webshop-itemlist-postsymbol1'))?_c('v-img',{staticClass:"imageIconClassSmall",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol1'; })[0].value))
                       : ("/webshopplanet/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol1'; })[0].value))}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"pl-1"},[(_vm.isImage(item, 'webshop-itemlist-postsymbol2'))?_c('v-img',{staticClass:"imageIconClassSmall",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol2'; })[0].value))
                       : ("/webshopplanet/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol2'; })[0].value))}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"pl-1"},[(_vm.isImage(item, 'webshop-itemlist-postsymbol3'))?_c('v-img',{staticClass:"imageIconClassSmall",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol3'; })[0].value))
                       : ("/webshopplanet/imageresource/" + (item.images.filter(function (x) { return x.label === 'webshop-itemlist-postsymbol3'; })[0].value))}}):_vm._e()],1)])],1)]),_vm._v(" "),_c('v-flex',{style:(("transform: translate(0, " + (_vm.isImage(item, 'webshop-itemlist-icon') ? '-25px' : '0') + ")")),attrs:{"xs9":_vm.isImage(item, 'webshop-itemlist-icon'),"xs12":!_vm.isImage(item, 'webshop-itemlist-icon')},on:{"click":function($event){return _vm.$emit('openItem', item)}}},[(item.desc && item.desc[_vm.$lang.current_lang])?_c('p',{class:{'mb-0 desc': true,  'px-0': _vm.isImage(item, 'webshop-itemlist-icon'), 'px-2': !_vm.isImage(item, 'webshop-itemlist-icon')},style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v(_vm._s(item.desc[_vm.$lang.current_lang] ?
                        item.desc[_vm.$lang.current_lang] : item.desc.en))]):_c('p',{staticClass:"mb-0 pl-3"},[_vm._v(" ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",style:(("transform: translate(0, " + (_vm.isImage(item, 'webshop-itemlist-icon') ? '-25px' : '0') + ")")),attrs:{"grow":_vm.isImage(item, 'webshop-itemlist-icon'),"xs12":!_vm.isImage(item, 'webshop-itemlist-icon')},on:{"click":function($event){return _vm.$emit('openItem', item)}}},[_c('div',{staticClass:"text-xs-right"},[(!isNaN(item.price) && !item.shouldOpenModal)?_c('span',{staticClass:"mr-2 price",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v("\n                    "+_vm._s(_vm.company ? _vm.company.currencySymbol : '')+_vm._s(item.price.toFixed(2))+"\n                  ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mx-0 my-btn my-0 elevation-0",attrs:{"dark":"","small":"","color":"accent","flat":"","data-add":"addFood"}},[_c('v-icon',{class:item.shouldOpenModal ? 'addWithOptions' : 'add',attrs:{"dark":""}},[_vm._v("\n                      "+_vm._s(item.shouldOpenModal ? 'view_module' : 'add')+"\n                    ")])],1)],1)])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(item.items && item.items.length > 0)?_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","wrap":"","px-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('Categories',{attrs:{"itemsList":_vm.items.filter(function (x) { return x.items && x.itemId === item.itemId; }),"nested":true},on:{"success":_vm.flashSuccess}})],1)],1):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuCategories_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345de536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuCategories_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-345de536"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345de536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showList)?_c('div',{class:{'items-wrap': true, 'px-4': _vm.$vuetify.breakpoint.mdAndUp}},[_c('v-flex',{attrs:{"xs12":"","mb-3":"","mt-5":_vm.width < 960,"pt-5":_vm.width < 960}},[_vm._l((_vm.itemsList),function(category,index){return [(_vm.isImage(category, 'webpage-itemlist-banner'))?_c('v-flex',{key:index+10000,attrs:{"xs12":"","mb-3":"","mt-5":index !== 0}},[_c('v-img',{staticClass:"imageBannerClass",attrs:{"contain":"","src":_vm.env === 'development' ? ("/api/imageresource/" + (category.images.find(function (x) { return x.label === 'webpage-itemlist-banner'; }).value))
              : ("/webshopplanet/imageresource/" + (category.images.find(function (x) { return x.label === 'webpage-itemlist-banner'; }).value))}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{key:index,staticClass:"text-xs-center",attrs:{"xs12":"","id":'abc-'+category.itemId,"mt-5":!_vm.isImage(category, 'webpage-itemlist-banner') && index !== 0}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('h1',{staticStyle:{"font-weight":"400"}},[_vm._v("\n            "+_vm._s(category.name[_vm.$lang.current_lang] ? category.name[_vm.$lang.current_lang] : category.name.en)+"\n          ")])]),_vm._v(" "),(category.desc && category.desc[_vm.$route.params.lang])?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[(category.desc && category.desc[_vm.$route.params.lang])?_c('h4',{staticStyle:{"font-weight":"400"}},[_vm._v(_vm._s(category.desc[_vm.$route.params.lang]))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"items-list mt-3 px-3",attrs:{"id":'cba-'+index}},[_c('MenuItems',{attrs:{"env":_vm.env,"items":category.items,"nested":false}})],1)],1)]})],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuItems_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d4d098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuItems_vue__ = __webpack_require__(433);
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77d4d098"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d4d098_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.items),function(item,index){return [(!item.items)?_c('v-flex',{key:index,staticClass:"text-xs-left",attrs:{"xs6":_vm.$vuetify.breakpoint.lgOnly || _vm.$vuetify.breakpoint.mdOnly  || _vm.$vuetify.breakpoint.smOnly,"xs4":_vm.$vuetify.breakpoint.xlOnly,"xs12":_vm.$vuetify.breakpoint.xsOnly,"px-4":_vm.$vuetify.breakpoint.smAndUp,"pr-4":_vm.$vuetify.breakpoint.xsOnly,"py-2":""}},[_c('v-layout',{staticClass:"text-xs-left",attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs11":"","pr-1":""}},[_c('h3',[(item.abbr && item.abbr[_vm.$lang.current_lang])?_c('span',{staticStyle:{"color":"red"}},[_vm._v("\n            "+_vm._s(item.abbr[_vm.$lang.current_lang])+"\n            ")]):_vm._e(),_vm._v("\n            "+_vm._s(item.name[_vm.$lang.current_lang] ? item.name[_vm.$lang.current_lang] : item.name.en)+"\n          ")]),_vm._v(" "),(item.desc && item.desc[_vm.$lang.current_lang])?_c('p',{staticClass:"text-xs-left",style:(_vm.goDark ? 'color: #ffffffb3;margin-bottom: 4px !important;' : 'margin-bottom: 4px !important;')},[_vm._v("\n            "+_vm._s(item.desc[_vm.$lang.current_lang] ? item.desc[_vm.$lang.current_lang] : item.desc.en)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":"","pr-2":""}},[_c('span',{staticClass:"price",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v("\n                    "+_vm._s(_vm.company && _vm.formatPrice(item) ? _vm.company.currencySymbol : '')+_vm._s(_vm.formatPrice(item))+"\n                  ")])]),_vm._v(" "),(item.sizes && item.sizes.length > 1)?_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs12":""}},[_c('p',{staticStyle:{"margin-top":"8px !important","margin-bottom":"4px !important","color":"#ffffffb3"}},[_vm._v("Sizes")])]):_vm._e(),_vm._v(" "),_vm._l((item.sizes),function(size,indexSize){return (item.sizes && item.sizes.length > 1)?[_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs11":""}},[_c('h5',{staticStyle:{"line-height":"23px"}},[_vm._v("\n              "+_vm._s(size.name[_vm.$lang.current_lang] ? size.name[_vm.$lang.current_lang] : size.name.en)+"\n            ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":""}},[_c('span',{staticClass:"mr-2 price",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v("\n                    "+_vm._s(_vm.company && _vm.formatPrice(item, indexSize) ? _vm.company.currencySymbol : '')+_vm._s(_vm.formatPrice(item, indexSize))+"\n                  ")])])]:_vm._e()}),_vm._v(" "),(item.styles && item.styles.length > 1)?_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs12":""}},[_c('p',{staticStyle:{"margin-top":"8px !important","margin-bottom":"4px !important","color":"#ffffffb3"}},[_vm._v("Styles")])]):_vm._e(),_vm._v(" "),_vm._l((item.styles),function(style){return (item.styles && item.styles.length > 1)?[_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs11":""}},[_c('h5',{staticStyle:{"line-height":"23px"}},[_vm._v("\n              "+_vm._s(style.name[_vm.$lang.current_lang] ? style.name[_vm.$lang.current_lang] : style.name.en)+"\n            ")])])]:_vm._e()}),_vm._v(" "),(item.variants && item.variants.length > 1)?_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs12":""}},[_c('p',{staticStyle:{"margin-top":"8px !important","margin-bottom":"4px !important","color":"#ffffffb3"}},[_vm._v("Variants")])]):_vm._e(),_vm._v(" "),_vm._l((item.variants),function(variant){return (item.variants && item.variants.length > 1)?[_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs11":""}},[_c('h5',{staticStyle:{"line-height":"23px"}},[_vm._v("\n              "+_vm._s(variant.name[_vm.$lang.current_lang] ? variant.name[_vm.$lang.current_lang] : variant.name.en)+"\n            ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":""}},[_c('span',{staticClass:"mr-2 price",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v("\n                    "+_vm._s(_vm.company && variant.price ? _vm.company.currencySymbol : '')+_vm._s(variant.price ? variant.price.toFixed(2) : '')+"\n                  ")])])]:_vm._e()}),_vm._v(" "),(item.options && item.options.length > 1)?_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs12":""}},[_c('p',{staticStyle:{"margin-top":"8px !important","margin-bottom":"4px !important","color":"#ffffffb3"}},[_vm._v("Options")])]):_vm._e(),_vm._v(" "),_vm._l((item.options),function(option){return (item.options && item.options.length > 1)?[_c('v-flex',{staticClass:"text-xs-left align-center",attrs:{"xs11":""}},[_c('h5',{staticStyle:{"line-height":"23px"}},[_vm._v("\n              "+_vm._s(option.name[_vm.$lang.current_lang] ? option.name[_vm.$lang.current_lang] : option.name.en)+"\n            ")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs1":""}},[_c('span',{staticClass:"mr-2 price",style:(_vm.goDark ? 'color: #ffffffb3' : '')},[_vm._v("\n                    "+_vm._s(_vm.company ? _vm.company.currencySymbol : '')+_vm._s(option.price.toFixed(2))+"\n                  ")])])]:_vm._e()})],2)],1):_vm._e(),_vm._v(" "),(item.items && item.items.length > 0)?_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","wrap":"","px-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('MenuCategories',{attrs:{"itemsList":_vm.items.filter(function (x) { return x.items && x.itemId === item.itemId; })}})],1)],1):_vm._e()]})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de/actions.js": 435,
	"./de/errors.js": 436,
	"./de/global.js": 437,
	"./de/header.js": 438,
	"./de/labels.js": 439,
	"./de/state.js": 238,
	"./de/success.js": 440,
	"./en/actions.js": 441,
	"./en/errors.js": 442,
	"./en/global.js": 443,
	"./en/header.js": 444,
	"./en/labels.js": 445,
	"./en/state.js": 239,
	"./en/success.js": 446
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 434;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'Erstelle Firma',
  edit: 'Bearbeiten',
  activate: 'Aktivieren',
  deactivate: 'Deaktivieren',
  cancel: 'Abbrechen',
  create: 'Erstellen',
  update: 'Ändern',
  submit: 'Speichern',
  pay: 'Zahlen',
  paid: 'Bezahlt',
  clear: 'Löschen',
  selectTime: 'Zeit wählen',
  unpaid: 'Zwischenliste',
  moveItems: 'Artikel verschieben',
  save: 'Speichern',
  cancelTransaction: 'Transaktion abbrechen',
  open: 'Öffnen',
  openTable: 'Öffne Tisch',
  show: 'Zeige',
  select: 'Auswählen',
  selectTable: 'Tisch wählen',
  selectContact: 'Kontakt wählen',
  selectDate: 'Datum wählen',
  selectMethod: 'Methode wählen',
  selectTerminal: 'Terminal wählen',
  reprint: 'Nachdruck',
  back: 'Zurück',
  download: 'Download',
  cancellation: 'Storno',
  print: 'Druck',
  nullReceipt: 'Null Beleg',
  restaurant: 'Restaurant',
  takeaway: 'Mitnahme',
  collection: 'Abholung',
  delivery: 'Lieferung',
  createContact: 'Kontakt erstellen',
  editContact: 'Kontakt bearbeiten',
  createAddress: 'Addresse erstellen',
  delete: 'Löschen',
  close: 'Schließen',
  deleteContact: 'Kontakt löschen',
  yes: 'Ja',
  no: 'Nein',
  addItem: 'Artikel hinzufügen',
  none: 'Keine',
  searchContacts: 'Kontakt suchen',
  processPayment: 'Zahlung durchführen',
  success: 'Erfolg',
  signatureOk: 'Signatur OK',
  signatureFailed: 'Signatur fehlgeschlagen',
  selectPayment: 'Zahlung wählen',
  addPayment: 'Zahlung hinzufügen',
  chooseTime: 'Zeit wählen',
  openCashdrawer: 'Kassenschublade öffnen',
  setDefault: 'Als Standard setzen',
  reregister: 'Neuregistrierung',
  proceed: 'Fortsetzen',
  refreshTerminals: 'Terminals aktualisieren',
  generate: 'Generieren',
  exportType: 'Zu inkludierende Daten wählen:',
  backToOrder: 'Zurück zu Bestellung',
  noOfPrints: 'Anzahl Kopien',
  view: 'Anzeigen',
  viewAndPrint: 'Anzeigen und drucken',
  isAdded: 'wurde zum Warenkorb gefügt',
  lineOneSearch: 'Bitte Zeile 1 ebenfalls eingeben um Suche auszulösen.',
  clearBasket: 'Leeren',
  orderNow: 'Bestellen',
  refreshBtn: 'Aktualisieren',
  addDiscount: 'Rabatt hinzufügen',
  reload: 'Neu laden',
  enterPasswordp: 'Bitte neues Kennwort eingeben',
  newPassword: 'Neues Kennwort',
  confirmPassword: 'Kennwort Bestätigung',
  register: 'Registrieren',
  forgotPassword: 'Kennwort vergessen',
  send: 'Absenden',
  resetPassword: 'Kennwort zurücksetzen',
  addAddress: 'Addresse hinzufügen',
  checkout: 'Zur Kasse',
  calculate: 'Prüfen',
  preorder: 'Vorbestellen',
  click: 'Klick um',
  goBack: 'zurück',
  here: 'zu gehen',
  add: 'Hinzufügen',
  address: 'Adresse',
  placeOrder: 'Bestellung absenden',
  order: 'Bestellung',
  remove: 'Entfernen'
};

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'Bittet um Eingabe in allen Pflichtfeldern!',
  missingUsername: 'Bitte Benutzername eingeben.',
  missingPassword: 'Bitte Kennwort eingeben.',
  noContacts: 'Keine Kontakte gefunden die gewählte Suchkriterien erfüllen.',
  contactNoAddresses: 'Dieser Kontakt verfügt über keine Adresse.',
  deleteContact: 'Kontakt löschen?',
  emptyField: 'Bitte Werte in allen Feldern einfügen.',
  priceNumber: 'Preis muss eine Zahl sein.',
  vatNumber: 'MwSt. muss eine Zahl sein.',
  selectOne: 'Bitte mindestens einen Artikel wählen.',
  enterOne: 'Bitte mindestens ein Suchkriterium wählen.',
  outOfBusinessHours: 'Aktuelle Zeit ist außerhalb der Geschäftszeiten',
  outOfYourHours: 'Gewählte Zeit ist außerhalb der Geschäftszeiten.',
  cantReachServer: 'Server nicht erreichbar für Summenberechnung. Gesamtpreis kann inkorrekt gerundet sein.',
  receiptSearch: 'Bittet Datum und Belegtyp oder Rechnungsnummer oder Belegnummer eingeben.',
  noReceipts: 'Keine Belege gefunden',
  noNotifications: 'Keine Benachrichtigungen.',
  noPayments: 'Keine Zahlungen gefunden.',
  noTerminals: 'Keine verfügbaren Terminals gefunden. Bitte prüfen ob Terminal im Leerlauf und keine Aktion auf dem Bildschirm angezeigt wird , dass die Netzwerk und Stromkabeln ordnungsgemäß angeschloßen und es nicht im Einzelmodus ist. Falls dies keine Lösung ermöglichen, bitte um Neustart des Terminals und - falls auch dies keine LÖsung ist - Kontakt mit dem Support.',
  onlyOpenPayments: 'Nur offene Zahlungen können gestartet werden.',
  calculationFailed: 'Rückgeldberechnung fehlgeschlagen. Offline Berechnung',
  notSameTotals: 'Summe der Zahlung ist nicht deckungsgleich mit Summe der Artikel. Bitte um Kontrolle der Zahlungen.',
  contactForDelivery: 'Bitte für Lieferung Kontakt wählen.',
  checkPrinter: 'Prüfung nach Standarddrucker des Benutzers fehlgeschlagen.',
  changeTable: 'Änderung der Tischnutzung fehlgeschlagen.',
  orderNotLocked: 'Auftragt ist nicht mehr gesperrt und Zahlung kann nicht fortgeführt werden.',
  tableNoOrders: 'Gewählte Tabelle beinhaltet keine Aufträge',
  failedToFetchTables: 'Suche nach offenen Tischaufträgen fehlgeschlagen',
  fetchTables: 'Suche nach Tischen fehlgeschlagen',
  fetchTableComments: 'Suche nach Tischkommentaren fehlgeschlagen.',
  markComment: 'Kennzeichnung des Kommentars als gelesen fehlgeschlagen.',
  fetchCategories: 'Suche nach Tischkategorien fehlgeschlagen.',
  noCatForTables: 'Keine Tischkategorien gefunden.',
  unpaidBill: 'Erstellung von Zwischenliste fehlgeschlagen',
  fetchPrinters: 'Suche nach Druckern fehlgeschlagen',
  checkDefaultPrinter: 'Prüfung nach Standarddrucker fehlgeschlagen',
  enterHost: 'Bitte Host eingeben.',
  enterKey: 'Bitte API Schlüssel eingeben.',
  noData: 'Keine Daten gefunden',
  printJobs: 'Suche nach Druckaufträgen fehlgeschlagen.',
  systemWarning: 'Diese Funktion kann ihre Arbeit und den Zustand des Systems gefährden; bitte nur auslösen falls ausdrücklich vom Support angewiesen. Bitte um Bestätigung dass die möglichen Konsequenzen verstanden wurden und die Aktion forgesetzt werden soll.',
  companySettings: 'Such nach Firmeneinstellungen fehlgeschlagen. Bitte erneut anmelden.',
  userRoles: 'Suche nach Benutzerrollen fehlgeschlagen. Bitte erneut anmelden.',
  depUnavailable: 'Sicherheitseinrichtung ausgefallen',
  enterDate: 'Bitte sowohl von als auch bis Datum eingeben.',
  fromDate: 'Von Datum darf nicht hinter dem bis Datum liegen',
  fetchPayments: 'Suche nach offenen Zahlungen fehlgeschlagen',
  noReports: 'Keine Berichte verfügbar',
  exportData: 'Datenexport fehlgeschlagen.',
  ticketStatus: 'Prüfung des Ticket Statuses fehlgeschlagen',
  ticketProcessed: 'Anfrage wird bearbeitet: Ticket#:',
  ticketData: 'Download der Ticketdaten fehlgeschlagen',
  fetchTaxReports: 'Download der Steuerdaten Berichts fehlgeschlagen',
  fetchItemUsage: 'Download der Artikelverkauf Berichts fehlgeschlagen',
  atLeastOneItemInCart: 'Bitte zumindest einen Artikel in den Warenkorb legen.',
  mustSelectOrderType: 'Bitte Bestelltyp wählen.',
  addContactFirst: 'Bitte einen Kontakt für diesen Bestelltyp wählen.',
  couldntReachServer: '***Couldn\'t reach the server for calculating total. Total price might not be correct.',
  mainwaySuccess: '***Mainaway successful',
  failedBill: 'Fehler beim erstellen der Zwischenliste',
  failedPrinters: 'Fehler beim Lesen der Drucker',
  failedDefaultPrinter: 'Standarddrucker konnte nicht gelesen werden',
  cantEditOrder: 'Diese Bestellung kann nicht bearbeitet werden.',
  failedTableComments: '***Failed to fetch table comments.',
  notLocked: 'Bestellung ist entsperrt und kann bearbeitet werden.',
  munutesAgo: '***minute(s) ago. Please retry later.',
  anotherUserLocked: 'Bestellung wird bereits durch einen anderen Benutzer bearbeitet',
  tableState: 'Tischstatus konnte nicht geändert werden.',
  sizesVariants: 'Größe oder Variante sind nicht gewählt für diesen Artikel!',
  failedCastalog: 'Katalog konnte nicht gelesen werden',
  required: 'Pflichtfeld!',
  minNineChars: 'Mindestens 9 Zeichen!',
  galaxyAlreadyAdded: 'Die gewählte Galaxy Card wurde bereits hinzugefügt!',
  galaxyCanceled: '***Error in processing, all Galaxy Bookings canceled!',
  galaxyNotActive: 'Die gewählte Galaxy Card ist inaktiv, bitte eine andere Karte wählen. Status:',
  galaxyBalaceZero: 'Diese Galaxy Card hat 0 Guthaben, bitte andere Karte wählen.',
  galaxyItemType: 'Fehler: Galaxy Card Guthaben und reguläre Artikel dürfen nicht kombiniert werden.',
  cardNotFound: 'Karte nicht gefunden.',
  mustSelectStyle: 'Bitte Stil wählen',
  mustSelectSize: 'Bitte Größe wählen',
  mustSelectVariant: 'Bitte Variante wählen',
  nameMustHaveCharacters: 'Name muss mindestens ein Zeichen beinhalten.',
  selfService: 'Self-service Sicht nicht gefunden',
  walletNotActivated: 'Etui nicht aktiviert, daher werden zugeordnete Artikel ausgeblendet',
  disabledCard: 'Deaktivierte Karten können nicht genutzt werden',
  contactAndWallet: 'Etui ID und Kontakt können nicht gleichzeitig gewählt werden',
  walletNotEnabled: 'Etui ist nicht aktiv',
  discountError: 'Dieser Rabatt kann nicht gewährt werden',
  noItemReport: 'Für den gewählten Zeitrahmen ist kein Bericht verfügbar',
  timeOut: 'Keine Antwort, bitte Internet Verbindung prüfen',
  mustBeNumber: '***Invoice number must contain only numbers.',
  requiredPassword: 'Kennwort ist ein Pflichtfeld',
  passwordConditions: 'Kennwort muss mehr als 6 und weniger als 35 Zeichen beinhalten',
  matchPasswords: '***Passwords do not match',
  failedPassword: '***Failed to save password',
  invalidKey: '***Invalid activation key',
  failedCompany: '***Failed to fetch company data.',
  nameLess: '***Name must be less than 35 characters',
  requiredEmail: 'Email ist ein Pflichtfeld',
  notValidEmail: 'Email ist ungültig',
  requiredPhone: 'Telefonnr. ist ein Pflichtfeld',
  notValidPhone: 'Telefonnr. ist ungültig',
  enterData: '***Please enter your data.',
  acceptPolicy: '***You must agree with our Terms & Conditions and privacy and cookies policy',
  failedRegistration: '***Failed to register user',
  enterCredentials: '***Please enter your credentials.',
  failedLogin: '***Failed to login',
  failedContactInfo: '***Failed to fetch contact info',
  sessionExpired: '***Session expired. Please log in again.',
  phoneOrEmail: '***You must enter either phone or email',
  failToSend: '***Failed to send request',
  failedCompanyPassword: '***Password reset successfuly, failed to fetch company data.',
  failedAddress: '***Failed to update address info',
  minimalDelivery: 'Mindestbestellsumme für Lieferung',
  commentShorter: '***Comment must be shorter than 1024 characters',
  invalidZip: 'Ungültige PLZ',
  noPostalFound: 'Keine PLZ gefunden für die getätigte Eingabe.',
  oneItem: 'Bitte legen Sie zumindest einen Artikel in den Warenkorb',
  line1: '***You must enter Line 1',
  invalidPostal: 'Die eingegebene PLZ ist ungültig.',
  postalValidate: '***Failed to validate Postal code.',
  codeOutsideArea: 'Die gewählte PLZ liegt außerhalb des Lieferbereiches.',
  failedCalculate: '***Failed to calculate delivery.',
  calculateServer: '***Failed to contact the server for calculating totals. Calculated offline.',
  zipRequired: '***Zip is required',
  countryRequired: '***Country is required',
  countryUnsupported: '***Country not supported',
  totalOver: '***The total must be over',
  thisDelivery: '***for this delivery method',
  validPostal: 'Bitte geben Sie eine gültige PLZ ein.',
  oneItemMinimum: 'Bitte legen Sie mindestens einen Artikel in den Warenkorb.',
  pageNotFound: '***Page not found',
  restaurantClosed: 'Das Restaurant ist im Moment geschlossen.',
  restaurantPreorder: 'Bestellen Sie jetzt vor, das Restaurant öffnet wieder um ',
  restaurantSoon: 'Restaurant schließt in Kürze. Bitte senden Sie die Bestellung so schnell wie möglich ab.',
  restaurantReceiving: '***Restaurant is not receiving orders for today anymore.',
  paymentFailed: '***Payment failed. Redirecting to order summary...',
  malformedPayment: '***Malformed payment query. Redirecting...',
  submitFailed: '***Failed with submitting payment',
  validPostalProvide: '***You must provide a valid postal code.',
  yourSearchFor: '***Your search for',
  foundNo: '***found no results',
  bizzHours: '***Current time is not within our business hours',
  bizzHours2: 'Die gewählte Zeit liegt außerhalb unseren Geschäftszeiten.',
  chosenTime: 'Gewählte Zeit muss später sein als in den nächsten',
  minutes: 'Minuten',
  restaurantClosedToday: 'Das Restaurant ist heute geschlossen',
  choseContact: '***Please choose a contact',
  acceptAgreement: 'Sie müssen den Bedingungen zustimmen um eine Bestellung tätigen zu können',
  addAddress: 'Bitte Adresse wählen',
  enterPhone: 'Bitte Telefonnr. eingeben',
  enterEmail: 'Bitte Email Adresse eingeben',
  enterLastName: 'Bitte Nachname eingeben',
  enterPayment: 'Bitte Zahlungsmethode wählen',
  workingHours: 'Die gewählte Zeit liegt außerhalb der Öffnungszeiten',
  failedOrder: 'Bestellung fehlgeschlagen',
  failedCalculate2: 'Lieferkostenberechnung fehlgeschlagen. Gesamtkosten konnten nicht ermittelt werden.',
  addressAT: 'Bitte Addresse wählen.',
  validPostalOrAddress: 'PLZ und/oder Adresse ist ungültig, bitte um Korrektur',
  requiredName: 'Nachname ist ein Pflichtfeld',
  acceptingOrders: 'Aktuell können wir keine Bestellungen annehmen, bitte versuchen Sie es später.',
  noOrders: 'Keine Bestellungen gefunden.'
};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = {
  notAvailable: 'Webshop ist aktuell nicht verfügbar',
  webshop: 'Webshop',
  eng: 'English',
  de: 'Deutsch',
  error404: 'Die gesuchte Seite existiert nicht!',
  invalid: 'Ungültig',
  abr: 'Abkürzung',
  name: 'Name',
  phone: 'Telefonnr.',
  persons: 'Kontakte',
  call: 'Anruf',
  total: 'Gesamt',
  status: 'Status',
  type: 'Typ',
  restaurant: 'Restaurant',
  all: 'Alle',
  none: 'Keine',
  allNone: 'Alle/Keine',
  date: 'Datum',
  paymentMethods: 'Zahlungsmethoden',
  paymentReports: 'Zahlungsberichte',
  deliveryMethods: 'Zustellart',
  openPayments: 'Offene Zahlungen',
  card: 'Karte',
  cash: 'Bar',
  amazon: 'Amazon',
  cardmanual: 'Karte manuell',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Rechnung',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Gutschein',
  galaxycard: 'Galaxy Card',
  collection: 'Abholung',
  delivery: 'Lieferung',
  website: 'Webseite',
  taxReport: 'Steuerbericht',
  itemUsage: 'Artikelverkauf',
  cancellationReason: 'Stornierungsgrund',
  cancellationReasonFalseEntry: 'Fehleingabe',
  cancellationReasonGoodWill: 'Kulanz',
  cancellationReasonComplaint: 'Reklamation',
  cancellationReasonReturn: 'Retournierung',
  vattotal: 'MwSt. Gesamt',
  label: 'Etikett',
  driver: 'Fahrer',
  collectAll: 'Alle einsammeln',
  open: '***Open',
  sale: '***Sale',
  registerCard: 'Karte anmelden',
  cardDetails: 'Karten Details',
  walletDetails: 'Etui Details',
  confirmed: 'Bestätigt',
  pending: '***Pending',
  canceled: '***Canceled',
  shoppingBasket: 'Einkaufskorb',
  zNonTraining: 'Regulär',
  zTraining: 'Training',
  orderDetails: 'Bestellübersicht',
  sysVersion: 'Backend Version',
  resourceId: 'Webshop ID',
  orange: 'Orange',
  blue: 'Blau',
  green: 'Grün',
  orderFees: 'Zustellgebühren',
  openingHours: 'Öffnungszeiten',
  quickLinks: 'Quicklinks',
  forgotPassword: 'Kennwort vergessen?',
  allRights: 'ALLE Rechte vorbehalten',
  selectMethod: 'Bitte Methode wählen',
  byEmail: 'Zurücksetzen mittels Email',
  byPhone: 'Zurücksetzen mittels Telefonnr.',
  deliveryMethod: 'Zustellart',
  paymentProgress: 'Zahlung wird durchgeführt',
  pleaseWait: 'Bitte wählen',
  selectTime: 'Zeit wählen',
  orderHistory: 'Bestellungshistorie',
  attention: 'Bitte BEACHTEN',
  foodAllergy: 'Wenn Sie - oder jemand für den Sie bestellen - eine Allergie hat, bitte',
  callRestaurant: 'kontaktieren Sie das Restaurant',
  language: 'Sprachen',
  english: 'English',
  german: 'Deutsch',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  colours: 'Farben',
  experiment: 'Experiment',
  feVersion: 'Frontend Version',
  theme: 'Theme',
  light: 'Light',
  dark: 'Dark',
  backTo: 'ZURÜCK ZU'
};

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = {
  cookie_1: 'Diese Website verwendet Cookies, um Ihre Erfahrung zu personalisieren. Details finden Sie in unseren',
  cookie_2: 'Durch die Nutzung unserer Website und die Zustimmung zu dieser Richtlinie, willigen Sie der Verwendung von Cookies zu',
  cookiePrivacy: 'Datenschutz- und Cookie Richtlinie',
  tearmsConditions: 'Allgemeine Geschäftsbedingungen',
  accept: 'Bestätigen',
  register: 'Registrieren',
  login: 'Anmelden',
  logout: 'Abmelden',
  history: 'Historie',
  settings: 'Einstellungen',
  notActive: 'Sehr geehrte Kundin sehr geehrter Kunde, dieser Webshop ist aktuell nicht aktiviert.',
  failLogOut: 'Abmeldung fehlgeschlagen',
  logOut: 'Sie sind nun abgemeldet',
  iAgree1: 'Hiermit stimme ich den',
  iAgree2: 'zu',
  and: 'sowie der',
  adminPanel: 'Admin Panel',
  besuche: 'Besuche',
  rateUs: 'Bitte bewerten Sie uns',
  rateHint: 'Sagen Sie uns ihre Meinung',
  orders: 'Bestellungen',
  customer: 'Kunde',
  deliveryTime: 'Lieferzeit',
  rating: 'Bewertung',
  value: 'Wert'
};

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Benutzername',
  password: 'Kennwort',
  name: 'Name',
  currency: 'Währung',
  status: 'Status',
  actions: 'Aktionen',
  filter: 'Firmenfilter',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  phone: 'Telefonnr.',
  email: 'Email',
  externalID: 'Externe ID',
  testMode: 'Test Modus',
  addressLine: 'Addresszeile',
  locality: 'Lokalität',
  townCity: 'Ort/Stadt',
  country: 'Land',
  postalcode: 'PLZ',
  createCompany: 'Firma erstellen',
  editCompany: 'Firma bearbeiten',
  customOption: 'Kundenoption',
  search: 'Suche',
  export: 'Exportieren',
  available: 'Verfügbar',
  inuse: 'In Verwendung',
  finishing: 'Abschluss',
  reserved: 'Reserviert',
  idle: 'Untätig',
  size: 'Größe',
  style: 'Stil',
  variant: 'Variante',
  options: 'Optionen',
  orderCode: 'Bestellkode',
  source: 'Quelle',
  discount: 'Rabatt',
  discountTotal: 'Rabattbetrag',
  percentDiscount: 'Rabatt %',
  terminals: 'Terminals',
  loadingTerminals: 'Lade Terminals...',
  payments: 'Zahlungen',
  from: 'Von',
  to: 'Bis',
  training: 'Training',
  notes: 'Anmerkungen ...',
  driverNotes: 'Fahrernotizen ...',
  serviceCharges: 'Service Gebühr',
  postalCode: 'PLZ',
  line1: 'Zeile 1',
  line2: 'Zeile 2',
  line3: 'Zeile 3',
  line4: 'Zeile 4',
  action: 'Aktion',
  serviceCharge: 'Servicegebühr',
  deliveryCharge: 'Liefergebühr',
  invoice: 'Rechnung',
  invoiceSearch: 'Rechnungssuche',
  receiptSearch: 'Belegsuche',
  invoiceNumber: 'Rechnungsnr.',
  receiptNo: 'Belegnr.',
  receiptTypes: 'Beleg Typ',
  startReceipt: 'Startbeleg',
  endReceipt: 'Endbeleg',
  monthlyReceipt: 'Monatlicher Beleg',
  yearlyReceipt: 'Jährlicher Beleg',
  nullReceipt: 'Null Beleg',
  regularReceipt: 'Normalbeleg',
  cancelReceipt: 'Stornobeleg',
  collectionReceipt: 'Sammelbeleg',
  allNone: '全部/没有',
  first: 'Vorname',
  last: 'Nachname',
  manufacturer: 'Hersteller',
  model: 'Modell',
  default: 'Standard',
  registeredOn: 'Angemeldet am',
  lastModifiedOn: 'Zuletzt verändert am',
  createdOn: 'Erstellt am',
  modifiedOn: 'Bearbeitet am',
  cashRegisterName: 'Kassenidentifikationsnummer',
  lines: 'Zeilen',
  collect: 'Einsammeln',
  reportLines: 'Bericht Zeilen',
  balances: 'Kontostände',
  previousSession: 'Vorherige Sitzungssumme',
  currentSession: 'Aktuelle Sitzungssumme',
  previousOrder: 'Vorheriger Auftrag',
  hour: 'Stunde',
  minute: 'Minute',
  beforeDiscount: 'Gesamtsumme vor Rabatt',
  mandatory: 'Pflichtfeld',
  loadingPayments: 'Lade Zahlungen...',
  transactions: 'Transaktionen',
  response: 'Antwort',
  loadingTransactions: 'Lade Transaktionen...',
  notifications: 'Benachrichtigungen',
  text: 'Text',
  themes: 'Themes',
  unpaidOrders: 'Unbezahlte Aufträge',
  numberOfPayments: 'Anzahl von Zahlungen',
  details: 'Details',
  tipAmount: 'Trinkgeld Anzahl',
  dcTaxRate: 'Liefergebühr MwSt.',
  orderId: 'Auftrag ID',
  download: 'Download',
  host: 'Host',
  changedHardware: 'Hardware geändert?',
  swithcCode: 'Tischwechsel Code',
  instance: 'Instanz',
  backendversion: 'Backend Version',
  ipAddress: 'IP Adresse',
  portNumber: 'Port Nummer',
  noUser: 'Kein Benutzer',
  regularInvoices: 'Reguläre Rechnungen',
  cancellationInvoices: 'Storno Rechnungen',
  printers: 'Drucker',
  printJobs: 'PrintJobs',
  changePassword: 'Kennwort ändern',
  dbOptimization: 'DB optimization',
  payment: 'Zahlung',
  system: 'System',
  dataExport: 'Daten Export',
  depReceipts: 'DEP und Belege',
  depAll: 'Alle Logs',
  cashAmount: 'Bar erhalten',
  changeGiven: 'Rückgeld',
  orderType: 'Ordertyp',
  tip: 'Trinkgeld',
  receiptNumber: 'Belegnr.',
  nonTrainingPayedOrders: 'Reguläre bezahlte Bestellungen',
  nonTrainingUnpaidOrders: 'Reguläre unbezahlte Bestellungen',
  nonTrainingServiceCharges: 'Reguläre Servicegebühr',
  trainingPayedOrders: 'Training bezahlte Bestellungen',
  trainingUnpaidOrders: 'Training unbezahlte Bestellungen',
  trainingServiceCharges: 'Training Servicegebühr',
  vatPrint: 'MwSt. Druck',
  monthlyTaxReport: 'Monatlicher Steuerbericht',
  generatedOn: 'Erstellt am',
  regularTotalAmount: 'Regular Gesamtsumme',
  amountOfOrders: 'Bestellungsanzahl',
  amountOfInvoices: 'Rechnungsanzahl',
  cancellationTotalAmount: 'Storno Gesamtsumme',
  detailsPerDay: 'Aufstellung nach Tagen',
  created: 'Erstellt',
  printed: 'Gedruckt',
  prepared: 'Zubereitet',
  inDelivery: 'In Lieferung',
  delivered: 'Geliefert',
  cancelled: 'Abgebrochen',
  notCollected: 'Nicht gesammelt',
  collected: 'Eingesammelt',
  disputed: 'Umstritten',
  regular: 'Regulär',
  cardName: 'Karten Name',
  cardId: 'Karten ID',
  register: 'Anmelden',
  externalId: 'Externe Karten ID',
  walletId: 'Etui ID',
  balance: 'Guthaben',
  cardData: 'Karten Daten',
  getCardBookings: 'Zeige Kartenbuchungen',
  noBookings: 'Keine Kartenbuchungen in dem gewählten Zeitrahmen gefunden.',
  cardBookings: 'Kartenbuchungen',
  amount: 'Betrag',
  expired: 'Abgelaufen',
  bookingId: 'Buchungsnr.',
  bookingType: 'Typ',
  noWallets: 'Kein Etui für diesen Kontakt gefunden.',
  wallets: 'Etuis',
  walletName: 'Etui Name',
  reservedAmount: 'Verfügbarer Betrag',
  walletDetails: 'Etui Details',
  enterGalaxyCard: 'Bitte Galaxy Card eingeben',
  number: 'Nr',
  mode: 'Modus',
  dark: 'Dunkel',
  simpleOrdering: 'Vereinfachte Bestellung',
  fontSizes: 'Schriftgrößen',
  theme: 'Farbe',
  useLastPaymentMethod: 'Letzte Zahlungsmethoden nutzen',
  amountOfPersons: 'Personenanzahl',
  refreshCompanySettings: 'Firmeneinstellungen aktualisieren',
  refreshCatalog: 'Katalog aktualisieren',
  reason: 'Bitte Grund der Deaktivierung eingeben',
  deactivationWarning: 'ACHTUNG: eine deaktivierte Karte ist nicht länger nutzbar. Die Deaktivierung kann nicht rückgängig gemacht werden.',
  none: 'Kein',
  discounts: 'Rabatte',
  clickToRemove: 'Klick auf vorhandenen Rabatt entfernt es',
  moon: '***Moon',
  webshop: '***Webshop',
  mostSoldItem: '***Most sold item count',
  mostCanceledItem: '***Most canceled item count',
  monthYear: '***Month / Year',
  soldCount: 'Verkaufszähler',
  canceledCount: 'Stornozähler',
  moonItemUsageSummary: 'Moon Artikelstatistik',
  webshopItemUsageSummary: 'Webshop Artikelstatistik',
  catalogId: 'Katalog Artikel ID',
  dailyitemusage: 'Täglich',
  monthlyitemusage: 'Monatlich',
  noCancelation: 'Keine Stornodaten.',
  servicecharge: 'Servicegeb',
  deliverycharge: 'Lieferung',
  itemprice: 'Artikel',
  totalSoldAmount: '***Sold amount',
  totalCancelledAmount: '***Cancelled amount',
  byVat: 'Nach Steuersatz',
  byTaxCategory: 'Nach Steuerkategorie',
  byPaymentType: 'Nach Zahlungsmethode',
  total: 'Gesamt',
  selectAddress: 'Adresse wählen',
  quantity: 'Menge',
  comment: 'Anmerkung',
  deliveryCharges: 'Lieferkosten',
  latitude: '***Latitude',
  longitude: '***Longitude',
  price: 'Preis',
  deliveryType: 'Zustellart',
  selectHours: '***Select hours',
  selectMinute: '***Select minutes',
  totalAmount: 'Gesamt',
  deliveryMethod: 'Zustellart',
  change: 'Ändern',
  contactInfo: 'Kontakt Informationen',
  paymentMethod: 'Zahlungsmethode',
  voucher: 'Gutschein',
  time: 'Zeit',
  startTyping: 'Bitte Eingabe starten für Suche',
  asSoon: 'Ehest möglich',
  address: 'Addresse',
  line3AT: 'Stiege/Wohnung/Adressdetails',
  line2AT: 'Hausnummer',
  line1AT: 'Straße',
  chat: 'Chat',
  allergens: 'Allergene',
  showAllergens: 'Allergene anzeigen',
  vatRate: 'MwSt.',
  firstName: 'Vorname',
  lastName: 'Nachname',
  tableName: 'Tischbezeichnung',
  dateTime: 'Datum & Uhrzeit',
  customerTrackingTitle1: 'Erhebung von Kontaktdaten von Gästen in der Gastronomie',
  customerTrackingTitle2: 'gemäß der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19. Die Eintragung erfolgt durch die Kundin/den Kunden:',
  customerDesc: 'Datenschutzrechtliche Information nach Art. 13 DSGVO:\n' + 'Zweck und Rechtsgrundlagen der Verarbeitung:\n' + 'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' + 'Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen natürlichen Person). § 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020\n' + 'Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19\n' + 'Verantwortlicher für die Verarbeitung der erhobenen personenbezogenen Daten $partnerCompanyName, $partnerPostalAddress, an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden können.\n\n' + 'Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empfänger weitergeleitet:\n' + 'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' + 'Empfänger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.\n' + 'Hinweise\n' + 'Ihre personenbezogenen Daten werden gem. § 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19 4 Wochen nach ihrer Aufnahme gelöscht.\n' + 'Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.\n' + 'Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtmäßig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der Österreichischen Datenschutzbehörde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at',
  visits: 'Visits',
  delete: 'Delete',
  save: 'Speichern',
  table: 'Tisch',
  deliveryOn: 'Lieferung am',
  ordersSearch: 'Bestellungssuche',
  blacklist: 'Blacklist',
  all: 'Alle'
};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = {
  paymentProccessing: 'Verarbeitung der Zahlungen gestartet.',
  paymentSuccessful: 'Zahlung als erfolgreich markiert.',
  transactionCancel: 'Storno der Transaktion gestartet.',
  reRegistration: 'Neu-Anmeldung erfolgreich',
  dataRedy: 'Ihre Daten sind bereit für',
  wallet: 'Etui: erfolgreich aktualisiert!',
  order: 'Bestellung',
  thankYuou: 'Danke für Ihren Auftrag!',
  yourOrderNuber: 'Ihre Bestellnummer ist:',
  created_successfully: 'erstellt.',
  updated_successfully: 'geändert.',
  companySettingsRefreshed: 'Firmeneinstellung erfolgreich aktualisiert!',
  catalogRefreshed: 'Katalog erfolgreich aktualisiert!',
  sendSuccess: 'Ihre Anfrage wurde gesendet. Sie erhalten in Kürze eine E-Mail!',
  addressUpdated: 'Adressdaten wurden aktualisiert',
  addedToCart: 'hinzugefügt',
  postalSet: 'PLZ gespeichert! Bitte auf Prüfen klicken um etwaige Lieferkosten zu berechnen.',
  deliveryCalculated: 'Lieferkosten erfolgreich berechnet.',
  registrationSuccessfully: 'Registrierung erfolgreich. Sie erhalten in Kürze eine E-Mail zur Aktivierung!',
  passSuccess: 'Kennwort erfolgreich gesetzt. Sie sind nun angemeldet.',
  thankYou: 'Vielen Dank für Ihre Bestellung! Bitte prüfen Sie ihr Email Postfach und den Spam Order.',
  paymentOrderOk: 'Bestellung erfolgreich bezahlt!',
  visitOk: 'Besuch erfolgreich dokumentiert.',
  rateOk: 'Vielen Dank! Ihre Meinung ist uns wichtig.',
  continueTo: 'Weiter zu',
  blacklist: 'Blacklist: Eintrag erfolgreich erstellt.'
};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = {
  createCompany: 'Create Company',
  edit: 'Edit',
  activate: 'Activate',
  deactivate: 'Deactivate',
  cancel: 'Cancel',
  create: 'Create',
  update: 'Update',
  submit: 'Submit',
  pay: 'Pay',
  paid: 'Paid',
  clear: 'Clear',
  selectTime: 'Select time',
  unpaid: 'Unpaid',
  moveItems: 'Move items',
  save: 'Save',
  cancelTransaction: 'Cancel transaction',
  open: 'Open',
  openTable: 'Open table',
  show: 'Show',
  select: 'Select',
  selectTable: 'Select table',
  selectContact: 'Select contact',
  selectDate: 'Select a date',
  selectMethod: 'Select method',
  selectTerminal: 'Select terminal',
  reprint: 'Reprint',
  back: 'Back',
  download: 'Download',
  cancellation: 'Cancellation',
  print: 'Print',
  nullReceipt: 'Null receipt',
  restaurant: 'Restaurant',
  takeaway: 'Take Away',
  collection: 'Collection',
  delivery: 'Delivery',
  createContact: 'Create Contact',
  editContact: 'Edit Contact',
  createAddress: 'Create Address',
  delete: 'Delete',
  close: 'Close',
  deleteContact: 'Delete contact',
  yes: 'Yes',
  no: 'No',
  addItem: 'Add item',
  none: 'None',
  searchContacts: 'Search Contacts',
  processPayment: 'Process payment',
  success: 'Success',
  signatureOk: 'Signature Ok',
  signatureFailed: 'Signature Failed',
  selectPayment: 'Select a payment',
  addPayment: 'Add payment',
  chooseTime: 'Choose time',
  openCashdrawer: 'Open cashdrawer',
  setDefault: 'Set default',
  reregister: 'Reregister',
  proceed: 'Proceed',
  refreshTerminals: 'Refresh terminals',
  generate: 'Generate',
  exportType: 'Select data to be included:',
  backToOrder: 'Back to order',
  noOfPrints: 'No. of prints',
  view: 'View',
  viewAndPrint: 'View and Print',
  isAdded: 'was added to your cart',
  lineOneSearch: 'Enter Line one to Search.',
  clearBasket: 'Clear',
  orderNow: 'Order now',
  refreshBtn: 'Refresh',
  addDiscount: 'Add Discount',
  reload: 'Reload',
  enterPassword: 'Please enter new password',
  newPassword: 'New password',
  confirmPassword: 'Confirm Password',
  register: 'Register',
  forgotPassword: 'Forgot password',
  send: 'Send',
  resetPassword: 'Reset password',
  addAddress: 'Add address',
  checkout: 'Checkout',
  calculate: 'Calculate',
  preorder: 'Preorder',
  click: 'Click',
  goBack: 'to go back',
  here: 'here',
  add: 'Add',
  address: 'address',
  placeOrder: 'Place order',
  order: 'Order',
  remove: 'Remove'
};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = {
  missingRequired: 'You must enter a value for required fields!',
  missingUsername: 'Please enter your username.',
  missingPassword: 'Please enter your password.',
  noContacts: 'No contact found with specified search criteria.',
  contactNoAddresses: 'This contact has no addresses',
  deleteContact: 'Are you sure you want to delete this contact?',
  emptyField: 'You must enter a value for each field.',
  priceNumber: 'Price must be a number.',
  vatNumber: 'Vat must be a number.',
  selectOne: 'You must select at least one item.',
  enterOne: 'You must enter at least one search parameter.',
  outOfBusinessHours: 'Current time is not within our business hours',
  outOfYourHours: 'The time you selected is not within your business hours.',
  cantReachServer: 'Couldn\'t reach the server for calculating total. Total price might not be correct.',
  receiptSearch: 'You must select a date and receipt type or enter invoice number or receipt number.',
  noReceipts: 'No receipts found',
  noNotifications: 'There are no notifications.',
  noPayments: 'No payments found.',
  noTerminals: 'No available terminals found. Please check that the PDQ is idle and no action is prompted on its screen, that its network and power cables are correctly connected and that it is not in Standalone Mode. Finally, restart the PDQ and, if the problem persists, please contact support.',
  onlyOpenPayments: 'Only open payments can be triggered.',
  calculationFailed: 'Failed to calculate change difference. Calculating offline',
  notSameTotals: 'Payment method totals are not the same as items totals. Please check the funds.',
  contactForDelivery: 'You must select a contact for delivery.',
  checkPrinter: 'Check for default printer of user failed.',
  changeTable: 'Failed to change table usage.',
  orderNotLocked: 'Order is not locked anymore and you cannot proceed with payment.',
  tableNoOrders: 'Current table has no orders',
  failedToFetchTables: 'Failed to fetch open table orders',
  fetchTables: 'Failed to fetch tables',
  fetchTableComments: 'Failed to fetch table comments.',
  markComment: 'Failed to mark comment as read.',
  fetchCategories: 'Failed to fetch categories.',
  noCatForTables: 'There are no categories for the tables.',
  unpaidBill: 'Failed to generate unpaid bill',
  fetchPrinters: 'Failed to fetch printers',
  checkDefaultPrinter: 'Failed to check default printer',
  enterHost: 'You must enter a host.',
  enterKey: 'You must enter an api key.',
  noData: 'No data found',
  printJobs: 'Failed to fetch print jobs.',
  systemWarning: 'Triggering this function can impact your system and work negatively; only trigger if advised by support. Please confirm that you are aware of the consequences and want to proceed.',
  companySettings: 'Error getting company settings. Please log in again.',
  userRoles: 'Error getting user roles. Please log in again.',
  depUnavailable: 'Encryption unit unavailable',
  enterDate: 'You must enter both from and to date.',
  fromDate: 'From date can\'t be after to date',
  fetchPayments: 'Failed to fetch open payments',
  noReports: 'No reports available',
  exportData: 'Failed to fetch export data.',
  ticketStatus: 'Failed to check ticket status',
  ticketProcessed: 'Request is being processed: ticket#:',
  ticketData: 'Failed to fetch ticket data',
  fetchTaxReports: 'Failed to fetch tax reports',
  fetchItemUsage: 'Failed to fetch item usage reports',
  atLeastOneItemInCart: 'You must have at least one item in cart.',
  mustSelectOrderType: 'You must select the order type.',
  addContactFirst: 'You must add a contact first for this order type.',
  couldntReachServer: 'Couldn\'t reach the server for calculating total. Total price might not be correct.',
  mainwaySuccess: 'Mainaway successful',
  failedBill: 'Failed to generate unpaid bill',
  failedPrinters: 'Failed to fetch printers',
  failedDefaultPrinter: 'Failed to check default printer',
  cantEditOrder: 'This order cannot be edited.',
  failedTableComments: 'Failed to fetch table comments.',
  notLocked: 'Order is not locked anymore and you cannot proceed with editing it.',
  munutesAgo: 'minute(s) ago. Please retry later.',
  anotherUserLocked: 'Another user locked the order',
  tableState: 'Failed to change table state.',
  sizesVariants: 'Sizes or Variants are not set for this item!',
  failedCastalog: 'Failed to fetch the catalog',
  required: 'Required!',
  minNineChars: 'Minimum 9 characters!',
  galaxyAlreadyAdded: 'This Galaxy card is already added!',
  galaxyCanceled: 'Error in processing, all Galaxy Bookings canceled!',
  galaxyNotActive: 'This Galaxy card is not active, please chose another card. Status:',
  galaxyBalaceZero: 'This Galaxy card has 0 balance, please choose another card.',
  galaxyItemType: 'Error: You cannot add Galaxy card balance and regular items together.',
  cardNotFound: 'Card not found.',
  mustSelectStyle: 'You must select a style',
  mustSelectSize: 'You must select a size',
  mustSelectVariant: 'You must select a variant',
  nameMustHaveCharacters: 'Name must have at least one character.',
  selfService: 'Self-service view not found',
  walletNotActivated: 'Wallet is not activated, hence related items will be hidden',
  disabledCard: 'Disabled cards can not be used',
  contactAndWallet: 'Wallet ID and Contact can\'t be selected at the same time',
  walletNotEnabled: 'Wallet is not enabled',
  discountError: 'You can not give this discount',
  noItemReport: 'There is no item report for this time frame',
  timeOut: 'No response, please check your internet connection',
  mustBeNumber: 'Invoice number must contain only numbers.',
  requiredPassword: 'Password is required',
  passwordConditions: 'Password must be longer than 6 and shorter than 35 characters',
  matchPasswords: 'Passwords do not match',
  failedPassword: 'Failed to save password',
  invalidKey: 'Invalid activation key',
  failedCompany: 'Failed to fetch company data.',
  nameLess: 'Name must be less than 35 characters',
  requiredEmail: 'Email is required',
  notValidEmail: 'Email is not valid',
  requiredPhone: 'Phone is required',
  notValidPhone: 'Phone is not valid',
  enterData: 'Please enter your data.',
  acceptPolicy: 'You must agree with our Terms & Conditions and privacy and cookies policy',
  failedRegistration: 'Failed to register user',
  enterCredentials: 'Please enter your credentials.',
  failedLogin: 'Failed to login',
  failedContactInfo: 'Failed to fetch contact info',
  sessionExpired: 'Session expired. Please log in again.',
  phoneOrEmail: 'You must enter either phone or email',
  failToSend: 'Failed to send request',
  failedCompanyPassword: 'Password reset successfuly, failed to fetch company data.',
  failedAddress: 'Failed to update address info',
  minimalDelivery: 'Minimal total amount for delivery',
  commentShorter: 'Comment must be shorter than 1024 characters',
  invalidZip: 'Invalid Zip code',
  noPostalFound: 'No postal code found for search parameters.',
  oneItem: 'You must have at least one item in cart to calculate delivery charges',
  line1: 'You must enter Line 1',
  invalidPostal: 'The Postal code you entered is invalid.',
  postalValidate: 'Failed to validate Postal code.',
  codeOutsideArea: 'The selected post code is outside of the delivery area.',
  failedCalculate: 'Failed to calculate delivery.',
  calculateServer: 'Failed to contact the server for calculating totals. Calculated offline.',
  zipRequired: 'Zip is required',
  countryRequired: 'Country is required',
  countryUnsupported: 'Country not supported',
  totalOver: 'The total must be over',
  thisDelivery: 'for this delivery method',
  validPostal: 'You must enter a valid postal code.',
  oneItemMinimum: 'You must have at least one item in cart.',
  pageNotFound: 'Page not found',
  restaurantClosed: 'Restaurant is currently closed.',
  restaurantPreorder: 'Preorder now, restaurant is opening again at',
  restaurantSoon: 'Restaurant is closing soon. Please make your order as soon as possible.',
  restaurantReceiving: 'Restaurant is not receiving orders for today anymore.',
  paymentFailed: 'Payment failed. Redirecting to order summary...',
  malformedPayment: 'Malformed payment query. Redirecting...',
  submitFailed: 'Failed with submitting payment',
  validPostalProvide: 'You must provide a valid postal code.',
  yourSearchFor: 'Your search for',
  foundNo: 'found no results',
  bizzHours: 'Current time is not within our business hours',
  bizzHours2: 'The time you selected is not within our business hours.',
  chosenTime: 'Chosen time must be later than next',
  minutes: 'minutes',
  restaurantClosedToday: 'The Restaurant is closed today',
  choseContact: 'Please choose a contact',
  acceptAgreement: 'You must accept the agreement to submit the order',
  addAddress: 'Please add an address',
  enterPhone: 'Please enter your phone number',
  enterEmail: 'Please enter your email',
  enterLastName: 'Please enter your Last Name',
  enterPayment: 'Please select payment method',
  workingHours: 'The time you picked is outside our working hours',
  failedOrder: 'Failed to submit order',
  failedCalculate2: 'Failed to calculate delivery. Total will not be calculated',
  addressAT: 'You must enter the Address',
  validPostalOrAddress: 'Postal code or address is not valid, please change',
  requiredName: 'Name is required',
  acceptingOrders: 'We are currently not accepting orders, please try later.',
  noOrders: 'No orders found.'
};

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = {
  notAvailable: 'Webshop is currently not available',
  webshop: 'Webshop',
  eng: 'English',
  de: 'Deutsch',
  error404: 'The page you are looking for does not exist!',
  invalid: 'Invalid',
  abr: 'Abbreviation',
  name: 'Name',
  phone: 'Phone',
  persons: 'Persons',
  call: 'Call',
  total: 'Total',
  status: 'Status',
  type: 'Type',
  restaurant: 'Restaurant',
  all: 'All',
  none: 'None',
  allNone: 'All/None',
  date: 'Date',
  paymentMethods: 'Payment methods',
  paymentReports: 'Payment Reports',
  deliveryMethods: 'Delivery methods',
  openPayments: 'Open payments',
  card: 'Card',
  cash: 'Cash',
  amazon: 'Amazon',
  cardmanual: 'Card Manual',
  deliveroo: 'Deliveroo',
  hungryhouse: 'Hungry House',
  invoice: 'Invoice',
  justeat: 'Justeat',
  ubereats: 'Ubereats',
  voucher: 'Voucher',
  galaxycard: 'Galaxy Card',
  collection: 'Collection',
  delivery: 'Delivery',
  website: 'Website',
  taxReport: 'Tax Report',
  itemUsage: 'Item Usage',
  cancellationReason: 'Cancellation reason',
  cancellationReasonFalseEntry: 'False entry',
  cancellationReasonGoodWill: 'Goodwill',
  cancellationReasonComplaint: 'Complaint',
  cancellationReasonReturn: 'Return',
  vattotal: 'VAT total',
  label: 'Label',
  driver: 'Driver',
  collectAll: 'Collect All',
  open: 'Open',
  sale: 'Sale',
  registerCard: 'Register Card',
  cardDetails: 'Card Details',
  walletDetails: 'Wallet Details',
  confirmed: 'Confirmed',
  pending: 'Pending',
  canceled: 'Canceled',
  shoppingBasket: 'Shopping basket',
  zNonTraining: 'Non-Training',
  zTraining: 'Training',
  orderDetails: 'Order summary',
  sysVersion: 'Backend version',
  resourceId: 'Resource id',
  orange: 'Orange',
  blue: 'Blue',
  green: 'Green',
  orderFees: 'Order fees',
  openingHours: 'Opening hours',
  quickLinks: 'Quicklinks',
  forgotPassword: 'Forgot password?',
  allRights: 'ALL Rights Reserved',
  selectMethod: 'Please select the method',
  byEmail: 'Reset by email address',
  byPhone: 'Reset by phone number',
  deliveryMethod: 'Delivery method',
  paymentProgress: 'Payment in progress',
  pleaseWait: 'Please wait',
  selectTime: 'Select time',
  orderHistory: 'Order History',
  attention: 'ATTENTION',
  foodAllergy: 'If you - or somebody you are ordering for - has a food allergy, please',
  callRestaurant: 'call the restaurant',
  language: 'Language',
  english: 'English',
  german: 'Deutsch',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  colours: 'Colours',
  experiment: 'Experiment',
  feVersion: 'Frontend version',
  theme: 'Theme',
  light: 'Light',
  dark: 'Dark',
  backTo: 'BACK TO'
};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = {
  cookie_1: 'This website uses cookies to personalise your experience. Details are described in our',
  cookie_2: 'By using our website and agreeing to this policy, you consent to our use of cookies',
  cookiePrivacy: 'Privacy and Cookies Policy',
  tearmsConditions: 'Terms & Conditions',
  accept: 'I Accept',
  register: 'Register',
  login: 'Log In',
  logout: 'Log Out',
  history: 'History',
  settings: 'Settings',
  notActive: 'Dear customer, this webshop is not currently active.',
  failLogOut: 'Failed to log out',
  logOut: 'You are now logged out',
  iAgree1: 'I hereby agree to the',
  iAgree2: '',
  and: 'and',
  adminPanel: 'Admin Panel',
  besuche: 'Visits',
  rateUs: 'Please rate us',
  rateHint: 'Please let us know what you think',
  orders: 'Orders',
  customer: 'Customer',
  deliveryTime: 'Delivery time',
  type: 'Type',
  rating: 'Rating',
  value: 'Value'
};

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {
  username: 'Username',
  password: 'Password',
  name: 'Name',
  currency: 'Currency',
  status: 'Status',
  actions: 'Actions',
  filter: 'Filter for company',
  active: 'Active',
  inactive: 'Inactive',
  phone: 'Phone',
  email: 'Email',
  externalID: 'External ID',
  testMode: 'Test mode',
  addressLine: 'Address line',
  locality: 'Locality',
  townCity: 'Town/City',
  country: 'Country',
  postalcode: 'Postal code',
  createCompany: 'Create company',
  editCompany: 'Edit company',
  customOption: 'Custom option',
  search: 'Search',
  export: 'Export',
  available: 'Available',
  inuse: 'In Use',
  finishing: 'Finishing',
  reserved: 'Reserved',
  idle: 'Idle',
  size: 'Size',
  style: 'Style',
  variant: 'Variant',
  options: 'Options',
  orderCode: 'Order code',
  source: 'Source',
  discount: 'Discount',
  discountTotal: 'Discount total',
  percentDiscount: 'Discount in %',
  terminals: 'Terminals',
  loadingTerminals: 'Loading terminals...',
  payments: 'Payments',
  from: 'From',
  to: 'To',
  training: 'Training',
  notes: 'Notes ...',
  driverNotes: 'Driver notes ...',
  serviceCharges: 'Service charges',
  postalCode: 'Postal code',
  line1: 'Line 1',
  line2: 'Line 2',
  line3: 'Line 3',
  line4: 'Line 4',
  action: 'Action',
  serviceCharge: 'Service charge',
  deliveryCharge: 'Delivery charge',
  invoice: 'Invoice',
  invoiceSearch: 'Invoice search',
  receiptSearch: 'Receipt search',
  invoiceNumber: 'Invoice Number',
  receiptNo: 'Receipt Number',
  receiptTypes: 'Receipt Types',
  startReceipt: 'Start Receipt',
  endReceipt: 'End Receipt',
  monthlyReceipt: 'Monthly Receipt',
  yearlyReceipt: 'Yearly Receipt',
  nullReceipt: 'Null Receipt',
  regularReceipt: 'Regular Receipt',
  cancelReceipt: 'Cancel Receipt',
  collectionReceipt: 'Collection Receipt',
  allNone: 'All/None',
  first: 'First name',
  last: 'Last name',
  manufacturer: 'Manufacturer',
  model: 'Model',
  default: 'Default',
  registeredOn: 'Registered on',
  lastModifiedOn: 'Last modified on',
  createdOn: 'Created on',
  modifiedOn: 'Modified on',
  cashRegisterName: 'Cash Register Name',
  lines: 'Lines',
  collect: 'Collect',
  reportLines: 'Report lines',
  balances: 'Balances',
  previousSession: 'Previous Session Totals',
  currentSession: 'Current Session Totals',
  previousOrder: 'Previous order',
  hour: 'Hour',
  minute: 'Minute',
  beforeDiscount: 'Total before discount',
  mandatory: 'Mandatory',
  loadingPayments: 'Loading payments...',
  transactions: 'Transactions',
  response: 'Response',
  loadingTransactions: 'Loading transactions...',
  notifications: 'Notifications',
  text: 'Text',
  themes: 'Themes',
  unpaidOrders: 'Unpaid orders',
  numberOfPayments: 'Number of payments',
  details: 'Details',
  tipAmount: 'Tip amount',
  dcTaxRate: 'Delivery Charges Tax Rate',
  orderId: 'Order ID',
  download: 'Download',
  host: 'Host',
  changedHardware: 'Changed hardware?',
  swithcCode: 'Table switch code',
  instance: 'Instance',
  backendversion: 'Backend version',
  ipAddress: 'IP Address',
  portNumber: 'Port Number',
  noUser: 'No user',
  regularInvoices: 'Regular invoices',
  cancellationInvoices: 'Cancellation invoices',
  printers: 'Printers',
  printJobs: 'PrintJobs',
  changePassword: 'Change password',
  dbOptimization: 'DB optimization',
  payment: 'Payment',
  system: 'System',
  dataExport: 'Data Export',
  depReceipts: 'DEP and receipts',
  depAll: 'All logs',
  cashAmount: 'Cash amount received',
  changeGiven: 'Change given',
  orderType: 'Order type',
  tip: 'Tip',
  receiptNumber: 'Receipt number',
  nonTrainingPayedOrders: 'Regular payed orders',
  nonTrainingUnpaidOrders: 'Regular unpayed orders',
  nonTrainingServiceCharges: 'Regular service charges',
  trainingPayedOrders: 'Training payed orders',
  trainingUnpaidOrders: 'Training unpayed orders',
  trainingServiceCharges: 'Training service charges',
  vatPrint: 'VAT Print',
  monthlyTaxReport: 'Monthly Tax Report',
  generatedOn: 'Generated on',
  regularTotalAmount: 'Regular Total Amount',
  amountOfOrders: 'Amount of orders',
  amountOfInvoices: 'Amount of invoices',
  cancellationTotalAmount: 'Cancellation Total Amount',
  detailsPerDay: 'Details per day',
  created: 'Created',
  printed: 'Printed',
  prepared: 'Prepared',
  inDelivery: 'In Delivery',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  notCollected: 'Not Collected',
  collected: 'Collected',
  disputed: 'Disputed',
  regular: 'Regular',
  cardName: 'Card Name',
  cardId: 'Card ID',
  register: 'Register',
  externalId: 'External card ID',
  walletId: 'Wallet ID',
  balance: 'Balance',
  cardData: 'Card Data',
  getCardBookings: 'Get Card Bookings',
  noBookings: 'There is no Bookings for this Card in this time frame.',
  cardBookings: 'Card Bookings',
  amount: 'Amount',
  expired: 'Expired',
  bookingId: 'Booking ID',
  bookingType: 'Booking type',
  noWallets: 'No wallets found for this contact.',
  wallets: 'Wallets',
  walletName: 'Wallet',
  reservedAmount: 'Available amount',
  walletDetails: 'Wallet Details',
  enterGalaxyCard: 'Enter Galaxy Card',
  number: 'No',
  mode: 'Mode',
  dark: 'Dark',
  simpleOrdering: 'Simple Ordering',
  fontSizes: 'Font Sizes',
  theme: 'Themes',
  useLastPaymentMethod: 'Use previous payment method',
  amountOfPersons: 'Amount of persons',
  refreshCompanySettings: 'Refresh Company Settings',
  refreshCatalog: 'Refresh Catalog',
  reason: 'Please enter a deactivation reason',
  deactivationWarning: 'ATTENTION: once deactivated, the card is no longer usable. This action can not be undone.',
  none: 'None',
  discounts: 'Discounts',
  clickToRemove: 'Click on discount button to remove it',
  moon: 'Moon',
  webshop: 'Webshop',
  mostSoldItem: 'Most sold item count',
  mostCanceledItem: 'Most canceled item count',
  monthYear: 'Month / Year',
  soldCount: 'Sold count',
  canceledCount: 'Canceled count',
  moonItemUsageSummary: 'Moon Item Usage Summary',
  webshopItemUsageSummary: 'Webshop Item Usage Summary',
  catalogId: 'Catalog Item ID',
  dailyitemusage: 'Daily',
  monthlyitemusage: 'Monthly',
  noCancelation: 'No data available.',
  servicecharge: 'Service charge',
  deliverycharge: 'Delivery charge',
  itemprice: 'Item',
  totalSoldAmount: 'Sold amount',
  totalCancelledAmount: 'Cancelled amount',
  byVat: 'By VAT rate',
  byTaxCategory: 'By tax category',
  byPaymentType: 'By payment type',
  total: 'Total',
  selectAddress: 'Select Address',
  quantity: 'Quantity',
  comment: 'Comment',
  deliveryCharges: 'Delivery charges',
  latitude: 'Latitude',
  longitude: 'Longitude',
  price: 'Price',
  deliveryType: 'Delivery type',
  selectHours: 'Select hours',
  selectMinute: 'Select minutes',
  totalAmount: 'Total Amount',
  deliveryMethod: 'Delivery method',
  change: 'Change',
  contactInfo: 'Contact information',
  paymentMethod: 'Payment method',
  voucher: 'Voucher',
  time: 'time',
  startTyping: 'Start typing to Search',
  asSoon: 'As soon as possible',
  address: 'Address',
  line3AT: 'Staircase/apartment/Address details',
  line2AT: 'House number',
  line1AT: 'Street',
  chat: 'Chat',
  allergens: 'Allergens',
  showAllergens: 'Show allergen(s)',
  vatRate: 'VAT rate',
  firstName: 'First Name',
  lastName: 'Last Name',
  tableName: 'Table Name',
  dateTime: 'Date and Time',
  customerTrackingTitle1: 'Erhebung von Kontaktdaten von Gästen in der Gastronomie',
  customerTrackingTitle2: 'gemäß der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19. Die Eintragung erfolgt durch die Kundin/den Kunden:',
  customerDesc: 'Datenschutzrechtliche Information nach Art. 13 DSGVO:\n' + 'Zweck und Rechtsgrundlagen der Verarbeitung:\n' + 'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' + 'Rechtsgrundlagen: Art. 6 Abs. 1 lit. d DSGVO (Verarbeitung personenbezogener Daten zum Schutz lebenswichtiger Interessen der betroffenen Person oder einer anderen natürlichen Person). § 5 Abs. 3 Epidemiegesetz 1950, BGBl. Nr. 186/1950 idF BGBl. I Nr. 103/2020\n' + 'Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19\n' + 'Verantwortlicher für die Verarbeitung der erhobenen personenbezogenen Daten $partnerCompanyName, $partnerPostalAddress, an die sich die betroffenen Personen zur Wahrnehmung ihrer datenschutzrechtlichen Rechte (z.B. Auskunft, Berichtigung) wenden können.\n\n' + 'Die verarbeiteten personenbezogenen Daten werden zu folgendem Zweck an folgende Empfänger weitergeleitet:\n' + 'Zweck: Contact Tracing zur Verhinderung der (Weiter-)Verbreitung von COVID-19 im Fall des Auftretens eines Verdachtsfalles von COVID-19\n' + 'Empfänger: die Daten sind auf Verlangen der MA 15-Gesundheitsdienst der Stadt Wien an diese weiterzuleiten.\n' + 'Hinweise\n' + 'Ihre personenbezogenen Daten werden gem. § 2 der Verordnung des Magistrats der Stadt Wien betreffend Auskunftserteilung für Contact Tracing im Zusammenhang mit Verdachtsfällen von COVID-19 4 Wochen nach ihrer Aufnahme gelöscht.\n' + 'Betroffenenrechte: Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder auf Widerspruch gegen die Verarbeitung.\n' + 'Wenn die Verarbeitung auf einer Einwilligung im Sinne des Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO beruht, haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf rechtmäßig war.Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der Österreichischen Datenschutzbehörde: Barichgasse 40-42, 1030 Wien, E-Mail: dsb@dsb.gv.at',
  visits: 'Visits',
  delete: 'Delete',
  save: 'Save',
  table: 'Table',
  deliveryOn: 'Delivery on',
  ordersSearch: 'Orders Search',
  blacklist: 'Blacklist',
  all: 'All'
};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = {
  paymentProccessing: 'Processing of payment started.',
  paymentSuccessful: 'Payment marked as successful.',
  transactionCancel: 'Cancellation of transaction started.',
  reRegistration: 'Re-registration Successful',
  dataRedy: 'Your data is ready for',
  wallet: 'Wallet: Update successful!',
  order: 'Order',
  thankYuou: 'Thank you for your order!',
  yourOrderNuber: 'Your order number is:',
  created_successfully: 'created successfully!',
  updated_successfully: 'updated successfully!',
  companySettingsRefreshed: 'Company settings refreshed successfully!',
  catalogRefreshed: 'Catalog refreshed successfully!',
  sendSuccess: 'Your request was sent. You will receive an email shortly!',
  addressUpdated: 'Address info updated',
  addedToCart: 'was added',
  postalSet: 'Postal code set! Click Calculate to see if there are delivery charges.',
  deliveryCalculated: 'Delivery charges calculated successfully.',
  registrationSuccessfully: 'Registration successful. You will receive activation email shortly',
  passSuccess: 'Password set successfully. You are now logged in.',
  thankYou: 'Thank you for your order! Please check your mailbox and spam folder for the confirmation.',
  paymentOrderOk: 'Order paid successfully!',
  visitOk: 'Visit successfully registered.',
  rateOk: 'Thank you! Your opinion is important to us.',
  continueTo: 'Continue to',
  blacklist: 'Blacklist: entry added successfully.'
};

/***/ })
],[246]);


// WEBPACK FOOTER //
// static/js/app.c2a9ed3f3a29e56e9544.js